(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("angular"));
	else if(typeof define === 'function' && define.amd)
		define(["angular"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("angular")) : factory(root["angular"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 77);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "angular"
var external__angular_ = __webpack_require__(0);
var external__angular__default = /*#__PURE__*/__webpack_require__.n(external__angular_);

// EXTERNAL MODULE: ./src/utils/index.ts + 4 modules
var utils = __webpack_require__(11);

// EXTERNAL MODULE: ./node_modules/uprr-angular-analytics/dist/uprr-angular-analytics.js
var uprr_angular_analytics = __webpack_require__(114);
var uprr_angular_analytics_default = /*#__PURE__*/__webpack_require__.n(uprr_angular_analytics);

// CONCATENATED MODULE: ./src/usage/usage.service.ts
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var usage_service_UsageService = function () {
    function UsageService(defaults, deps) {
        var _this = this;

        _classCallCheck(this, UsageService);

        this.defaults = defaults;
        this.pending = [];
        this.submitted = false;
        this.submitting = false;
        Object(external__angular_["extend"])(this, deps);
        this.flushOnAppBootstrap = this.defaults.flushOnAppBootstrap;
        this.inProgress = null;
        this.isDisabled = this.defaults.isDisabled;
        this.$rootScope.$on(this.defaults.locationChangeEvent, function (ev, next, current) {
            if (next === current) {
                if (_this.flushOnAppBootstrap) {
                    _this.$stop();
                    _this.$submit();
                }
            } else {
                _this.$stop();
                _this.$submit();
            }
        });
    }
    // TODO: Is this even used?


    _createClass(UsageService, [{
        key: 'progress',
        value: function progress(newProgress) {
            if (newProgress) {
                this.inProgress = newProgress;
            } else {
                return this.inProgress;
            }
        }
    }, {
        key: '$submit',
        value: function $submit() {
            if (this.submitting || this.pending.length === 0) {
                this.$stop();
                return;
            }
            var toSubmit = {};
            var index = this.pending.length;
            var url = this.pending[0].url;
            while (index--) {
                var component = this.pending.pop();
                if (!Object(external__angular_["isDefined"])(toSubmit[component.name])) {
                    toSubmit[component.name] = 1;
                } else {
                    toSubmit[component.name]++;
                }
            }
            this.$http.get(this.RC_USAGE_URL, {
                params: Object(external__angular_["extend"])(toSubmit, {
                    _ts: new Date().getTime(),
                    diy_ID: this.RC_USAGE_DP_URL,
                    url: url,
                    v: this.rcUtils.Ricola.info.version
                })
            });
            this.submitting = true;
            this.$stop();
        }
    }, {
        key: '$stop',
        value: function $stop() {
            this.$interval.cancel(this.inProgress);
            this.submitting = false;
            this.inProgress = null;
        }
    }, {
        key: '$start',
        value: function $start() {
            this.inProgress = this.$interval(this.$submit.bind(this), this.defaults.RC_USAGE_SUBMIT_INTERVAL);
        }
    }, {
        key: 'register',
        value: function register(name) {
            if (!this.isDisabled) {
                this.pending.push({
                    name: name,
                    url: this.$location.absUrl()
                });
                if (!this.inProgress) {
                    this.$start();
                }
            }
        }
    }]);

    return UsageService;
}();

/* harmony default export */ var usage_service = (usage_service_UsageService);
// CONCATENATED MODULE: ./src/usage/usage.constants.ts
var RC_USAGE_URL = '/uit/ricola/analytics/diy_rr_stats.gif';
var RC_USAGE_DP_URL = '16873';
// CONCATENATED MODULE: ./src/usage/usage.provider.ts
var usage_provider__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function usage_provider__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/** Exposed as an AngularJS provider via `UsageProvider`. */

var usage_provider_UsageProvider = function () {
    function UsageProvider() {
        usage_provider__classCallCheck(this, UsageProvider);

        this.defaults = {
            flushOnAppBootstrap: false,
            RC_USAGE_SUBMIT_INTERVAL: 1500,
            locationChangeEvent: '$locationChangeStart',
            isDisabled: false
        };
    }
    /** @internal */


    usage_provider__createClass(UsageProvider, [{
        key: 'setFlushOnBootstrap',
        value: function setFlushOnBootstrap(s) {
            this.defaults.flushOnAppBootstrap = s;
        }
        /** @internal */

    }, {
        key: 'setLocationChangeEvent',
        value: function setLocationChangeEvent(e) {
            this.defaults.locationChangeEvent = e;
        }
        /** @internal */

    }, {
        key: 'setSubmitInterval',
        value: function setSubmitInterval(i) {
            this.defaults.RC_USAGE_SUBMIT_INTERVAL = i;
        }
        /**
         * Disables Ricola telemetry
         */

    }, {
        key: 'disableUsageTracking',
        value: function disableUsageTracking() {
            this.defaults.isDisabled = true;
        }
        /** @internal */

    }, {
        key: '$get',
        value: ['$interval', '$http', '$location', '$rootScope', 'rcUtils', function $get($interval, $http, $location, $rootScope, rcUtils) {
            'ngInject';

            return new usage_service(this.defaults, {
                $interval: $interval,
                $http: $http,
                $location: $location,
                $rootScope: $rootScope,
                rcUtils: rcUtils,
                RC_USAGE_URL: RC_USAGE_URL,
                RC_USAGE_DP_URL: RC_USAGE_DP_URL
            });
        }]
    }]);

    return UsageProvider;
}();

/* harmony default export */ var usage_provider = (usage_provider_UsageProvider);
// CONCATENATED MODULE: ./src/usage/index.ts
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return usage_provider; });




/* harmony default export */ var usage = __webpack_exports__["b"] = (Object(external__angular_["module"])('rc.usage', [utils["a" /* default */], uprr_angular_analytics_default.a]).provider('Usage', usage_provider).name);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(34)('wks');
var uid = __webpack_require__(21);
var Symbol = __webpack_require__(5).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var KEYS;
(function (KEYS) {
    KEYS[KEYS["TAB"] = 9] = "TAB";
    KEYS[KEYS["ENTER"] = 13] = "ENTER";
    KEYS[KEYS["ESC"] = 27] = "ESC";
    KEYS[KEYS["SPACE"] = 32] = "SPACE";
    KEYS[KEYS["PAGEUP"] = 33] = "PAGEUP";
    KEYS[KEYS["PAGEDOWN"] = 34] = "PAGEDOWN";
    KEYS[KEYS["LEFT"] = 37] = "LEFT";
    KEYS[KEYS["UP"] = 38] = "UP";
    KEYS[KEYS["RIGHT"] = 39] = "RIGHT";
    KEYS[KEYS["DOWN"] = 40] = "DOWN";
    KEYS[KEYS["DELETE"] = 46] = "DELETE";
})(KEYS || (KEYS = {}));
/* harmony default export */ __webpack_exports__["a"] = (KEYS);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _i18n = __webpack_require__(1);

	var _i18n2 = _interopRequireDefault(_i18n);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var defaultTranslations = __webpack_require__(2);


	var ricola3I18N = new _i18n2.default(defaultTranslations);
	exports.default = ricola3I18N;
	module.exports = exports['default'];

/***/ },
/* 1 */
/***/ function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Ricola3I18N = function () {
	  function Ricola3I18N() {
	    var translations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	    _classCallCheck(this, Ricola3I18N);

	    this.translations = translations;
	  }

	  _createClass(Ricola3I18N, [{
	    key: "get",
	    value: function get(key) {
	      var values = this.translations[key];
	      if (!values) {
	        throw new Error("no translation found for " + key);
	      }
	      return values;
	    }
	  }]);

	  return Ricola3I18N;
	}();

	exports.default = Ricola3I18N;
	module.exports = exports["default"];

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = {
		"rc.addRemove.available": {
			"en-US": "Available",
			"es-MX": "Disponible"
		},
		"rc.addRemove.selected": {
			"en-US": "Selected",
			"es-MX": "Seleccionado"
		},
		"rc.appTemplate.logout": {
			"en-US": "Logout",
			"es-MX": "Salir"
		},
		"rc.calendar.today": {
			"en-US": "Today",
			"es-MX": "Hoy"
		},
		"rc.calendar.ok": {
			"en-US": "OK",
			"es-MX": "Procesado"
		},
		"rc.infiniteScroll.loading": {
			"en-US": "Loading...",
			"es-MX": "Cargando..."
		},
		"rc.loading.loading": {
			"en-US": "Loading",
			"es-MX": "Cargando"
		},
		"rc.table.column-dropdown": {
			"en-US": "Columns",
			"es-MX": "Columnas"
		},
		"rc.validation.invalid-generic": {
			"en-US": "{{fieldLabel}} is invalid",
			"es-MX": "{{fieldLabel}} es invalido"
		},
		"rc.validation.invalid-required": {
			"en-US": "{{fieldLabel}} is required",
			"es-MX": "{{fieldLabel}} es requerido"
		},
		"rc.validation.invalid-length": {
			"en-US": "{{fieldLabel}} is too long",
			"es-MX": "{{fieldLabel}} es muy largo"
		},
		"rc.validation.invalid-header": {
			"en-US": "Correct the following:",
			"es-MX": "Corregir lo siguiente:"
		},
		"rc.wizard.back": {
			"en-US": "Back",
			"es-MX": "Regresar"
		},
		"rc.wizard.submit": {
			"en-US": "Submit",
			"es-MX": "Procesar"
		},
		"rc.wizard.next": {
			"en-US": "Next",
			"es-MX": "Siguiente"
		},
		"rc.example.label": {
			"en-US": "Example Label",
			"es-MX": ""
		}
	};

/***/ }
/******/ ]);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 6 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(16);
var IE8_DOM_DEFINE = __webpack_require__(52);
var toPrimitive = __webpack_require__(35);
var dP = Object.defineProperty;

exports.f = __webpack_require__(9) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(18)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 10 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "angular"
var external__angular_ = __webpack_require__(0);
var external__angular__default = /*#__PURE__*/__webpack_require__.n(external__angular_);

// CONCATENATED MODULE: ./src/utils/utils.service.feature-tests.ts
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


function cssAnimations() {
    // CSS Animations test - https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Using_CSS_animations/Detecting_CSS_animation_support
    var elm = document.createElement('div');
    var animation = false,
        animationstring = 'animation',
        keyframeprefix = '',
        domPrefixes = 'Webkit Moz O ms Khtml'.split(' '),
        pfx = '';
    if (typeof elm.style.animationName !== 'undefined') {
        animation = true;
    }
    if (!animation) {
        for (var i = 0; i < domPrefixes.length; i++) {
            if (isPropDefined(elm.style, domPrefixes[i] + 'AnimationName')) {
                pfx = domPrefixes[i];
                animationstring = pfx + 'Animation';
                keyframeprefix = '-' + pfx.toLowerCase() + '-';
                animation = true;
                break;
            }
        }
    }
    if (!animation) {
        addBodyClass('no-css-animation');
    }
}
function cssTransitions() {
    var elm = document.createElement('div'),
        domPrefixes = 'Webkit Moz O ms Khtml'.split(' '),
        transitions = false;
    if (elm.style.transition !== 'undefined') {
        transitions = true;
    } else {
        for (var i = 0; i < domPrefixes.length; i++) {
            if (isPropDefined(elm.style, domPrefixes[i] + 'Transition')) {
                transitions = true;
                break;
            }
        }
    }
    if (!transitions) {
        addBodyClass('no-css-transition');
    }
}
function addBodyClass(className) {
    Object(external__angular_["element"])(document.body).addClass(className);
}
function isPropDefined(obj, propName) {
    return typeof obj[propName] !== 'undefined';
}

var utils_service_feature_tests_FeatureTests = function () {
    function FeatureTests() {
        _classCallCheck(this, FeatureTests);
    }

    _createClass(FeatureTests, [{
        key: 'runFeatureTests',
        value: function runFeatureTests() {
            cssAnimations();
            cssTransitions();
        }
    }, {
        key: 'cssTransition',
        value: function cssTransition() {
            return !Object(external__angular_["element"])(document.body).hasClass('no-css-transition');
        }
    }]);

    return FeatureTests;
}();

/* harmony default export */ var utils_service_feature_tests = (utils_service_feature_tests_FeatureTests);
// CONCATENATED MODULE: ./src/utils/user-id.constants.ts
var USER_ID_SERVICE_URL = '/uit/ricola/2.5/service/env.inc';
// CONCATENATED MODULE: ./src/utils/utils.service.user-id.ts
var utils_service_user_id__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function utils_service_user_id__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var utils_service_user_id_RcUserId = function () {
    RcUserId.$inject = ['$http'];

    function RcUserId($http) {
        'ngInject';

        utils_service_user_id__classCallCheck(this, RcUserId);

        this.$http = $http;
    }

    utils_service_user_id__createClass(RcUserId, [{
        key: 'get',
        value: function get(config) {
            var url = USER_ID_SERVICE_URL + '?q=' + Date.now();
            return this.$http.get(url, Object(external__angular_["extend"])({
                transformResponse: function transformResponse(response) {
                    try {
                        var json = Object(external__angular_["fromJson"])(response);
                        if (!!json.userId && json.userId === '(none)') {
                            json.userId = '';
                        }
                        return json;
                    } catch (exception) {
                        return response;
                    }
                }
            }, config));
        }
    }]);

    return RcUserId;
}();

/* harmony default export */ var utils_service_user_id = (utils_service_user_id_RcUserId);
// CONCATENATED MODULE: ./src/utils/utils.service.ts
rcUtilsService.$inject = ['$timeout', '$rootScope', '$window'];
function rcUtilsService($timeout, $rootScope, $window) {
    'ngInject';

    var service = this;
    /* Use to identify object class.
       Is thing a date?                getClass(thing) === 'Date'
       Is thing an array?              getClass(thing) === 'Array'
       Is thing a regular expression?  getClass(thing) === 'RegExp'
       etc. */
    service.getClass = function (thing) {
        return Object.prototype.toString.call(thing).slice('[object '.length, -']'.length);
    };
    service.throttle = function (delay, noTrailing, callback, debounceMode) {
        var timeoutId,
            lastExec = 0;
        if (typeof noTrailing !== 'boolean') {
            debounceMode = callback;
            callback = noTrailing;
            noTrailing = false;
        }
        var wrapper = function wrapper() {
            var that = this,
                elapsed = new Date().getTime() - lastExec,
                args = arguments,
                exec = function exec() {
                lastExec = new Date().getTime();
                callback.apply(that, args);
            },
                clear = function clear() {
                timeoutId = null;
            };
            if (debounceMode && !timeoutId) {
                exec();
            }
            if (timeoutId) {
                $timeout.cancel(timeoutId);
            }
            if (!debounceMode && elapsed > delay) {
                exec();
            } else if (noTrailing !== true) {
                timeoutId = $timeout(debounceMode ? clear : exec, !debounceMode ? delay - elapsed : delay);
            }
        };
        return wrapper;
    };
    // any string prefixed with $$ will be replaced as part of the build process
    service.Ricola = {
        info: {
            version: '3.4.8',
            description: 'Union Pacific\'s responsive, mobile-first component library built with AngularJS and Foundation.'.replace('&#x27;', "'"),
            contributors: 'Cary Smith,Doug Stock,Matt Steele',
            angularVersion: '>=1.6.3',
            foundationVersion: '5.5.2',
            buildDate: '2018-01-26T19:21:53.527Z',
            repositoryUrl: 'http://git-dev.uit.tla.uprr.com:9080/user-experience/ricola3.git'
        }
    };
    $window.Ricola = service.Ricola;
}
// CONCATENATED MODULE: ./src/utils/index.ts




/* harmony default export */ var utils = __webpack_exports__["a"] = (Object(external__angular_["module"])('rc.utils', []).service('rcFeatureTests', utils_service_feature_tests).service('rcUserId', utils_service_user_id).service('rcUtils', rcUtilsService).name);

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "angular"
var external__angular_ = __webpack_require__(0);
var external__angular__default = /*#__PURE__*/__webpack_require__.n(external__angular_);

// CONCATENATED MODULE: ./src/keyboardNavigation/keyboard-navigation.constants.ts
var KEYS = {
    TAB: 9,
    ENTER: 13,
    ESC: 27,
    SPACE: 32,
    PAGEUP: 33,
    PAGEDOWN: 34,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    DELETE: 46
};
// CONCATENATED MODULE: ./src/keyboardNavigation/index.ts


/* harmony default export */ var keyboardNavigation = __webpack_exports__["a"] = (Object(external__angular_["module"])('rc.keyboardNavigation', []).constant('KEYS', KEYS).name);

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "angular"
var external__angular_ = __webpack_require__(0);
var external__angular__default = /*#__PURE__*/__webpack_require__.n(external__angular_);

// EXTERNAL MODULE: ./src/bindHtml/index.ts + 2 modules
var bindHtml = __webpack_require__(25);

// CONCATENATED MODULE: ./src/i18n/translatable-expression.component.ts
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var translatable_expression_component_TranslatableExpressionController = function () {
    TranslatableExpressionController.$inject = ['$interpolate', '$scope', '$rootScope', '$log', '$rcTranslateUtils'];

    function TranslatableExpressionController($interpolate, $scope, $rootScope, $log, $rcTranslateUtils) {
        'ngInject';

        _classCallCheck(this, TranslatableExpressionController);

        this.$interpolate = $interpolate;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$log = $log;
        this.$rcTranslateUtils = $rcTranslateUtils;
    }

    _createClass(TranslatableExpressionController, [{
        key: '$onInit',
        value: function $onInit() {
            // We avoid a binding this way
            this.templates = this.i18nTemplates();
            this.refreshTranslation();
            this.handleTranslationChangeEvents();
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.fieldLabel && Object(external__angular_["isDefined"])(this.templates)) {
                this.refreshTranslation();
            }
        }
    }, {
        key: 'updateFieldLabelBinding',
        value: function updateFieldLabelBinding(template) {
            return template.replace('{{fieldLabel}}', '{{rcTranslatableExpression.fieldLabel}}');
        }
    }, {
        key: 'refreshTranslation',
        value: function refreshTranslation() {
            var language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$rcTranslateUtils.currentLanguage();

            var template = this.templates[language];
            if (!template) {
                this.$log.warn('no translated expression set for ' + language + ' (' + this.templates + ')');
                return;
            }
            var message = this.$interpolate(this.updateFieldLabelBinding(template))(this.$scope);
            this.expression = message;
        }
    }, {
        key: 'handleTranslationChangeEvents',
        value: function handleTranslationChangeEvents() {
            var _this = this;

            this.$rcTranslateUtils.onTranslateChange(function (data) {
                _this.refreshTranslation(data.language);
            });
        }
    }]);

    return TranslatableExpressionController;
}();
var TranslatableExpressionComponent = {
    bindings: {
        i18nTemplates: '&',
        fieldLabel: '@'
    },
    template: '<span rc-bind-html-unsafe="rcTranslatableExpression.expression"></span>',
    controller: translatable_expression_component_TranslatableExpressionController,
    controllerAs: 'rcTranslatableExpression'
};
/* harmony default export */ var translatable_expression_component = (TranslatableExpressionComponent);
// CONCATENATED MODULE: ./src/i18n/translate-utils.provider.ts
var translate_utils_provider__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function translate_utils_provider__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_LANGUAGE = 'en-US';
/** @internal */
var TranslateUtils = function () {
    function TranslateUtils($injector, $rootScope) {
        var defaultLanguage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_LANGUAGE;

        translate_utils_provider__classCallCheck(this, TranslateUtils);

        this.$injector = $injector;
        this.$rootScope = $rootScope;
        this.defaultLanguage = defaultLanguage;
        this.init();
    }

    translate_utils_provider__createClass(TranslateUtils, [{
        key: 'init',
        value: function init() {
            if (this.$injector.has('$translate')) {
                this.$translate = this.$injector.get('$translate');
            }
        }
    }, {
        key: 'hasTranslateService',
        value: function hasTranslateService() {
            return !!this.$translate;
        }
    }, {
        key: 'onTranslateChange',
        value: function onTranslateChange(cb) {
            this.$rootScope.$on('$translateChangeSuccess', function (evt, data) {
                cb(data);
            });
        }
    }, {
        key: 'currentLanguage',
        value: function currentLanguage() {
            if (this.hasTranslateService()) {
                return this.$translate.use() || this.defaultLanguage;
            }
            return this.defaultLanguage;
        }
    }]);

    return TranslateUtils;
}();
/**
 * Exposed as an AngularJS provider via `$rcTranslateUtilsProvider`.
 */

var TranslateUtilsProvider = function () {
    /** @internal */
    function TranslateUtilsProvider() {
        translate_utils_provider__classCallCheck(this, TranslateUtilsProvider);

        this.defaultLanguage = DEFAULT_LANGUAGE;
    }
    /**
     * The cx-i18n directive will automatically identify the user's preferred language, and change the language at runtime to reflect the user's preference.
     *
     * If you are not using cx-i18n and need to change from the default en-US language, use this method.
     * @param language The default language to set. Example: 'es-MX'
     */


    translate_utils_provider__createClass(TranslateUtilsProvider, [{
        key: 'setDefaultLanguage',
        value: function setDefaultLanguage(language) {
            this.defaultLanguage = language;
        }
        /** @internal */

    }, {
        key: '$get',
        value: ['$injector', '$rootScope', function $get($injector, $rootScope) {
            'ngInject';

            return new TranslateUtils($injector, $rootScope, this.defaultLanguage);
        }]
    }]);

    return TranslateUtilsProvider;
}();

/* harmony default export */ var translate_utils_provider = (TranslateUtilsProvider);
// CONCATENATED MODULE: ./src/i18n/index.ts
/* unused concated harmony import TranslateUtilsProvider */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return translate_utils_provider; });




/* harmony default export */ var i18n = __webpack_exports__["a"] = (Object(external__angular_["module"])('rc.i18n', [bindHtml["a" /* default */]]).provider('$rcTranslateUtils', translate_utils_provider).component('rcTranslatableExpression', translatable_expression_component).name);
// Public API


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var hide = __webpack_require__(15);
var has = __webpack_require__(10);
var SRC = __webpack_require__(21)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(6).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(7);
var createDesc = __webpack_require__(27);
module.exports = __webpack_require__(9) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "angular"
var external__angular_ = __webpack_require__(0);
var external__angular__default = /*#__PURE__*/__webpack_require__.n(external__angular_);

// CONCATENATED MODULE: ./src/position/position.service.ts
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var round = Math.round;
/**
 * A set of utility methods that can be use to retrieve position of DOM elements.
 * It is meant to be used where we need to absolute-position DOM elements in
 * relation to other, existing elements (this is the case for tooltips, popovers,
 * typeahead suggestions etc.).
 */

var PositionService = function () {
    PositionService.$inject = ['$document', '$window'];

    // TODO: This class is a bit sloppy between when its using a jQ vs raw html elements
    function PositionService($document, $window) {
        'ngInject';

        _classCallCheck(this, PositionService);

        this.$document = $document;
        this.$window = $window;
    }

    _createClass(PositionService, [{
        key: '$getStyle',
        value: function $getStyle(element, cssprop) {
            if (element.currentStyle) {
                // IE
                return element.currentStyle[cssprop];
            } else if (this.$window.getComputedStyle) {
                return this.$window.getComputedStyle(element)[cssprop];
            }
            // finally try and get inline style
            return element.style[cssprop];
        }
        /**
         * Checks if a given element is statically positioned
         * @param {object} element - raw DOM element
         */

    }, {
        key: '$isStaticPositioned',
        value: function $isStaticPositioned(element) {
            return (this.$getStyle(element, 'position') || 'static') === 'static';
        }
        /**
         * returns the closest, non-statically positioned parentOffset of a given element
         * @param {object} element
         */

    }, {
        key: '$parentOffsetEl',
        value: function $parentOffsetEl(element) {
            var docDomEl = this.$document[0];
            var offsetParent = element.offsetParent || docDomEl;
            while (offsetParent && offsetParent !== docDomEl && this.$isStaticPositioned(offsetParent)) {
                offsetParent = offsetParent.offsetParent;
            }
            return offsetParent || docDomEl;
        }
        /**
         * @param element
         * @deprecated Only used by tooltip (and only when not appended to body)
         */

    }, {
        key: 'position',
        value: function position(element) {
            var elBCR = this.offset(element);
            var offsetParentBCR = {
                top: 0,
                left: 0
            };
            var offsetParentEl = this.$parentOffsetEl(element[0]);
            if (offsetParentEl !== this.$document[0]) {
                // TODO: Can a jq element be used like a function??????
                offsetParentBCR = this.offset(element(offsetParentEl));
                if (!offsetParentEl.nodeName.match(/body/gi)) {
                    offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;
                    offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;
                }
            }
            var boundingClientRect = element[0].getBoundingClientRect();
            return {
                width: boundingClientRect.width || element.prop('offsetWidth'),
                height: boundingClientRect.height || element.prop('offsetHeight'),
                top: elBCR.top - offsetParentBCR.top,
                left: elBCR.left - offsetParentBCR.left
            };
        }
        // Returns element position information, in CSS pixels
        // Top and Left are relative to the Document, and can be used with 'position: absolute' on body-appended elements

    }, {
        key: 'offset',
        value: function offset(element) {
            if (!(element instanceof HTMLElement)) {
                element = element[0];
            }
            var boundingClientRect = element.getBoundingClientRect();
            var documentElement = this.$document[0].documentElement;
            // top/left for "layout viewport". See http://www.quirksmode.org/blog/archives/2016/11/viewports_resea.html

            var documentClientRect = documentElement.getBoundingClientRect();
            var _$window = this.$window,
                pageXOffset = _$window.pageXOffset,
                pageYOffset = _$window.pageYOffset;

            var yOffsetDifference = pageYOffset + documentClientRect.top;
            var xOffsetDifference = pageXOffset + documentClientRect.left;
            var topFromLayoutViewport = boundingClientRect.top - yOffsetDifference;
            var leftFromLayoutViewport = boundingClientRect.left - xOffsetDifference;
            return {
                width: boundingClientRect.width,
                height: boundingClientRect.height,
                // We might be able to simplify this, not sure clientTop/Left will ever be nonzero
                top: topFromLayoutViewport + pageYOffset - documentElement.clientTop,
                left: leftFromLayoutViewport + pageXOffset - documentElement.clientLeft
            };
        }
        /**
         * Detects whether the top and/or bottom edge of the target element are above/below the
         * top and bottom edge of the scroll container.
         * TODO: Replace with IntersectionObserver when fully supported.
         */

    }, {
        key: 'relativeToContainer',
        value: function relativeToContainer(element, scrollContainer) {
            if (!(element instanceof HTMLElement)) {
                element = element[0];
            }
            if (!(scrollContainer instanceof HTMLElement)) {
                scrollContainer = scrollContainer[0];
            }
            var above = false;
            var aboveBy = 0;
            var below = false;
            var belowBy = 0;
            if (scrollContainer && scrollContainer.nodeName === 'BODY') {
                var rectangle = element.getBoundingClientRect();
                var _window = window,
                    innerHeight = _window.innerHeight;

                above = rectangle.top < 0 && rectangle.bottom > 0;
                aboveBy = 0 - rectangle.top;
                below = rectangle.top < rectangle.height && rectangle.bottom > innerHeight;
                belowBy = rectangle.bottom - innerHeight;
            } else {
                var elementHeight = element.offsetHeight;
                var targetTop = round(this.offset(element).top);
                var targetTotal = round(targetTop + elementHeight);
                var containerTop = round(this.offset(scrollContainer).top);
                var containerTotal = round(containerTop + scrollContainer.offsetHeight);
                above = targetTop + 1 < containerTop && targetTotal > 0;
                aboveBy = elementHeight + containerTop - targetTotal - 1;
                below = targetTotal - 1 > containerTotal && containerTotal - targetTop > 0;
                belowBy = targetTotal - containerTotal;
            }
            return { above: above, aboveBy: aboveBy, below: below, belowBy: belowBy };
        }
    }]);

    return PositionService;
}();

/* harmony default export */ var position_service = (PositionService);
// CONCATENATED MODULE: ./src/position/element-alignment.service.ts
var element_alignment_service__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function element_alignment_service__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AlignmentService = function () {
    function AlignmentService() {
        element_alignment_service__classCallCheck(this, AlignmentService);

        this.$populatePositionStrategies();
    }

    element_alignment_service__createClass(AlignmentService, [{
        key: 'align',
        value: function align(_ref) {
            var target = _ref.target,
                popup = _ref.popup,
                alignment = _ref.alignment;

            return this.$naiveAlign({ target: target, popup: popup, alignment: alignment });
        }
    }, {
        key: '$naiveAlign',
        value: function $naiveAlign(_ref2) {
            var target = _ref2.target,
                popup = _ref2.popup,
                alignment = _ref2.alignment;

            return this.$getPosition(target, popup, alignment);
        }
    }, {
        key: '$populatePositionStrategies',
        value: function $populatePositionStrategies() {
            this.positionStrategies = new Map();
            this.positionStrategies.set('bottom-left', function (target, popup) {
                return {
                    top: target.top + target.height,
                    left: target.left
                };
            });
            this.positionStrategies.set('bottom-right', function (target, popup) {
                return {
                    top: target.top + target.height,
                    left: target.left - popup.width
                };
            });
            this.positionStrategies.set('bottom-center', function (target, popup) {
                return {
                    top: target.top + target.height,
                    left: target.left + target.width / 2 - popup.width / 2
                };
            });
            this.positionStrategies.set('right-middle', function (target, popup) {
                return {
                    top: target.top + target.height / 2 - popup.height / 2,
                    left: target.left + target.width
                };
            });
            this.positionStrategies.set('left-middle', function (target, popup) {
                return {
                    top: target.top + target.height / 2 - popup.height / 2,
                    left: target.left - popup.width
                };
            });
            this.positionStrategies.set('top-center', function (target, popup) {
                return {
                    top: target.top - popup.height,
                    left: target.left + target.width / 2 - popup.width / 2
                };
            });
        }
    }, {
        key: '$getPosition',
        value: function $getPosition(target, popup, alignment) {
            return this.positionStrategies.get(alignment)(target, popup);
        }
    }]);

    return AlignmentService;
}();

/* harmony default export */ var element_alignment_service = (AlignmentService);
// CONCATENATED MODULE: ./src/position/alignment-adjuster.service.ts
var alignment_adjuster_service__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function alignment_adjuster_service__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AlignmentAdjuster = function () {
    function AlignmentAdjuster($body) {
        alignment_adjuster_service__classCallCheck(this, AlignmentAdjuster);

        this.$body = $body;
    }

    alignment_adjuster_service__createClass(AlignmentAdjuster, [{
        key: '$getViewportDimensions',
        value: function $getViewportDimensions() {
            var bodyClientRect = this.$body[0].getBoundingClientRect();
            var offsetTop = bodyClientRect.top * -1;
            var offsetLeft = bodyClientRect.left * -1;
            return {
                width: bodyClientRect.width,
                height: bodyClientRect.height,
                top: offsetTop,
                bottom: offsetTop + bodyClientRect.height,
                left: offsetLeft,
                right: offsetLeft + bodyClientRect.width
            };
        }
    }, {
        key: '$getDocumentDimensions',
        value: function $getDocumentDimensions() {
            var body = this.$body[0];
            return {
                top: 0,
                left: 0,
                height: body.scrollHeight,
                width: body.scrollWidth,
                right: body.scrollWidth,
                bottom: body.scrollHeight
            };
        }
    }, {
        key: 'adjustVerticallyForViewport',
        value: function adjustVerticallyForViewport(_ref) {
            var alignment = _ref.alignment,
                popup = _ref.popup,
                nubSize = _ref.nubSize,
                _ref$containInViewpor = _ref.containInViewport,
                containInViewport = _ref$containInViewpor === undefined ? true : _ref$containInViewpor;

            var body = this.$getViewportDimensions();
            return {
                top: alignment.top + this.$adjustVertically({
                    alignment: alignment,
                    popup: popup,
                    body: body,
                    containInViewport: containInViewport
                }),
                left: alignment.left + nubSize
            };
        }
    }, {
        key: 'adjustHorizontallyForViewport',
        value: function adjustHorizontallyForViewport(_ref2) {
            var alignment = _ref2.alignment,
                popup = _ref2.popup,
                nubSize = _ref2.nubSize,
                _ref2$containInViewpo = _ref2.containInViewport,
                containInViewport = _ref2$containInViewpo === undefined ? true : _ref2$containInViewpo;

            var body = this.$getViewportDimensions();
            return {
                top: alignment.top + nubSize,
                left: alignment.left + this.$adjustHorizontally({
                    alignment: alignment,
                    popup: popup,
                    body: body,
                    containInViewport: containInViewport
                })
            };
        }
    }, {
        key: 'fitsInViewport',
        value: function fitsInViewport(_ref3) {
            var alignment = _ref3.alignment,
                popup = _ref3.popup;

            var body = this.$getViewportDimensions();
            return alignment.left + popup.width <= body.right && alignment.top + popup.height <= body.bottom && alignment.top >= body.top && alignment.left >= body.left;
        }
    }, {
        key: '$adjustHorizontally',
        value: function $adjustHorizontally(_ref4) {
            var alignment = _ref4.alignment,
                popup = _ref4.popup,
                body = _ref4.body,
                containInViewport = _ref4.containInViewport;

            if (containInViewport && popup.width > body.width) {
                throw new Error('Popup is too wide to meet constraints');
            }
            if (alignment.left < 0) {
                return -alignment.left + body.left;
            } else {
                var popupRightEdge = alignment.left + popup.width;
                return Math.min(0, body.right - popupRightEdge);
            }
        }
    }, {
        key: '$adjustVertically',
        value: function $adjustVertically(_ref5) {
            var alignment = _ref5.alignment,
                popup = _ref5.popup,
                body = _ref5.body,
                containInViewport = _ref5.containInViewport;

            if (containInViewport && popup.height > body.height) {
                throw new Error('Popup is too tall to meet constraints');
            }
            if (alignment.top < 0) {
                return -alignment.top + body.top;
            } else {
                var popupBottomEdge = alignment.top + popup.height;
                return Math.min(0, body.bottom - popupBottomEdge);
            }
        }
    }]);

    return AlignmentAdjuster;
}();

/* harmony default export */ var alignment_adjuster_service = (AlignmentAdjuster);
// CONCATENATED MODULE: ./src/position/strategic-positioner.service.ts
var strategic_positioner_service__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function strategic_positioner_service__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var StrategicMenuPositionerService = function () {
    StrategicMenuPositionerService.$inject = ['$document', '$position'];

    function StrategicMenuPositionerService($document, $position) {
        'ngInject';

        strategic_positioner_service__classCallCheck(this, StrategicMenuPositionerService);

        this.$position = $position;
        this.$body = $document.find('body');
    }

    strategic_positioner_service__createClass(StrategicMenuPositionerService, [{
        key: 'positionerFor',
        value: function positionerFor(strategies, nubOffset) {
            return new strategic_positioner_service_StrategicMenuPositioner(this.$body, this.$position, strategies, nubOffset);
        }
    }]);

    return StrategicMenuPositionerService;
}();

/* harmony default export */ var strategic_positioner_service = (StrategicMenuPositionerService);

var strategic_positioner_service_StrategicMenuPositioner = function () {
    function StrategicMenuPositioner($body, $position, strategies, nubOffset) {
        strategic_positioner_service__classCallCheck(this, StrategicMenuPositioner);

        this.$position = $position;
        this.strategies = strategies;
        this.nubOffset = nubOffset;
        this.backupStrategy = strategies[0];
        this.alignmentService = new element_alignment_service();
        this.alignmentAdjuster = new alignment_adjuster_service($body);
        this.$setupStrategies();
    }

    strategic_positioner_service__createClass(StrategicMenuPositioner, [{
        key: 'position',
        value: function position(target, popup) {
            var targetOffset = this.$position.offset(Object(external__angular_["element"])(target));
            var popupOffset = this.$position.offset(Object(external__angular_["element"])(popup));
            return this.$strategicallyPosition(targetOffset, popupOffset);
        }
    }, {
        key: '$setupStrategies',
        value: function $setupStrategies() {
            this.strategiesMap = new Map();
            this.strategiesMap.set('bottom-center', {
                alignment: 'bottom-center',
                adjustHorizontally: true,
                invertNubOffset: false,
                exposedAlignment: 'bottom'
            });
            this.strategiesMap.set('top-center', {
                alignment: 'top-center',
                adjustHorizontally: true,
                invertNubOffset: true,
                exposedAlignment: 'top'
            });
            this.strategiesMap.set('bottom-left', {
                alignment: 'bottom-left',
                adjustHorizontally: true,
                invertNubOffset: false,
                exposedAlignment: 'below'
            });
            this.strategiesMap.set('right-middle', {
                alignment: 'right-middle',
                adjustHorizontally: false,
                invertNubOffset: false,
                exposedAlignment: 'right'
            });
            this.strategiesMap.set('left-middle', {
                alignment: 'left-middle',
                adjustHorizontally: false,
                invertNubOffset: true,
                exposedAlignment: 'left'
            });
        }
    }, {
        key: '$strategicallyPosition',
        value: function $strategicallyPosition(targetOffset, popupOffset) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.strategies[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var strategyName = _step.value;

                    var strategy = this.strategiesMap.get(strategyName);
                    try {
                        var alignment = this.$calculateAlignment(targetOffset, popupOffset, strategy);
                        if (this.alignmentAdjuster.fitsInViewport({
                            alignment: alignment,
                            popup: popupOffset
                        })) {
                            return Object.assign({ alignment: strategy.exposedAlignment }, alignment);
                        }
                    } catch (e) {
                        continue;
                    }
                }
                // backup
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var backup = Object.assign({ containInViewport: false }, this.strategiesMap.get(this.backupStrategy));
            return Object.assign({ alignment: backup.exposedAlignment }, this.$calculateAlignment(targetOffset, popupOffset, backup));
        }
    }, {
        key: '$calculateAlignmentWithoutAdjustment',
        value: function $calculateAlignmentWithoutAdjustment(targetOffset, popupOffset, _ref) {
            var alignment = _ref.alignment;

            return this.alignmentService.align({
                target: targetOffset,
                popup: popupOffset,
                alignment: alignment
            });
        }
    }, {
        key: '$calculateAlignment',
        value: function $calculateAlignment(targetOffset, popupOffset, strategy) {
            var alignmentResults = this.$calculateAlignmentWithoutAdjustment(targetOffset, popupOffset, strategy);
            var alignment = strategy.alignment,
                adjustHorizontally = strategy.adjustHorizontally,
                invertNubOffset = strategy.invertNubOffset,
                containInViewport = strategy.containInViewport;

            if (adjustHorizontally) {
                return this.alignmentAdjuster.adjustHorizontallyForViewport({
                    alignment: alignmentResults,
                    popup: popupOffset,
                    containInViewport: containInViewport,
                    nubSize: invertNubOffset ? -this.nubOffset : this.nubOffset
                });
            }
            return this.alignmentAdjuster.adjustVerticallyForViewport({
                alignment: alignmentResults,
                popup: popupOffset,
                containInViewport: containInViewport,
                nubSize: invertNubOffset ? -this.nubOffset : this.nubOffset
            });
        }
    }]);

    return StrategicMenuPositioner;
}();
// CONCATENATED MODULE: ./src/position/index.ts



/* harmony default export */ var src_position = __webpack_exports__["a"] = (Object(external__angular_["module"])('rc.position', []).service('$strategicPositioner', strategic_positioner_service).service('$position', position_service).name);

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(55);
var defined = __webpack_require__(38);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "angular"
var external__angular_ = __webpack_require__(0);
var external__angular__default = /*#__PURE__*/__webpack_require__.n(external__angular_);

// CONCATENATED MODULE: ./src/mediaQuery/mediaQuery.constants.ts
// FIXME These are deprecated. Use rcMediaQuery.minSize() instead.
var BREAKPOINTS = {
    SMALL: '0px',
    MEDIUM: '501px',
    LARGE: '751px',
    XLARGE: '1025px',
    XXLARGE: '1201px'
};
// CONCATENATED MODULE: ./src/mediaQuery/mediaQuery.service.ts
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SIZES = ['small', 'medium', 'large', 'xlarge', 'xxlarge'];
/**
 * Exposed as an AngularJS service via `rcMediaQuery`
 */

var MediaQueryService = function () {
    MediaQueryService.$inject = ['$window'];

    /** @internal */
    function MediaQueryService($window) {
        'ngInject';

        _classCallCheck(this, MediaQueryService);

        this.$window = $window;
    }
    /** @internal */


    _createClass(MediaQueryService, [{
        key: 'matches',
        value: function matches(query) {
            return this.$window.matchMedia(query).matches;
        }
        /**
         * A wrapper around `$window.matchMedia`
         * @param query a CSS expression, such as '350px'
         * @returns true if the current window is at least `query` wide
         */

    }, {
        key: 'minWidth',
        value: function minWidth(query) {
            return this.matches('(min-width: ' + query + ')');
        }
        /** @internal */

    }, {
        key: '$currentSize',
        value: function $currentSize() {
            return this.$window.getComputedStyle(document.body, ':before').getPropertyValue('content').replace(/"/g, '') || 'large';
        }
        /**
         * A utililty to check if the page is large enough to trigger a particular breakpoint
         * @param size small|medium|large|xlarge|xxlarge
         * @return whether the current window size is at least `size` large
         */

    }, {
        key: 'minSize',
        value: function minSize(size) {
            return SIZES.indexOf(this.$currentSize()) >= SIZES.indexOf(size);
        }
    }]);

    return MediaQueryService;
}();

/* harmony default export */ var mediaQuery_service = (MediaQueryService);
// CONCATENATED MODULE: ./src/mediaQuery/index.ts
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return mediaQuery_service; });



/* harmony default export */ var mediaQuery = __webpack_exports__["b"] = (Object(external__angular_["module"])('rc.mediaQuery', []).constant('BREAKPOINTS', BREAKPOINTS).service('rcMediaQuery', mediaQuery_service).name);


/***/ }),
/* 21 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var core = __webpack_require__(6);
var hide = __webpack_require__(15);
var redefine = __webpack_require__(14);
var ctx = __webpack_require__(28);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(54);
var enumBugKeys = __webpack_require__(43);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "angular"
var external__angular_ = __webpack_require__(0);
var external__angular__default = /*#__PURE__*/__webpack_require__.n(external__angular_);

// EXTERNAL MODULE: ./src/usage/index.ts + 3 modules
var usage = __webpack_require__(1);

// CONCATENATED MODULE: ./src/bindHtml/bind-html.directive.ts
rcBindHtmlUnsafeDirective.$inject = ['$parse', '$timeout', '$compile', 'Usage'];

function rcBindHtmlUnsafeDirective($parse, $timeout, $compile, Usage) {
    'ngInject';

    return {
        compile: function compile(compileEl, compileAttrs) {
            var rcBindHtmlGetter = $parse(compileAttrs.rcBindHtmlUnsafe);
            var shouldCompileGetter = $parse(compileAttrs.compile);
            //TODO: SHould not be accessing internal angular =-O
            $compile.$$addBindingClass(compileEl);
            return function link(scope, element, attrs) {
                Usage.register('bindhtml');
                //TODO: SHould not be accessing internal angular =-O
                $compile.$$addBindingInfo(element, attrs.rcBindHtmlUnsafe);
                scope.$watch(attrs.rcBindHtmlUnsafe, bindHtmlWatch);
                function bindHtmlWatch() {
                    // Retrieve what may be compilable html
                    var html = rcBindHtmlGetter(scope);
                    if (Object(external__angular_["isDefined"])(html) && shouldCompileGetter(scope)) {
                        $timeout(function () {
                            element.append(tryToCompile(html));
                        });
                    } else {
                        element.html(html || '');
                    }
                }
                /* TODO: Not completely pleased with this solution. If it is marked for compile, then this should not be necessary but
                 * the rcAlert currently does not require the developer to specify. */
                function tryToCompile(html) {
                    try {
                        return $compile(html)(scope);
                    } catch (err) {
                        return html;
                    }
                }
            };
        }
    };
}
/* harmony default export */ var bind_html_directive = (rcBindHtmlUnsafeDirective);
// CONCATENATED MODULE: ./src/bindHtml/bind-html.directive.compile.ts
rcBindHtmlUnsafeCompileDirective.$inject = ['$compile', 'Usage'];
function rcBindHtmlUnsafeCompileDirective($compile, Usage) {
    'ngInject';

    return {
        restrict: 'A',
        scope: {
            html: '=rcBindHtmlUnsafeCompile'
        },
        link: function link(scope, element, attrs) {
            Usage.register('bindhtml');
            var watcher = scope.$watch(function () {
                return scope.html;
            }, function (value) {
                element.html(value);
                $compile(element.contents())(scope);
            });
            scope.$on('$destroy', function () {
                watcher();
            });
        }
    };
}
/* harmony default export */ var bind_html_directive_compile = (rcBindHtmlUnsafeCompileDirective);
// CONCATENATED MODULE: ./src/bindHtml/index.ts




/* harmony default export */ var bindHtml = __webpack_exports__["a"] = (Object(external__angular_["module"])('rc.bindHtml', [usage["b" /* default */]]).directive('rcBindHtmlUnsafe', bind_html_directive).directive('rcBindHtmlUnsafeCompile', bind_html_directive_compile).name);

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removableEventHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);

function removableEventHandler($element, eventName, handler) {
    var target = Object(__WEBPACK_IMPORTED_MODULE_0_angular__["element"])($element);
    target.on(eventName, handler);
    return function () {
        target.off(eventName, handler);
    };
}

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(81);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(7).f;
var has = __webpack_require__(10);
var TAG = __webpack_require__(2)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "angular"
var external__angular_ = __webpack_require__(0);
var external__angular__default = /*#__PURE__*/__webpack_require__.n(external__angular_);

// EXTERNAL MODULE: ./src/usage/index.ts + 3 modules
var usage = __webpack_require__(1);

// EXTERNAL MODULE: ./src/overlay/index.ts + 2 modules
var overlay = __webpack_require__(50);

// EXTERNAL MODULE: ./src/modal/modal-v1/modal.html
var modal_v1_modal = __webpack_require__(155);
var modal_default = /*#__PURE__*/__webpack_require__.n(modal_v1_modal);

// CONCATENATED MODULE: ./src/modal/modal-v1/modal.directive.ts
rcModalWindowDirective.$inject = ['$window', '$timeout', '$rootScope', '$location', 'Usage', '$rcModalStack', 'rcFeatureTests'];

function rcModalWindowDirective($window, $timeout, $rootScope, $location, Usage, $rcModalStack, rcFeatureTests) {
    'ngInject';

    function postLink(scope, $element, attrs) {
        Usage.register('modal');
        scope.windowClass = attrs.windowClass || '';
        scope.title = attrs.title || '';
        scope.includeCancel = (attrs.includeCancel || 'true') === 'true';
        scope.cancelModal = function () {
            var topModal = $rcModalStack.getTop();
            if (topModal) {
                $rcModalStack.dismiss(topModal.key, 'cancelled');
            }
        };
        scope.$$modalElement = $element.find('modal-container');
        // Close the modal when navigation occurs
        scope.$on('$locationChangeStart', function ($event) {
            // Do not remove a scope mid-$digest!
            $timeout(function () {
                return scope.cancelModal();
            });
        });
        scope.$$modalElement.on('mousewheel', function (event) {
            event.stopPropagation();
            return false;
        });
    }
    return {
        restrict: 'EA',
        scope: {
            index: '@',
            title: '@rcModalTitle'
        },
        transclude: true,
        template: modal_default.a,
        link: postLink
    };
}
// CONCATENATED MODULE: ./src/modal/modal-v1/modal.provider.ts

function $rcModalProvider() {
    $rcModalService.$inject = ['$injector', '$rootScope', '$q', '$http', '$templateCache', '$controller', '$rcModalStack'];

    var options = this.options = {};
    this.$get = $rcModalService;
    return this;
    function $rcModalService($injector, $rootScope, $q, $http, $templateCache, $controller, $rcModalStack) {
        'ngInject';

        var $rcModal = {
            open: function open(modalOptions) {
                var modalResultDeferred = $q.defer();
                var modalOpenedDeferred = $q.defer();
                // prepare an instance of a modal to be injected into controllers and returned to a caller
                var modalInstance = {
                    result: modalResultDeferred.promise,
                    opened: modalOpenedDeferred.promise,
                    close: function close(result) {
                        $rcModalStack.close(modalInstance, result);
                    },
                    dismiss: function dismiss(reason) {
                        $rcModalStack.dismiss(modalInstance, reason);
                    }
                };
                // merge and clean up options
                modalOptions = Object(external__angular_["extend"])({}, options, modalOptions);
                modalOptions.resolve = modalOptions.resolve || {};
                // verify options
                if (!modalOptions.template && !modalOptions.templateUrl) {
                    throw new Error('One of template or templateUrl options is required.');
                }
                var templateAndResolvePromise = $q.all([getTemplatePromise(modalOptions)].concat(getResolvePromises(modalOptions.resolve)));
                templateAndResolvePromise.then(function (tplAndVars) {
                    var modalScope = (modalOptions.scope || $rootScope).$new();
                    modalScope.$close = modalInstance.close;
                    modalScope.$dismiss = modalInstance.dismiss;
                    var ctrlLocals = {};
                    var resolveIter = 1;
                    // controllers
                    if (modalOptions.controller) {
                        ctrlLocals.$scope = modalScope;
                        ctrlLocals.$modalInstance = modalInstance;
                        Object(external__angular_["forEach"])(modalOptions.resolve, function (value, key) {
                            ctrlLocals[key] = tplAndVars[resolveIter++];
                        });
                        var ctrlInstance = $controller(modalOptions.controller, ctrlLocals);
                        if (modalOptions.controllerAs) {
                            modalScope[modalOptions.controllerAs] = ctrlInstance;
                        }
                    }
                    $rcModalStack.open(modalInstance, {
                        scope: modalScope,
                        deferred: modalResultDeferred,
                        content: tplAndVars[0],
                        windowClass: modalOptions.windowClass,
                        title: modalOptions.title,
                        includeCancel: modalOptions.includeCancel
                    });
                }).catch(function (reason) {
                    modalResultDeferred.reject(reason);
                });
                templateAndResolvePromise.then(function () {
                    modalOpenedDeferred.resolve(true);
                }).catch(function () {
                    modalOpenedDeferred.reject(false);
                });
                modalInstance.result.catch(external__angular_["noop"]);
                modalInstance.opened.catch(external__angular_["noop"]);
                return modalInstance;
            }
        };
        return $rcModal;
        function getTemplatePromise(modalOptions) {
            return modalOptions.template ? $q.when(modalOptions.template) : $http.get(modalOptions.templateUrl, { cache: $templateCache }).then(function (result) {
                return result.data;
            });
        }
        function getResolvePromises(resolves) {
            var promisesArr = [];
            Object(external__angular_["forEach"])(resolves, function (value, key) {
                if (Object(external__angular_["isFunction"])(value) || Object(external__angular_["isArray"])(value)) {
                    promisesArr.push($q.when($injector.invoke(value)));
                }
            });
            return promisesArr;
        }
    }
}
// CONCATENATED MODULE: ./src/modal/modal-v1/modal.service.stack.ts
$rcModalStackService.$inject = ['$document', '$compile', '$rootScope', '$$rcStackedMap'];

function $rcModalStackService($document, $compile, $rootScope, $$rcStackedMap) {
    'ngInject';

    var OPENED_MODAL_CLASS = 'rc-modal-open';
    var backdropDomEl, backdropScope;
    var openedWindows = $$rcStackedMap.createNew();
    var $rcModalStack = this;
    function backdropIndex() {
        var topBackdropIndex = -1;
        var opened = openedWindows.keys();
        for (var i = 0; i < opened.length; i++) {
            topBackdropIndex = i;
        }
        return topBackdropIndex;
    }
    $rootScope.$watch(backdropIndex, function (newBackdropIndex) {
        if (backdropScope) {
            backdropScope.index = newBackdropIndex;
        }
    });
    function removeModalWindow(modalInstance) {
        var body = $document.find('body').eq(0);
        var modalWindow = openedWindows.get(modalInstance).value;
        // clean up the stack
        openedWindows.remove(modalInstance);
        // remove window DOM element
        modalWindow.modalDomEl.remove();
        modalWindow.modalScope.$destroy();
        checkRemoveBackdrop();
        body.toggleClass(OPENED_MODAL_CLASS, openedWindows.length() > 0);
    }
    function checkRemoveBackdrop() {
        // remove backdrop if no longer needed
        if (backdropDomEl && backdropIndex() === -1) {
            backdropScope.$destroy();
            backdropDomEl.remove();
        }
    }
    function moveBackdropBehind(modalInstance) {
        // move top-most modal over backdrop
        if (modalInstance && backdropDomEl) {
            backdropDomEl.after(modalInstance.value.modalDomEl);
        }
    }
    $rcModalStack.open = function (modalInstance, modal) {
        openedWindows.add(modalInstance, {
            deferred: modal.deferred,
            modalScope: modal.scope
        });
        var body = $document.find('body').eq(0),
            currBackdropIndex = backdropIndex();
        if (currBackdropIndex >= 0 && !backdropDomEl) {
            backdropScope = $rootScope.$new(true);
            backdropScope.index = currBackdropIndex;
            // TODO: Change to use rc-overlay when it can be more easily overriden on the fly
            backdropDomEl = Object(external__angular_["element"])('<modal-overlay></modal-overlay>');
        }
        var angularDomEl = Object(external__angular_["element"])('<rc-modal-window></rc-modal-window>');
        angularDomEl.attr('window-class', modal.windowClass);
        angularDomEl.attr('index', openedWindows.length() - 1);
        angularDomEl.attr('rc-modal-title', modal.title);
        angularDomEl.attr('include-cancel', modal.includeCancel);
        angularDomEl.html(modal.content);
        var modalDomEl = $compile(angularDomEl)(modal.scope);
        openedWindows.top().value.modalDomEl = modalDomEl;
        body.append(backdropDomEl);
        body.append(modalDomEl);
        body.addClass(OPENED_MODAL_CLASS);
    };
    $rcModalStack.close = function (modalInstance, result) {
        var modalWindow = openedWindows.get(modalInstance).value;
        if (modalWindow) {
            modalWindow.deferred.resolve(result);
            removeModalWindow(modalInstance);
        }
        moveBackdropBehind(openedWindows.top());
    };
    $rcModalStack.dismiss = function (modalInstance, reason) {
        var modalWindow = openedWindows.get(modalInstance).value;
        if (modalWindow) {
            modalWindow.deferred.reject(reason);
            removeModalWindow(modalInstance);
        }
        moveBackdropBehind(openedWindows.top());
    };
    $rcModalStack.dismissAll = function (reason) {
        var topModal = this.getTop();
        while (topModal) {
            this.dismiss(topModal.key, reason);
            topModal = this.getTop();
        }
    };
    $rcModalStack.getTop = function () {
        return openedWindows.top();
    };
}
// CONCATENATED MODULE: ./src/modal/modal-v1/modal.service.stacked-map.ts
/**
 * A helper, internal data structure that acts as a map but also allows getting / removing
 * elements in the LIFO order
 */
function $$rcStackedMapService() {
    var service = this;
    service.createNew = function () {
        var stack = [];
        return {
            add: function add(key, value) {
                stack.push({
                    key: key,
                    value: value
                });
            },
            get: function get(key) {
                for (var i = 0; i < stack.length; i++) {
                    if (key === stack[i].key) {
                        return stack[i];
                    }
                }
            },
            keys: function keys() {
                var keys = [];
                for (var i = 0; i < stack.length; i++) {
                    keys.push(stack[i].key);
                }
                return keys;
            },
            top: function top() {
                return stack[stack.length - 1];
            },
            remove: function remove(key) {
                var idx = -1;
                for (var i = 0; i < stack.length; i++) {
                    if (key === stack[i].key) {
                        idx = i;
                        break;
                    }
                }
                return stack.splice(idx, 1)[0];
            },
            removeTop: function removeTop() {
                return stack.splice(stack.length - 1, 1)[0];
            },
            length: function length() {
                return stack.length;
            }
        };
    };
}
// CONCATENATED MODULE: ./src/modal/modal-v1/index.ts







/* harmony default export */ var modal_v1 = (Object(external__angular_["module"])('rc.modal.v1', [usage["b" /* default */], overlay["a" /* default */]]).directive('rcModalWindow', rcModalWindowDirective).provider('$rcModal', $rcModalProvider).service('$rcModalStack', $rcModalStackService).service('$$rcStackedMap', $$rcStackedMapService).name);
// Public API

// EXTERNAL MODULE: ./src/modal/modal-v2/modal.html
var modal_v2_modal = __webpack_require__(156);
var modal_v2_modal_default = /*#__PURE__*/__webpack_require__.n(modal_v2_modal);

// CONCATENATED MODULE: ./src/modal/modal-v2/modal.component.ts
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var ModalController = function () {
    ModalController.$inject = ['$document', '$attrs', '$transclude'];

    function ModalController($document, $attrs, $transclude) {
        'ngInject';

        _classCallCheck(this, ModalController);

        this.$attrs = $attrs;
        this.$transclude = $transclude;
        this.openClass = 'rc-modal-open';
        this.$body = $document.find('body');
    }

    _createClass(ModalController, [{
        key: '$onInit',
        value: function $onInit() {
            this.showCancel = !(this.includeCancel === 'false');
            this.hasFooter = this.$transclude.isSlotFilled('footer');
            this.$initUserClasses();
        }
    }, {
        key: '$initUserClasses',
        value: function $initUserClasses() {
            this.userClasses = [];
            if (this.$attrs.class) {
                this.userClasses = this.$attrs.class.split(' ');
            }
            if (this.hasFooter) {
                this.userClasses.push('has-footer');
            }
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(_ref) {
            var toggle = _ref.toggle;
            var toggled = toggle.currentValue;

            if (toggled) {
                this.$body.addClass(this.openClass);
            } else {
                this.$body.removeClass(this.openClass);
            }
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.close();
        }
    }, {
        key: 'close',
        value: function close() {
            this.toggle = false;
            this.$body.removeClass(this.openClass);
            if (this.onClose) {
                this.onClose();
            }
        }
    }]);

    return ModalController;
}();
var ModalComponent = {
    bindings: {
        toggle: '<',
        includeCancel: '@',
        heading: '@',
        onClose: '&?'
    },
    transclude: {
        header: '?rcModalHeader',
        footer: '?rcModalFooter'
    },
    template: modal_v2_modal_default.a,
    controller: ModalController
};

/* harmony default export */ var modal_component = (ModalController);
// CONCATENATED MODULE: ./src/modal/modal-v2/index.ts


/* harmony default export */ var modal_v2 = (Object(external__angular_["module"])('rc.modal.v2', []).component('rcModal', ModalComponent).name);
// EXTERNAL MODULE: ./src/utils/utils.events.ts
var utils_events = __webpack_require__(26);

// CONCATENATED MODULE: ./src/modal/tabkey-isolation.directive.ts
var tabkey_isolation_directive__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function tabkey_isolation_directive__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var TABBABLE = ['a[href]', 'area[href]', 'input:not([disabled])', 'button:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'iframe', 'object', 'embed', '*[tabindex]:not([tabindex^="-"])', '*[contenteditable=true]'].join(',');
var tabkey_isolation_directive_TabIsolationController = function () {
    TabIsolationController.$inject = ['$element', '$window'];

    function TabIsolationController($element, $window) {
        'ngInject';

        tabkey_isolation_directive__classCallCheck(this, TabIsolationController);

        this.$element = $element;
        this.$window = $window;
    }

    tabkey_isolation_directive__createClass(TabIsolationController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this._eventRemover = Object(utils_events["a" /* removableEventHandler */])(this.$element, 'keydown', function (event) {
                return _this._processKeyUp(event);
            });
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this._eventRemover();
        }
    }, {
        key: '_processKeyUp',
        value: function _processKeyUp(event) {
            event.key === 'Tab' && this._processTabKey(event);
        }
    }, {
        key: '_processTabKey',
        value: function _processTabKey(event) {
            var tabbable = [].slice.call(this.$element[0].querySelectorAll(TABBABLE));
            if (event.target === tabbable[0] && event.shiftKey) {
                stopEvent(event);
                tabbable[tabbable.length - 1].focus();
            } else if (event.target === tabbable[tabbable.length - 1]) {
                stopEvent(event);
                tabbable[0].focus();
            }
        }
    }]);

    return TabIsolationController;
}();
function stopEvent(event) {
    event.stopImmediatePropagation();
    event.stopPropagation();
    event.preventDefault();
}
function TabIsolationDirective() {
    return {
        restrict: 'A',
        controller: tabkey_isolation_directive_TabIsolationController
    };
}
// CONCATENATED MODULE: ./src/modal/index.ts




/* harmony default export */ var src_modal = __webpack_exports__["a"] = (Object(external__angular_["module"])('rc.modal', [modal_v1, modal_v2]).directive('tabIsolation', TabIsolationDirective).name);
// Public API


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(51);
var test = {};
test[__webpack_require__(2)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(14)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 33 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(8);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(80)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(39)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 37 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(40);
var $export = __webpack_require__(22);
var redefine = __webpack_require__(14);
var hide = __webpack_require__(15);
var has = __webpack_require__(10);
var Iterators = __webpack_require__(23);
var $iterCreate = __webpack_require__(82);
var setToStringTag = __webpack_require__(29);
var getPrototypeOf = __webpack_require__(86);
var ITERATOR = __webpack_require__(2)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(16);
var dPs = __webpack_require__(83);
var enumBugKeys = __webpack_require__(43);
var IE_PROTO = __webpack_require__(42)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(53)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(85).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(34)('keys');
var uid = __webpack_require__(21);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(87);
var getKeys = __webpack_require__(24);
var redefine = __webpack_require__(14);
var global = __webpack_require__(5);
var hide = __webpack_require__(15);
var Iterators = __webpack_require__(23);
var wks = __webpack_require__(2);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(21)('meta');
var isObject = __webpack_require__(8);
var has = __webpack_require__(10);
var setDesc = __webpack_require__(7).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(18)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(2);


/***/ }),
/* 48 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "angular"
var external__angular_ = __webpack_require__(0);
var external__angular__default = /*#__PURE__*/__webpack_require__.n(external__angular_);

// EXTERNAL MODULE: ./node_modules/angular-messages/index.js
var angular_messages = __webpack_require__(130);
var angular_messages_default = /*#__PURE__*/__webpack_require__.n(angular_messages);

// EXTERNAL MODULE: ./src/bindHtml/index.ts + 2 modules
var bindHtml = __webpack_require__(25);

// EXTERNAL MODULE: ./src/inputFieldWrapper/index.ts + 2 modules
var inputFieldWrapper = __webpack_require__(71);

// EXTERNAL MODULE: ./src/usage/index.ts + 3 modules
var usage = __webpack_require__(1);

// EXTERNAL MODULE: ./src/i18n/index.ts + 2 modules
var i18n = __webpack_require__(13);

// EXTERNAL MODULE: ./node_modules/ricola3-i18n-translations/lib/index.js
var lib = __webpack_require__(4);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./src/validation/validation.provider.ts
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/** @internal */
var validation_provider_ValidationErrorMessagesService = function () {
    function ValidationErrorMessagesService(data) {
        _classCallCheck(this, ValidationErrorMessagesService);

        this.data = data;
    }

    _createClass(ValidationErrorMessagesService, [{
        key: 'getErrorMessages',
        value: function getErrorMessages() {
            var dataAsArray = [];
            Object(external__angular_["forEach"])(this.data, function (value, key) {
                dataAsArray.push({ label: key, message: value });
            });
            return Object(external__angular_["copy"])(dataAsArray);
        }
    }, {
        key: 'getErrorMessage',
        value: function getErrorMessage(type) {
            var message = Object(external__angular_["copy"])(this.data[type]);
            if (message) {
                return {
                    label: type,
                    message: message
                };
            }
        }
    }]);

    return ValidationErrorMessagesService;
}();
var MESSAGES = {};
/**
 * Exposed as an AngularJS provider via `rcValidationErrorMessagesProvider`
 */

var validation_provider_ValidationErrorMessagesProvider = function () {
    function ValidationErrorMessagesProvider() {
        _classCallCheck(this, ValidationErrorMessagesProvider);
    }

    _createClass(ValidationErrorMessagesProvider, [{
        key: 'addErrorMessage',

        /**
         * Registers a custom validator with Ricola's validation pipeline.
         * @param label The name of your validator.
         * @param message A custom error message, if you need to override the standard.
         */
        value: function addErrorMessage(label) {
            var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : lib_default.a.get('rc.validation.invalid-generic');

            if (Object(external__angular_["isString"])(message)) {
                // Warn about passing non-translated data, and we will fix it ourselves.
                console.warn('validation error messages should be internationalized', message); /* eslint no-console: 0, angular/log: 0*/
                MESSAGES[label] = {
                    'en-US': message,
                    'es-MX': message
                };
            } else {
                MESSAGES[label] = message;
            }
        }
        /** @internal */

    }, {
        key: '$get',
        value: function $get() {
            return new validation_provider_ValidationErrorMessagesService(MESSAGES);
        }
    }]);

    return ValidationErrorMessagesProvider;
}();

/* harmony default export */ var validation_provider = (validation_provider_ValidationErrorMessagesProvider);
// CONCATENATED MODULE: ./src/validation/validation.configs.ts
rcDefaultValidatorsConfig.$inject = ['rcValidationErrorMessagesProvider'];
rcRequiredConfig.$inject = ['rcValidationErrorMessagesProvider'];
rcValidateCounterConfig.$inject = ['rcValidationErrorMessagesProvider'];


function rcValidateCounterConfig(rcValidationErrorMessagesProvider) {
    'ngInject';

    rcValidationErrorMessagesProvider.addErrorMessage('rcCharacterCounter', lib_default.a.get('rc.validation.invalid-length'));
}
function rcRequiredConfig(rcValidationErrorMessagesProvider) {
    'ngInject';

    rcValidationErrorMessagesProvider.addErrorMessage('rcRequired', lib_default.a.get('rc.validation.invalid-required'));
}
function rcDefaultValidatorsConfig(rcValidationErrorMessagesProvider) {
    'ngInject';
    // Required is special

    rcValidationErrorMessagesProvider.addErrorMessage('required', lib_default.a.get('rc.validation.invalid-required'));
    var builtinValidators = ['min', 'max', 'number', 'minlength', 'maxlength', 'pattern', 'url', 'week', 'month', 'time', 'datetimelocal'];
    Object(external__angular_["forEach"])(builtinValidators, function (validator) {
        rcValidationErrorMessagesProvider.addErrorMessage(validator);
    });
}
// CONCATENATED MODULE: ./src/validation/validation.validators.ts
var regexTest = function regexTest(regex) {
    return function (input) {
        return regex.test(input);
    };
};
// To pass this validator, value must:
// 1. Be an integer
// 2. Be greater than zero
// 3. Have fewer than (or equal to) digits than the "length" param
var simpleLengthTest = function simpleLengthTest(length) {
    return function (input) {
        var asInteger = parseFloat(input);
        if (asInteger % 1 === 0 && asInteger > 0) {
            return input.length <= length;
        }
        return false;
    };
};
function prependZeros(val, length) {
    var spaceleft = length - val.length;
    if (spaceleft > 0) {
        val = new Array(spaceleft + 1).join('0') + val;
    }
    return val;
}
function numberGreaterThanAndLength(min, length) {
    return function (val) {
        val = prependZeros(val, length);
        return val > min && val.length === length;
    };
}
var ztsTest = function ztsTest(input) {
    var numberGreaterThan0Length2 = numberGreaterThanAndLength(0, 2);
    var numberGreaterThan0Length3 = numberGreaterThanAndLength(0, 3);
    var numberGreaterThanMinus1Length2 = numberGreaterThanAndLength(-1, 2);
    var pieces = input.split(/[ -]/);
    // [0] length 2, > 0 | [1] length 3, > 0 | [2] length 2, >= 0
    return numberGreaterThan0Length2(pieces[0]) && numberGreaterThan0Length3(pieces[1]) && numberGreaterThanMinus1Length2(pieces[2]);
};
var validation_validators_validators = [
// Regular Expression validators
{ name: 'circ7', test: regexTest(/^[a-z]+\s?[0-9]{3}[a-z]?$/i) }, { name: 'alpha', test: regexTest(/^[A-Z ]+$/i) }, { name: 'carrier', test: regexTest(/^[a-z0-9]{2,4}$/i) }, {
    name: 'circ7List',
    test: regexTest(/^(\w{2,3}\d{3}[,;]{1}\s?)*\w{2,3}\d{3}$/i)
}, {
    name: 'currency',
    test: regexTest(/^-?\$?(?:0|[1-9]\d{0,2}(?:,?\d{3})*)(?:\.\d+)?$/)
}, {
    name: 'date',
    test: regexTest(/^(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])$/)
}, {
    name: 'dateTime',
    test: regexTest(/^((?:0[1-9]|1[012])\/?(?:0[1-9]|[12][0-9]|3[01]))[ ]?((?:[0-1][0-9]|2[0-3]):?[0-5][0-9])$/)
}, {
    name: 'dateWithYear',
    test: regexTest(/^(0[1-9]|1[012])\/?(0[1-9]|[12][0-9]|3[01])\/?([0-9]{4})$/)
}, {
    name: 'email',
    test: regexTest(/^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i)
}, { name: 'employeeId', test: regexTest(/^\d{7}$/) }, { name: 'equipmentId', test: regexTest(/^[a-z]{1,4}[\s]?\d{1,6}$/i) }, {
    name: 'equipmentIdList',
    test: regexTest(/^([a-z]{1,4}[\s]?\d{1,6}[,;\n]{1}\s?)*[a-z]{1,4}[\s]?\d{1,6}$/i)
}, { name: 'integer', test: regexTest(/^(0*\d+|-?[1-9]+\d*)$/) }, { name: 'lata', test: regexTest(/^[a-z]{1,2}\d{5,6}$/i) }, { name: 'numeric', test: regexTest(/(^0$)|(^-?[1-9]\d*(\.\d+)?$)/) }, {
    name: 'phone',
    test: regexTest(/^(\(?[0-9]{1,3}\)?)?[- ]?([0-9]{3})?[- ]?([0-9]{3})[- ]?([0-9]{4})(?:[ ]?x([0-9]*))?$/i)
}, { name: 'time', test: regexTest(/^([01][0-9]|2[0-3]):[0-5][0-9]$/) }, { name: 'timeWithSeconds', test: regexTest(/^\d{2}:\d{2}:\d{2}$/) }, { name: 'trainId', test: regexTest(/^\d?[a-z]{1}\w{1,6} \d{2}$/i) }, {
    name: 'trainIdList',
    test: regexTest(/^(\d?[a-z]{1}\w{1,6} \d{2}[,;]{1}\s?)*\d?[a-z]{1}\w{1,6} \d{2}$/i)
}, { name: 'trainSymbol', test: regexTest(/^\d?\w{2,7}$/i) }, { name: 'userId', test: regexTest(/^\w{4}\d{3}$/i) }, { name: 'zipcode', test: regexTest(/^\d{5}(-\d{4})?$/) }, { name: 'yardTrack', test: regexTest(/^\d{1,2}[. \/]\d{1,3}$/) },
// Simple Length validators
{ name: 'yard', test: simpleLengthTest(2) }, { name: 'track', test: simpleLengthTest(3) }, { name: 'seq', test: simpleLengthTest(4) },
// Special validators
{ name: 'zts', test: ztsTest }];
/* harmony default export */ var validation_validators = (validation_validators_validators);
// CONCATENATED MODULE: ./src/validation/validation.service.validators.ts
var validation_service_validators__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function validation_service_validators__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


/**
 * Exposed as an AngularJS service via `$rcValidators`
 */

var validation_service_validators_ValidatorsService = function () {
    function ValidatorsService() {
        validation_service_validators__classCallCheck(this, ValidatorsService);
    }

    validation_service_validators__createClass(ValidatorsService, [{
        key: 'passes',

        /**
         * A convenience method to test a string against a built-in Ricola validator.
         * @param validator the validator to test against. Example: 'trainId'
         * @param input The input to test against. Example: 'MHOKC'
         */
        value: function passes(validator, input) {
            var val = validation_validators.filter(function (i) {
                return i.name === validator;
            });
            if (val.length !== 1) {
                return null;
            }
            return val[0].test(input);
        }
    }]);

    return ValidatorsService;
}();

/* harmony default export */ var validation_service_validators = (validation_service_validators_ValidatorsService);
// CONCATENATED MODULE: ./src/validation/blur-after-click.service.ts
var blur_after_click_service__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function blur_after_click_service__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BlurAfterClick = function () {
    BlurAfterClick.$inject = ['$document', '$timeout'];

    function BlurAfterClick($document, $timeout) {
        'ngInject';

        blur_after_click_service__classCallCheck(this, BlurAfterClick);

        this.$document = $document;
        this.$timeout = $timeout;
        this.mousedownTimer = false;
        this.triggeringElementsQueue = [];
        this.$init();
    }

    blur_after_click_service__createClass(BlurAfterClick, [{
        key: '$init',
        value: function $init() {
            var _this = this;

            this.$document.on('mousedown', function () {
                _this.mousedownTimer = true;
                setTimeout(function () {
                    _this.mousedownTimer = false;
                });
            });
            this.$document.on('mouseup', function () {
                _this.$flushEventsQueue();
            });
        }
    }, {
        key: '$flushEventsQueue',
        value: function $flushEventsQueue() {
            var _this2 = this;

            this.triggeringElementsQueue.forEach(function ($element) {
                _this2.$triggerEvent($element);
            });
            this.triggeringElementsQueue = [];
        }
    }, {
        key: '$triggerEvent',
        value: function $triggerEvent($element) {
            $element.triggerHandler('blurAfterClick');
        }
    }, {
        key: 'registerBlurAfterClick',
        value: function registerBlurAfterClick($element) {
            var _this3 = this;

            $element.on('blur', function () {
                if (_this3.mousedownTimer) {
                    _this3.triggeringElementsQueue.push($element);
                } else {
                    _this3.$triggerEvent($element);
                }
            });
        }
    }]);

    return BlurAfterClick;
}();

/* harmony default export */ var blur_after_click_service = (BlurAfterClick);
// CONCATENATED MODULE: ./src/validation/validation.utils.ts

function validation_utils_rcValidationGetLabelFor($element) {
    var elementId = $element.name || $element.id;
    var parentElement = $element.form ? $element.form : document;
    var label = parentElement.querySelector('label[for="' + elementId + '"]');
    if (!label) {
        var ancestor = void 0;
        for (ancestor = Object(external__angular_["element"])($element).parent(); ancestor[0] && !(ancestor[0].tagName === 'LABEL' || ancestor[0].tagName === 'BODY');) {
            ancestor = ancestor.parent();
        }
        if (ancestor[0] && ancestor[0].tagName === 'LABEL') {
            label = ancestor[0];
        }
    }
    return label;
}
// EXTERNAL MODULE: ./src/validation/templates/validation.rc-form-errors.html
var validation_rc_form_errors = __webpack_require__(132);
var validation_rc_form_errors_default = /*#__PURE__*/__webpack_require__.n(validation_rc_form_errors);

// CONCATENATED MODULE: ./src/validation/validation-form-errors.component.ts
var validation_form_errors_component__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function validation_form_errors_component__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var validation_form_errors_component_FormErrorsController = function () {
    FormErrorsController.$inject = ['$scope', '$element', '$rootScope', '$rcValidationFieldErrors'];

    function FormErrorsController($scope, $element, $rootScope, $rcValidationFieldErrors) {
        'ngInject';

        validation_form_errors_component__classCallCheck(this, FormErrorsController);

        this.$scope = $scope;
        this.$element = $element;
        this.$rootScope = $rootScope;
        this.$rcValidationFieldErrors = $rcValidationFieldErrors;
        this.modelControllersWithErrors = new Set();
        this.showErrors = false;
    }

    validation_form_errors_component__createClass(FormErrorsController, [{
        key: '$hasErrorsToShow',
        value: function $hasErrorsToShow() {
            return this.modelControllersWithErrors.size > 0;
        }
    }, {
        key: '$registerErrorTogglingCallback',
        value: function $registerErrorTogglingCallback(modelController) {
            var _this = this;

            this.$rcValidationFieldErrors.onErrorToggle(modelController, function (showError) {
                if (showError) {
                    _this.modelControllersWithErrors.add(modelController);
                } else {
                    _this.modelControllersWithErrors.delete(modelController);
                }
            });
        }
    }, {
        key: '$postLink',
        value: function $postLink() {
            var _this2 = this;

            this.errorContainer = Object(external__angular_["element"])(this.$element[0].querySelector('.rc-form-errors-container'));
            this.$rcValidationFieldErrors.registerFormController(this.form, {
                onModelRegistration: function onModelRegistration(_ref) {
                    var modelController = _ref.modelController,
                        $compiledElement = _ref.$compiledElement;

                    _this2.errorContainer.append($compiledElement);
                    _this2.$registerErrorTogglingCallback(modelController);
                },
                onModelDestroy: function onModelDestroy(_ref2) {
                    var modelController = _ref2.modelController,
                        $compiledElement = _ref2.$compiledElement;

                    _this2.modelControllersWithErrors.delete(modelController);
                    $compiledElement.remove();
                }
            });
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this3 = this;

            this.headerTranslations = lib_default.a.get('rc.validation.invalid-header');
            this.$scope.$watch(function () {
                return _this3.form.$invalid && _this3.form.$submitted && _this3.$hasErrorsToShow();
            }, function (showErrors) {
                _this3.showErrors = showErrors;
                if (_this3.showErrors) {
                    _this3.$rootScope.$broadcast('$rcFormErrorsDisplayed', _this3.form);
                }
            });
        }
    }]);

    return FormErrorsController;
}();
var FormErrorsComponent = {
    require: {
        form: '^form'
    },
    template: validation_rc_form_errors_default.a,
    controller: validation_form_errors_component_FormErrorsController,
    controllerAs: 'rcFormErrors'
};
/* harmony default export */ var validation_form_errors_component = (FormErrorsComponent);
// EXTERNAL MODULE: ./src/validation/templates/input-field-errors.html
var input_field_errors = __webpack_require__(133);
var input_field_errors_default = /*#__PURE__*/__webpack_require__.n(input_field_errors);

// CONCATENATED MODULE: ./src/validation/input-field-errors.component.ts
var input_field_errors_component__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function input_field_errors_component__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var input_field_errors_component_InputFieldErrorsController = function () {
    InputFieldErrorsController.$inject = ['$log', 'rcValidationErrorMessages', '$rcValidationFieldErrors'];

    function InputFieldErrorsController($log, rcValidationErrorMessages, $rcValidationFieldErrors) {
        'ngInject';

        input_field_errors_component__classCallCheck(this, InputFieldErrorsController);

        this.$log = $log;
        this.rcValidationErrorMessages = rcValidationErrorMessages;
        this.$rcValidationFieldErrors = $rcValidationFieldErrors;
    }

    input_field_errors_component__createClass(InputFieldErrorsController, [{
        key: '$onInit',
        value: function $onInit() {
            if (Object(external__angular_["isUndefined"])(this.ngModelController) && Object(external__angular_["isUndefined"])(this.ngModelName)) {
                return;
            }
            var formController = this.form;
            if (Object(external__angular_["isUndefined"])(this.ngModelController)) {
                this.ngModelController = formController[this.ngModelName];
            }
            var modelController = this.ngModelController;
            var customErrorMessages = this.customErrorMessages;

            this.fieldLabel = this.fieldLabel || 'This field';
            this.clickable = Object(external__angular_["isDefined"])(this.onClick);
            /* Add error messages for configured validation */
            var validators = this.makeValidators(Object.keys(modelController.$validators));
            var asyncValidators = this.makeValidators(Object.keys(modelController.$asyncValidators));
            this.errorMessages = validators.concat(asyncValidators);
            // Parsing validators don't get added to the $validators pipeline
            // If there is a $parser set on this, it's possible there is a special validator set
            // See http://www.yearofmoo.com/2014/09/taming-forms-in-angularjs-1-3.html#html5-validators-and-parse-errors
            // It'd be nice to only register the specific validators that have been added, rather than all of them.
            if (modelController.$parsers.length > 0) {
                var parsers = this.makeValidators(['number', 'date', 'time', 'datetimelocal', 'week', 'month']);
                this.errorMessages = this.errorMessages.concat(parsers);
            }
            this.$configureVisibility();
        }
    }, {
        key: '$configureVisibility',
        value: function $configureVisibility() {
            var _this = this;

            this.$rcValidationFieldErrors.onErrorToggle(this.ngModelController, function (showErrors) {
                _this.showErrors = showErrors;
            });
        }
    }, {
        key: 'i18nify',
        value: function i18nify(message) {
            if (Object(external__angular_["isString"])(message)) {
                this.$log.warn('validation error message ' + message + ' is not internationalized');
                return {
                    'en-US': message,
                    'es-MX': message
                };
            }
            return message;
        }
    }, {
        key: 'htmlifyErrorMessage',
        value: function htmlifyErrorMessage(input) {
            return input.replace('{{fieldLabel}}', '<span class="rc-error-text-label">{{fieldLabel}}</span>');
        }
    }, {
        key: 'determineErrorMessage',
        value: function determineErrorMessage(value, customErrorMessages) {
            // custom-error-message="{ translations }"
            if (Object(external__angular_["isString"])(customErrorMessages)) {
                this.$log.warn('Deprecated usage of custom-error-messages attribute for string "' + customErrorMessages + '". ' + 'Future versions of Ricola will not support this kind of functionality. ' + 'When providing custom error messages, an error type _MUST_ be defined, preferrably with i18n translations. ' + 'Please refer to current documentation for implementation details.');
                return this.i18nify(customErrorMessages);
                // custom-error-message="{ errorType: { translations } }"
            } else if (Object(external__angular_["isObject"])(customErrorMessages) && customErrorMessages[value.label]) {
                return this.i18nify(customErrorMessages[value.label]);
            }
            return value.message;
        }
    }, {
        key: 'addValidator',
        value: function addValidator(key) {
            var errorMessages = this.rcValidationErrorMessages.getErrorMessage(key);
            if (errorMessages) {
                var message = this.determineErrorMessage(errorMessages, this.customErrorMessages);
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = Object.keys(message)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var messageKey = _step.value;

                        message[messageKey] = this.htmlifyErrorMessage(message[messageKey]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                delete errorMessages.message;
                errorMessages.messageTranslations = message;
                return errorMessages;
            }
        }
    }, {
        key: 'makeValidators',
        value: function makeValidators(validatorNames) {
            var _this2 = this;

            return validatorNames.map(function (validator) {
                return _this2.addValidator(validator);
            });
        }
    }]);

    return InputFieldErrorsController;
}();
var InputFieldErrorsComponent = {
    require: {
        form: '?^form'
    },
    bindings: {
        ngModelController: '<?',
        ngModelName: '@?',
        customErrorMessages: '<',
        fieldLabel: '@',
        onClick: '&?'
    },
    controllerAs: 'inputFieldErrors',
    controller: input_field_errors_component_InputFieldErrorsController,
    template: input_field_errors_default.a
};
/* harmony default export */ var input_field_errors_component = (InputFieldErrorsComponent);
// CONCATENATED MODULE: ./src/validation/validation-input-field-errors.service.ts
var validation_input_field_errors_service__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function validation_input_field_errors_service__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


/**
 * Exposed as an AngularJS service via `$rcValidationFieldErrors`.
 */

var validation_input_field_errors_service_ValidationFieldErrorsService = function () {
    function ValidationFieldErrorsService() {
        validation_input_field_errors_service__classCallCheck(this, ValidationFieldErrorsService);

        // We use Maps since they allow objects as keys, normal {} objects do not
        this.formControllers = new Map();
        this.modelControllers = new Map();
        this.$pendingModelCallbacks = [];
    }

    validation_input_field_errors_service__createClass(ValidationFieldErrorsService, [{
        key: 'registerFormController',
        value: function registerFormController(formController, callbacks) {
            this.formControllers.set(formController, {
                callbacks: callbacks
            });
        }
        /**
         * A hook into the lifecycle of Ricola's showing/hiding of form errors.
         * @param modelController The form element to hook into
         * @param callback A function which will be triggered. Will be invoked with a `showErrors` flag.
         */

    }, {
        key: 'onErrorToggle',
        value: function onErrorToggle(modelController, callback) {
            if (this.modelControllers.has(modelController)) {
                this.modelControllers.get(modelController).callbacks.push(callback);
            } else {
                this.$pendingModelCallbacks.push({
                    modelController: modelController,
                    callback: callback
                });
            }
        }
        /** @internal */

    }, {
        key: 'registerElement',
        value: function registerElement(formController, modelController, $compiledElement, modelControllerScope) {
            var callbacks = this.$pendingModelCallbacks.filter(function (callback) {
                return callback.modelController === modelController;
            }).map(function (registration) {
                return registration.callback;
            });
            this.$pendingModelCallbacks = this.$pendingModelCallbacks.filter(function (callback) {
                return callback.modelControllers !== modelController;
            });
            this.modelControllers.set(modelController, {
                modelController: modelController,
                formController: formController,
                $compiledElement: $compiledElement,
                callbacks: callbacks
            });
            if (this.formControllers.get(formController)) {
                this.$invokeRegistrationCallback(formController, modelController);
            }
        }
        /**
         * @internal
         * Avoids memory leaks for registered model controllers in the case of ng-if or DOM removal
         */

    }, {
        key: 'unregisterModelController',
        value: function unregisterModelController(modelController) {
            var model = this.modelControllers.get(modelController);
            if (model.formController) {
                var formController = this.formControllers.get(model.formController);
                if (formController && formController.callbacks && formController.callbacks.onModelDestroy) {
                    formController.callbacks.onModelDestroy(model);
                }
            }
            this.modelControllers.delete(modelController);
        }
        /**
         * Shows field errors
         * @param modelController The ng-model to show
         */

    }, {
        key: 'showError',
        value: function showError(modelController) {
            if (this.$isRegistered(modelController)) {
                this.$invokeShowErrorCallbacks(modelController, true);
            }
        }
        /**
         * Hides field errors
         * @param modelController the ng-model to hide
         */

    }, {
        key: 'hideError',
        value: function hideError(modelController) {
            if (this.$isRegistered(modelController)) {
                this.$invokeShowErrorCallbacks(modelController, false);
            }
        }
    }, {
        key: '$isRegistered',
        value: function $isRegistered(modelController) {
            return Object(external__angular_["isDefined"])(this.modelControllers.get(modelController));
        }
    }, {
        key: '$invokeShowErrorCallbacks',
        value: function $invokeShowErrorCallbacks(modelController, showError) {
            var callbacks = this.modelControllers.get(modelController).callbacks;
            callbacks.forEach(function (callback) {
                callback(showError);
            });
        }
    }, {
        key: '$invokeRegistrationCallback',
        value: function $invokeRegistrationCallback(formController, modelController) {
            var formCallbacks = this.formControllers.get(formController).callbacks;
            if (formCallbacks.onModelRegistration) {
                formCallbacks.onModelRegistration(this.modelControllers.get(modelController));
            }
        }
    }]);

    return ValidationFieldErrorsService;
}();

/* harmony default export */ var validation_input_field_errors_service = (validation_input_field_errors_service_ValidationFieldErrorsService);
// CONCATENATED MODULE: ./src/validation/error-register.directive.ts
var error_register_directive__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function error_register_directive__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var error_register_directive_InputFieldErrorsCtrl = function () {
    InputFieldErrorsCtrl.$inject = ['$scope', 'ngModel', 'form', '$el', '$rcValidationFieldErrors', 'BlurAfterClick'];

    function InputFieldErrorsCtrl($scope, ngModel, form, $el, $rcValidationFieldErrors, BlurAfterClick) {
        'ngInject';

        error_register_directive__classCallCheck(this, InputFieldErrorsCtrl);

        this.$scope = $scope;
        this.ngModel = ngModel;
        this.form = form;
        this.$el = $el;
        this.$rcValidationFieldErrors = $rcValidationFieldErrors;
        this.BlurAfterClick = BlurAfterClick;
    }

    error_register_directive__createClass(InputFieldErrorsCtrl, [{
        key: '$setErrorState',
        value: function $setErrorState(value) {
            if (value) {
                this.$rcValidationFieldErrors.showError(this.modelController);
            } else {
                this.$rcValidationFieldErrors.hideError(this.modelController);
            }
        }
    }, {
        key: '$checkErrorState',
        value: function $checkErrorState() {
            // Are there any errors on the field that aren't 'required'?
            var showErrors = void 0;
            if (!this.formController || this.formController.$submitted) {
                showErrors = Object.keys(this.modelController.$error).length > 0;
            } else {
                showErrors = Object.keys(this.modelController.$error).filter(function (i) {
                    return !(i === 'required' || i === 'rcRequired' || i === 'ngRequired');
                }).length > 0;
            }
            this.$setErrorState(showErrors);
        }
    }, {
        key: '$registerAsyncWatch',
        value: function $registerAsyncWatch() {
            var _this = this;

            if (Object.keys(this.modelController.$asyncValidators).length === 0) {
                return;
            }
            if (this.pendingAsyncWatch) {
                return this.pendingAsyncWatch;
            }
            return this.$scope.$watch(function () {
                return _this.modelController.$pending;
            }, function (newVal, oldVal) {
                // When the async operator has finished, run through checks
                if (Object(external__angular_["isUndefined"])(newVal) && Object(external__angular_["isDefined"])(oldVal) && _this.modelController.$dirty) {
                    // If there is a pending $watch, deregister it
                    if (_this.pendingAsyncWatch) {
                        _this.pendingAsyncWatch();
                        _this.pendingAsyncWatch = null;
                    }
                    _this.$checkErrorState();
                }
            });
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            var formController = this.form;
            var modelController = this.ngModel;
            Object(external__angular_["extend"])(this, { formController: formController, modelController: modelController });
            this.BlurAfterClick.registerBlurAfterClick(this.$el);
            this.$scope.$watch(function () {
                return modelController.$valid;
            }, function (isValid) {
                if (isValid) {
                    _this2.$setErrorState(false);
                }
            });
            // TODO Binding to form submit doesn't feel "angular-y", I bet there is a better way
            Object(external__angular_["element"])(this.$el[0].form).on('submit', function () {
                _this2.$setErrorState(modelController.$invalid);
                _this2.$scope.$apply();
            });
            // We grab it this way so we don't have to rely on a $name, see #202
            if (formController) {
                this.$scope.$watch(function () {
                    return formController.$pristine;
                }, function (newVal) {
                    if (newVal) {
                        _this2.$setErrorState(false);
                    }
                });
            }
            this.$scope.$on('$destroy', function () {
                delete _this2.$scope.ngModelController;
                delete _this2.$scope.ngModelName;
            });
            this.pendingAsyncWatch = null;
            // When the asynchronous validators complete their work, check the error state
            // Note: this looks like an interesting alternative to $watch. Let's keep an eye on it!
            // https://github.com/angular/angular.js/issues/10768
            this.$el.on('blurAfterClick', function () {
                _this2.pendingAsyncWatch = _this2.$registerAsyncWatch();
                _this2.$checkErrorState();
                _this2.$scope.$apply();
            });
        }
    }]);

    return InputFieldErrorsCtrl;
}();

/* harmony default export */ var error_register_directive = (['$rcValidationFieldErrors', 'BlurAfterClick', function ($rcValidationFieldErrors, BlurAfterClick) {
    'ngInject';

    return {
        require: {
            ngModel: '?ngModel',
            form: '?^form'
        },
        priority: 2,
        restrict: 'A',
        link: function link($scope, $el, $attrs, ctrls) {
            var form = ctrls.form,
                ngModel = ctrls.ngModel;

            var ctrl = new error_register_directive_InputFieldErrorsCtrl($scope, ngModel, form, $el, $rcValidationFieldErrors, BlurAfterClick);
            ctrl.$onInit();
        }
    };
}]);
// CONCATENATED MODULE: ./src/validation/validation.directive.required.ts

function makeRequiredDirective(directiveName) {
    var requiredClass = 'rc-validate-required';
    /* Have to manually inject here.. */
    return ['Usage', 'rcValidationGetLabelFor', '$log', '$rcInputFieldWrapper', function (Usage, rcValidationGetLabelFor, $log, $rcInputFieldWrapper) {
        'ngInject';

        if (directiveName === 'rcRequired') {
            $log.warn('rc-required is deprecated. Use the normal "required" attribute instead');
        }
        var addRequiredIndicator = function addRequiredIndicator($element, scope) {
            var label = rcValidationGetLabelFor($element[0]);
            if (label) {
                Object(external__angular_["element"])(label).addClass('rc-required-label');
            }
            var sizeAttr = $element.attr('size') || '';
            if (sizeAttr) {
                sizeAttr = ' size="' + sizeAttr + '"';
            }
            /* Need another wrapper here to style per HF spec:  3px "border" to indicate required. */
            // We assume the input field has been wrapped by the rc-input-field-wrapper directive
            $rcInputFieldWrapper.getInputFieldWrapperFor($element).addClass(requiredClass);
        };
        var removeRequiredIndicator = function removeRequiredIndicator($element, scope) {
            var label = rcValidationGetLabelFor($element[0]);
            if (label) {
                Object(external__angular_["element"])(label).removeClass('rc-required-label');
            }
            $rcInputFieldWrapper.getInputFieldWrapperFor($element).removeClass(requiredClass);
        };
        var hasIndicator = function hasIndicator($element) {
            return $rcInputFieldWrapper.getInputFieldWrapperFor($element).hasClass(requiredClass);
        };
        var hasNoIndicator = function hasNoIndicator($element) {
            return !hasIndicator($element);
        };
        return {
            require: 'ngModel',
            restrict: 'A',
            priority: 1,
            scope: true,
            link: function link(scope, element, attrs, ctrl) {
                Usage.register('required');
                var requiredAttr = attrs[directiveName];
                if (requiredAttr) {
                    var validationExpr = scope.$eval(requiredAttr);
                    attrs.$set('validationRequired', requiredAttr === true ? true : validationExpr);
                } else {
                    attrs.$set('validationRequired', true);
                }
                attrs.$observe('validationRequired', function (isRequired) {
                    if (isRequired && hasNoIndicator(element)) {
                        addRequiredIndicator(element, scope);
                    } else if (!isRequired && hasIndicator(element)) {
                        removeRequiredIndicator(element, scope);
                    }
                });
                var validator = function validator(modelValue, viewValue) {
                    if (attrs.validationRequired && ctrl.$isEmpty(viewValue)) {
                        return false;
                    }
                    return true;
                };
                ctrl.$validators[directiveName] = validator;
                scope.$watch(attrs[directiveName], function (value) {
                    if (Object(external__angular_["isDefined"])(value)) {
                        attrs.$set('validationRequired', value);
                    }
                    ctrl.$setValidity(directiveName, validator(ctrl.$modelValue, ctrl.$viewValue));
                });
            }
        };
    }];
}
// CONCATENATED MODULE: ./src/validation/input-field-wrapper.validation.directive.ts
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

RcInputFieldErrorWrapper.$inject = ['$compile', 'rcValidationGetLabelFor', '$log', '$rcInputFieldWrapper', '$rcValidationFieldErrors'];

function RcInputFieldErrorWrapper($compile, rcValidationGetLabelFor, $log, $rcInputFieldWrapper, $rcValidationFieldErrors) {
    'ngInject';

    var getLabelText = function getLabelText(labelEl) {
        if (labelEl) {
            return labelEl.textContent.replace(/\:$/, '');
        }
        return 'This field';
    };
    var resolveLabelText = function resolveLabelText(customErrorLabel, el) {
        if (customErrorLabel) {
            return customErrorLabel;
        }
        return getLabelText(rcValidationGetLabelFor(el));
    };
    var validationPreconditions = function validationPreconditions(modelController, formController, element) {
        // If it's not wrapped, don't apply it
        if ($rcInputFieldWrapper.shouldNotWrapField(element)) {
            return false;
        }
        if (!modelController) {
            $log.warn('Validation requires an "ng-model" attribute', element[0]);
            return false;
        }
        var none = function none(arr) {
            return Object.keys(arr).length === 0;
        };
        // If no validators or parsers are registered, it's unnecessary
        var $validators = modelController.$validators,
            $parsers = modelController.$parsers,
            $asyncValidators = modelController.$asyncValidators;

        if (none($validators) && none($parsers) && none($asyncValidators)) {
            return false;
        }
        return true;
    };
    // We're adding $rcValidationMetadata to the $scope here
    // Why? So we can pass it to the <rc-input-wrapper> directive
    // without requiring the user to pass in a 'name' attribute on this or the form
    var populateFieldErrorScope = function populateFieldErrorScope($scope, modelController, labelText, formController) {
        $scope.$rcValidationMetadata = {
            modelController: modelController,
            labelText: labelText,
            formController: formController
        };
    };
    var makeInputFieldErrors = function makeInputFieldErrors(customErrorMessages) {
        var enableOnClick = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var $inputFieldErrors = Object(external__angular_["element"])('<rc-input-field-errors\n                form-controller="$rcValidationMetadata.formController"\n                ng-model-controller="$rcValidationMetadata.modelController"\n                field-label="{{$rcValidationMetadata.labelText}}">');
        if (customErrorMessages) {
            $inputFieldErrors.attr({
                'custom-error-messages': customErrorMessages
            });
        }
        if (enableOnClick) {
            $inputFieldErrors.attr({
                'on-click': '$rcValidationMetadata.focus()'
            });
        }
        return $inputFieldErrors;
    };
    var link = function link($scope, el, attrs, ctrls) {
        var _ctrls = _slicedToArray(ctrls, 2),
            modelController = _ctrls[0],
            formController = _ctrls[1];

        if (!validationPreconditions(modelController, formController, el)) {
            return;
        }
        var labelText = resolveLabelText(attrs.errorLabel, el[0]);
        populateFieldErrorScope($scope, modelController, labelText, formController);
        // Yeah, this is hacky. Ideally we would be using an isolate scope and binding them directly.
        // A potential refactoring opportunity!
        attrs.$observe('errorLabel', function (newValue) {
            $scope.$rcValidationMetadata.labelText = newValue;
        });
        modelController.el = el;
        var fieldErrors = null;
        if (Object(external__angular_["isUndefined"])(attrs.manualErrorsList)) {
            fieldErrors = makeInputFieldErrors(attrs.customErrorMessages);
            // Append it outside of the rc-input-wrapper .parent()
            $rcInputFieldWrapper.getInputFieldWrapperFor(el).after(fieldErrors);
            $compile(fieldErrors)($scope);
        }
        if (formController) {
            $scope.$watch(function () {
                return formController.$pristine && !formController.$submitted;
            }, function (newVal) {
                if (newVal) {
                    $rcValidationFieldErrors.hideError(modelController);
                }
            });
        }
        $scope.$rcValidationMetadata.focus = function () {
            el[0].focus();
        };
        var $formFieldErrors = void 0;
        if (formController) {
            $formFieldErrors = makeInputFieldErrors(attrs.customErrorMessages, true);
            $formFieldErrors = $compile($formFieldErrors)($scope);
        }
        // Register component with the form's controller
        // TODO Is there a way to move this initialization out of here?
        $rcValidationFieldErrors.registerElement(formController, modelController, $formFieldErrors, $scope);
        $rcValidationFieldErrors.onErrorToggle(modelController, function (showError) {
            var inputWrapper = $rcInputFieldWrapper.getInputFieldWrapperFor(el);
            if (showError) {
                inputWrapper.addClass('rc-validate-error');
            } else {
                inputWrapper.removeClass('rc-validate-error');
            }
        });
        $scope.$on('$destroy', function () {
            if (fieldErrors && Object(external__angular_["isFunction"])(fieldErrors.remove)) {
                fieldErrors.remove();
            }
            $rcValidationFieldErrors.unregisterModelController(modelController);
        });
    };
    return {
        restrict: 'E',
        scope: true,
        priority: 2,
        require: ['?ngModel', '?^form'],
        link: link
    };
}
// CONCATENATED MODULE: ./src/validation/register-angular-validators.ts

var rcValidateName = function rcValidateName(name) {
    return 'rcValidate' + name.charAt(0).toUpperCase() + name.slice(1);
};
function registerValidators(module) {
    validation_validators.forEach(function (validator) {
        module.config(['rcValidationErrorMessagesProvider', function (rcValidationErrorMessagesProvider) {
            'ngInject';

            rcValidationErrorMessagesProvider.addErrorMessage(validator.name);
        }]);
        module.directive(rcValidateName(validator.name), function () {
            return {
                require: 'ngModel',
                restrict: 'A',
                priority: 1,
                link: function link(scope, element, attrs, ctrl) {
                    ctrl.$validators[validator.name] = function (modelValue, viewValue) {
                        return ctrl.$isEmpty(viewValue) || validator.test(viewValue);
                    };
                }
            };
        });
    });
}
// CONCATENATED MODULE: ./src/validation/formatters/auto-formatter-factory.directive.ts
var formatterFactory = function formatterFactory(formattingFn) {
    return function () {
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function link($scope, $el, $attr, ngModelCtrl) {
                $el.on('blur', function () {
                    var $viewValue = ngModelCtrl.$viewValue;

                    if ($viewValue) {
                        var formatted = formattingFn($viewValue);
                        if (formatted) {
                            ngModelCtrl.$setViewValue(formatted);
                            ngModelCtrl.$render();
                        }
                    }
                });
            }
        };
    };
};
/* harmony default export */ var auto_formatter_factory_directive = (formatterFactory);
// CONCATENATED MODULE: ./src/validation/formatters/day.ts
var day__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();


var formatToStandard = function formatToStandard($viewValue) {
    $viewValue = $viewValue.replace(/[\.\-\:\_]/, '/');
    if ($viewValue.match(/^\d{4}$/)) {
        var _$viewValue$split = $viewValue.split(''),
            _$viewValue$split2 = day__slicedToArray(_$viewValue$split, 4),
            h1 = _$viewValue$split2[0],
            h2 = _$viewValue$split2[1],
            m1 = _$viewValue$split2[2],
            m2 = _$viewValue$split2[3];

        return '' + h1 + h2 + '/' + m1 + m2;
    }
    if ($viewValue.match(/^\d{3}$/)) {
        return formatToStandard('0' + $viewValue);
    }
    if ($viewValue.match(/^\d\/\d{2}/)) {
        return formatToStandard('0' + $viewValue);
    }
    if ($viewValue.match(/^\d{2}\/\d{2}$/)) {
        return $viewValue;
    }
    return null;
};

/* harmony default export */ var day = (auto_formatter_factory_directive(formatToStandard));
// CONCATENATED MODULE: ./src/validation/formatters/time.ts

var time_formatToStandard = function formatToStandard($viewValue) {
    if ($viewValue.match(/^\d{1,4}$/)) {
        return reformatDateOnly($viewValue);
    } else if ($viewValue.match(/^\d:\d\d$/)) {
        return '0' + $viewValue;
    }
    if ($viewValue.match(/^\d{2}:\d{2}$/)) {
        return $viewValue;
    }
    return null;
};
var reformatDateOnly = function reformatDateOnly($viewValue) {
    var inputLength = $viewValue.length;
    var hours = $viewValue.substring(0, inputLength - 2);
    var minutes = '00';
    if (inputLength > 2) {
        minutes = $viewValue.substring(inputLength - 2);
    } else {
        hours = $viewValue;
    }
    if (hours.length === 1) {
        hours = '0' + hours;
    }
    return hours + ':' + minutes;
};

/* harmony default export */ var time = (auto_formatter_factory_directive(time_formatToStandard));
// CONCATENATED MODULE: ./src/validation/formatters/circ7.ts

var circ7_formatToStandard = function formatToStandard($viewValue) {
    if ($viewValue.match(/^\w\d{3}\w?$/)) {
        var formatted = $viewValue.split('');
        formatted.splice(1, 0, ' ');
        return formatted.join('');
    }
    return null;
};

/* harmony default export */ var circ7 = (auto_formatter_factory_directive(circ7_formatToStandard));
// CONCATENATED MODULE: ./src/validation/formatters/index.ts



var formatters_registerAutoFormatters = function registerAutoFormatters(module) {
    module.directive('rcValidateFormatTime', time).directive('rcValidateFormatDate', day).directive('rcValidateFormatCirc7', circ7);
};
/* harmony default export */ var formatters = (formatters_registerAutoFormatters);
// CONCATENATED MODULE: ./src/validation/input-composers/factory.directive.ts
var factory_directive__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();


var addUserElements = function addUserElements($input, $compileEl, $compileAttrs) {
    var attrs = Object.keys($compileAttrs.$attr);
    var userAttrs = attrs.filter(function (x) {
        return x.indexOf('$') !== 0;
    }).map(function (x) {
        return [$compileAttrs.$attr[x], $compileAttrs[x]];
    });
    userAttrs.forEach(function (_ref) {
        var _ref2 = factory_directive__slicedToArray(_ref, 2),
            attr = _ref2[0],
            val = _ref2[1];

        $input.attr(attr, val);
        $compileEl.removeAttr(attr);
    });
};
var addAttrs = function addAttrs($input, defaultAttrs) {
    Object.keys(defaultAttrs).forEach(function (attr) {
        return $input.attr(attr, defaultAttrs[attr]);
    });
};
var factory_directive_makeInputComposer = function makeInputComposer(defaultAttrs) {
    return ['$compile', function ($compile) {
        'ngInject';

        return {
            priority: 1001 /* ng-repeat + 1 */
            , terminal: true,
            restrict: 'E',
            compile: compile
        };
        function compile($element, $attrs) {
            var $input = Object(external__angular_["element"])('<input type="text">');
            addAttrs($input, defaultAttrs);
            addUserElements($input, $element, $attrs);
            $element.append($input);
            return function ($scope, $el) {
                $compile($el.children())($scope);
            };
        }
    }];
};
/* harmony default export */ var factory_directive = (factory_directive_makeInputComposer);
// CONCATENATED MODULE: ./src/validation/input-composers/time.ts

var time_attrs = {
    size: 6,
    placeholder: 'HH:MM',
    'rc-validate-time': '',
    'rc-validate-format-time': ''
};

/* harmony default export */ var input_composers_time = (factory_directive(time_attrs));
// CONCATENATED MODULE: ./src/validation/input-composers/date.ts

var date_attrs = {
    size: 6,
    placeholder: 'MM/DD',
    'rc-validate-date': '',
    'rc-validate-format-date': ''
};

/* harmony default export */ var date = (factory_directive(date_attrs));
// CONCATENATED MODULE: ./src/validation/input-composers/circ7.ts

var circ7_attrs = {
    size: 7,
    placeholder: 'Circ-7',
    'rc-validate-circ7': '',
    'rc-validate-format-circ7': ''
};

/* harmony default export */ var input_composers_circ7 = (factory_directive(circ7_attrs));
// CONCATENATED MODULE: ./src/validation/input-composers/index.ts



var input_composers_registerInputComposers = function registerInputComposers(module) {
    module.directive('rcInputTime', input_composers_time).directive('rcInputDate', date).directive('rcInputCirc7', input_composers_circ7);
};
/* harmony default export */ var input_composers = (input_composers_registerInputComposers);
// CONCATENATED MODULE: ./src/validation/characters-left-initializer.directive.ts

/* harmony default export */ var characters_left_initializer_directive = (['$document', '$compile', '$parse', function ($document, $compile, $parse) {
    'ngInject';

    return {
        restrict: 'A',
        require: '?ngModel',
        link: function link($scope, $el, $attrs, ngModelCtrl) {
            if (!ngModelCtrl) {
                return;
            }
            var maxCharacters = $parse($attrs.rcValidateCounter)($scope);
            var addValidator = function addValidator() {
                ngModelCtrl.$validators.rcCharacterCounter = function (modelValue) {
                    var viewValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

                    var characters = viewValue.length;
                    return maxCharacters - characters >= 0;
                };
            };
            var addCharacterCounterComponent = function addCharacterCounterComponent() {
                // add rc-characters-left visiblity display
                var charsLeftScope = $scope.$new();
                var charsLeftEl = Object(external__angular_["element"])('<rc-characters-left\n                        model-view-value="charsLeftModel.$viewValue"\n                        is-visible="focused"\n                        max-characters="{{maxCharacters}}">');
                charsLeftScope.charsLeftModel = ngModelCtrl;
                charsLeftScope.maxCharacters = maxCharacters;
                $el.on('focus', function () {
                    charsLeftScope.$apply(function () {
                        charsLeftScope.focused = true;
                    });
                });
                $el.on('blur', function () {
                    charsLeftScope.$apply(function () {
                        charsLeftScope.focused = false;
                    });
                });
                var $charsLeftEl = $compile(charsLeftEl)(charsLeftScope);
                $el.parent().append($charsLeftEl);
            };
            addValidator();
            addCharacterCounterComponent();
        }
    };
}]);
// CONCATENATED MODULE: ./src/validation/characters-left.component.ts
var characters_left_component__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function characters_left_component__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CharactersLeftController = function () {
    function CharactersLeftController() {
        characters_left_component__classCallCheck(this, CharactersLeftController);
    }

    characters_left_component__createClass(CharactersLeftController, [{
        key: '$onInit',
        value: function $onInit() {
            this.maxCharacters = parseInt(this.maxCharacters);
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.modelViewValue) {
                this.onViewChange(changes.modelViewValue.currentValue);
            }
        }
    }, {
        key: 'onViewChange',
        value: function onViewChange() {
            var viewValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            this.charsRemaining = this.maxCharacters - viewValue.length;
        }
    }, {
        key: 'overLimit',
        get: function get() {
            return this.charsRemaining < 0;
        }
    }]);

    return CharactersLeftController;
}();
var CharactersLeftComponent = {
    bindings: {
        modelViewValue: '<',
        isVisible: '<',
        maxCharacters: '@'
    },
    template: '<div ng-if="$ctrl.isVisible" class="characters-left" ng-class="{ overLimit: $ctrl.overLimit }">\n            <span ng-bind="$ctrl.charsRemaining"></span>\n        </div>',
    controller: CharactersLeftController
};
/* harmony default export */ var characters_left_component = (CharactersLeftComponent);
// CONCATENATED MODULE: ./src/validation/index.ts
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return validation_service_validators; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return validation_provider; });






















var validationModule = Object(external__angular_["module"])('rc.validation', ['ngMessages', bindHtml["a" /* default */], inputFieldWrapper["a" /* default */], i18n["a" /* default */], usage["b" /* default */]]).component('rcFormErrors', validation_form_errors_component).component('rcInputFieldErrors', input_field_errors_component).service('$rcValidators', validation_service_validators).service('$rcValidationFieldErrors', validation_input_field_errors_service).provider('rcValidationErrorMessages', validation_provider).directive('rcValidateCounter', characters_left_initializer_directive).directive('rcRequired', makeRequiredDirective('rcRequired')).directive('ngRequired', makeRequiredDirective('ngRequired')).directive('required', makeRequiredDirective('required')).config(rcValidateCounterConfig).config(rcRequiredConfig).config(rcDefaultValidatorsConfig).service('BlurAfterClick', blur_after_click_service).value('rcValidationGetLabelFor', validation_utils_rcValidationGetLabelFor).directive('ngModel', error_register_directive).directive('input', RcInputFieldErrorWrapper).directive('select', RcInputFieldErrorWrapper).directive('textarea', RcInputFieldErrorWrapper).component('rcCharactersLeft', characters_left_component);
registerValidators(validationModule);
formatters(validationModule);
input_composers(validationModule);
/* harmony default export */ var validation = __webpack_exports__["c"] = (validationModule.name);
// Public API


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "angular"
var external__angular_ = __webpack_require__(0);
var external__angular__default = /*#__PURE__*/__webpack_require__.n(external__angular_);

// EXTERNAL MODULE: ./src/usage/index.ts + 3 modules
var usage = __webpack_require__(1);

// EXTERNAL MODULE: ./src/position/index.ts + 4 modules
var position = __webpack_require__(17);

// EXTERNAL MODULE: ./src/overlay/overlay.component.html
var overlay_component = __webpack_require__(154);
var overlay_component_default = /*#__PURE__*/__webpack_require__.n(overlay_component);

// CONCATENATED MODULE: ./src/overlay/overlay.component.ts
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var STRATEGIES = ['bottom-center', 'top-center'];
var NUB_OFFSET = 7;

var overlay_component_Overlay = function () {
    Overlay.$inject = ['$scope', '$compile', '$document', '$element', '$position', '$strategicPositioner'];

    function Overlay($scope, $compile, $document, $element, $position, $strategicPositioner) {
        'ngInject';

        _classCallCheck(this, Overlay);

        this.$scope = $scope;
        this.$compile = $compile;
        this.$element = $element;
        this.$position = $position;
        this.$body = $document.find('body'), this.strategicPositioner = $strategicPositioner.positionerFor(STRATEGIES, NUB_OFFSET);
    }

    _createClass(Overlay, [{
        key: 'onCurtainClose',
        value: function onCurtainClose() {
            this.visible = false;
            this.$hidePopup();
        }
    }, {
        key: 'open',
        value: function open() {
            this.visible = true;
        }
    }, {
        key: '$calculateOverlayPosition',
        value: function $calculateOverlayPosition() {
            var $popup = Object(external__angular_["element"])(this.$overlayPopup[0].querySelector('.rc-overlay-popup-content'));
            var targetOffset = this.$position.offset(this.$overlayTarget);
            var popupOffset = this.$position.offset($popup);
            var overlayPosition = this.strategicPositioner.position(this.$overlayTarget, $popup);
            this.popupOrientation = overlayPosition.alignment;
            this.overlayPosition = this.$asPx(overlayPosition);
        }
    }, {
        key: '$asPx',
        value: function $asPx(coordinates) {
            return {
                top: coordinates.top + 'px',
                left: coordinates.left + 'px'
            };
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.toggle && changes.toggle.currentValue !== this.visible) {
                this.visible = changes.toggle.currentValue;
            }
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            this.visible = false;
            this.$overlayPopup = this.$element.find('overlay-content');
            this.$overlayTarget = this.$element;
            this.$hidePopup();
        }
    }, {
        key: '$doCheck',
        value: function $doCheck() {
            var $popup = this.$overlayPopup[0].querySelector('.rc-overlay-popup-content');
            if ($popup) {
                this.$calculateOverlayPosition();
            }
        }
    }, {
        key: '$hidePopup',
        value: function $hidePopup() {
            this.overlayPosition = {
                top: '-9999px',
                left: '0px'
            };
            this.popupOrientation = 'bottom';
        }
    }, {
        key: 'targetStyles',
        get: function get() {
            var styles = {
                'rc-overlay-open': this.visible
            };
            styles['rc-overlay-popup-' + this.popupOrientation] = this.visible;
            return styles;
        }
    }, {
        key: 'visible',
        get: function get() {
            return this._visible;
        },
        set: function set(newVal) {
            this._visible = newVal;
            if (this._visible) {
                var overlayCurtain = Object(external__angular_["element"])('<rc-overlay-curtain\n                on-curtain-close="$ctrl.onCurtainClose()"\n                close-fn="$ctrl.closeCurtain">\n            ');
                var $overlayCurtain = this.$compile(overlayCurtain)(this.$scope);
                this.$body.append($overlayCurtain);
                this.$body.append(this.$overlayPopup.detach());
            } else {
                // Send an event to the overlay-curtain, letting it know it should destroy itself
                // Is there a better way to communicate between these components? This feels hacky and bad.
                // In ng2 we have a few more options.
                // See https://angular.io/docs/ts/latest/cookbook/component-communication.html#!#bidirectional-service
                this.$scope.$broadcast('rc.overlay.closed');
                if (this.$overlayPopup) {
                    this.$element.append(this.$overlayPopup.detach());
                }
            }
            if (this.onOverlayToggle) {
                this.onOverlayToggle({ $event: this.visible });
            }
        }
    }]);

    return Overlay;
}();

/* harmony default export */ var overlay_overlay_component = (overlay_component_Overlay);

var OverlayComponent = {
    template: overlay_component_default.a,
    controller: overlay_component_Overlay,
    bindings: {
        toggle: '<',
        onOverlayToggle: '&'
    },
    transclude: {
        overlayContent: 'rcOverlayContent',
        overlayTarget: 'rcOverlayTarget'
    }
};

// CONCATENATED MODULE: ./src/overlay/overlay-curtain.component.ts
var overlay_curtain_component__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function overlay_curtain_component__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OverlayCurtain = function () {
    OverlayCurtain.$inject = ['$element', '$scope'];

    function OverlayCurtain($element, $scope) {
        'ngInject';

        overlay_curtain_component__classCallCheck(this, OverlayCurtain);

        this.$element = $element;
        this.$scope = $scope;
    }

    overlay_curtain_component__createClass(OverlayCurtain, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$scope.$on('rc.overlay.closed', function () {
                _this.$element.remove();
            });
        }
    }, {
        key: 'handleComponentClicked',
        value: function handleComponentClicked() {
            this.onCurtainClose && this.onCurtainClose();
            this.$element.remove();
        }
    }]);

    return OverlayCurtain;
}();

/* harmony default export */ var overlay_curtain_component = (OverlayCurtain);

var OverlayCurtainComponent = {
    template: '<div class="overlay-curtain" ng-click="$ctrl.handleComponentClicked()"></div>',
    bindings: {
        onCurtainClose: '&'
    },
    controller: OverlayCurtain
};

// CONCATENATED MODULE: ./src/overlay/index.ts





/* harmony default export */ var overlay = __webpack_exports__["a"] = (Object(external__angular_["module"])('rc.overlay', [position["a" /* default */], usage["b" /* default */]]).component('rcOverlayCurtain', OverlayCurtainComponent).component('rcOverlay', OverlayComponent).name);

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(33);
var TAG = __webpack_require__(2)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(9) && !__webpack_require__(18)(function () {
  return Object.defineProperty(__webpack_require__(53)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
var document = __webpack_require__(5).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(10);
var toIObject = __webpack_require__(19);
var arrayIndexOf = __webpack_require__(56)(false);
var IE_PROTO = __webpack_require__(42)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(33);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(19);
var toLength = __webpack_require__(57);
var toAbsoluteIndex = __webpack_require__(84);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(37);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(38);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(2)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(15)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(7).f;
var create = __webpack_require__(41);
var redefineAll = __webpack_require__(62);
var ctx = __webpack_require__(28);
var anInstance = __webpack_require__(63);
var forOf = __webpack_require__(64);
var $iterDefine = __webpack_require__(39);
var step = __webpack_require__(60);
var setSpecies = __webpack_require__(92);
var DESCRIPTORS = __webpack_require__(9);
var fastKey = __webpack_require__(45).fastKey;
var validate = __webpack_require__(46);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(14);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(28);
var call = __webpack_require__(89);
var isArrayIter = __webpack_require__(90);
var anObject = __webpack_require__(16);
var toLength = __webpack_require__(57);
var getIterFn = __webpack_require__(91);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var $export = __webpack_require__(22);
var redefine = __webpack_require__(14);
var redefineAll = __webpack_require__(62);
var meta = __webpack_require__(45);
var forOf = __webpack_require__(64);
var anInstance = __webpack_require__(63);
var isObject = __webpack_require__(8);
var fails = __webpack_require__(18);
var $iterDetect = __webpack_require__(93);
var setToStringTag = __webpack_require__(29);
var inheritIfRequired = __webpack_require__(94);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(30);
var createDesc = __webpack_require__(27);
var toIObject = __webpack_require__(19);
var toPrimitive = __webpack_require__(35);
var has = __webpack_require__(10);
var IE8_DOM_DEFINE = __webpack_require__(52);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(9) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(54);
var hiddenKeys = __webpack_require__(43).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isPhantomJS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return shouldDeepRender; });
/** See https://github.com/SAP/openui5/blob/master/src/sap.ui.core/test/sap/ui/core/qunit/AppCacheBuster.qunit.html#L59-L60 */
var isPhantomJS = function isPhantomJS() {
    return !Object.getOwnPropertyDescriptor(Node.prototype, 'childNodes');
};
var shouldDeepRender = function shouldDeepRender() {
    return !isPhantomJS();
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.skate = {})));
}(this, (function (exports) { 'use strict';

function define(Ctor) {
  var registry = customElements;
  var is = Ctor.is;
  if (!registry.get(is)) {
    registry.define(is, Ctor);
  }
  return Ctor;
}

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var defs = {
  bubbles: true,
  cancelable: true,
  composed: false
};

function emit(elem, name, opts) {
  opts = _extends({}, defs, opts);
  var e = void 0;
  if ('composed' in CustomEvent.prototype) {
    e = new CustomEvent(name, opts);
  } else {
    e = document.createEvent('CustomEvent');
    e.initCustomEvent(name, opts.bubbles, opts.cancelable, opts.detail);
    Object.defineProperty(e, 'composed', { value: opts.composed });
  }
  return elem.dispatchEvent(e);
}

function getValue(elem) {
  var checked = elem.checked,
      type = elem.type,
      value = elem.value;

  if (type === 'checkbox' || type === 'radio') {
    return checked ? value || true : false;
  }
  return value;
}

function link(elem, target) {
  return function (e) {
    // TODO revisit once all browsers have native support.
    //
    // We fallback to checking the composed path. Unfortunately this behaviour
    // is difficult to impossible to reproduce as it seems to be a possible
    // quirk in the shadydom polyfill that incorrectly returns null for the
    var localTarget = e.target || e.composedPath && e.composedPath()[0];
    var value = getValue(localTarget);
    var localTargetName = target || localTarget.name || 'value';

    if (localTargetName.indexOf('.') > -1) {
      var parts = localTargetName.split('.');
      var firstPart = parts[0];
      var propName = parts.pop();
      var obj = parts.reduce(function (prev, curr) {
        return prev[curr];
      }, elem);

      obj[propName || localTarget.name] = value;
      elem[firstPart] = elem[firstPart];
    } else {
      elem[localTargetName] = value;
    }
  };
}

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withChildren = function withChildren() {
  var Base = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : HTMLElement;
  return function (_Base) {
    _inherits(_class, _Base);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this2 = this;

        if (_get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), "connectedCallback", this)) {
          _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), "connectedCallback", this).call(this);
        }
        if (this.childrenChangedCallback) {
          var mo = new MutationObserver(function () {
            return _this2.childrenChangedCallback();
          });
          mo.observe(this, { childList: true });
          this.childrenChangedCallback();
        }
      }
    }]);

    return _class;
  }(Base);
};

var _createClass$2 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Mo = typeof MutationObserver === 'function' ? MutationObserver : function () {
  function _class2(func) {
    _classCallCheck$2(this, _class2);

    this.func = func;
  }

  _createClass$2(_class2, [{
    key: 'observe',
    value: function observe(node) {
      var func = this.func;

      var prop = {
        set: function set() {
          if (typeof Promise === 'undefined') {
            setTimeout(func);
          } else {
            new Promise(function (resolve) {
              return resolve();
            }).then(func);
          }
        }
      };
      Object.defineProperty(node, 'textContent', prop);
    }
  }]);

  return _class2;
}();

function dashCase(str) {
  return str.split(/([_A-Z])/).reduce(function (one, two, idx) {
    var dash = !one || idx % 2 === 0 ? '' : '-';
    two = two === '_' ? '' : two;
    return '' + one + dash + two.toLowerCase();
  });
}

function debounce(cbFunc) {
  var scheduled = false;
  var i = 0;
  var elem = document.createElement('span');
  var observer = new Mo(function () {
    cbFunc();
    scheduled = false;
  });

  observer.observe(elem, { childList: true });

  return function () {
    if (!scheduled) {
      scheduled = true;
      elem.textContent = '' + i;
      i += 1;
    }
  };
}

var empty = function empty(val) {
  return val == null;
};

function keys(obj) {
  obj = obj || {};
  var names = Object.getOwnPropertyNames(obj);
  return Object.getOwnPropertySymbols ? names.concat(Object.getOwnPropertySymbols(obj)) : names;
}

function sym(description) {
  return typeof Symbol === 'function' ? Symbol(description ? String(description) : undefined) : uniqueId(description);
}

function uniqueId(description) {
  return (description ? String(description) : '') + 'xxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function normaliseAttributeDefinition(name, prop) {
  var attribute = prop.attribute;

  var obj = (typeof attribute === "undefined" ? "undefined" : _typeof(attribute)) === "object" ? _extends$1({}, attribute) : {
    source: attribute,
    target: attribute
  };
  if (obj.source === true) {
    obj.source = dashCase(name);
  }
  if (obj.target === true) {
    obj.target = dashCase(name);
  }
  return obj;
}

function normalisePropertyDefinition(name, prop) {
  var coerce = prop.coerce,
      def = prop.default,
      deserialize = prop.deserialize,
      serialize = prop.serialize;

  return {
    attribute: normaliseAttributeDefinition(name, prop),
    coerce: coerce || function (v) {
      return v;
    },
    default: def,
    deserialize: deserialize || function (v) {
      return v;
    },
    serialize: serialize || function (v) {
      return v;
    }
  };
}

function syncAttributeToProperty(elem, name, value) {
  if (elem._syncingPropertyToAttribute) {
    return;
  }
  var propDefs = elem.constructor.props;
  for (var propName in propDefs) {
    var _propDefs$propName = propDefs[propName],
        source = _propDefs$propName.attribute.source,
        deserialize = _propDefs$propName.deserialize;

    if (source === name) {
      elem._syncingAttributeToProperty = propName;
      elem[propName] = value == null ? value : deserialize(value);
      elem._syncingAttributeToProperty = null;
    }
  }
}

function syncPropertyToAttribute(elem, target, serialize, val) {
  if (target && elem._syncingAttributeToProperty !== target) {
    var serialized = serialize(val);
    elem._syncingPropertyToAttribute = true;
    if (serialized == null) {
      elem.removeAttribute(target);
    } else {
      elem.setAttribute(target, serialized);
    }
    elem._syncingPropertyToAttribute = false;
  }
}

var _get$1 = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass$1 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function prop(definition) {
  var propertyDefinition = definition || {};

  // Allows decorators, or imperative definitions.
  var func = function func(_ref, name) {
    var constructor = _ref.constructor;

    var normalised = normalisePropertyDefinition(name, propertyDefinition);
    var _value = sym(name);

    // Ensure that we can cache properties. We have to do this so the _props object literal doesn't modify parent
    // classes or share the instance anywhere where it's not intended to be shared explicitly in userland code.
    if (!constructor.hasOwnProperty('_props')) {
      constructor._props = {};
    }

    // Cache the value so we can reference when syncing the attribute to the property.
    constructor._props[name] = normalised;

    if (normalised.attribute.source) {
      constructor.observedAttributes = normalised.attribute.source;
    }

    Object.defineProperty(constructor.prototype, name, {
      configurable: true,
      get: function get() {
        var val = this[_value];
        return val == null ? normalised.default : val;
      },
      set: function set(val) {
        this[_value] = normalised.coerce(val);
        syncPropertyToAttribute(this, normalised.attribute.target, normalised.serialize, val);
        this._updateDebounced();
      }
    });
  };

  // Allows easy extension of pre-defined props { ...prop(), ...{} }.
  Object.keys(propertyDefinition).forEach(function (key) {
    return func[key] = propertyDefinition[key];
  });

  return func;
}

var withProps = function withProps() {
  var Base = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : HTMLElement;
  return function (_Base) {
    _inherits$1(_class2, _Base);

    _createClass$1(_class2, [{
      key: 'props',
      get: function get() {
        var _this2 = this;

        return keys(this.constructor.props).reduce(function (prev, curr) {
          prev[curr] = _this2[curr];
          return prev;
        }, {});
      },
      set: function set(props) {
        var _this3 = this;

        var ctorProps = this.constructor.props;
        keys(props).forEach(function (k) {
          return k in ctorProps && (_this3[k] = props[k]);
        });
      }
    }], [{
      key: 'observedAttributes',
      get: function get() {
        return this._observedAttributes || [];
      },
      set: function set(attrs) {
        if (!this.hasOwnProperty('_observedAttributes')) {
          this._observedAttributes = [];
        }
        this._observedAttributes = this.observedAttributes.concat(attrs);
      }
    }, {
      key: 'props',
      get: function get() {
        return this._props || {};
      },
      set: function set(props) {
        var _this4 = this;

        keys(props).forEach(function (name) {
          var func = props[name];
          if (typeof func !== 'function') func = prop(func);
          func({ constructor: _this4 }, name);
        });
      }
    }]);

    function _class2() {
      _classCallCheck$1(this, _class2);

      var _this = _possibleConstructorReturn$1(this, (_class2.__proto__ || Object.getPrototypeOf(_class2)).call(this));

      _this._updateCallback = function () {
        if (_this._updating || !_this._connected) {
          return;
        }

        // Flag as rendering. This prevents anything from trying to render - or
        // queueing a render - while there is a pending render.
        _this._updating = true;

        // Prev / next props for prop lifecycle callbacks.
        var prev = _this._prevProps;
        var next = _this._prevProps = _this.props;

        // Always call set, but only call changed if the props updated.
        if (_this.propsSetCallback) {
          _this.propsSetCallback(next, prev);
        }

        // We only need to check if props have updated if we need to call the
        // changed callback.
        if (_this.propsChangedCallback && _this.propsUpdatedCallback(next, prev)) {
          _this.propsChangedCallback(next, prev);
        }

        _this._updating = false;
      };

      if (_this._constructed) return _possibleConstructorReturn$1(_this);
      _this._constructed = true;
      _this._updateDebounced = debounce(_this._updateCallback);
      return _this;
    }

    _createClass$1(_class2, [{
      key: 'connectedCallback',
      value: function connectedCallback() {
        if (this._connected) return;
        this._connected = true;
        // $FlowFixMe - HTMLElement doesn't implement connectedCallback.
        if (_get$1(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'connectedCallback', this)) _get$1(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'connectedCallback', this).call(this);
        this._updateDebounced();
      }
    }, {
      key: 'disconnectedCallback',
      value: function disconnectedCallback() {
        if (!this._connected) return;
        this._connected = false;
        // $FlowFixMe - HTMLElement doesn't implement disconnectedCallback.
        if (_get$1(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'disconnectedCallback', this)) _get$1(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'disconnectedCallback', this).call(this);
      }

      // Called to see if the props changed.

    }, {
      key: 'propsUpdatedCallback',
      value: function propsUpdatedCallback(next, prev) {
        return !prev || keys(prev).some(function (k) {
          return prev[k] !== next[k];
        });
      }
    }, {
      key: 'attributeChangedCallback',
      value: function attributeChangedCallback(name, oldValue, newValue) {
        if (_get$1(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'attributeChangedCallback', this))
          // $FlowFixMe - HTMLElement doesn't implement attributeChangedCallback.
          _get$1(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'attributeChangedCallback', this).call(this, name, oldValue, newValue);
        syncAttributeToProperty(this, name, newValue);
      }

      // Invokes the complete render lifecycle.

    }]);

    return _class2;
  }(Base);
};

var parse = JSON.parse;
var stringify = JSON.stringify;

var attribute = Object.freeze({ source: true });
var zeroOrNumber = function zeroOrNumber(val) {
  return empty(val) ? 0 : Number(val);
};

var any = prop({
  attribute: attribute
});

var array = prop({
  attribute: attribute,
  coerce: function coerce(val) {
    return Array.isArray(val) ? val : empty(val) ? null : [val];
  },
  default: Object.freeze([]),
  deserialize: parse,
  serialize: stringify
});

var boolean = prop({
  attribute: attribute,
  coerce: Boolean,
  default: false,
  deserialize: function deserialize(val) {
    return !empty(val);
  },
  serialize: function serialize(val) {
    return val ? '' : null;
  }
});

var number = prop({
  attribute: attribute,
  default: 0,
  coerce: zeroOrNumber,
  deserialize: zeroOrNumber,
  serialize: function serialize(val) {
    return empty(val) ? null : String(Number(val));
  }
});

var object = prop({
  attribute: attribute,
  default: Object.freeze({}),
  deserialize: parse,
  serialize: stringify
});

var string = prop({
  attribute: attribute,
  default: '',
  coerce: String,
  serialize: function serialize(val) {
    return empty(val) ? null : String(val);
  }
});

var props = {
  any: any,
  array: array,
  boolean: boolean,
  number: number,
  object: object,
  string: string
};

var _createClass$3 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$2(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var attachShadowOptions = { mode: 'open' };

function attachShadow(elem) {
  return elem.attachShadow ? elem.attachShadow(attachShadowOptions) : elem;
}

var withRenderer = function withRenderer() {
  var Base = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : HTMLElement;
  return function (_Base) {
    _inherits$2(_class2, _Base);

    function _class2() {
      _classCallCheck$3(this, _class2);

      return _possibleConstructorReturn$2(this, (_class2.__proto__ || Object.getPrototypeOf(_class2)).apply(this, arguments));
    }

    _createClass$3(_class2, [{
      key: 'propsChangedCallback',
      value: function propsChangedCallback() {
        var _this2 = this;

        if (this.rendererCallback) {
          this.rendererCallback(this.renderRoot, function () {
            return _this2.renderCallback && _this2.renderCallback(_this2);
          });
        }

        if (this.renderedCallback) {
          this.renderedCallback();
        }
      }
    }, {
      key: 'renderRoot',
      get: function get() {
        return this._shadowRoot || (this._shadowRoot = this.shadowRoot || attachShadow(this));
      }
    }]);

    return _class2;
  }(Base);
};

var suffix = 0;

function formatName(prefix, suffix) {
  prefix = prefix || "element";
  return (prefix.indexOf("-") === -1 ? "x-" + prefix : prefix) + (suffix ? "-" + suffix : "");
}

function generateName(Ctor) {
  var registry = customElements;
  var prefix = dashCase(Ctor.name);
  while (registry.get(formatName(prefix, suffix))) {
    suffix++;
  }
  return formatName(prefix, suffix++);
}

var _createClass$4 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$3(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$3(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withUnique = function withUnique() {
  var Base = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : HTMLElement;
  return function (_Base) {
    _inherits$3(_class2, _Base);

    function _class2() {
      _classCallCheck$4(this, _class2);

      return _possibleConstructorReturn$3(this, (_class2.__proto__ || Object.getPrototypeOf(_class2)).apply(this, arguments));
    }

    _createClass$4(_class2, null, [{
      key: 'is',
      get: function get() {
        return this._is || (this._is = generateName(this));
      },
      set: function set(is) {
        this._is = is;
      }
    }]);

    return _class2;
  }(Base);
};

var withComponent = function withComponent(Base) {
  return withChildren(withProps(withRenderer(withUnique(Base || HTMLElement))));
};

exports.define = define;
exports.emit = emit;
exports.link = link;
exports.withChildren = withChildren;
exports.withComponent = withComponent;
exports.prop = prop;
exports.withProps = withProps;
exports.props = props;
exports.withRenderer = withRenderer;
exports.withUnique = withUnique;

Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=index.js.map


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "angular"
var external__angular_ = __webpack_require__(0);
var external__angular__default = /*#__PURE__*/__webpack_require__.n(external__angular_);

// EXTERNAL MODULE: ./src/usage/index.ts + 3 modules
var usage = __webpack_require__(1);

// EXTERNAL MODULE: ./src/alerts/templates/alerts.html
var alerts = __webpack_require__(125);
var alerts_default = /*#__PURE__*/__webpack_require__.n(alerts);

// CONCATENATED MODULE: ./src/alerts/alerts.component.ts
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var alerts_component_AlertsController = function () {
    AlertsController.$inject = ['$element', 'Usage'];

    function AlertsController($element, Usage) {
        'ngInject';

        _classCallCheck(this, AlertsController);

        this.$element = $element;
        Usage.register('alerts');
    }

    _createClass(AlertsController, [{
        key: '$onInit',
        value: function $onInit() {
            this.$element.addClass('rc-alerts');
        }
    }, {
        key: 'getAlertsClasses',
        value: function getAlertsClasses() {
            if (Object(external__angular_["isString"])(this.position) && this.position.trim().length > 0) {
                return ['rc-alerts-positioned', this.position];
            }
            return '';
        }
    }]);

    return AlertsController;
}();
var AlertsComponent = {
    bindings: {
        alerts: '=',
        position: '@'
    },
    controller: alerts_component_AlertsController,
    controllerAs: 'rcAlertsCtrl',
    template: alerts_default.a
};
/* harmony default export */ var alerts_component = (AlertsComponent);
// CONCATENATED MODULE: ./src/alerts/alerts.service.ts
var alerts_service__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function alerts_service__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


function getBoolean(value, defaultValue) {
    return typeof value === 'boolean' ? value : defaultValue;
}
/**
 * Exposed as an Angular service via `$rcAlerts`
 */

var alerts_service_AlertsService = function () {
    function AlertsService(config) {
        alerts_service__classCallCheck(this, AlertsService);

        this.alerts = [];
        Object(external__angular_["extend"])(this, config);
    }
    // TODO: Update this API.......kinda horrifying
    /**
     * Adds a new Alert to the Alerts array
     * See the `add` method for more details
     * @return self for chaining
     */


    alerts_service__createClass(AlertsService, [{
        key: 'add',
        value: function add(message, title, type, icon, closeButton, tla, timeout, onClose, focus) {
            var _this = this;

            if (!!(timeout || this.defaults.timeout) && !onClose) {
                onClose = function onClose(index) {
                    _this.remove(index);
                };
            }
            this.removeFocusFromAlerts();
            this.alerts.push({
                message: message,
                title: title,
                type: type,
                icon: getBoolean(icon, this.defaults.icon),
                closeButton: getBoolean(closeButton, this.defaults.closeButton),
                tla: tla || this.defaults.tla,
                timeout: typeof timeout === 'boolean' || !!timeout ? timeout : this.defaults.timeout,
                onClose: Object(external__angular_["isFunction"])(onClose) ? onClose : this.defaults.onClose,
                focus: getBoolean(focus, this.defaults.focus)
            });
            return this;
        }
        /** Removes all alerts from the array */

    }, {
        key: 'clear',
        value: function clear() {
            this.alerts.length = 0;
            return this;
        }
        /** Shorthand to add an `error` alert to the array.  */

    }, {
        key: 'error',
        value: function error(message, title, icon, closeButton, tla, timeout, onClose) {
            return this.add(message, title, 'error', icon, closeButton, tla, timeout, onClose);
        }
        /** Shorthand to add an `info` alert to the array.  */

    }, {
        key: 'info',
        value: function info(message, title, icon, closeButton, tla, timeout, onClose) {
            return this.add(message, title, 'info', icon, closeButton, tla, timeout, onClose);
        }
        /** Shorthand to add an `success` alert to the array.  */

    }, {
        key: 'success',
        value: function success(message, title, icon, closeButton, tla, timeout, onClose) {
            return this.add(message, title, 'success', icon, closeButton, tla, timeout, onClose);
        }
        /** Shorthand to add an `warning` alert to the array.  */

    }, {
        key: 'warning',
        value: function warning(message, title, icon, closeButton, tla, timeout, onClose) {
            return this.add(message, title, 'warning', icon, closeButton, tla, timeout, onClose);
        }
        /** @internal */

    }, {
        key: 'focusLastAlert',
        value: function focusLastAlert() {
            var _this2 = this;

            if (this.alerts && !!this.alerts.length) {
                this.$timeout(function () {
                    _this2.alerts[_this2.alerts.length - 1].focus = true;
                });
            }
        }
        /** @internal */

    }, {
        key: 'remove',
        value: function remove(index) {
            if (this.alerts[index]) {
                this.alerts.splice(index, 1);
            }
            if (this.defaults.focus) {
                this.removeFocusFromAlerts();
                this.focusLastAlert();
            }
            return this;
        }
        /** @internal */

    }, {
        key: 'removeFocusFromAlerts',
        value: function removeFocusFromAlerts() {
            for (var index = 0; index < this.alerts.length; index++) {
                this.alerts[index].focus = false;
            }
        }
    }]);

    return AlertsService;
}();

/* harmony default export */ var alerts_service = (alerts_service_AlertsService);
// CONCATENATED MODULE: ./src/alerts/alerts.provider.ts
var alerts_provider__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function alerts_provider__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var DEFAULTS = {
    icon: true,
    closeButton: true,
    tla: '',
    timeout: 10000,
    onClose: external__angular_["noop"],
    clearOnChangeEvent: false,
    stateChangeEvent: '$routeChangeSuccess',
    focus: false
};
/**
 * Exposed as an Angular provider via `$rcAlertsProvider`
 */

var alerts_provider_AlertsProvider = function () {
    function AlertsProvider() {
        alerts_provider__classCallCheck(this, AlertsProvider);

        this.defaults = DEFAULTS;
    }
    /** @internal */


    alerts_provider__createClass(AlertsProvider, [{
        key: 'clearOnChangeEvent',
        value: function clearOnChangeEvent() {
            this.defaults.clearOnChangeEvent = true;
            return this;
        }
        /** @internal */

    }, {
        key: 'config',
        value: function config(configObj) {
            Object(external__angular_["extend"])(this.defaults, configObj);
            return this;
        }
        /** Automatically focuses new alerts. */

    }, {
        key: 'focusAlerts',
        value: function focusAlerts() {
            this.defaults.focus = true;
        }
    }, {
        key: '$get',
        value: ['$rootScope', '$timeout', function $get($rootScope, $timeout) {
            'ngInject';

            return new alerts_service({
                $rootScope: $rootScope,
                $timeout: $timeout,
                defaults: this.defaults
            });
        }]
    }]);

    return AlertsProvider;
}();

/* harmony default export */ var alerts_provider = (alerts_provider_AlertsProvider);
// CONCATENATED MODULE: ./src/alerts/index.ts
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return alerts_service; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return alerts_provider; });





/* harmony default export */ var src_alerts = __webpack_exports__["c"] = (Object(external__angular_["module"])('rc.alerts', [usage["b" /* default */]]).component('rcAlerts', alerts_component).provider('$rcAlerts', alerts_provider).name);
// Public API



/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "angular"
var external__angular_ = __webpack_require__(0);
var external__angular__default = /*#__PURE__*/__webpack_require__.n(external__angular_);

// CONCATENATED MODULE: ./src/inputFieldWrapper/inputFieldWrapper.service.ts
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var inputFieldWrapper_service_InputFieldWrapperService = function () {
    function InputFieldWrapperService() {
        _classCallCheck(this, InputFieldWrapperService);
    }

    _createClass(InputFieldWrapperService, [{
        key: 'shouldNotWrapField',
        value: function shouldNotWrapField($element) {
            if ($element[0].nodeName === 'INPUT') {
                var blacklistedTypes = ['radio', 'checkbox', 'button', 'submit', 'reset'];
                if (blacklistedTypes.indexOf($element.attr('type')) !== -1) {
                    return true;
                }
            }
            return false;
        }
    }, {
        key: 'getInputFieldWrapperFor',
        value: function getInputFieldWrapperFor($element) {
            if ($element.parent().parent().hasClass('rc-input-wrapper')) {
                return $element.parent().parent();
            }
            if ($element.parent().hasClass('rc-input-wrapper')) {
                return $element.parent();
            }
            return Object(external__angular_["element"])();
        }
    }]);

    return InputFieldWrapperService;
}();

/* harmony default export */ var inputFieldWrapper_service = (inputFieldWrapper_service_InputFieldWrapperService);
// CONCATENATED MODULE: ./src/inputFieldWrapper/inputFieldWrapper.directive.ts
InputFieldWrapper.$inject = ['$rcInputFieldWrapper', '$timeout'];
function InputFieldWrapper($rcInputFieldWrapper, $timeout) {
    'ngInject';

    return {
        restrict: 'E',
        priority: 2,
        compile: InputFieldWrapperCompile
    };
    function InputFieldWrapperCompile(element, attrs) {
        // If it's a input, do not apply to radio, button, or checkbox elements
        if (!$rcInputFieldWrapper.shouldNotWrapField(element)) {
            return { pre: InputFieldWrapperPreLink };
        }
    }
    function InputFieldWrapperPreLink(scope, element, attrs) {
        var size = attrs.size;

        var selectEl = element[0].nodeName === 'SELECT';
        var wrappableElement = element;
        var classList = 'rc-input-wrapper';
        if (element.hasClass('expand')) {
            classList += ' expand';
        }
        if (element.parent().hasClass('button-addon')) {
            wrappableElement = element.parent();
        }
        var $wrapped = wrappableElement.wrap('<div>').parent();
        $wrapped.addClass(classList);
        if (size) {
            $wrapped.attr('size', size);
        }
        if (selectEl) {
            $wrapped.attr('select', 'select');
        }
        // Don't leave wrappers lying around... SID#187012
        scope.$on('$destroy', function () {
            var wrapper = wrappableElement.parent();
            if (wrapper.hasClass('rc-input-wrapper')) {
                wrapper.remove();
            }
        });
    }
}
// CONCATENATED MODULE: ./src/inputFieldWrapper/index.ts



/* harmony default export */ var inputFieldWrapper = __webpack_exports__["a"] = (Object(external__angular_["module"])('rc.inputFieldWrapper', []).service('$rcInputFieldWrapper', inputFieldWrapper_service).directive('select', InputFieldWrapper).directive('textarea', InputFieldWrapper).directive('input', InputFieldWrapper).name);

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "angular"
var external__angular_ = __webpack_require__(0);
var external__angular__default = /*#__PURE__*/__webpack_require__.n(external__angular_);

// EXTERNAL MODULE: ./src/i18n/index.ts + 2 modules
var i18n = __webpack_require__(13);

// EXTERNAL MODULE: ./src/usage/index.ts + 3 modules
var usage = __webpack_require__(1);

// EXTERNAL MODULE: ./node_modules/ricola3-i18n-translations/lib/index.js
var lib = __webpack_require__(4);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./src/infiniteScroll/infiniteScroll.directive.ts
rcInfiniteScrollDirective.$inject = ['$log', '$compile', 'Usage'];


function rcInfiniteScrollDirective($log, $compile, Usage) {
    'ngInject';

    return {
        restrict: 'A',
        scope: {
            rcInfiniteScroll: '&',
            rcInfiniteScrollComplete: '@?'
        },
        link: function link(scope, $element) {
            Usage.register('infinite-scroll');
            var loadingIndicator = Object(external__angular_["element"])('<span ng-class="{hidden: !loading, finished: rcInfiniteScrollComplete}">\n                <rc-translatable-expression i18n-templates="loadingTranslation"></rc-translatable-expression>\n            </span>');
            function getMoreData() {
                scope.loading = true;
                $log.debug('Getting more data....');
                scope.$parent.$apply(function () {
                    scope.rcInfiniteScroll();
                });
            }
            function onComplete() {
                scope.loading = false;
                $log.debug('Finished getting data');
                if (scope.rcInfiniteScrollComplete === 'true') {
                    scope.finished = true;
                }
            }
            scope.loading = false;
            scope.finished = false;
            scope.loadingTranslation = lib_default.a.get('rc.infiniteScroll.loading');
            loadingIndicator = $compile(loadingIndicator)(scope);
            $element.append(loadingIndicator);
            $element.on('scroll', function (e) {
                var targetElement = e.target;
                if (targetElement.scrollTop + targetElement.offsetHeight === targetElement.scrollHeight) {
                    if (scope.rcInfiniteScrollComplete !== 'true') {
                        getMoreData();
                    }
                }
            });
            scope.$on('rcScroll.complete', onComplete);
        }
    };
}
// CONCATENATED MODULE: ./src/infiniteScroll/index.ts




/* harmony default export */ var infiniteScroll = __webpack_exports__["a"] = (Object(external__angular_["module"])('rc.infiniteScroll', [i18n["a" /* default */], usage["b" /* default */]]).directive('rcInfiniteScroll', rcInfiniteScrollDirective).name);

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "angular"
var external__angular_ = __webpack_require__(0);
var external__angular__default = /*#__PURE__*/__webpack_require__.n(external__angular_);

// EXTERNAL MODULE: ./src/usage/index.ts + 3 modules
var usage = __webpack_require__(1);

// EXTERNAL MODULE: ./src/i18n/index.ts + 2 modules
var i18n = __webpack_require__(13);

// EXTERNAL MODULE: ./src/loading/templates/loading-backdrop.html
var loading_backdrop = __webpack_require__(152);
var loading_backdrop_default = /*#__PURE__*/__webpack_require__.n(loading_backdrop);

// CONCATENATED MODULE: ./src/loading/loading.directive.backdrop.ts

function rcLoadingBackdropDirective() {
    return {
        restrict: 'EA',
        template: loading_backdrop_default.a
    };
}
/* harmony default export */ var loading_directive_backdrop = (rcLoadingBackdropDirective);
// EXTERNAL MODULE: ./src/loading/templates/loading.html
var loading = __webpack_require__(153);
var loading_default = /*#__PURE__*/__webpack_require__.n(loading);

// CONCATENATED MODULE: ./src/loading/loading.directive.content.ts

function rcLoadingContentDirective() {
    return {
        restrict: 'EA',
        template: loading_default.a
    };
}
/* harmony default export */ var loading_directive_content = (rcLoadingContentDirective);
// EXTERNAL MODULE: ./node_modules/ricola3-i18n-translations/lib/index.js
var lib = __webpack_require__(4);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./src/loading/loading.directive.ts
rcLoadingDirective.$inject = ['$compile', '$document', 'Usage'];


function buildLoadingElement(type) {
    return '<rc-loading-' + type + '\n        ng-style="zIndex"\n        ng-class="{ \'rc-loading-inline\': inline }"></rc-loading-' + type + '>';
}
function rcLoadingDirective($compile, $document, Usage) {
    'ngInject';

    return {
        scope: {
            condition: '=rcLoading',
            message: '@'
        },
        link: LoadingLink
    };
    function LoadingLink(scope, element, attrs) {
        Usage.register('loading');
        scope.inline = Object(external__angular_["isDefined"])(attrs.inline);
        scope.zIndex = Object(external__angular_["isUndefined"])(attrs.zIndex) ? {} : { 'z-index': attrs.zIndex };
        scope.useTooltip = scope.inline && Object(external__angular_["isDefined"])(attrs.message);
        var loadingElement = $compile(buildLoadingElement('content'))(scope);
        var backdropElement = $compile(buildLoadingElement('backdrop'))(scope);
        var affectedElement = scope.inline ? element : $document.find('body').eq(0);
        scope.$watch('condition', function (newValue) {
            if (newValue === true) {
                affectedElement.addClass('rc-loading-wrapper');
                affectedElement.append(backdropElement);
                affectedElement.append(loadingElement);
            } else {
                removeLoading();
            }
        });
        scope.loadingTranslation = lib_default.a.get('rc.loading.loading');
        // If the scope if blown up, make sure the 'loading' is removed too.
        scope.$on('$destroy', removeLoading);
        function removeLoading() {
            affectedElement.removeClass('rc-loading-wrapper');
            backdropElement.remove();
            loadingElement.remove();
        }
    }
}
// CONCATENATED MODULE: ./src/loading/index.ts






/* harmony default export */ var src_loading = __webpack_exports__["a"] = (Object(external__angular_["module"])('rc.loading', [i18n["a" /* default */], usage["b" /* default */]]).directive('rcLoadingBackdrop', loading_directive_backdrop).directive('rcLoadingContent', loading_directive_content).directive('rcLoading', rcLoadingDirective).name);

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "angular"
var external__angular_ = __webpack_require__(0);
var external__angular__default = /*#__PURE__*/__webpack_require__.n(external__angular_);

// EXTERNAL MODULE: ./src/usage/index.ts + 3 modules
var usage = __webpack_require__(1);

// EXTERNAL MODULE: ./src/modal/index.ts + 8 modules
var modal = __webpack_require__(31);

// EXTERNAL MODULE: ./src/loading/index.ts + 3 modules
var loading = __webpack_require__(73);

// CONCATENATED MODULE: ./src/reauthenticate/reauthenticate.config.ts
/* harmony default export */ var reauthenticate_config = (['$httpProvider', function ($httpProvider) {
    'ngInject';

    $httpProvider.interceptors.push('ReauthenticateInterceptor');
}]);
// CONCATENATED MODULE: ./src/reauthenticate/reauthenticate.directive.ts
function ReauthenticateIframeOnloadDirective() {
    return {
        restrict: 'A',
        scope: {
            currentLocation: '&rcReauthenticateIframeOnload'
        },
        link: ReauthenticateIframeOnloadLink
    };
    function ReauthenticateIframeOnloadLink(scope, element, attrs) {
        element.on('load', function (value) {
            scope.currentLocation({
                location: element[0].contentWindow.location
            });
        });
    }
}
// CONCATENATED MODULE: ./src/reauthenticate/reauthenticate.controller.modal.ts
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


/* Simplistic modal controller. Auto-closes when secured location reached properly */

var reauthenticate_controller_modal_ReauthModalController = function () {
    ReauthModalController.$inject = ['$modalInstance'];

    function ReauthModalController($modalInstance) {
        'ngInject';

        _classCallCheck(this, ReauthModalController);

        this.$modalInstance = $modalInstance;
        this.loginPath = null;
    }

    _createClass(ReauthModalController, [{
        key: 'verifyLocation',
        value: function verifyLocation(location) {
            var currentPath = location.pathname || '';
            /* Navigation past the initial Siteminder login represents success */
            if (currentPath === RICOLA_REAUTH_PATH || this.loginPath && this.loginPath !== currentPath) {
                this.$modalInstance.close('Authenticated');
            } else {
                /* First (and subsequent failed) request "should" hit SiteMinder's /admin/login.fcc */
                this.loginPath = currentPath;
            }
        }
    }]);

    return ReauthModalController;
}();

/* harmony default export */ var reauthenticate_controller_modal = (reauthenticate_controller_modal_ReauthModalController);
// CONCATENATED MODULE: ./src/reauthenticate/reauthenticate.provider.ts


var RICOLA_REAUTH_PATH = '/uit/ricola/secure/ricola3ReauthToken.html';
function DefaultReauthenticateInterceptorProvider() {
    var _this = this;

    var defaults = this.defaults = {
        retryLastRequest: true,
        retryAllPreviousRequests: false,
        showReauthModal: true,
        reauthEvent: 'RcAuthentication',
        successEvent: 'RcAuthenticationSuccess'
    };
    this.config = function (configObj) {
        Object(external__angular_["extend"])(defaults, configObj);
        return _this;
    };
    this.retryLastRequest = function (value) {
        if (Object(external__angular_["isDefined"])(value)) {
            defaults.retryLastRequest = !!value;
            if (defaults.retryLastRequest) {
                defaults.retryAllPreviousRequests = false;
            }
        }
        return _this;
    };
    this.retryAllPreviousRequests = function (value) {
        if (Object(external__angular_["isDefined"])(value)) {
            defaults.retryAllPreviousRequests = !!value;
            if (defaults.retryAllPreviousRequests) {
                defaults.retryLastRequest = false;
            }
        }
        return _this;
    };
    this.$get = ['$q', '$injector', '$cacheFactory', function ($q, $injector, $cacheFactory) {
        'ngInject';

        var interceptor = {};
        var requestBuffer = [];
        var modalInstance = null;
        function showReauthModal(shouldDisplay) {
            $injector.get('$rootScope').$broadcast(defaults.reauthEvent);
            if (shouldDisplay) {
                $cacheFactory.get('$http').removeAll();
                if (modalInstance === null) {
                    var rcModal = $injector.get('$rcModal');
                    modalInstance = rcModal.open({
                        template: '<div class="rc-reauthenticate">\n                                <iframe src="' + RICOLA_REAUTH_PATH + '?q=' + Date.now() + '"\n                                    rc-reauthenticate-iframe-onload="reauth.verifyLocation(location)" ></iframe>\n                            </div>',
                        controller: reauthenticate_controller_modal,
                        controllerAs: 'reauth',
                        includeCancel: false
                    });
                    modalInstance.result.then(successfulLogin, destroyModalInstance);
                }
            }
        }
        function retryRequest(config, deferred) {
            var $http = $injector.get('$http');
            $http(config).then(function (response) {
                return deferred.resolve(response);
            }).catch(function (response) {
                return deferred.reject(response);
            });
        }
        function retryBufferedRequests() {
            for (var i = 0; i < requestBuffer.length; i++) {
                retryRequest(requestBuffer[i].config, requestBuffer[i].deferred);
            }
            requestBuffer = [];
        }
        function successfulLogin() {
            // Register the usage of the module (since they are now authenticated)
            $injector.get('Usage').register('reauthenticate');
            $injector.get('$rootScope').$broadcast(defaults.successEvent);
            /*
            * Clear all previous $http responses to avoid cached SiteMinder 200 status login HTML.
            * Angular's default $http cache uses the url & all parameters as the key so it is easier
            * to clear everything than try to match it.
            */
            $cacheFactory.get('$http').removeAll();
            retryBufferedRequests();
            destroyModalInstance();
        }
        function destroyModalInstance() {
            modalInstance = null;
        }
        function getBufferedRequestPromise(config) {
            var deferred = $q.defer();
            if (defaults.retryLastRequest) {
                requestBuffer = [];
            }
            requestBuffer.push({
                config: config,
                deferred: deferred
            });
            return deferred.promise;
        }
        function rejectResponse401(response) {
            response.status = 401;
            response.statusText = 'Unauthorized';
            return $q.reject(response);
        }
        interceptor.response = function (response) {
            if (containsSiteMinderData(response)) {
                showReauthModal(defaults.showReauthModal);
                if (defaults.retryLastRequest || defaults.retryAllPreviousRequests) {
                    return getBufferedRequestPromise(response.config);
                }
                return rejectResponse401(response);
            }
            return response || $q.when(response);
        };
        interceptor.triggerModal = function () {
            showReauthModal(true);
        };
        return interceptor;
    }];
    return this;
}
function containsSiteMinderData(response) {
    if (Object(external__angular_["isDefined"])(response)) {
        var data = response.data;
        if (Object(external__angular_["isString"])(data)) {
            // Normal Siteminder possibilities
            if (data.indexOf('LOGINFORM') > 0) {
                return data.indexOf('smauthreason') > 0 || data.indexOf('smagentname') > 0 || data.indexOf('smquerydata') > 0;
            }
            // Latent network SiteMinder response:
            // This page is used to hold your data while you are being authorized.... for your request.
            if (data.indexOf('AUTOSUBMIT') > 0 && data.indexOf('SMPostPreserve')) {
                return true;
            }
        }
    }
    return false;
}
// CONCATENATED MODULE: ./src/reauthenticate/index.ts
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return RICOLA_REAUTH_PATH; });







/* harmony default export */ var reauthenticate = __webpack_exports__["b"] = (Object(external__angular_["module"])('rc.reauthenticate', [usage["b" /* default */], modal["a" /* default */], loading["a" /* default */]]).config(reauthenticate_config).directive('rcReauthenticateIframeOnload', ReauthenticateIframeOnloadDirective).provider('ReauthenticateInterceptor', DefaultReauthenticateInterceptorProvider).name);
// Public API


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "angular"
var external__angular_ = __webpack_require__(0);
var external__angular__default = /*#__PURE__*/__webpack_require__.n(external__angular_);

// EXTERNAL MODULE: ./src/infiniteScroll/index.ts + 1 modules
var infiniteScroll = __webpack_require__(72);

// EXTERNAL MODULE: ./src/keyboardNavigation/index.ts + 1 modules
var keyboardNavigation = __webpack_require__(12);

// EXTERNAL MODULE: ./src/mediaQuery/index.ts + 2 modules
var mediaQuery = __webpack_require__(20);

// EXTERNAL MODULE: ./src/position/index.ts + 4 modules
var position = __webpack_require__(17);

// EXTERNAL MODULE: ./src/usage/index.ts + 3 modules
var usage = __webpack_require__(1);

// EXTERNAL MODULE: ./src/utils/index.ts + 4 modules
var utils = __webpack_require__(11);

// EXTERNAL MODULE: ./src/overlay/index.ts + 2 modules
var overlay = __webpack_require__(50);

// CONCATENATED MODULE: ./src/table/table.directive.column-priorities.ts
ColumnPrioritiesDirective.$inject = ['$timeout'];

function ColumnPrioritiesDirective($timeout) {
    'ngInject';

    return {
        restrict: 'A',
        require: 'rcTable',
        priority: 1,
        compile: ColumnPrioritiesCompile
    };
    function ColumnPrioritiesCompile(tElement, tAttrs) {
        // We convert single quotes to double quotes because it is strict JSON. SID#149365
        var priorities = Object(external__angular_["fromJson"])(tAttrs.columnPriorities.replace(/'/g, '"'));
        // Find the tds we wish to add classes to
        // Will choose the first <tr> row either in the tbody or directly on the table
        // TODO This is strictly convention, but we should allow for more flexibility when defining tables
        var getTds = function getTds(table) {
            var inTbody = table.querySelector('tbody > tr');
            var tr = inTbody || table.querySelector('> tr');
            return Object(external__angular_["element"])(tr.querySelectorAll('td'));
        };
        var tds = getTds(tElement[0]);
        if (tds.length !== priorities.length) {
            throw new Error('Number of columns (' + tds.length + ') must equal number of priorities (' + priorities.length + ') given in columnPriorities.');
        }
        var cells = Array.prototype.slice.call(tds).concat(Array.prototype.slice.call(tElement.find('th')));
        addPriorityClassesToCells(priorities, cells);
        return function (scope, element, attrs) {
            scope.columnPriorities = priorities;
            scope.$on('rc.table.thead.ready', function () {
                $timeout(function () {
                    var ths = Array.prototype.slice.call(element.find('th'));
                    addPriorityClassesToCells(priorities, ths);
                });
            });
        };
    }
}
function addPriorityClassesToCells(priorities, cells) {
    Object(external__angular_["forEach"])(cells, function (cell, index) {
        Object(external__angular_["element"])(cell).addClass('rc-priority-' + priorities[index % priorities.length]);
    });
}
// CONCATENATED MODULE: ./src/table/table.factory.ts
RcTableParamsFactory.$inject = ['$q', '$log'];

function RcTableParamsFactory($q, $log) {
    'ngInject';

    var RcTableParams = function RcTableParams(userParameters, userSettings) {
        var _this = this;

        var self = this;
        var log = function log() {
            for (var _len = arguments.length, argss = Array(_len), _key = 0; _key < _len; _key++) {
                argss[_key] = arguments[_key];
            }

            if (settings.debugMode && $log.debug) {
                var _$log$debug;

                (_$log$debug = $log.debug).apply.apply(_$log$debug, [_this].concat(argss));
            }
        };
        this.data = [];
        // move to controller
        this.doInfiniteScroll = function () {
            var deferred = $q.defer();
            var result = settings.onInfiniteScroll(deferred, _this);
            var realPromise = result ? result : deferred.promise;
            return $q.when(realPromise).then(function (newData) {
                log('got more data from infiniteScroll');
                _this.data = newData;
            });
        };
        /**
         * Default implementation. Expected to be overridden by user settings.
         */
        this.getData = function ($defer, params) {
            log('Calling default getData() method');
            if (Object(external__angular_["isArray"])(_this.data) && Object(external__angular_["isObject"])(params)) {
                $defer.resolve(_this.data);
            } else {
                $defer.resolve([]);
            }
        };
        /**
         * @ngdoc method
         * @name rcTable.factory:RcTableParams#getGroups
         * @methodOf rcTable.factory:RcTableParams
         * @description Return groups for table grouping
         */
        this.getGroups = function ($defer, column) {
            var deferWrapper = $q.defer();
            // can be the settings object or the RcTableParams
            var returnedValue = this.getData(deferWrapper, self);
            var realPromise = returnedValue ? $q.resolve(returnedValue) : deferWrapper.promise;
            return realPromise.then(function (data) {
                var groups = {};
                Object(external__angular_["forEach"])(data, function (item) {
                    if (item.isRcTableGroup) {
                        // Do not regroup those that have been grouped
                        groups[item.value] = item;
                    } else {
                        var groupName = Object(external__angular_["isFunction"])(column) ? column(item) : item[column];
                        groups[groupName] = groups[groupName] || {
                            data: [],
                            $hideRows: settings.defaultCollapsedGroups,
                            isRcTableGroup: true,
                            value: groupName
                        };
                        groups[groupName].data.push(item);
                    }
                });
                var result = [];
                for (var i in groups) {
                    if (groups.hasOwnProperty(i)) {
                        result.push(groups[i]);
                    }
                }
                log('rcTable: refresh groups', result);
                return result;
            });
        };
        this.isGroupedBy = function () {
            return !!_this.settings().groupBy;
        };
        /**
         * @ngdoc method
         * @name rcTable.factory:RcTableParams#isSortBy
         * @methodOf rcTable.factory:RcTableParams
         * @description Checks sort field
         *
         * @param {string} field     Field name
         * @param {string} direction Direction of sorting 'asc' or 'desc'
         * @returns {Array} Return true if field sorted by direction
         */
        this.isSortBy = function (field, direction) {
            return Object(external__angular_["isDefined"])(params.sorting[field]) && params.sorting[field] === direction;
        };
        this.onInfiniteScroll = function ($defer, params) {
            $defer.resolve([]);
        };
        /**
         * @ngdoc method
         * @name rcTable.factory:RcTableParams#orderBy
         * @methodOf rcTable.factory:RcTableParams
         * @description Return object of sorting parameters for angular filter
         *
         * @returns {Array} Array like: [ '-name', '+age' ]
         */
        this.orderBy = function () {
            var sorting = [];
            for (var column in params.sorting) {
                if (params.sorting.hasOwnProperty(column)) {
                    sorting.push((params.sorting[column] === 'asc' ? '+' : '-') + column);
                }
            }
            return sorting;
        };
        /**
         * @ngdoc method
         * @name rcTable.factory:RcTableParams#parameters
         * @methodOf rcTable.factory:RcTableParams
         * @description Set new parameters or get current parameters
         *
         * @param {string} newParameters      New parameters
         * @param {string} parseParamsFromUrl Flag if parse parameters like in url
         * @returns {Object} Current parameters or `this`
         */
        this.parameters = function (newParameters) {
            var parseParamsFromUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            // TODO: What the heck is parseParamsFromUrl about?
            if (Object(external__angular_["isDefined"])(newParameters)) {
                Object(external__angular_["forEach"])(newParameters, function (value, key) {
                    if (parseParamsFromUrl && key.indexOf('[') >= 0) {
                        var keys = key.split(/\[(.*)\]/).reverse();
                        var lastKey = '';
                        for (var i = 0, len = keys.length; i < len; i++) {
                            var name = keys[i];
                            if (name !== '') {
                                var v = value;
                                value = {};
                                value[lastKey = name] = isNumber(v) ? parseFloat(v) : v;
                            }
                        }
                        if (lastKey === 'sorting') {
                            params[lastKey] = {};
                        }
                        params[lastKey] = Object(external__angular_["extend"])(params[lastKey] || {}, value[lastKey]);
                    } else {
                        params[key] = isNumber(newParameters[key]) ? parseFloat(newParameters[key]) : newParameters[key];
                    }
                });
                // Just a hack to ensure even newParameters get initialized
                if (Object.keys(newParameters).length === 0) {
                    params.fakekeyvalue = 'something else';
                }
                log('rcTable: set parameters', params);
            }
            return params;
        };
        /**
         * @ngdoc method
         * @name rcTable.factory:RcTableParams#reload
         * @methodOf rcTable.factory:RcTableParams
         * @description Reload table data
         * @param {function} callback      Callback to execute when data load is complete
         */
        this.reload = function () {
            var $defer = $q.defer();
            var returnedValue = void 0;
            if (settings.groupBy) {
                returnedValue = settings.getGroups($defer, settings.groupBy);
            } else {
                returnedValue = settings.getData($defer, _this);
            }
            var usablePromise = returnedValue ? $q.when(returnedValue) : $defer.promise;
            log('rcTable: reload data');
            usablePromise.then(function (data) {
                _this.data = data;
            });
            return usablePromise;
        };
        /**
         * @ngdoc method
         * @name rcTable.factory:RcTableParams#settings
         * @methodOf rcTable.factory:RcTableParams
         * @description Set new settings for table
         *
         * @param {string} newSettings New settings or undefined
         * @returns {Object} Current settings
         */
        this.settings = function (newSettings) {
            if (Object(external__angular_["isDefined"])(newSettings) || Object(external__angular_["isUndefined"])(settings)) {
                settings = Object(external__angular_["extend"])(defaultSettings, newSettings);
            }
            return settings;
        };
        /**
         * @ngdoc method
         * @name rcTable.factory:RcTableParams#sorting
         * @methodOf rcTable.factory:RcTableParams
         * @description If 'sorting' parameter is not set, return current sorting. Otherwise set current sorting.
         *
         * @param {string} sorting New sorting
         * @returns {Object} Current sorting
         */
        this.sorting = function (sorting) {
            return Object(external__angular_["isDefined"])(sorting) ? _this.parameters({
                sorting: sorting
            }) : params.sorting;
        };
        this.toggleGroups = function () {
            var deferred = $q.defer();
            var groupBy = _this.settings().groupBy;
            var returnedPromise = _this.getGroups(deferred, groupBy);
            var usablePromise = returnedPromise ? $q.resolve(returnedPromise) : deferred.promise;
            return usablePromise.then(function (data) {
                _this.$hideRows = !_this.$hideRows;
                Object(external__angular_["forEach"])(data, function ($group) {
                    $group.$hideRows = _this.$hideRows;
                });
            });
        };
        var params = this.$params = {
            sorting: {},
            group: {} // TODO: Verify still needed. Not part of documented API.
        };
        // Defaults to be overridden by developer via the second class argument
        var settings = void 0;
        var defaultSettings = {
            // Removed from API, does not appear to be used anywhere
            // data: null, // allows data to be set when table is initialized
            groupBy: null,
            defaultSort: 'asc',
            defaultCollapsedGroups: false,
            getGroups: this.getGroups,
            getData: this.getData,
            onInfiniteScroll: this.onInfiniteScroll
        };
        this.settings(userSettings);
        this.$hideRows = settings.defaultCollapsedGroups;
        this.parameters(userParameters, true);
        return this;
    };
    return RcTableParams;
}
/* harmony default export */ var table_factory = (RcTableParamsFactory);
function isNumber(value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
}
// CONCATENATED MODULE: ./src/table/table.controller.agent.ts
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Proxy controller to provide a single point of contact for use within
 * the rc-table's transcluded <table> templates without having to cross scope
 * boundaries.
 */
var TableAgentController = function () {
    TableAgentController.$inject = ['$scope'];

    function TableAgentController($scope) {
        'ngInject';

        _classCallCheck(this, TableAgentController);

        this.$scope = $scope;
    }

    _createClass(TableAgentController, [{
        key: 'addRcTableController',
        value: function addRcTableController(controller) {
            this.tableCtrl = controller;
        }
    }, {
        key: 'getColumns',
        value: function getColumns() {
            return this.tableCtrl.columns || [];
        }
    }, {
        key: 'isAscendingSort',
        value: function isAscendingSort(column) {
            return this.tableCtrl && this.tableCtrl.isAscendingSort(column);
        }
    }, {
        key: 'isDescendingSort',
        value: function isDescendingSort(column) {
            return this.tableCtrl && this.tableCtrl.isDescendingSort(column);
        }
    }, {
        key: 'isSortable',
        value: function isSortable(column) {
            return this.tableCtrl && this.tableCtrl.isSortable(column);
        }
    }, {
        key: 'sortBy',
        value: function sortBy(column, event) {
            return this.tableCtrl && this.tableCtrl.sortBy(column, event);
        }
    }]);

    return TableAgentController;
}();

/* harmony default export */ var table_controller_agent = (TableAgentController);
// CONCATENATED MODULE: ./src/table/table.directive.agent.ts
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();


var ROW_HOVER_CLASS = 'rc-hover';
var ROW_STRIPE_CLASS = 'rc-stripes';
var TABLE_LAYOUT_CLASS = 'rc-table-layout';
var TABLE_REFLOW_CLASS = 'rc-table-reflow';
var NON_COPY_CLASSES = ['ng-class', 'rc-table', 'rc-hover', 'rc-stripes', 'ng-scope', 'rc-table-layout'];
function TableAgent() {
    return {
        restrict: 'A',
        require: ['rcTableAgent', '?^rcTable'],
        scope: false,
        controller: table_controller_agent,
        controllerAs: '$rcTblAgent',
        link: TableAgentLink
    };
    function TableAgentLink(scope, element, attrs, controllers) {
        // Hack to allow transcluded scope access to controller
        // TODO: Should be revisited and handled some other way if possible
        var _controllers = _slicedToArray(controllers, 2),
            agentCtrl = _controllers[0],
            rcTblCtrl = _controllers[1];

        if (rcTblCtrl) {
            rcTblCtrl.setTableScope(scope);
            agentCtrl.addRcTableController(rcTblCtrl);
            addClasses();
            addParentClasses();
        }
        function addClasses() {
            element.addClass(TABLE_LAYOUT_CLASS);
            element.addClass(ROW_STRIPE_CLASS);
            if (!rcTblCtrl.noRowHover) {
                element.addClass(ROW_HOVER_CLASS);
            }
            if (!element.hasClass('rc-table')) {
                element.addClass('rc-table');
            }
        }
        function addParentClasses() {
            var parent = element.parent();
            element.attr('class').split(' ').filter(function (value) {
                return NON_COPY_CLASSES.indexOf(value) === -1;
            }).forEach(function (value) {
                parent.addClass(value);
            });
            // If the developer has not provided any other means to handle a table
            // that may not fit horizontally on the page, read that as: they are not
            // using another mode that will handle a table that is too wide, assign
            // this safe/catch all class.
            //
            // Should toggle columns be included in this list? Without coupling it
            // with column priorities it doesn't do much automagically to control
            // the width of the table.
            if (!rcTblCtrl.hasColumnPriorities) {
                parent.addClass('rc-table-overflow');
            }
        }
    }
}
// EXTERNAL MODULE: ./node_modules/ricola3-i18n-translations/lib/index.js
var lib = __webpack_require__(4);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./src/table/templates/table.html
var templates_table = __webpack_require__(159);
var table_default = /*#__PURE__*/__webpack_require__.n(templates_table);

// EXTERNAL MODULE: ./src/common/keyboard-codes.ts
var keyboard_codes = __webpack_require__(3);

// CONCATENATED MODULE: ./src/table/table.component.ts
var table_component__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function table_component__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var ASCENDING = 'asc';
var DESCENDING = 'desc';
var AFTER_LOAD_EVENT = 'rcTableAfterReloadData';
function stopDomEvent(event) {
    event.stopPropagation();
    event.preventDefault();
    event.returnValue = false;
}
var table_component_TableController = function () {
    TableController.$inject = ['$scope', '$element', '$attrs', '$timeout', '$window', 'RcTableParams', 'Usage', '$fixedEnds'];

    function TableController($scope, $element, $attrs, $timeout, $window, RcTableParams, Usage, $fixedEnds) {
        'ngInject';

        table_component__classCallCheck(this, TableController);

        this.$scope = $scope;
        this.$element = $element;
        this.$attrs = $attrs;
        this.$timeout = $timeout;
        this.$window = $window;
        this.RcTableParams = RcTableParams;
        this.$fixedEnds = $fixedEnds;
        this.$processingScroll = false;
        Usage.register('table');
    }

    table_component__createClass(TableController, [{
        key: '$onInit',
        value: function $onInit() {
            this.changeHandlers = [];
            this.columnDropdownText = lib_default.a.get('rc.table.column-dropdown');
            this.displayMode = Object(external__angular_["isString"])(this.$attrs.tableMode) ? this.$attrs.tableMode.toLowerCase().trim() : null;
            this.hasColumnPriorities = Object(external__angular_["isDefined"])(this.$attrs.columnPriorities);
            this.noRowHover = Object(external__angular_["isDefined"])(this.$attrs.noRowHover);
            this.showColumnToggle = Object(external__angular_["isDefined"])(this.$attrs.toggleColumns);
            this.hasInfiniteScroll = Object(external__angular_["isDefined"])(this.$attrs.tableInfiniteScroll);
        }
    }, {
        key: '$postLink',
        value: function $postLink() {
            var _this = this;

            if (!this.config) {
                this.config = new this.RcTableParams();
            }
            if (this.displayMode === 'reflow') {
                this.$element.addClass('rc-table-reflow');
            }
            if (this.hasInfiniteScroll) {
                this.$element.find('table-content').addClass('rc-table-scroll-container');
            }
            // Table-scope values should likely be set in some other way
            this.$scope.$watchCollection(function () {
                return _this.config.data;
            }, function (current, previous) {
                if (_this.config.isGroupedBy()) {
                    _this.tableScope.$groups = current;
                } else {
                    _this.tableScope.$data = current;
                }
                _this.$adjustLayout();
            });
            this.$scope.$on('$rcModalHeightUpdated', function () {
                return _this.$adjustLayout();
            });
            this.$updateColumnSettings();
            this.$timeout(function () {
                var fixHeaders = _this.$element[0].hasAttribute('fixed-headers');
                var fixFooters = _this.$element[0].hasAttribute('fixed-footers');
                var table = _this.$element.find('table-content').find('table');
                _this.$fixedEnds.manage(table[0], fixHeaders, fixFooters);
                _this.$scope.$emit('rc.table.thead.ready');
            });
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            /* Upon initialization, the params object may not yet be created due to async maneuvers */
            if (changes.config && Object(external__angular_["isDefined"])(changes.config.currentValue)) {
                this.reloadData();
            }
        }
        // For changes that may affect other components

    }, {
        key: '$adjustLayout',
        value: function $adjustLayout() {
            //this.$rcFixedTableElements.refreshFixedElements();
            Object(external__angular_["forEach"])(this.changeHandlers, function (handler) {
                return handler();
            });
        }
    }, {
        key: '$updateColumnSettings',
        value: function $updateColumnSettings() {
            var _this2 = this;

            Object(external__angular_["forEach"])(this.columns, function (column, index) {
                if (_this2.priorities) {
                    column.priority = _this2.priorities[index];
                }
            });
        }
    }, {
        key: 'currentSort',
        value: function currentSort() {
            return this.config.sorting();
        }
    }, {
        key: 'hasGroups',
        value: function hasGroups() {
            return this.config.isGroupedBy();
        }
    }, {
        key: 'isAscendingSort',
        value: function isAscendingSort(column) {
            return column ? this.config.isSortBy(column.sortable(), ASCENDING) : false;
        }
    }, {
        key: 'isDescendingSort',
        value: function isDescendingSort(column) {
            return column ? this.config.isSortBy(column.sortable(), DESCENDING) : false;
        }
    }, {
        key: 'isSortable',
        value: function isSortable(column) {
            return column && column.sortable() ? true : false;
        }
        // TODO: Verify toggled information via forEach($group.hideRows)...

    }, {
        key: 'onIsolateScroll',
        value: function onIsolateScroll(isolate) {
            var _this3 = this;

            if (this.hasInfiniteScroll && isolate.boundary === 'bottom') {
                stopDomEvent(isolate.event);
                if (!this.$processingScroll) {
                    this.$processingScroll = true;
                    this.config.doInfiniteScroll().then(function () {
                        _this3.$adjustLayout();
                        _this3.$scope.$emit(AFTER_LOAD_EVENT);
                        _this3.$processingScroll = false;
                    });
                }
            }
        }
    }, {
        key: 'registerChangeHandler',
        value: function registerChangeHandler(callback) {
            this.changeHandlers.push(callback);
        }
    }, {
        key: 'reloadData',
        value: function reloadData() {
            var _this4 = this;

            this.config.reload().then(function () {
                _this4.$adjustLayout();
                _this4.$scope.$emit(AFTER_LOAD_EVENT);
            });
        }
    }, {
        key: 'setColumns',
        value: function setColumns(columns) {
            if (Object(external__angular_["isArray"])(columns)) {
                this.columns = columns;
            }
        }
    }, {
        key: 'onColumnToggle',
        value: function onColumnToggle(event) {
            this.columns[event.index].toggleStatus = event.state;
            if (event.state === true) {
                this.$element.removeClass('column-' + event.index + '-off');
                this.$element.addClass('column-' + event.index + '-on');
            } else if (event.state === false) {
                this.$element.removeClass('column-' + event.index + '-on');
                this.$element.addClass('column-' + event.index + '-off');
            } else {
                this.$element.removeClass('column-' + event.index + '-on');
                this.$element.removeClass('column-' + event.index + '-off');
            }
            /* Yet another dirty IE hack....because it will not repaint the pseudo elements...
             * SID #163111 */
            this.$window.getComputedStyle(this.$element[0]);
            this.$adjustLayout();
        }
    }, {
        key: 'setTableScope',
        value: function setTableScope(tableScope) {
            this.tableScope = tableScope;
        }
        // TODO: Untangle this from the config object...sheesh

    }, {
        key: 'sortBy',
        value: function sortBy(column, event) {
            if (event.type === 'keyup' && event.which !== keyboard_codes["a" /* default */].ENTER) {
                return;
            }
            var sortable = column && column.sortable();
            if (!sortable) {
                return;
            }
            // Feasibly allows multiple sort via ctrl/meta + click...works but needs research
            var sortObject = event.ctrlKey || event.metaKey ? this.config.sorting() : {};
            if (this.config.isSortBy(sortable, ASCENDING)) {
                sortObject[sortable] = DESCENDING;
            } else if (this.config.isSortBy(sortable, DESCENDING)) {
                sortObject[sortable] = ASCENDING;
            } else {
                sortObject[sortable] = this.config.settings().defaultSort;
            }
            this.config.sorting(sortObject);
            this.reloadData();
        }
    }, {
        key: 'toggleGroups',
        value: function toggleGroups() {
            this.config.toggleGroups();
        }
    }, {
        key: 'expandCollapseText',
        get: function get() {
            var groups = this.config.isGroupedBy() && this.tableScope.$groups || [];
            var allClosed = groups.length > 0 && !groups.some(function (group) {
                return group.$hideRows === false;
            });
            return allClosed ? 'Expand All' : 'Collapse All';
        }
    }]);

    return TableController;
}();
var TableComponent = {
    bindings: {
        config: '<?params',
        priorities: '<?columnPriorities',
        hideControls: '&'
    },
    controller: table_component_TableController,
    controllerAs: 'rcTblCtrl',
    template: table_default.a,
    transclude: {
        content: 'table',
        control: '?rcTableControl'
    }
};
/* harmony default export */ var table_component = (TableComponent);
// EXTERNAL MODULE: ./src/table/templates/table-header.html
var table_header = __webpack_require__(160);
var table_header_default = /*#__PURE__*/__webpack_require__.n(table_header);

// CONCATENATED MODULE: ./src/table/table.utils.ts
var table_utils__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function table_utils__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var table_utils_TableUtils = function () {
    function TableUtils() {
        table_utils__classCallCheck(this, TableUtils);
    }

    table_utils__createClass(TableUtils, null, [{
        key: 'modifyNgClass',
        value: function modifyNgClass($element, additionalValues) {
            if ($element && additionalValues) {
                var affectedEl = Object(external__angular_["element"])($element);
                var revision = '{ ' + additionalValues.trim();
                var existing = affectedEl.attr('ng-class');
                if (existing) {
                    existing = existing.replace(/[{}]/g, '').trim();
                    revision += ', ' + existing;
                }
                revision += ' }';
                affectedEl.attr('ng-class', revision);
            }
        }
    }]);

    return TableUtils;
}();

/* harmony default export */ var table_utils = (table_utils_TableUtils);
// CONCATENATED MODULE: ./src/table/table.directive.ts
TableDirective.$inject = ['$parse'];



var REFLOW_CELL_LABEL_CLASS = 'rc-table-cell-label';
/**
 * Bootstrapping directive to modify the transcluded <table> element according
 * configuration needs before it gets compiled
 */
function TableDirective($parse) {
    'ngInject';

    return {
        restrict: 'E',
        priority: 1,
        scope: false,
        require: 'rcTable',
        compile: TableCompile
    };
    function TableCompile(element, attrs) {
        // Add table-agent directive to proxy rc-table ctrl functionality in <table> scope
        var children = element.children();
        Object(external__angular_["forEach"])(children, function (child, index) {
            if (child.nodeName === 'TABLE') {
                child.setAttribute('rc-table-agent', '');
            }
        });
        // Build column information (sorting, priorities, toggling).
        var columns = getConfiguredColumns(element, attrs);
        // Add <thead> element or modify the existing
        addHeaderTemplating(element, columns);
        // Added to attrs information to be accessible in Link function
        // otherwise the columns do not show up in JSBin
        attrs.tableColumns = columns;
        return TableLink;
    }
    function TableLink(scope, element, attrs, rcTblCtrl) {
        // Ensure the same column objects not used for multiple tables in an ng-repeat SID#214361
        var columns = Object(external__angular_["copy"])(attrs.tableColumns);
        Object(external__angular_["forEach"])(columns, function (column) {
            column.localScope = scope;
            // TODO: Break this double reference...ctrl -> column -> ctrl -> bleh
            column.rcTblCtrl = rcTblCtrl;
        });
        rcTblCtrl.setColumns(columns || []);
        delete attrs.tableColumns;
    }
    function getConfiguredColumns($element, attrs) {
        var row = void 0;
        // Will add column data directly to an array on the element to pass to controller during link
        var columns = [];
        var identity = 0;
        Object(external__angular_["forEach"])($element.find('tr'), function (tr) {
            tr = Object(external__angular_["element"])(tr);
            if (!tr.hasClass('rc-table-group') && !row) {
                row = tr;
            }
        });
        // no rows, no work to do
        if (!row) {
            return;
        }
        var tableRowElements = row.find('th');
        if (tableRowElements.length === 0) {
            tableRowElements = row.find('td');
        }
        Object(external__angular_["forEach"])(tableRowElements, function (item) {
            columns.push(buildColumn(item));
        });
        return columns;
        function buildColumn(rawDOM) {
            var cell = Object(external__angular_["element"])(rawDOM);
            var parsedTitle = parsedAttribute(cell, 'title', ' ');
            var sortableTitle = parsedAttribute(cell, 'sortable', false)();
            var headerTemplateURL = parsedAttribute(cell, 'header', false);
            // Reflow mode needs an attribute to move the title in-line with the value
            cell.attr('data-title-text', parsedTitle());
            // This.localScope & this.rcTblCtrl are added during Link phase
            // Functions cannot be converted to () =>  due to context
            return {
                header: function header() {
                    return headerTemplateURL(this.localScope);
                },
                id: identity++,
                sortable: function sortable() {
                    return $parse(cell.attr('sortable'))(this.localScope) || false;
                },
                sortIndex: function sortIndex() {
                    var sortOrder = this.rcTblCtrl.currentSort();
                    var j = 0;
                    for (var title in sortOrder) {
                        /* Ignore inheritied properties. */
                        if (sortOrder.hasOwnProperty(title)) {
                            if (title === sortableTitle) {
                                return 'sort-index-' + j;
                            }
                            j++;
                        }
                    }
                },
                show: cell.attr('ng-show') ? function () {
                    return $parse(cell.attr('ng-show'))(this.localScope);
                } : function () {
                    return true;
                },
                tabindex: sortableTitle ? '0' : null,
                title: function title() {
                    return parsedTitle(this.localScope);
                }
            };
        }
    }
    function addHeaderTemplating($element, columns) {
        // create or apply headers
        // TODO this should be its own directive, probably!
        var thead = $element.find('thead');
        if (!thead.length) {
            // Apply the standard header
            // var headerTemplateHtml = `<thead>${rcTableHeaderTemplate}</thead>`;
            var headerTemplate = Object(external__angular_["element"])(table_header_default.a);
            $element.find('table').prepend(headerTemplate);
        } else {
            // TODO This sorting logic is a subset of what's in the header template
            // We should remove it from the header template and perform it all here.
            var headerItems = thead.find('th');
            for (var j = 0; j < headerItems.length; j++) {
                var th = Object(external__angular_["element"])(headerItems[j]);
                if (columns[j] && columns[j].sortable()) {
                    // Move to column.id values to use in both templates
                    // $rcTblAgent.isSortable(column.id)
                    table_utils.modifyNgClass(th, '"sortable": $rcTblAgent.isSortable($rcTblAgent.getColumns()[' + j + ']),\n                        "sort-asc": $rcTblAgent.isAscendingSort($rcTblAgent.getColumns()[' + j + ']),\n                        "sort-desc": $rcTblAgent.isDescendingSort($rcTblAgent.getColumns()[' + j + '])');
                    th.attr('ng-click', '$rcTblAgent.sortBy($rcTblAgent.getColumns()[' + j + '], $event)');
                    th.attr('ng-keyup', '$rcTblAgent.sortBy($rcTblAgent.getColumns()[' + j + '], $event)');
                    th.addClass('sort-index-0'); // This is hardcoded; I don't think we support any other sort indexes
                }
            }
        }
    }
    function parsedAttribute(element, attrName, defaultValue) {
        var parsable = element.attr('x-data-' + attrName) || element.attr('data-' + attrName) || element.attr(attrName);
        return function (scope) {
            return $parse(parsable)(scope) || defaultValue;
        };
    }
}
// EXTERNAL MODULE: ./src/table/templates/table.column-toggle.html
var table_column_toggle = __webpack_require__(161);
var table_column_toggle_default = /*#__PURE__*/__webpack_require__.n(table_column_toggle);

// CONCATENATED MODULE: ./src/table/table.component.column-toggle.ts
var table_component_column_toggle__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function table_component_column_toggle__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




/* 20em, 30em, 40em, ... */
var INCREMENT = 10;
// TODO - make this extendable somehow
var BREAKPOINT_MAP = {
    1: calculateBreakpointEM(1),
    2: calculateBreakpointEM(2),
    3: calculateBreakpointEM(3),
    4: calculateBreakpointEM(4),
    5: calculateBreakpointEM(5),
    6: calculateBreakpointEM(6),
    7: calculateBreakpointEM(7),
    8: calculateBreakpointEM(8),
    9: calculateBreakpointEM(9)
};
function calculateBreakpointEM(input) {
    return input * INCREMENT + INCREMENT + 'em';
}
function buildRemovableHandler($element, event, handler) {
    var wrapped = Object(external__angular_["element"])($element);
    wrapped.on(event, handler);
    return function () {
        wrapped.off(event, handler);
    };
}
var table_component_column_toggle_ColumnToggleController = function () {
    ColumnToggleController.$inject = ['$scope', '$timeout', '$window', '$document', 'rcMediaQuery'];

    function ColumnToggleController($scope, $timeout, $window, $document, rcMediaQuery) {
        'ngInject';

        table_component_column_toggle__classCallCheck(this, ColumnToggleController);

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$window = $window;
        this.$document = $document;
        this.rcMediaQuery = rcMediaQuery;
        this.isOpen = false;
        this.states = [];
    }

    table_component_column_toggle__createClass(ColumnToggleController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.toggleLabel = lib_default.a.get('rc.table.column-dropdown');
            this.tableCtrl.registerChangeHandler(function () {
                _this.$updateColumnToggleStatuses();
            });
        }
    }, {
        key: '$postLink',
        value: function $postLink() {
            var _this2 = this;

            var close = function close() {
                _this2.$scope.$apply(function () {
                    _this2.isOpen = false;
                });
            };
            this.removeDocHandlers = buildRemovableHandler(this.$document, 'click', close);
            var debounce = void 0;
            var resize = function resize() {
                if (debounce) {
                    _this2.$timeout.cancel(debounce);
                }
                debounce = _this2.$timeout(function () {
                    return _this2.$updateColumnToggleStatuses();
                }, 100);
            };
            this.removeWindowHandlers = buildRemovableHandler(this.$window, 'resize', resize);
            this.$updateColumnToggleStatuses();
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.removeDocHandlers();
            this.removeWindowHandlers();
        }
        /* Manual selection/deselection of a column supercedes column priority */

    }, {
        key: '$calculateVisibility',
        value: function $calculateVisibility(column) {
            if (Object(external__angular_["isDefined"])(column.toggleStatus)) {
                return column.toggleStatus;
            } else if (Object(external__angular_["isDefined"])(column.priority)) {
                if (column.priority === 'persist') {
                    return true;
                } else if (column.priority === 'hidden') {
                    return false;
                }
                return this.rcMediaQuery.minWidth(BREAKPOINT_MAP[column.priority]);
            }
            return true;
        }
    }, {
        key: '$updateColumnToggleStatuses',
        value: function $updateColumnToggleStatuses() {
            var _this3 = this;

            this.states.length = 0;
            Object(external__angular_["forEach"])(this.columns, function (column) {
                var visible = _this3.$calculateVisibility(column);
                _this3.states.push({
                    visible: visible,
                    title: column.title()
                });
            });
        }
    }, {
        key: 'isTogglable',
        value: function isTogglable(index) {
            var priority = this.columns[index].priority;
            return priority ? priority !== 'persist' : true;
        }
    }, {
        key: 'toggleColumn',
        value: function toggleColumn(index, event) {
            event.stopPropagation();
            if (event.target.nodeName !== 'LABEL') {
                var state = this.states[index].visible;
                // row click will not trigger the input change
                if (event.target.nodeName !== 'INPUT') {
                    state = !state;
                }
                this.onColumnToggle({
                    $event: { index: index, state: state }
                });
            }
        }
    }, {
        key: 'toggleDisplay',
        value: function toggleDisplay(event) {
            event.stopPropagation();
            this.isOpen = !this.isOpen;
        }
    }]);

    return ColumnToggleController;
}();
var ColumnToggleComponent = {
    bindings: {
        columns: '<',
        onColumnToggle: '&'
    },
    require: {
        tableCtrl: '^^rcTable'
    },
    controller: table_component_column_toggle_ColumnToggleController,
    controllerAs: 'toggleCtrl',
    template: table_column_toggle_default.a
};
/* harmony default export */ var table_component_column_toggle = (ColumnToggleComponent);
// EXTERNAL MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__(162);

// EXTERNAL MODULE: ./src/utils/utils.events.ts
var utils_events = __webpack_require__(26);

// CONCATENATED MODULE: ./src/table/fixed-ends.service.ts
var fixed_ends_service__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function fixed_ends_service__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// This will break in hot-reload mode for IE11. Final build unaffected.
// https://github.com/que-etc/resize-observer-polyfill/issues/20


var Edges;
(function (Edges) {
    Edges[Edges["TOP"] = 0] = "TOP";
    Edges[Edges["BOTTOM"] = 1] = "BOTTOM";
})(Edges || (Edges = {}));
var CELLS = 'td,th';
var FOOTER = 'TFOOT';
var HEADER = 'THEAD';
var LOCK_FIXED = 'fixed-lock';
var MUTATION_CONFIG = { childList: true, subtree: true };
var SCROLL = 'scroll';
var TRACKER = 'is-tracker';

var FixedEndsService = function () {
    FixedEndsService.$inject = ['$position'];

    function FixedEndsService($position) {
        'ngInject';

        fixed_ends_service__classCallCheck(this, FixedEndsService);

        this.$position = $position;
    }

    fixed_ends_service__createClass(FixedEndsService, [{
        key: 'manage',
        value: function manage(table, manageHeader, manageFooter) {
            new fixed_ends_service_TableEndsManager(this.$position, table, manageHeader, manageFooter);
        }
    }]);

    return FixedEndsService;
}();

/* harmony default export */ var fixed_ends_service = (FixedEndsService);

var fixed_ends_service_TableEndsManager = function () {
    function TableEndsManager($position, table, manageHeader, manageFooter) {
        fixed_ends_service__classCallCheck(this, TableEndsManager);

        this.$position = $position;
        this.table = table;
        this.manageHeader = manageHeader;
        this.manageFooter = manageFooter;
        this._eventRemovers = [];
        this._isAbove = false;
        this._isBelow = false;
        (manageHeader === true || manageFooter === true) && this._init();
    }

    fixed_ends_service__createClass(TableEndsManager, [{
        key: '_init',
        value: function _init() {
            this._parentContext = this.table.parentElement;
            this._scrollContext = isScrollable(this._parentContext) ? this._parentContext : getUniscrollContainer(this.table);
            this._header = this.manageHeader && this.table.querySelector(HEADER) || null;
            this._footer = this.manageFooter && this.table.querySelector(FOOTER) || null;
            this._buildObservers();
            this._setTrackingEdges();
            this._bindEventHandlers();
            this._onMutations();
        }
    }, {
        key: '_addEdgeTracker',
        value: function _addEdgeTracker(target) {
            var previous = this._getTrackerFor(target);
            // TODO: Reduce to just 'previous.remove()' when IE11 has died a horrible death
            previous && previous.parentNode.removeChild(previous);
            var tracker = buildTrackingEdge(target, this._trackCellObserver);
            target.insertAdjacentElement('afterend', tracker);
        }
    }, {
        key: '_addEventHandler',
        value: function _addEventHandler(target, eventName, handler) {
            this._eventRemovers.push(Object(utils_events["a" /* removableEventHandler */])(target, eventName, handler));
        }
    }, {
        key: '_bindEventHandlers',
        value: function _bindEventHandlers() {
            var _this = this;

            this._addEventHandler(document, SCROLL, function () {
                return _this._onScroll();
            });
            if (!isBody(this._scrollContext)) {
                this._addEventHandler(this._scrollContext, SCROLL, function () {
                    return _this._onScroll();
                });
            }
            // Horizontal scroll capture if body scroll is not being used
            if (this._parentContext !== this._scrollContext) {
                this._addEventHandler(this._parentContext, SCROLL, function () {
                    return _this._onScroll();
                });
            }
            this.table.addEventListener('$destroy', function () {
                return _this._cleanup();
            });
        }
    }, {
        key: '_buildObservers',
        value: function _buildObservers() {
            var _this2 = this;

            this._originObserver = new MutationObserver(function () {
                return _this2._onMutations();
            });
            this.manageHeader && this._originObserver.observe(this._header, MUTATION_CONFIG);
            this.manageFooter && this._originObserver.observe(this._footer, MUTATION_CONFIG);
            this._viewableObserver = new ResizeObserver_es["a" /* default */](function () {
                return _this2._onResizeViewable();
            });
            this._viewableObserver.observe(this._parentContext);
            this._viewableObserver.observe(document.body);
            this._trackCellObserver = new ResizeObserver_es["a" /* default */](function () {
                return _this2._onResizeTracking();
            });
        }
    }, {
        key: '_cleanup',
        value: function _cleanup() {
            this._originObserver.disconnect();
            this._viewableObserver.disconnect();
            this._trackCellObserver.disconnect();
            this._eventRemovers.forEach(function (remover) {
                return remover();
            });
        }
    }, {
        key: '_checkIntersect',
        value: function _checkIntersect() {
            var intersect = this.$position.relativeToContainer(this.table, this._scrollContext);
            // Change the state if the header is moving past the bottom
            if (intersect.above === true && intersect.belowBy < 0 && intersect.aboveBy + this._header.offsetHeight > this.table.offsetHeight) {
                intersect.above = false;
            }
            // Only modify if the above/below state has changed
            if (this.manageHeader && intersect.above !== this._isAbove) {
                this._onIntersectChange(this._header, intersect.above);
                this._isAbove = intersect.above;
            }
            if (intersect.below === true && intersect.aboveBy < 0 && intersect.belowBy + this._header.offsetHeight > this.table.offsetHeight) {
                intersect.below = false;
            }
            if (this.manageFooter && intersect.below !== this._isBelow) {
                this._onIntersectChange(this._footer, intersect.below);
                this._isBelow = intersect.below;
            }
        }
    }, {
        key: '_getTrackerFor',
        value: function _getTrackerFor(target) {
            return this.table.querySelector(target.nodeName + '[' + TRACKER + ']');
        }
    }, {
        key: '_lock',
        value: function _lock(target) {
            var tracker = this._getTrackerFor(target);
            // Avoid excess flicker by padding before taking the element out of flow. Keeps the intersect consistent.
            if (target.nodeName === HEADER) {
                this.table.style.paddingTop = target.getBoundingClientRect().height + 'px';
            } else {
                this.table.style.paddingBottom = target.getBoundingClientRect().height + 'px';
            }
            target.setAttribute(LOCK_FIXED, '');
            // When initially taken from the flow, the cells will collapse to their natural width.
            // Set it as the minWidth on tracking cells.
            this._syncToTrackerWidths(target);
            this._positionViewable(target);
        }
    }, {
        key: '_onScroll',
        value: function _onScroll() {
            var _this3 = this;

            cancelAnimationFrame(this._scrollAnimationFrameID);
            this._scrollAnimationFrameID = window.requestAnimationFrame(function () {
                var headLocked = isLocked(_this3._header);
                var footLocked = isLocked(_this3._footer);
                _this3._checkIntersect();
                // If the locked state has not changed, check horizontal alignment
                headLocked === true && isLocked(_this3._header) && _this3._positionViewable(_this3._header);
                footLocked === true && isLocked(_this3._footer) && _this3._positionViewable(_this3._footer);
                _this3._scrollAnimationFrameID = null;
            });
        }
    }, {
        key: '_onIntersectChange',
        value: function _onIntersectChange(target, isBeyond) {
            if (isBeyond && !isLocked(target)) {
                this._lock(target);
            } else if (!isBeyond && isLocked(target)) {
                this._unlock(target);
            }
        }
    }, {
        key: '_onMutations',
        value: function _onMutations() {
            var _this4 = this;

            window.requestAnimationFrame(function () {
                // Resizes will fire due to tracking cell width changes
                _this4._setTrackingEdges();
            });
        }
    }, {
        key: '_removeTrackingEdges',
        value: function _removeTrackingEdges() {
            this._trackCellObserver.disconnect();
            var previous = this.table.querySelectorAll(HEADER + '[' + TRACKER + '],' + FOOTER + '[' + TRACKER + ']');
            for (var index = 0; index < previous.length; index++) {
                this.table.removeChild(previous[index]);
            }
            // Left-over widths may affect new alignments
            this.manageHeader && removeWidths(this._header);
            this.manageFooter && removeWidths(this._footer);
        }
    }, {
        key: '_onResizeTracking',
        value: function _onResizeTracking() {
            var _this5 = this;

            window.requestAnimationFrame(function () {
                isLocked(_this5._header) && _this5._syncToTrackerWidths(_this5._header);
                isLocked(_this5._footer) && _this5._syncToTrackerWidths(_this5._footer);
            });
        }
    }, {
        key: '_onResizeViewable',
        value: function _onResizeViewable() {
            var _this6 = this;

            cancelAnimationFrame(this._resizeAnimationFrameID);
            this._resizeAnimationFrameID = window.requestAnimationFrame(function () {
                var headLocked = isLocked(_this6._header);
                var footLocked = isLocked(_this6._footer);
                _this6._checkIntersect();
                // Do not realign recently locked/unlocked items
                if (headLocked === true && isLocked(_this6._header)) {
                    _this6._syncToTrackerWidths(_this6._header);
                    _this6._positionViewable(_this6._header);
                }
                if (footLocked === true && isLocked(_this6._footer)) {
                    _this6._syncToTrackerWidths(_this6._footer);
                    _this6._positionViewable(_this6._footer);
                }
            });
        }
    }, {
        key: '_setTrackingEdges',
        value: function _setTrackingEdges() {
            this._removeTrackingEdges();
            this.manageHeader && this._addEdgeTracker(this._header);
            this.manageFooter && this._addEdgeTracker(this._footer);
        }
    }, {
        key: '_syncToTrackerWidths',
        value: function _syncToTrackerWidths(target) {
            var tracker = this._getTrackerFor(target);
            var innerScroll = this._parentContext === this._scrollContext ? 2 : 0;
            // IE11 requires exact measurement. OffsetWidth does not cut it.
            target.style.width = this.table.getBoundingClientRect().width + 'px';
            syncEdgeCells(target, tracker);
        }
    }, {
        key: '_positionViewable',
        value: function _positionViewable(target) {
            this._setEdgePosition(target);
            this._setViewableEdge(target);
        }
    }, {
        key: '_setEdgePosition',
        value: function _setEdgePosition(target) {
            var top = void 0;
            if (isBody(this._scrollContext)) {
                top = target === this._header ? 0 : window.innerHeight - target.offsetHeight;
            } else if (this._parentContext === this._scrollContext) {
                var fromTopEdge = this.$position.offset(this._scrollContext).top - window.pageYOffset;
                top = target === this._header ? fromTopEdge : fromTopEdge + this._scrollContext.clientHeight - target.offsetHeight;
            } else {
                var isModalScroll = this._scrollContext.nodeName === 'MODAL-CONTENT';
                var offsetTop = this.$position.offset(this._scrollContext).top;
                top = target === this._header ? offsetTop : offsetTop + this._scrollContext.offsetHeight - target.offsetHeight;
                top = top - (isModalScroll ? window.pageYOffset : 0);
            }
            target.style.left = this.$position.offset(this.table).left + 'px';
            target.style.top = top + 'px';
        }
        // Only expose the width available to the parentContext

    }, {
        key: '_setViewableEdge',
        value: function _setViewableEdge(target) {
            var tracker = this._getTrackerFor(target);
            var clientWidth = this._parentContext.offsetWidth;
            var scrollWidth = this.table.offsetWidth;
            if (clientWidth < scrollWidth) {
                var scrollLeft = this._parentContext.scrollLeft;
                var vertScrollBar = this._parentContext.offsetWidth - this._parentContext.clientWidth;
                var right = scrollWidth - clientWidth - scrollLeft;
                target.style.clipPath = 'inset(0 ' + (right + vertScrollBar) + 'px 0 ' + scrollLeft + 'px)';
                // For browsers that do not support the clip-path property (IE11, FF, etc)
                // @deprecated and should eventually go away
                if (!target.style.clipPath) {
                    right = clientWidth + scrollLeft;
                    target.style.clip = 'rect(0px, ' + (right - vertScrollBar) + 'px, ' + target.offsetHeight + 'px, ' + scrollLeft + 'px)';
                }
            } else {
                target.style.clipPath = null;
                target.style.clip = null;
            }
        }
    }, {
        key: '_unlock',
        value: function _unlock(target) {
            removeWidths(target);
            removeWidths(this._getTrackerFor(target));
            cleanLockAttributes(target);
            if (target.nodeName === HEADER) {
                this.table.style.paddingTop = null;
            } else {
                this.table.style.paddingBottom = null;
            }
        }
    }]);

    return TableEndsManager;
}();

function buildTrackingEdge(target, observer) {
    var trackingEdge = target.cloneNode(true);
    cleanLockAttributes(trackingEdge);
    trackingEdge.setAttribute(TRACKER, '');
    var trackers = trackingEdge.querySelectorAll(CELLS);
    for (var index = 0; index < trackers.length; index++) {
        var cell = trackers[index];
        cell.innerHTML = '<width-only>' + cell.innerHTML + '</width-only>';
        observer.observe(cell);
    }
    return trackingEdge;
}
function cleanLockAttributes(target) {
    target.removeAttribute(LOCK_FIXED);
    target.removeAttribute('style');
}
function getUniscrollContainer(target) {
    var container = document.body;
    var modal = container.querySelector('modal-container');
    if (modal) {
        var potentials = modal.querySelectorAll(target.nodeName);
        for (var index = 0; index < potentials.length; index++) {
            if (potentials[index] === target) {
                return modal.querySelector('modal-content');
            }
        }
    }
    return container;
}
function isBody(target) {
    return target && target.nodeName === 'BODY';
}
function isLocked(target) {
    return target && target.hasAttribute(LOCK_FIXED);
}
function isScrollable(target) {
    if (!target) {
        return;
    }
    var style = window.getComputedStyle(target, null);
    // TODO: Remove 1px offset. IE11 always fails at scrollHeight vs clientHeight.
    if (target.scrollHeight > target.clientHeight + 1 || style.maxHeight !== 'none') {
        return true;
    }
    return style.overflow === SCROLL || style.overflowY === SCROLL;
}
function removeWidths(target) {
    if (!target) {
        return;
    }
    target.style.width = null;
    var cells = target.querySelectorAll(CELLS);
    for (var index = 0; index < cells.length; index++) {
        cells[index].style.width = null;
        cells[index].style.minWidth = null;
    }
}
function syncEdgeCells(original, tracker) {
    if (!original || !tracker) {
        return;
    }
    var cells = original.querySelectorAll(CELLS);
    var trackCells = tracker.querySelectorAll(CELLS);
    if (cells.length !== trackCells.length) {
        return;
    }
    for (var index = 0; index < cells.length; index++) {
        syncCells(cells[index], trackCells[index]);
    }
}
function syncCells(cell, tracker) {
    if (!cell || !tracker) {
        return;
    }
    // IE11 requires exact measurement. OffsetWidth does not cut it.
    cell.style.width = tracker.getBoundingClientRect().width + 'px';
}
// CONCATENATED MODULE: ./src/table/index.ts















/* harmony default export */ var src_table = __webpack_exports__["a"] = (Object(external__angular_["module"])('rc.table', [infiniteScroll["a" /* default */], keyboardNavigation["a" /* default */], mediaQuery["b" /* default */], position["a" /* default */], usage["b" /* default */], utils["a" /* default */], overlay["a" /* default */]]).component('rcTable', table_component).component('rcTableColumnToggle', table_component_column_toggle).directive('columnPriorities', ColumnPrioritiesDirective).directive('rcTableAgent', TableAgent).directive('rcTable', TableDirective).service('$fixedEnds', fixed_ends_service).factory('RcTableParams', table_factory).name);


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "angular"
var external__angular_ = __webpack_require__(0);
var external__angular__default = /*#__PURE__*/__webpack_require__.n(external__angular_);

// EXTERNAL MODULE: ./src/bindHtml/index.ts + 2 modules
var bindHtml = __webpack_require__(25);

// EXTERNAL MODULE: ./src/position/index.ts + 4 modules
var position = __webpack_require__(17);

// EXTERNAL MODULE: ./src/usage/index.ts + 3 modules
var usage = __webpack_require__(1);

// CONCATENATED MODULE: ./src/tooltip/tooltip.directive.ts
rcTooltipDirective.$inject = ['$tooltip'];
function rcTooltipDirective($tooltip) {
    'ngInject';

    return $tooltip('rcTooltip', 'tooltip', 'mouseenter');
}
/* harmony default export */ var tooltip_directive = (rcTooltipDirective);
// EXTERNAL MODULE: ./src/tooltip/templates/tooltip-popup.html
var tooltip_popup = __webpack_require__(167);
var tooltip_popup_default = /*#__PURE__*/__webpack_require__.n(tooltip_popup);

// CONCATENATED MODULE: ./src/tooltip/tooltip.directive.popup.ts

function rcTooltipPopupDirective() {
    return {
        restrict: 'EA',
        scope: {
            content: '@',
            placement: '@',
            animation: '&',
            isOpen: '&'
        },
        template: tooltip_popup_default.a
    };
}
/* harmony default export */ var tooltip_directive_popup = (rcTooltipPopupDirective);
// CONCATENATED MODULE: ./src/tooltip/tooltip.directive.unsafe.ts
rcTooltipUnsafeDirective.$inject = ['$tooltip'];
function rcTooltipUnsafeDirective($tooltip) {
    'ngInject';

    return $tooltip('rcTooltipHtmlUnsafe', 'tooltip', 'mouseenter');
}
/* harmony default export */ var tooltip_directive_unsafe = (rcTooltipUnsafeDirective);
// EXTERNAL MODULE: ./src/tooltip/templates/tooltip-html-unsafe-popup.html
var tooltip_html_unsafe_popup = __webpack_require__(168);
var tooltip_html_unsafe_popup_default = /*#__PURE__*/__webpack_require__.n(tooltip_html_unsafe_popup);

// CONCATENATED MODULE: ./src/tooltip/tooltip.directive.unsafe.popup.ts

function rcTooltipHtmlUnsafePopupDirective() {
    return {
        restrict: 'EA',
        scope: {
            content: '@',
            placement: '@',
            animation: '&',
            isOpen: '&'
        },
        template: tooltip_html_unsafe_popup_default.a
    };
}
/* harmony default export */ var tooltip_directive_unsafe_popup = (rcTooltipHtmlUnsafePopupDirective);
// CONCATENATED MODULE: ./src/tooltip/tooltip.service.ts
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var tooltip_service_TooltipService = function () {
    function TooltipService() {
        _classCallCheck(this, TooltipService);
    }

    _createClass(TooltipService, [{
        key: "open",
        value: function open(tooltipScope) {
            if (this.openScope) {
                this.openScope.ttIsOpen = false;
            }
            this.openScope = tooltipScope;
        }
    }, {
        key: "close",
        value: function close(tooltipScope) {
            if (this.openScope === tooltipScope) {
                this.openScope = null;
            }
        }
    }]);

    return TooltipService;
}();

/* harmony default export */ var tooltip_service = (tooltip_service_TooltipService);
// CONCATENATED MODULE: ./src/tooltip/tooltip.provider.ts

/**
 * The following features are still outstanding: animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, html tooltips, and selector delegation.
 */
/**
 * The $tooltip service creates tooltip- and popover-like directives as well as
 * houses global options for them.
 */
function $tooltipProvider() {
    TooltipService.$inject = ['$window', '$compile', '$timeout', '$parse', '$document', '$position', '$interpolate', 'Usage', 'tooltipService'];

    // The default options tooltip and popover.
    var defaultOptions = {
        placement: 'top',
        animation: true,
        popupDelay: 500,
        hoverTimeoutMills: 1200
    };
    // Default hide triggers for each show trigger
    var triggerMap = {
        mouseenter: 'mouseleave',
        click: 'click',
        focus: 'blur'
    };
    // The options specified to the provider globally.
    var globalOptions = {};
    /**
     * `options({})` allows global configuration of all tooltips in the
     * application.
     *
     *   var app = angular.module( 'App', ['rc.tooltip.tooltip'], function( $tooltipProvider ) {
     *     // place tooltips left instead of top by default
     *     $tooltipProvider.options( { placement: 'left' } );
     *   });
     */
    this.options = function (value) {
        Object(external__angular_["extend"])(globalOptions, value);
        return this;
    };
    /**
     * This allows you to extend the set of trigger mappings available. E.g.:
     *
     *   $tooltipProvider.setTriggers( 'openTrigger': 'closeTrigger' );
     */
    this.setTriggers = function setTriggers(triggers) {
        Object(external__angular_["extend"])(triggerMap, triggers);
        return this;
    };
    /**
     * This is a helper function for translating camel-case to snake-case.
     */
    function snakeCase(name) {
        var regexp = /[A-Z]/g;
        var separator = '-';
        return name.replace(regexp, function (letter, pos) {
            return (pos ? separator : '') + letter.toLowerCase();
        });
    }
    this.$get = TooltipService;
    return this;
    /**
     * Returns the actual instance of the $tooltip service.
     * TODO support multiple triggers
     */
    function TooltipService($window, $compile, $timeout, $parse, $document, $position, $interpolate, Usage, tooltipService) {
        'ngInject';

        return function $tooltip(type, prefix, defaultTriggerShow) {
            var options = Object(external__angular_["extend"])({}, defaultOptions, globalOptions);
            /**
             * Returns an object of show and hide triggers.
             *
             * If a trigger is supplied,
             * it is used to show the tooltip; otherwise, it will use the `trigger`
             * option passed to the `$tooltipProvider.options` method; else it will
             * default to the trigger supplied to this directive factory.
             *
             * The hide trigger is based on the show trigger. If the `trigger` option
             * was passed to the `$tooltipProvider.options` method, it will use the
             * mapped trigger from `triggerMap` or the passed trigger if the map is
             * undefined; otherwise, it uses the `triggerMap` value of the show
             * trigger; else it will just use the show trigger.
             */
            function getTriggers(trigger) {
                var show = trigger || options.trigger || defaultTriggerShow;
                var hide = triggerMap[show] || show;
                return {
                    show: show,
                    hide: hide
                };
            }
            var directiveName = snakeCase(type);
            var startSym = $interpolate.startSymbol();
            var endSym = $interpolate.endSymbol();
            var template = '<div ' + directiveName + '-popup\n                content="' + startSym + '::ttContent' + endSym + '"\n                placement="' + startSym + '::ttPlacement' + endSym + '"\n                animation="ttAnimation"\n                is-open="ttIsOpen"></div>';
            return {
                restrict: 'EA',
                scope: true,
                compile: function compile(tElem, tAttrs) {
                    var tooltipLinker = $compile(template);
                    return function link(scope, $element, attrs) {
                        Usage.register('tooltip');
                        var tooltip = null;
                        var transitionTimeout;
                        var popupTimeout;
                        var appendToBody = Object(external__angular_["isDefined"])(options.appendToBody) ? options.appendToBody : true;
                        var triggers = getTriggers();
                        var hasRegisteredTriggers = false;
                        var hasEnableExp = Object(external__angular_["isDefined"])(attrs[prefix + 'Enable']);
                        if (!(!!$element[0].nodeName.match(/i|img|button/gi) || $element.hasClass('button'))) {
                            $element.addClass('has-tip');
                        }
                        var positionTooltip = function positionTooltip() {
                            var position, ttWidth, ttHeight, ttPosition;
                            // Get the position of the directive element.
                            position = appendToBody ? $position.offset($element) : $position.position($element);
                            if (scope.ttPlacement !== 'left') {
                                // Force a height adjustment for non-left elements
                                tooltip.css({ left: position.left + 'px' });
                            }
                            // Get the height and width of the tooltip so we can center it.
                            ttWidth = tooltip.prop('offsetWidth');
                            ttHeight = tooltip.prop('offsetHeight');
                            var ttPlacement = getAvailablePlacement(position, ttWidth, ttHeight);
                            // Calculate the tooltip's top and left coordinates to center it with this directive.
                            switch (ttPlacement) {
                                case 'right':
                                    ttPosition = {
                                        top: position.top + position.height / 2 - ttHeight / 2,
                                        left: position.left + position.width + 10
                                    };
                                    break;
                                case 'bottom':
                                    ttPosition = {
                                        top: position.top + position.height + 10,
                                        left: position.left
                                    };
                                    break;
                                case 'left':
                                    ttPosition = {
                                        top: position.top + position.height / 2 - ttHeight / 2,
                                        left: position.left - ttWidth - 10
                                    };
                                    break;
                                default:
                                    ttPosition = {
                                        top: position.top - ttHeight - 10,
                                        left: position.left
                                    };
                                    break;
                            }
                            ttPosition.top += 'px';
                            ttPosition.left += 'px';
                            // Now set the calculated positioning.
                            tooltip.css(ttPosition);
                        };
                        function getAvailablePlacement(elementPosition, ttWidth, ttHeight) {
                            var moveFromTo = function moveFromTo(oldPos, pos) {
                                var tipElement = Object(external__angular_["element"])(tooltip[0].querySelector('.tooltip'));
                                tipElement.removeClass('tip-' + oldPos);
                                tipElement.addClass('tip-' + pos);
                                return pos;
                            };
                            var placement = scope.ttPlacement;
                            var elementOffset = $position.offset($element);
                            var cannotFitOnTheLeft = elementPosition.left < ttWidth;
                            // Rotate to availale space: left-> right-> top-> bottom-> top
                            if (placement === 'left' && cannotFitOnTheLeft) {
                                placement = moveFromTo('left', 'right');
                            }
                            if (placement === 'right' && elementPosition.left + ttWidth > $window.innerWidth) {
                                placement = cannotFitOnTheLeft ? moveFromTo('right', 'top') : moveFromTo('right', 'left');
                            }
                            if (placement === 'top' && elementOffset.top - ttHeight < $window.scrollY) {
                                placement = moveFromTo('top', 'bottom');
                            }
                            if (placement === 'bottom' && elementOffset.top + ttHeight > $window.scrollY + $window.innerHeight) {
                                placement = moveFromTo('bottom', 'top');
                            }
                            return placement;
                        }
                        // By default, the tooltip is not open.
                        // TODO add ability to start tooltip opened
                        scope.ttIsOpen = false;
                        function toggleTooltipBind() {
                            if (!scope.ttIsOpen) {
                                showTooltipBind();
                            } else {
                                hideTooltipBind();
                            }
                        }
                        // Show the tooltip with delay if specified, otherwise show it immediately
                        function showTooltipBind() {
                            if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
                                return;
                            }
                            if (scope.ttPopupDelay) {
                                popupTimeout = $timeout(show, scope.ttPopupDelay, false);
                            } else {
                                show();
                            }
                        }
                        var allowTooltipHover = Object(external__angular_["isDefined"])(attrs[prefix + 'AllowHover']);
                        var hoverTimeout;
                        function hideTooltipBind() {
                            if (allowTooltipHover) {
                                // 1200 "seems" just enough time to be properly cancelled.
                                var mills = scope.$eval(attrs[prefix + 'AllowHover']) || options.hoverTimeoutMills;
                                hoverTimeout = $timeout(applyHide, mills);
                            } else {
                                applyHide();
                            }
                        }
                        function applyHide() {
                            scope.$apply(function () {
                                if (!scope.ttHovering) {
                                    if (hoverTimeout) {
                                        $timeout.cancel(hoverTimeout);
                                    }
                                    hide();
                                }
                            });
                        }
                        function tooltipMouseEnter() {
                            scope.ttHovering = true;
                        }
                        function tooltipMouseLeave() {
                            scope.ttHovering = false;
                            applyHide();
                        }
                        // Show the tooltip popup element.
                        function show() {
                            if (hoverTimeout) {
                                // Remove $timeout-delayed if trying to show the same tooltip again
                                $timeout.cancel(hoverTimeout);
                                hide();
                            }
                            // Don't show empty tooltips.
                            if (!scope.ttContent) {
                                return external__angular_["noop"];
                            }
                            createTooltip();
                            // If there is a pending remove transition, we must cancel it, lest the
                            // tooltip be mysteriously removed.
                            if (transitionTimeout) {
                                $timeout.cancel(transitionTimeout);
                            }
                            // Set the initial positioning.
                            tooltip.css({
                                top: 0,
                                left: 0,
                                display: 'block'
                            });
                            if (allowTooltipHover) {
                                tooltip.bind('mouseenter', tooltipMouseEnter);
                                tooltip.bind('mouseleave', tooltipMouseLeave);
                            }
                            // Now we add it to the DOM because need some info about it. But it's not
                            // visible yet anyway.
                            if (appendToBody) {
                                $document.find('body').append(tooltip);
                            } else {
                                $element.after(tooltip);
                            }
                            // align tooltip before showing
                            positionTooltip();
                            // When a tooltip is open, it will close when a user clicks/touches anywere else
                            // Should be removed if the tooltip is removed
                            $document.find('body').bind('click touchstart', hide);
                            // And show the tooltip.
                            scope.ttIsOpen = true;
                            tooltipService.open(scope);
                            scope.$digest(); // digest required as $apply is not called
                        }
                        // Hide the tooltip popup element.
                        function hide() {
                            // First things first: we don't show it anymore.
                            scope.ttIsOpen = false;
                            tooltipService.close(scope);
                            // if tooltip is going to be shown after delay, we must cancel this
                            $timeout.cancel(popupTimeout);
                            // And now we remove it from the DOM. However, if we have animation, we
                            // need to wait for it to expire beforehand.
                            // FIXME: this is a placeholder for a port of the transitions library.
                            if (scope.ttAnimation) {
                                transitionTimeout = $timeout(removeTooltip, 500);
                            } else {
                                removeTooltip();
                            }
                        }
                        function createTooltip() {
                            // There can only be one tooltip element per directive shown at once.
                            if (tooltip) {
                                removeTooltip();
                            }
                            tooltip = tooltipLinker(scope, function () {});
                            // Get contents rendered into the tooltip
                            scope.$digest();
                        }
                        function removeTooltip() {
                            if (tooltip) {
                                $document.find('body').unbind('click touchstart', hide);
                                tooltip.remove();
                                tooltip = null;
                            }
                        }
                        /**
                         * Observe the relevant attributes.
                         */
                        attrs.$observe(type, function (val) {
                            scope.ttContent = val;
                            if (!val && scope.ttIsOpen) {
                                hide();
                            }
                        });
                        if (Object(external__angular_["isUndefined"])(attrs[prefix + 'Placement'])) {
                            attrs[prefix + 'Placement'] = options.placement;
                        }
                        attrs.$observe(prefix + 'Placement', function (val) {
                            scope.ttPlacement = Object(external__angular_["isDefined"])(val) ? val : options.placement;
                        });
                        if (Object(external__angular_["isUndefined"])(attrs[prefix + 'PopupDelay'])) {
                            attrs[prefix + 'PopupDelay'] = options.popupDelay;
                        }
                        attrs.$observe(prefix + 'PopupDelay', function (val) {
                            var delay = parseInt(val, 10);
                            scope.ttPopupDelay = !isNaN(delay) ? delay : options.popupDelay;
                        });
                        var unregisterTriggers = function unregisterTriggers() {
                            if (hasRegisteredTriggers) {
                                $element.unbind(triggers.show, showTooltipBind);
                                $element.unbind(triggers.hide, hideTooltipBind);
                            }
                        };
                        var unregisterTriggerFunction = function unregisterTriggerFunction() {};
                        if (Object(external__angular_["isUndefined"])(attrs[prefix + 'Trigger'])) {
                            attrs[prefix + 'Trigger'] = options.trigger || defaultTriggerShow;
                        }
                        attrs.$observe(prefix + 'Trigger', function (val) {
                            unregisterTriggers();
                            unregisterTriggerFunction();
                            triggers = getTriggers(val);
                            if (Object(external__angular_["isFunction"])(triggers.show)) {
                                unregisterTriggerFunction = scope.$watch(function () {
                                    return triggers.show(scope, $element, attrs);
                                }, function (valSet) {
                                    return valSet ? $timeout(show) : $timeout(hide);
                                });
                            } else {
                                if (triggers.show === triggers.hide) {
                                    $element.bind(triggers.show, toggleTooltipBind);
                                } else {
                                    $element.bind(triggers.show, showTooltipBind);
                                    $element.bind(triggers.hide, hideTooltipBind);
                                }
                            }
                            hasRegisteredTriggers = true;
                        });
                        var animation = scope.$eval(attrs[prefix + 'Animation']);
                        scope.ttAnimation = Object(external__angular_["isDefined"])(animation) ? !!animation : options.animation;
                        attrs.$observe(prefix + 'AppendToBody', function (val) {
                            appendToBody = Object(external__angular_["isDefined"])(val) ? $parse(val)(scope) : appendToBody;
                        });
                        // if a tooltip is attached to <body> we need to remove it on
                        // location change as its parent scope will probably not be destroyed
                        // by the change.
                        if (appendToBody) {
                            scope.$on('$locationChangeSuccess', function closeTooltipOnLocationChangeSuccess() {
                                if (scope.ttIsOpen) {
                                    hide();
                                }
                            });
                        }
                        // Make sure tooltip is destroyed and removed.
                        scope.$on('$destroy', function onDestroyTooltip() {
                            $timeout.cancel(transitionTimeout);
                            $timeout.cancel(popupTimeout);
                            $timeout.cancel(hoverTimeout);
                            unregisterTriggers();
                            unregisterTriggerFunction();
                            removeTooltip();
                        });
                    };
                }
            };
        };
    }
}
// CONCATENATED MODULE: ./src/tooltip/index.ts










/* harmony default export */ var src_tooltip = __webpack_exports__["a"] = (Object(external__angular_["module"])('rc.tooltip', [bindHtml["a" /* default */], position["a" /* default */], usage["b" /* default */]]).directive('rcTooltip', tooltip_directive).provider('$tooltip', $tooltipProvider).directive('rcTooltipPopup', tooltip_directive_popup).directive('rcTooltipHtmlUnsafe', tooltip_directive_unsafe).directive('rcTooltipHtmlUnsafePopup', tooltip_directive_unsafe_popup).service('tooltipService', tooltip_service).name);
// Typings


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(78);


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/core-js/es6/map.js
var map = __webpack_require__(79);
var map_default = /*#__PURE__*/__webpack_require__.n(map);

// EXTERNAL MODULE: ./node_modules/core-js/es6/set.js
var set = __webpack_require__(96);
var set_default = /*#__PURE__*/__webpack_require__.n(set);

// EXTERNAL MODULE: ./node_modules/core-js/es6/symbol.js
var symbol = __webpack_require__(98);
var symbol_default = /*#__PURE__*/__webpack_require__.n(symbol);

// EXTERNAL MODULE: ./node_modules/core-js/fn/object/assign.js
var object_assign = __webpack_require__(104);
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/core-js/fn/symbol/iterator.js
var iterator = __webpack_require__(107);
var iterator_default = /*#__PURE__*/__webpack_require__.n(iterator);

// EXTERNAL MODULE: ./node_modules/core-js/fn/array/includes.js
var includes = __webpack_require__(108);
var includes_default = /*#__PURE__*/__webpack_require__.n(includes);

// EXTERNAL MODULE: ./src/utils/feature-tests.ts
var feature_tests = __webpack_require__(68);

// EXTERNAL MODULE: external "angular"
var external__angular_ = __webpack_require__(0);
var external__angular__default = /*#__PURE__*/__webpack_require__.n(external__angular_);

// EXTERNAL MODULE: ./src/alerts/index.ts + 3 modules
var alerts = __webpack_require__(70);

// EXTERNAL MODULE: ./src/mediaQuery/index.ts + 2 modules
var mediaQuery = __webpack_require__(20);

// EXTERNAL MODULE: ./src/modal/index.ts + 8 modules
var modal = __webpack_require__(31);

// EXTERNAL MODULE: ./src/reauthenticate/index.ts + 4 modules
var reauthenticate = __webpack_require__(74);

// EXTERNAL MODULE: ./src/table/index.ts + 9 modules
var table = __webpack_require__(75);

// EXTERNAL MODULE: ./src/tooltip/index.ts + 6 modules
var tooltip = __webpack_require__(76);

// EXTERNAL MODULE: ./src/usage/index.ts + 3 modules
var usage = __webpack_require__(1);

// EXTERNAL MODULE: ./src/validation/index.ts + 25 modules
var validation = __webpack_require__(49);

// CONCATENATED MODULE: ./src/public-api.ts








// CONCATENATED MODULE: ./src/index.ts
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "AlertsService", function() { return alerts["b" /* AlertsService */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "AlertsProvider", function() { return alerts["a" /* AlertsProvider */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MediaQueryService", function() { return mediaQuery["a" /* MediaQueryService */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "UsageProvider", function() { return usage["a" /* UsageProvider */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ValidatorsService", function() { return validation["b" /* ValidatorsService */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ValidationErrorMessagesProvider", function() { return validation["a" /* ValidationErrorMessagesProvider */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "RICOLA_REAUTH_PATH", function() { return reauthenticate["a" /* RICOLA_REAUTH_PATH */]; });








/*
 * Few things to note here:
 * - We use require() because it's the only supported syntax for both Webpack 1 and Rollup
 * - Would prefer to use import() as it's the propsed standard and works w/ Webpack 2+,
 *   but until Rollup supports we'll stick with require
 */
if (Object(feature_tests["a" /* shouldDeepRender */])()) {
  // Web Components Polyfills
  // This will require more complexity once we introduce components with shadow DOM.
  __webpack_require__(110);
  __webpack_require__(111);
} else {
  // Function.prototype.bind
  // In a future Ricola when Phantom 1.x has lower usage, move this polyfill to spec.bundle.js,
  // as described in http://wiki.www.uprr.com/confluence/questions/106178691/answers/106178710
  __webpack_require__(112);
}
/*
 * Angular APIs

 * Webpack hosts *all* ES import statements and runs them before any require statements.
 * We need the shouldDeepRender() function to run before loading any component modules,
 * so that necessitates us to use require() here.
 */
var ComponentModules = __webpack_require__(113).default;
var submodules = Object.keys(ComponentModules).map(function (component) {
  var name = component.substr(0, 1).toLowerCase() + component.substr(1);
  return 'rc.' + name;
});
/* harmony default export */ var src = __webpack_exports__["default"] = (Object(external__angular_["module"])('rc', submodules).name);
// Exported Public Typings


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(32);
__webpack_require__(36);
__webpack_require__(44);
__webpack_require__(88);
module.exports = __webpack_require__(6).Map;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(37);
var defined = __webpack_require__(38);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(41);
var descriptor = __webpack_require__(27);
var setToStringTag = __webpack_require__(29);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(15)(IteratorPrototype, __webpack_require__(2)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(7);
var anObject = __webpack_require__(16);
var getKeys = __webpack_require__(24);

module.exports = __webpack_require__(9) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(37);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(5).document;
module.exports = document && document.documentElement;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(10);
var toObject = __webpack_require__(58);
var IE_PROTO = __webpack_require__(42)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(59);
var step = __webpack_require__(60);
var Iterators = __webpack_require__(23);
var toIObject = __webpack_require__(19);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(39)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(61);
var validate = __webpack_require__(46);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(65)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(16);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(23);
var ITERATOR = __webpack_require__(2)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(51);
var ITERATOR = __webpack_require__(2)('iterator');
var Iterators = __webpack_require__(23);
module.exports = __webpack_require__(6).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var dP = __webpack_require__(7);
var DESCRIPTORS = __webpack_require__(9);
var SPECIES = __webpack_require__(2)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(2)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
var setPrototypeOf = __webpack_require__(95).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(8);
var anObject = __webpack_require__(16);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(28)(Function.call, __webpack_require__(66).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(32);
__webpack_require__(36);
__webpack_require__(44);
__webpack_require__(97);
module.exports = __webpack_require__(6).Set;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(61);
var validate = __webpack_require__(46);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(65)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(99);
__webpack_require__(32);
module.exports = __webpack_require__(6).Symbol;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(5);
var has = __webpack_require__(10);
var DESCRIPTORS = __webpack_require__(9);
var $export = __webpack_require__(22);
var redefine = __webpack_require__(14);
var META = __webpack_require__(45).KEY;
var $fails = __webpack_require__(18);
var shared = __webpack_require__(34);
var setToStringTag = __webpack_require__(29);
var uid = __webpack_require__(21);
var wks = __webpack_require__(2);
var wksExt = __webpack_require__(47);
var wksDefine = __webpack_require__(100);
var enumKeys = __webpack_require__(101);
var isArray = __webpack_require__(102);
var anObject = __webpack_require__(16);
var toIObject = __webpack_require__(19);
var toPrimitive = __webpack_require__(35);
var createDesc = __webpack_require__(27);
var _create = __webpack_require__(41);
var gOPNExt = __webpack_require__(103);
var $GOPD = __webpack_require__(66);
var $DP = __webpack_require__(7);
var $keys = __webpack_require__(24);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(67).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(30).f = $propertyIsEnumerable;
  __webpack_require__(48).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(40)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(15)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var core = __webpack_require__(6);
var LIBRARY = __webpack_require__(40);
var wksExt = __webpack_require__(47);
var defineProperty = __webpack_require__(7).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(24);
var gOPS = __webpack_require__(48);
var pIE = __webpack_require__(30);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(33);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(19);
var gOPN = __webpack_require__(67).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(105);
module.exports = __webpack_require__(6).Object.assign;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(22);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(106) });


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(24);
var gOPS = __webpack_require__(48);
var pIE = __webpack_require__(30);
var toObject = __webpack_require__(58);
var IObject = __webpack_require__(55);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(18)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(36);
__webpack_require__(44);
module.exports = __webpack_require__(47).f('iterator');


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(109);
module.exports = __webpack_require__(6).Array.includes;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(22);
var $includes = __webpack_require__(56)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(59)('includes');


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** This allows transpiled class code to be used in a modern browser for custom elements*/
window.customElements && eval("\n(() => {\n  'use strict';\n  if (!window.customElements) return;\n  const NativeHTMLElement = window.HTMLElement;\n  const nativeDefine = window.customElements.define;\n  const nativeGet = window.customElements.get;\n  const tagnameByConstructor = new Map();\n  const constructorByTagname = new Map();\n  let browserConstruction = false;\n  let userConstruction = false;\n\n  window.HTMLElement = function() {\n    if (!browserConstruction) {\n      const tagname = tagnameByConstructor.get(this.constructor);\n      const fakeClass = nativeGet.call(window.customElements, tagname);\n      userConstruction = true;\n      const instance = new (fakeClass)();\n      return instance;\n    }\n    browserConstruction = false;\n  };\n  window.HTMLElement.prototype = NativeHTMLElement.prototype;\n\n  const define = (tagname, elementClass) => {\n    const elementProto = elementClass.prototype;\n    const StandInElement = class extends NativeHTMLElement {\n      constructor() {\n        super();\n        Object.setPrototypeOf(this, elementProto);\n\n        if (!userConstruction) {\n          browserConstruction = true;\n          elementClass.call(this);\n        }\n        userConstruction = false;\n      }\n    };\n    const standInProto = StandInElement.prototype;\n    StandInElement.observedAttributes = elementClass.observedAttributes;\n    standInProto.connectedCallback = elementProto.connectedCallback;\n    standInProto.disconnectedCallback = elementProto.disconnectedCallback;\n    standInProto.attributeChangedCallback = elementProto.attributeChangedCallback;\n    standInProto.adoptedCallback = elementProto.adoptedCallback;\n\n    tagnameByConstructor.set(elementClass, tagname);\n    constructorByTagname.set(tagname, elementClass);\n    nativeDefine.call(window.customElements, tagname, StandInElement);\n  };\n  const get = (tagname) => constructorByTagname.get(tagname);\n  Object.defineProperty(window, 'customElements', {value: window.customElements, configurable: true, writable: true});\n  Object.defineProperty(window.customElements, 'define', {value: define, configurable: true, writable: true});\n  Object.defineProperty(window.customElements, 'get', {value: get, configurable: true, writable: true});\n})();\n");

//# sourceMappingURL=custom-element.js.map


/***/ }),
/* 111 */
/***/ (function(module, exports) {

(function(){
'use strict';var h=new function(){};var aa=new Set("annotation-xml color-profile font-face font-face-src font-face-uri font-face-format font-face-name missing-glyph".split(" "));function m(b){var a=aa.has(b);b=/^[a-z][.0-9_a-z]*-[\-.0-9_a-z]*$/.test(b);return!a&&b}function n(b){var a=b.isConnected;if(void 0!==a)return a;for(;b&&!(b.__CE_isImportDocument||b instanceof Document);)b=b.parentNode||(window.ShadowRoot&&b instanceof ShadowRoot?b.host:void 0);return!(!b||!(b.__CE_isImportDocument||b instanceof Document))}
function p(b,a){for(;a&&a!==b&&!a.nextSibling;)a=a.parentNode;return a&&a!==b?a.nextSibling:null}
function t(b,a,d){d=d?d:new Set;for(var c=b;c;){if(c.nodeType===Node.ELEMENT_NODE){var e=c;a(e);var f=e.localName;if("link"===f&&"import"===e.getAttribute("rel")){c=e.import;if(c instanceof Node&&!d.has(c))for(d.add(c),c=c.firstChild;c;c=c.nextSibling)t(c,a,d);c=p(b,e);continue}else if("template"===f){c=p(b,e);continue}if(e=e.__CE_shadowRoot)for(e=e.firstChild;e;e=e.nextSibling)t(e,a,d)}c=c.firstChild?c.firstChild:p(b,c)}}function u(b,a,d){b[a]=d};function v(){this.a=new Map;this.o=new Map;this.f=[];this.b=!1}function ba(b,a,d){b.a.set(a,d);b.o.set(d.constructor,d)}function w(b,a){b.b=!0;b.f.push(a)}function x(b,a){b.b&&t(a,function(a){return y(b,a)})}function y(b,a){if(b.b&&!a.__CE_patched){a.__CE_patched=!0;for(var d=0;d<b.f.length;d++)b.f[d](a)}}function z(b,a){var d=[];t(a,function(b){return d.push(b)});for(a=0;a<d.length;a++){var c=d[a];1===c.__CE_state?b.connectedCallback(c):A(b,c)}}
function B(b,a){var d=[];t(a,function(b){return d.push(b)});for(a=0;a<d.length;a++){var c=d[a];1===c.__CE_state&&b.disconnectedCallback(c)}}
function C(b,a,d){d=d?d:{};var c=d.w||new Set,e=d.s||function(a){return A(b,a)},f=[];t(a,function(a){if("link"===a.localName&&"import"===a.getAttribute("rel")){var d=a.import;d instanceof Node&&"complete"===d.readyState?(d.__CE_isImportDocument=!0,d.__CE_hasRegistry=!0):a.addEventListener("load",function(){var d=a.import;if(!d.__CE_documentLoadHandled){d.__CE_documentLoadHandled=!0;d.__CE_isImportDocument=!0;d.__CE_hasRegistry=!0;var f=new Set(c);f.delete(d);C(b,d,{w:f,s:e})}})}else f.push(a)},c);
if(b.b)for(a=0;a<f.length;a++)y(b,f[a]);for(a=0;a<f.length;a++)e(f[a])}
function A(b,a){if(void 0===a.__CE_state){var d=b.a.get(a.localName);if(d){d.constructionStack.push(a);var c=d.constructor;try{try{if(new c!==a)throw Error("The custom element constructor did not produce the element being upgraded.");}finally{d.constructionStack.pop()}}catch(r){throw a.__CE_state=2,r;}a.__CE_state=1;a.__CE_definition=d;if(d.attributeChangedCallback)for(d=d.observedAttributes,c=0;c<d.length;c++){var e=d[c],f=a.getAttribute(e);null!==f&&b.attributeChangedCallback(a,e,null,f,null)}n(a)&&
b.connectedCallback(a)}}}v.prototype.connectedCallback=function(b){var a=b.__CE_definition;a.connectedCallback&&a.connectedCallback.call(b)};v.prototype.disconnectedCallback=function(b){var a=b.__CE_definition;a.disconnectedCallback&&a.disconnectedCallback.call(b)};v.prototype.attributeChangedCallback=function(b,a,d,c,e){var f=b.__CE_definition;f.attributeChangedCallback&&-1<f.observedAttributes.indexOf(a)&&f.attributeChangedCallback.call(b,a,d,c,e)};function D(b,a){this.c=b;this.a=a;this.b=void 0;C(this.c,this.a);"loading"===this.a.readyState&&(this.b=new MutationObserver(this.f.bind(this)),this.b.observe(this.a,{childList:!0,subtree:!0}))}function E(b){b.b&&b.b.disconnect()}D.prototype.f=function(b){var a=this.a.readyState;"interactive"!==a&&"complete"!==a||E(this);for(a=0;a<b.length;a++)for(var d=b[a].addedNodes,c=0;c<d.length;c++)C(this.c,d[c])};function ca(){var b=this;this.b=this.a=void 0;this.f=new Promise(function(a){b.b=a;b.a&&a(b.a)})}function F(b){if(b.a)throw Error("Already resolved.");b.a=void 0;b.b&&b.b(void 0)};function G(b){this.i=!1;this.c=b;this.m=new Map;this.j=function(b){return b()};this.g=!1;this.l=[];this.u=new D(b,document)}
G.prototype.define=function(b,a){var d=this;if(!(a instanceof Function))throw new TypeError("Custom element constructors must be functions.");if(!m(b))throw new SyntaxError("The element name '"+b+"' is not valid.");if(this.c.a.get(b))throw Error("A custom element with name '"+b+"' has already been defined.");if(this.i)throw Error("A custom element is already being defined.");this.i=!0;var c,e,f,r,k;try{var g=function(b){var a=l[b];if(void 0!==a&&!(a instanceof Function))throw Error("The '"+b+"' callback must be a function.");
return a},l=a.prototype;if(!(l instanceof Object))throw new TypeError("The custom element constructor's prototype is not an object.");c=g("connectedCallback");e=g("disconnectedCallback");f=g("adoptedCallback");r=g("attributeChangedCallback");k=a.observedAttributes||[]}catch(q){return}finally{this.i=!1}a={localName:b,constructor:a,connectedCallback:c,disconnectedCallback:e,adoptedCallback:f,attributeChangedCallback:r,observedAttributes:k,constructionStack:[]};ba(this.c,b,a);this.l.push(a);this.g||
(this.g=!0,this.j(function(){return da(d)}))};function da(b){if(!1!==b.g){b.g=!1;for(var a=b.l,d=[],c=new Map,e=0;e<a.length;e++)c.set(a[e].localName,[]);C(b.c,document,{s:function(a){if(void 0===a.__CE_state){var e=a.localName,f=c.get(e);f?f.push(a):b.c.a.get(e)&&d.push(a)}}});for(e=0;e<d.length;e++)A(b.c,d[e]);for(;0<a.length;){for(var f=a.shift(),e=f.localName,f=c.get(f.localName),r=0;r<f.length;r++)A(b.c,f[r]);(e=b.m.get(e))&&F(e)}}}G.prototype.get=function(b){if(b=this.c.a.get(b))return b.constructor};
G.prototype.whenDefined=function(b){if(!m(b))return Promise.reject(new SyntaxError("'"+b+"' is not a valid custom element name."));var a=this.m.get(b);if(a)return a.f;a=new ca;this.m.set(b,a);this.c.a.get(b)&&!this.l.some(function(a){return a.localName===b})&&F(a);return a.f};G.prototype.v=function(b){E(this.u);var a=this.j;this.j=function(d){return b(function(){return a(d)})}};window.CustomElementRegistry=G;G.prototype.define=G.prototype.define;G.prototype.get=G.prototype.get;
G.prototype.whenDefined=G.prototype.whenDefined;G.prototype.polyfillWrapFlushCallback=G.prototype.v;var H=window.Document.prototype.createElement,ea=window.Document.prototype.createElementNS,fa=window.Document.prototype.importNode,ga=window.Document.prototype.prepend,ha=window.Document.prototype.append,ia=window.DocumentFragment.prototype.prepend,ja=window.DocumentFragment.prototype.append,I=window.Node.prototype.cloneNode,J=window.Node.prototype.appendChild,K=window.Node.prototype.insertBefore,L=window.Node.prototype.removeChild,M=window.Node.prototype.replaceChild,N=Object.getOwnPropertyDescriptor(window.Node.prototype,
"textContent"),O=window.Element.prototype.attachShadow,P=Object.getOwnPropertyDescriptor(window.Element.prototype,"innerHTML"),Q=window.Element.prototype.getAttribute,R=window.Element.prototype.setAttribute,S=window.Element.prototype.removeAttribute,T=window.Element.prototype.getAttributeNS,U=window.Element.prototype.setAttributeNS,ka=window.Element.prototype.removeAttributeNS,la=window.Element.prototype.insertAdjacentElement,ma=window.Element.prototype.prepend,na=window.Element.prototype.append,
V=window.Element.prototype.before,oa=window.Element.prototype.after,pa=window.Element.prototype.replaceWith,qa=window.Element.prototype.remove,ra=window.HTMLElement,W=Object.getOwnPropertyDescriptor(window.HTMLElement.prototype,"innerHTML"),sa=window.HTMLElement.prototype.insertAdjacentElement;function ta(){var b=X;window.HTMLElement=function(){function a(){var a=this.constructor,c=b.o.get(a);if(!c)throw Error("The custom element being constructed was not registered with `customElements`.");var e=c.constructionStack;if(!e.length)return e=H.call(document,c.localName),Object.setPrototypeOf(e,a.prototype),e.__CE_state=1,e.__CE_definition=c,y(b,e),e;var c=e.length-1,f=e[c];if(f===h)throw Error("The HTMLElement constructor was either called reentrantly for this constructor or called multiple times.");
e[c]=h;Object.setPrototypeOf(f,a.prototype);y(b,f);return f}a.prototype=ra.prototype;return a}()};function Y(b,a,d){function c(a){return function(d){for(var e=[],c=0;c<arguments.length;++c)e[c-0]=arguments[c];for(var c=[],f=[],l=0;l<e.length;l++){var q=e[l];q instanceof Element&&n(q)&&f.push(q);if(q instanceof DocumentFragment)for(q=q.firstChild;q;q=q.nextSibling)c.push(q);else c.push(q)}a.apply(this,e);for(e=0;e<f.length;e++)B(b,f[e]);if(n(this))for(e=0;e<c.length;e++)f=c[e],f instanceof Element&&z(b,f)}}d.h&&(a.prepend=c(d.h));d.append&&(a.append=c(d.append))};function ua(){var b=X;u(Document.prototype,"createElement",function(a){if(this.__CE_hasRegistry){var d=b.a.get(a);if(d)return new d.constructor}a=H.call(this,a);y(b,a);return a});u(Document.prototype,"importNode",function(a,d){a=fa.call(this,a,d);this.__CE_hasRegistry?C(b,a):x(b,a);return a});u(Document.prototype,"createElementNS",function(a,d){if(this.__CE_hasRegistry&&(null===a||"http://www.w3.org/1999/xhtml"===a)){var c=b.a.get(d);if(c)return new c.constructor}a=ea.call(this,a,d);y(b,a);return a});
Y(b,Document.prototype,{h:ga,append:ha})};function va(){var b=X;function a(a,c){Object.defineProperty(a,"textContent",{enumerable:c.enumerable,configurable:!0,get:c.get,set:function(a){if(this.nodeType===Node.TEXT_NODE)c.set.call(this,a);else{var e=void 0;if(this.firstChild){var d=this.childNodes,k=d.length;if(0<k&&n(this))for(var e=Array(k),g=0;g<k;g++)e[g]=d[g]}c.set.call(this,a);if(e)for(a=0;a<e.length;a++)B(b,e[a])}}})}u(Node.prototype,"insertBefore",function(a,c){if(a instanceof DocumentFragment){var e=Array.prototype.slice.apply(a.childNodes);
a=K.call(this,a,c);if(n(this))for(c=0;c<e.length;c++)z(b,e[c]);return a}e=n(a);c=K.call(this,a,c);e&&B(b,a);n(this)&&z(b,a);return c});u(Node.prototype,"appendChild",function(a){if(a instanceof DocumentFragment){var c=Array.prototype.slice.apply(a.childNodes);a=J.call(this,a);if(n(this))for(var e=0;e<c.length;e++)z(b,c[e]);return a}c=n(a);e=J.call(this,a);c&&B(b,a);n(this)&&z(b,a);return e});u(Node.prototype,"cloneNode",function(a){a=I.call(this,a);this.ownerDocument.__CE_hasRegistry?C(b,a):x(b,a);
return a});u(Node.prototype,"removeChild",function(a){var c=n(a),e=L.call(this,a);c&&B(b,a);return e});u(Node.prototype,"replaceChild",function(a,c){if(a instanceof DocumentFragment){var e=Array.prototype.slice.apply(a.childNodes);a=M.call(this,a,c);if(n(this))for(B(b,c),c=0;c<e.length;c++)z(b,e[c]);return a}var e=n(a),f=M.call(this,a,c),d=n(this);d&&B(b,c);e&&B(b,a);d&&z(b,a);return f});N&&N.get?a(Node.prototype,N):w(b,function(b){a(b,{enumerable:!0,configurable:!0,get:function(){for(var a=[],b=
0;b<this.childNodes.length;b++)a.push(this.childNodes[b].textContent);return a.join("")},set:function(a){for(;this.firstChild;)L.call(this,this.firstChild);J.call(this,document.createTextNode(a))}})})};function wa(b){var a=Element.prototype;function d(a){return function(e){for(var c=[],d=0;d<arguments.length;++d)c[d-0]=arguments[d];for(var d=[],k=[],g=0;g<c.length;g++){var l=c[g];l instanceof Element&&n(l)&&k.push(l);if(l instanceof DocumentFragment)for(l=l.firstChild;l;l=l.nextSibling)d.push(l);else d.push(l)}a.apply(this,c);for(c=0;c<k.length;c++)B(b,k[c]);if(n(this))for(c=0;c<d.length;c++)k=d[c],k instanceof Element&&z(b,k)}}V&&(a.before=d(V));V&&(a.after=d(oa));pa&&u(a,"replaceWith",function(a){for(var e=
[],c=0;c<arguments.length;++c)e[c-0]=arguments[c];for(var c=[],d=[],k=0;k<e.length;k++){var g=e[k];g instanceof Element&&n(g)&&d.push(g);if(g instanceof DocumentFragment)for(g=g.firstChild;g;g=g.nextSibling)c.push(g);else c.push(g)}k=n(this);pa.apply(this,e);for(e=0;e<d.length;e++)B(b,d[e]);if(k)for(B(b,this),e=0;e<c.length;e++)d=c[e],d instanceof Element&&z(b,d)});qa&&u(a,"remove",function(){var a=n(this);qa.call(this);a&&B(b,this)})};function xa(){var b=X;function a(a,c){Object.defineProperty(a,"innerHTML",{enumerable:c.enumerable,configurable:!0,get:c.get,set:function(a){var e=this,d=void 0;n(this)&&(d=[],t(this,function(a){a!==e&&d.push(a)}));c.set.call(this,a);if(d)for(var f=0;f<d.length;f++){var r=d[f];1===r.__CE_state&&b.disconnectedCallback(r)}this.ownerDocument.__CE_hasRegistry?C(b,this):x(b,this);return a}})}function d(a,c){u(a,"insertAdjacentElement",function(a,e){var d=n(e);a=c.call(this,a,e);d&&B(b,e);n(a)&&z(b,e);
return a})}O&&u(Element.prototype,"attachShadow",function(a){return this.__CE_shadowRoot=a=O.call(this,a)});if(P&&P.get)a(Element.prototype,P);else if(W&&W.get)a(HTMLElement.prototype,W);else{var c=H.call(document,"div");w(b,function(b){a(b,{enumerable:!0,configurable:!0,get:function(){return I.call(this,!0).innerHTML},set:function(a){var b="template"===this.localName?this.content:this;for(c.innerHTML=a;0<b.childNodes.length;)L.call(b,b.childNodes[0]);for(;0<c.childNodes.length;)J.call(b,c.childNodes[0])}})})}u(Element.prototype,
"setAttribute",function(a,c){if(1!==this.__CE_state)return R.call(this,a,c);var e=Q.call(this,a);R.call(this,a,c);c=Q.call(this,a);b.attributeChangedCallback(this,a,e,c,null)});u(Element.prototype,"setAttributeNS",function(a,c,d){if(1!==this.__CE_state)return U.call(this,a,c,d);var e=T.call(this,a,c);U.call(this,a,c,d);d=T.call(this,a,c);b.attributeChangedCallback(this,c,e,d,a)});u(Element.prototype,"removeAttribute",function(a){if(1!==this.__CE_state)return S.call(this,a);var c=Q.call(this,a);S.call(this,
a);null!==c&&b.attributeChangedCallback(this,a,c,null,null)});u(Element.prototype,"removeAttributeNS",function(a,c){if(1!==this.__CE_state)return ka.call(this,a,c);var d=T.call(this,a,c);ka.call(this,a,c);var e=T.call(this,a,c);d!==e&&b.attributeChangedCallback(this,c,d,e,a)});sa?d(HTMLElement.prototype,sa):la?d(Element.prototype,la):console.warn("Custom Elements: `Element#insertAdjacentElement` was not patched.");Y(b,Element.prototype,{h:ma,append:na});wa(b)};/*

 Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
 This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
 The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
 The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
 Code distributed by Google as part of the polymer project is also
 subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
var Z=window.customElements;if(!Z||Z.forcePolyfill||"function"!=typeof Z.define||"function"!=typeof Z.get){var X=new v;ta();ua();Y(X,DocumentFragment.prototype,{h:ia,append:ja});va();xa();document.__CE_hasRegistry=!0;var customElements=new G(X);Object.defineProperty(window,"customElements",{configurable:!0,enumerable:!0,value:customElements})};
}).call(self);

//# sourceMappingURL=custom-elements.min.js.map


/***/ }),
/* 112 */
/***/ (function(module, exports) {

if (typeof Function.prototype.bind != 'function') {
    Function.prototype.bind = function bind(obj) {
        var args = Array.prototype.slice.call(arguments, 1),
            self = this,
            nop = function() {
            },
            bound = function() {
                return self.apply(
                    this instanceof nop ? this : (obj || {}), args.concat(
                        Array.prototype.slice.call(arguments)
                    )
                );
            };
        nop.prototype = this.prototype || {};
        bound.prototype = new nop();
        return bound;
    };
}


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: external "angular"
var external__angular_ = __webpack_require__(0);
var external__angular__default = /*#__PURE__*/__webpack_require__.n(external__angular_);

// EXTERNAL MODULE: ./src/usage/index.ts + 3 modules
var usage = __webpack_require__(1);

// EXTERNAL MODULE: ./src/keyboardNavigation/index.ts + 1 modules
var keyboardNavigation = __webpack_require__(12);

// EXTERNAL MODULE: ./src/accordion/templates/accordion.html
var accordion = __webpack_require__(115);
var accordion_default = /*#__PURE__*/__webpack_require__.n(accordion);

// CONCATENATED MODULE: ./src/accordion/accordion.component.ts
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var DEFAULT_CLOSE_OTHERS = true;
var accordion_component_AccordionController = function () {
    AccordionController.$inject = ['Usage'];

    function AccordionController(Usage) {
        'ngInject';

        _classCallCheck(this, AccordionController);

        this._panels = [];
        Usage.register('accordion');
    }

    _createClass(AccordionController, [{
        key: 'addPanel',
        value: function addPanel(panel) {
            this._panels.push(panel);
        }
    }, {
        key: 'opened',
        value: function opened(openPanel) {
            if (this.individually) {
                Object(external__angular_["forEach"])(this._panels, function (panel) {
                    if (panel.isOpen && panel !== openPanel) {
                        panel.isOpen = false;
                    }
                });
            }
        }
    }, {
        key: 'removePanel',
        value: function removePanel(panel) {
            var index = this._panels.indexOf(panel);
            if (index !== -1) {
                this._panels.splice(index, 1);
            }
        }
    }, {
        key: 'individually',
        get: function get() {
            var configuredClose = this.closeOthers();
            return Object(external__angular_["isDefined"])(configuredClose) ? configuredClose : DEFAULT_CLOSE_OTHERS;
        }
    }]);

    return AccordionController;
}();
var AccordionComponent = {
    bindings: {
        closeOthers: '&'
    },
    controller: accordion_component_AccordionController,
    controllerAs: 'rcAccCtrl',
    transclude: true,
    template: accordion_default.a
};
/* harmony default export */ var accordion_component = (AccordionComponent);
// EXTERNAL MODULE: ./src/accordion/templates/accordion-panel.html
var accordion_panel = __webpack_require__(116);
var accordion_panel_default = /*#__PURE__*/__webpack_require__.n(accordion_panel);

// EXTERNAL MODULE: ./src/common/keyboard-codes.ts
var keyboard_codes = __webpack_require__(3);

// CONCATENATED MODULE: ./src/accordion/accordion.component.panel.ts
var accordion_component_panel__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function accordion_component_panel__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var ACTIVE_PANEL_CLASS = 'active';
var accordion_component_panel_AccordionPanelController = function () {
    AccordionPanelController.$inject = ['$element'];

    function AccordionPanelController($element) {
        'ngInject';

        accordion_component_panel__classCallCheck(this, AccordionPanelController);

        this.$element = $element;
    }

    accordion_component_panel__createClass(AccordionPanelController, [{
        key: '$onInit',
        value: function $onInit() {
            this.accordionCtrl.addPanel(this);
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.accordionCtrl.removePanel(this);
        }
    }, {
        key: 'isNonEnterKeyup',
        value: function isNonEnterKeyup(event) {
            // TODO: extract to KEYS Util.isEntrKey(key)
            return event.type === 'keyup' && event.which !== keyboard_codes["a" /* default */].ENTER;
        }
    }, {
        key: 'handleEvent',
        value: function handleEvent(event) {
            if (this.isNonEnterKeyup(event)) {
                return;
            }
            this.isOpen = !this.isOpen;
        }
    }, {
        key: 'isOpen',
        get: function get() {
            return this._isOpen;
        },
        set: function set(value) {
            this._isOpen = value;
            /* isOpen is a bound value and may be set during initialization before other bindings are available */
            if (value === true) {
                this.accordionCtrl && this.accordionCtrl.opened(this);
                this.$element && this.$element.addClass(ACTIVE_PANEL_CLASS);
                this.onOpen && this.onOpen();
            } else if (value === false) {
                this.$element && this.$element.removeClass(ACTIVE_PANEL_CLASS);
                this.onClose && this.onClose();
            }
        }
    }, {
        key: 'heading',
        get: function get() {
            return this._heading;
        },
        set: function set(heading) {
            this._heading = heading;
        }
    }]);

    return AccordionPanelController;
}();
var AccordionPanelComponent = {
    bindings: {
        heading: '@?',
        isOpen: '=?',
        onOpen: '&',
        onClose: '&'
    },
    require: {
        accordionCtrl: '^rcAccordion'
    },
    controller: accordion_component_panel_AccordionPanelController,
    controllerAs: 'rcAccPnlCtrl',
    template: accordion_panel_default.a,
    transclude: {
        accordionHeading: '?rcAccordionHeading'
    }
};
/* harmony default export */ var accordion_component_panel = (AccordionPanelComponent);
// CONCATENATED MODULE: ./src/accordion/index.ts





/* harmony default export */ var src_accordion = (Object(external__angular_["module"])('rc.accordion', [usage["b" /* default */], keyboardNavigation["a" /* default */]]).component('rcAccordion', accordion_component).component('rcAccordionPanel', accordion_component_panel).name);
// CONCATENATED MODULE: ./src/listview/listview.directive.ts
rcListviewDirective.$inject = ['$parse', 'Usage'];
function rcListviewDirective($parse, Usage) {
    'ngInject';

    return {
        restrict: 'EA',
        compile: ListviewCompile
    };
    function ListviewCompile(compileEl, attrs) {
        compileEl.addClass('rc-listview');
        var inset = $parse(attrs.inset)(null);
        if (typeof inset === 'boolean' && !inset) {
            compileEl.addClass('rc-listview-full-width');
        }
        return ListviewLink;
    }
    function ListviewLink(scope, element, attrs) {
        Usage.register('listview');
    }
}
/* harmony default export */ var listview_directive = (rcListviewDirective);
// CONCATENATED MODULE: ./src/listview/listview.directive.input-group.ts
inputGroupDirective.$inject = ['$parse', '$timeout'];
function inputGroupDirective($parse, $timeout) {
    'ngInject';

    return {
        restrict: 'A',
        compile: function compile(element, attrs) {
            element.addClass('rc-input-group');
            return linkFn;
        }
    };
    function linkFn(scope, element, attrs) {
        var isHorizontal = $parse(attrs.horizontal)(scope) ? 'horizontal' : '',
            isFullWidth = $parse(attrs.fullWidth)(scope) ? 'full-width' : '';
        element.addClass(isHorizontal);
        element.addClass(isFullWidth);
        if (isHorizontal) {
            $timeout(function () {
                var firstInputType = element.find('input')[0].type.toLowerCase();
                element.addClass('rc-' + firstInputType + '-group');
            });
        }
    }
}
/* harmony default export */ var listview_directive_input_group = (inputGroupDirective);
// CONCATENATED MODULE: ./src/listview/index.ts




/* harmony default export */ var listview = (Object(external__angular_["module"])('rc.listview', [usage["b" /* default */]]).directive('rcListview', listview_directive).directive('inputGroup', listview_directive_input_group).name);
// EXTERNAL MODULE: ./src/utils/feature-tests.ts
var feature_tests = __webpack_require__(68);

// EXTERNAL MODULE: ./src/groupbox/templates/groupbox.html
var groupbox = __webpack_require__(119);
var groupbox_default = /*#__PURE__*/__webpack_require__.n(groupbox);

// CONCATENATED MODULE: ./src/groupbox/groupbox.component.ts
var groupbox_component__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function groupbox_component__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var GroupboxController = function () {
    GroupboxController.$inject = ['Usage', '$element'];

    function GroupboxController(Usage, $element) {
        'ngInject';

        groupbox_component__classCallCheck(this, GroupboxController);

        this.$element = $element;
        Usage.register('groupbox');
    }

    groupbox_component__createClass(GroupboxController, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.$element[0].hasAttribute('light-styling')) {
                this.$element[0].children[0].setAttribute('light-styling', '');
            }
        }
    }]);

    return GroupboxController;
}();
var GroupboxComponent = {
    bindings: {
        heading: '@?'
    },
    transclude: {
        header: '?rcGroupboxHeading'
    },
    controller: GroupboxController,
    template: groupbox_default.a
};
/* harmony default export */ var groupbox_component = (GroupboxComponent);
// CONCATENATED MODULE: ./src/groupbox/index.ts



if (Object(feature_tests["a" /* shouldDeepRender */])()) {
    __webpack_require__(117);
}

/* harmony default export */ var src_groupbox = (Object(external__angular_["module"])('rc.groupbox', [usage["b" /* default */]]).component('rcGroupbox', groupbox_component).name);
// EXTERNAL MODULE: ./src/i18n/index.ts + 2 modules
var i18n = __webpack_require__(13);

// EXTERNAL MODULE: ./src/addRemove/templates/add-remove.html
var add_remove = __webpack_require__(120);
var add_remove_default = /*#__PURE__*/__webpack_require__.n(add_remove);

// EXTERNAL MODULE: ./node_modules/ricola3-i18n-translations/lib/index.js
var lib = __webpack_require__(4);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./src/addRemove/add-remove.component.ts
var add_remove_component__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function add_remove_component__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




function swapOut(items, from, to) {
    Object(external__angular_["forEach"])(items, function (item) {
        from.splice(from.indexOf(item), 1);
        to.push(item);
    });
}
var add_remove_component_AddRemoveController = function () {
    AddRemoveController.$inject = ['$element', 'Usage'];

    function AddRemoveController($element, Usage) {
        'ngInject';

        add_remove_component__classCallCheck(this, AddRemoveController);

        this.$element = $element;
        this.addRem = [];
        this.addSel = [];
        Usage.register('addRemove');
    }

    add_remove_component__createClass(AddRemoveController, [{
        key: '$onInit',
        value: function $onInit() {
            this.$element.addClass('rc-add-remove');
            this.available = this.available || [];
            this.selected = this.selected || [];
            this.displayProperty = this.displayProperty || '';
            this.availableTranslation = lib_default.a.get('rc.addRemove.available');
            this.selectedTranslation = lib_default.a.get('rc.addRemove.selected');
        }
    }, {
        key: 'addAll',
        value: function addAll() {
            this.selected = this.selected.concat(this.available);
            this.available = [];
            this.addRem = [];
        }
    }, {
        key: 'makeAllAvailable',
        value: function makeAllAvailable() {
            swapOut(this.addSel, this.selected, this.available);
            this.addSel = [];
        }
    }, {
        key: 'makeAllSelected',
        value: function makeAllSelected() {
            swapOut(this.addRem, this.available, this.selected);
            this.addRem = [];
        }
    }, {
        key: 'makeAvailable',
        value: function makeAvailable(item) {
            this.available.push(item);
            this.selected.splice(this.selected.indexOf(item), 1);
        }
    }, {
        key: 'makeSelected',
        value: function makeSelected(item) {
            this.selected.push(item);
            this.available.splice(this.available.indexOf(item), 1);
        }
    }, {
        key: 'removeAll',
        value: function removeAll() {
            this.available = this.available.concat(this.selected);
            this.selected = [];
            this.addSel = [];
        }
    }]);

    return AddRemoveController;
}();
// TODO: potentially break template out to sub-components
var AddRemoveComponent = {
    bindings: {
        available: '=',
        selected: '=',
        displayProperty: '=?'
    },
    controller: add_remove_component_AddRemoveController,
    controllerAs: 'addRemove',
    template: add_remove_default.a
};
/* harmony default export */ var add_remove_component = (AddRemoveComponent);
// EXTERNAL MODULE: ./src/addRemove/templates/add-remove-small.html
var add_remove_small = __webpack_require__(121);
var add_remove_small_default = /*#__PURE__*/__webpack_require__.n(add_remove_small);

// CONCATENATED MODULE: ./src/addRemove/add-remove.directive.small.ts

// TODO: This should likely become a non-data-mutating component
function RcAddRemoveSmallDirective() {
    return {
        restrict: 'A',
        template: add_remove_small_default.a
    };
}
// EXTERNAL MODULE: ./src/addRemove/templates/add-remove-large.html
var add_remove_large = __webpack_require__(122);
var add_remove_large_default = /*#__PURE__*/__webpack_require__.n(add_remove_large);

// CONCATENATED MODULE: ./src/addRemove/add-remove.directive.large.ts

// TODO: This should likely become a non-data-mutating component
function RcAddRemoveLargeDirective() {
    return {
        restrict: 'A',
        template: add_remove_large_default.a
    };
}
// CONCATENATED MODULE: ./src/addRemove/index.ts








/* harmony default export */ var addRemove = (Object(external__angular_["module"])('rc.addRemove', [usage["b" /* default */], listview, src_groupbox, i18n["a" /* default */]]).component('rcAddRemove', add_remove_component).directive('rcAddRemoveSmall', RcAddRemoveSmallDirective).directive('rcAddRemoveLarge', RcAddRemoveLargeDirective).name);
// EXTERNAL MODULE: ./src/alert/templates/alert.html
var templates_alert = __webpack_require__(123);
var alert_default = /*#__PURE__*/__webpack_require__.n(templates_alert);

// CONCATENATED MODULE: ./src/alert/alert.component.ts
var alert_component__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function alert_component__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var alert_component_AlertController = function () {
    AlertController.$inject = ['$scope', '$element', '$timeout', 'Usage'];

    function AlertController($scope, $element, $timeout, Usage) {
        'ngInject';

        alert_component__classCallCheck(this, AlertController);

        this.$scope = $scope;
        this.$element = $element;
        this.$timeout = $timeout;
        Usage.register('alert');
    }

    alert_component__createClass(AlertController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.onClose = Object(external__angular_["isFunction"])(this.onClose) ? this.onClose : external__angular_["noop"];
            this.timeoutMs = Object(external__angular_["isDefined"])(this.timeoutMs) ? this.timeoutMs : null;
            this.$scope.$watch(function () {
                return _this.focus();
            }, function (val) {
                if (val && typeof val === 'boolean' && _this.isClosable()) {
                    _this.$scope.$evalAsync(function () {
                        _this.$element.find('a')[0].focus();
                    });
                }
            });
            if (this.timeoutMs && /^\d+$/.test(this.timeoutMs)) {
                this._timer = this.$timeout(function () {
                    if (!_this.closeAlert) {
                        _this.close();
                    }
                }, parseInt(this.timeoutMs, 10));
            }
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            // Ensure the time clears if manually removed via $rcAlerts.clear() SID#215083
            this.$timeout.cancel(this._timer);
        }
    }, {
        key: 'close',
        value: function close() {
            this.onClose();
            this.closeAlert = true;
        }
    }, {
        key: 'getAlertClasses',
        value: function getAlertClasses() {
            return [this.getTypeClass(), this.showIcon() !== false ? 'show-icon' : null, this.closeAlert ? 'close-alert' : null];
        }
    }, {
        key: 'getTypeClass',
        value: function getTypeClass() {
            return this.type || 'info';
        }
    }, {
        key: 'isClosable',
        value: function isClosable() {
            return this.closeButton() !== false;
        }
    }]);

    return AlertController;
}();
var AlertComponent = {
    bindings: {
        type: '@',
        timeoutMs: '@timeout',
        closeButton: '&',
        showIcon: '&',
        ossInfo: '&',
        onClose: '&',
        focus: '&'
    },
    controller: alert_component_AlertController,
    controllerAs: 'rcAlertCtrl',
    template: alert_default.a,
    transclude: true
};
/* harmony default export */ var alert_component = (AlertComponent);
// EXTERNAL MODULE: ./src/alert/templates/alert.oss.html
var alert_oss = __webpack_require__(124);
var alert_oss_default = /*#__PURE__*/__webpack_require__.n(alert_oss);

// CONCATENATED MODULE: ./src/alert/alert.component.oss.ts
var alert_component_oss__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function alert_component_oss__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var alert_component_oss_AlertOssController = function () {
    function AlertOssController() {
        'ngInject';

        alert_component_oss__classCallCheck(this, AlertOssController);
    }

    alert_component_oss__createClass(AlertOssController, [{
        key: 'display',
        value: function display() {
            return this.tla() === true || this.isTla();
        }
    }, {
        key: 'isTla',
        value: function isTla() {
            var tla = this.tla();
            return Object(external__angular_["isString"])(tla) && tla.trim().length > 0;
        }
    }]);

    return AlertOssController;
}();
var AlertOssComponent = {
    bindings: {
        tla: '&'
    },
    controller: alert_component_oss_AlertOssController,
    controllerAs: 'rcAlertOssCtrl',
    template: alert_oss_default.a
};
/* harmony default export */ var alert_component_oss = (AlertOssComponent);
// CONCATENATED MODULE: ./src/alert/index.ts




/* harmony default export */ var src_alert = (Object(external__angular_["module"])('rc.alert', [usage["b" /* default */]]).component('rcAlert', alert_component).component('rcAlertOss', alert_component_oss).name);
// EXTERNAL MODULE: ./src/alerts/index.ts + 3 modules
var alerts = __webpack_require__(70);

// CONCATENATED MODULE: ./src/hoverIntent/hover-intent.constants.ts
var HOVER_TRIGGERS = [{
    name: 'rcHoverintent',
    trigger: 'mouseenter',
    cancel: 'mouseleave'
}, {
    name: 'rcHoverleave',
    trigger: 'mouseleave',
    cancel: 'mouseenter'
}];
// CONCATENATED MODULE: ./src/hoverIntent/index.ts

var hoverModule = Object(external__angular_["module"])('rc.hoverIntent', []);
var defaultDelay = 150;

Object(external__angular_["forEach"])(HOVER_TRIGGERS, function (e) {
    /* Manual dependency injection because ngmin/ngannotate doesn't pick this up */
    hoverModule.directive(e.name, ['$timeout', function ($timeout) {
        'ngInject';

        return {
            restrict: 'A',
            link: function link(scope, element, attributes) {
                var hoverPromise = void 0;
                function cancelDelayedEvent() {
                    var result = $timeout.cancel(hoverPromise);
                }
                element.bind(e.trigger, function (event) {
                    cancelDelayedEvent();
                    var delay = scope.$eval(attributes.rcHoverintentDelay) || 150;
                    hoverPromise = $timeout(function () {
                        scope.$eval(attributes[e.name], { $event: event });
                    }, delay);
                });
                element.bind(e.cancel, function () {
                    cancelDelayedEvent();
                });
            }
        };
    }]);
});
/* harmony default export */ var hoverIntent = (hoverModule.name);
// CONCATENATED MODULE: ./src/seamlessUi/seamlessUi.service.ts
var seamlessUi_service__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function seamlessUi_service__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var SEAMLESS_UI_CLASS = 'ricSeamlessUI';

var seamlessUi_service_SeamlessUiService = function () {
    SeamlessUiService.$inject = ['$window'];

    function SeamlessUiService($window) {
        'ngInject';

        seamlessUi_service__classCallCheck(this, SeamlessUiService);

        this.$window = $window;
    }

    seamlessUi_service__createClass(SeamlessUiService, [{
        key: 'isInSeamlessUIMode',
        value: function isInSeamlessUIMode() {
            try {
                return Object(external__angular_["element"])(this.$window.frameElement).hasClass(SEAMLESS_UI_CLASS);
            } catch (e) {
                return false;
            }
        }
    }, {
        key: 'openUrl',
        value: function openUrl(url, label) {
            this.$window.top.uit.sui.component.tabs.getTab(this.$window).create({ url: url, label: label });
        }
    }]);

    return SeamlessUiService;
}();

/* harmony default export */ var seamlessUi_service = (seamlessUi_service_SeamlessUiService);
// CONCATENATED MODULE: ./src/seamlessUi/index.ts


/* harmony default export */ var seamlessUi = (Object(external__angular_["module"])('rc.seamlessUi', []).service('rcSeamlessUi', seamlessUi_service).name);
// EXTERNAL MODULE: ./src/utils/index.ts + 4 modules
var utils = __webpack_require__(11);

// CONCATENATED MODULE: ./src/appTemplate/footer.service.ts
var footer_service__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function footer_service__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EMPLOYEES_FOOTER_CONTENT = [{ label: 'Home', url: 'https://employees.www.uprr.com/emp' }, { label: 'Search', url: 'https://employees.www.uprr.com/emp/search' }, { label: 'New Stuff', url: 'https://employees.www.uprr.com/emp/newstuff' }, {
    label: 'Phonebook',
    url: 'https://employees.www.uprr.com/emp/hr/phonebook'
}, {
    label: 'UP Online',
    url: 'https://employees.www.uprr.com/emp/news/uponline'
}, { label: 'Help', url: 'https://employees.www.uprr.com/helpinfo.shtml' }, { label: 'Feedback', url: 'https://employees.www.uprr.com/feedback.shtml' }];
var PUBLIC_FOOTER_CONTENT = [{ label: 'Home', url: 'https://www.up.com/index.htm' }, { label: 'Safety', url: 'https://www.up.com/aboutup/community/safety/' }, { label: 'Search', url: 'https://c02.my.uprr.com/uprr/search/' }, { label: 'Site Info', url: 'https://www.up.com/aboutup/site_info/' }, {
    label: 'Copyright',
    url: 'https://www.up.com/aboutup/corporate_info/copyright/'
}, {
    label: 'Privacy',
    url: 'https://www.up.com/aboutup/corporate_info/privacy/'
}, { label: 'Contact UP', url: 'https://www.up.com/aboutup/contact/' }, {
    label: 'Feedback',
    url: 'https://c02.my.uprr.com/uprr/info/feedback.shtml'
}];

var FooterService = function () {
    FooterService.$inject = ['$window'];

    function FooterService($window) {
        'ngInject';

        footer_service__classCallCheck(this, FooterService);

        this.$window = $window;
    }

    footer_service__createClass(FooterService, [{
        key: '$isEmployeeUrl',
        value: function $isEmployeeUrl() {
            var hostname = this.$window.location.hostname;

            return hostname.match(/(home|employees)\.www\.uprr\.com/);
        }
    }, {
        key: 'resolveFooterUrls',
        value: function resolveFooterUrls() {
            if (this.$isEmployeeUrl()) {
                return EMPLOYEES_FOOTER_CONTENT;
            }
            return PUBLIC_FOOTER_CONTENT;
        }
    }]);

    return FooterService;
}();

/* harmony default export */ var footer_service = (FooterService);
// EXTERNAL MODULE: ./src/appTemplate/templates/app-template.html
var app_template = __webpack_require__(126);
var app_template_default = /*#__PURE__*/__webpack_require__.n(app_template);

// CONCATENATED MODULE: ./src/appTemplate/app-template.constants.ts
var RC_APP_TEMPLATE_LOGOUT_LINK = '/admin/logout.cfm';
var RC_APP_TEMPLATE_HEADER_LOGO_LINK = '/';
// CONCATENATED MODULE: ./src/appTemplate/app-template.component.ts
var app_template_component__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function app_template_component__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var app_template_component_RC_APP_TEMPLATE_LOGOUT_LINK = RC_APP_TEMPLATE_LOGOUT_LINK;
var app_template_component_AppTemplateController = function () {
    AppTemplateController.$inject = ['$attrs', '$rcAppTemplateFooterService', '$transclude', 'Usage'];

    function AppTemplateController($attrs, $rcAppTemplateFooterService, $transclude, Usage) {
        'ngInject';

        app_template_component__classCallCheck(this, AppTemplateController);

        this.$attrs = $attrs;
        this.$rcAppTemplateFooterService = $rcAppTemplateFooterService;
        this.$transclude = $transclude;
        Usage.register('appTemplate');
    }

    app_template_component__createClass(AppTemplateController, [{
        key: '$onInit',
        value: function $onInit() {
            this.i18n = Object(external__angular_["isDefined"])(this.$attrs.i18nLanguageToggle);
            this.enableMiniMenu = !Object(external__angular_["isDefined"])(this.$attrs.noMiniMenu);
            this.initFooter();
            this.initLogoLink();
        }
    }, {
        key: 'initLogoLink',
        value: function initLogoLink() {
            this.enableLogoLink = true;
            if (Object(external__angular_["isDefined"])(this.$attrs.noLogoLink)) {
                this.enableLogoLink = false;
            }
            this.logoLinkUrl = this.logoLinkUrl || RC_APP_TEMPLATE_HEADER_LOGO_LINK;
        }
    }, {
        key: 'initFooter',
        value: function initFooter() {
            this.showFooter = true;
            // TODO: Isolate these to separate variable types
            var noFooterContent = typeof this.footerContent === 'boolean' && !!this.footerContent === false;
            if (Object(external__angular_["isDefined"])(this.$attrs.hideFooter) || noFooterContent) {
                this.showFooter = false;
                return;
            }
            this.footerContent = this.footerContent || this.$rcAppTemplateFooterService.resolveFooterUrls();
        }
    }, {
        key: 'doesNavContentExist',
        value: function doesNavContentExist() {
            var jsNavContent = this.navContent && this.navContent.length > 0;
            var transcludedNav = this.$transclude.isSlotFilled('navContent');
            return jsNavContent || transcludedNav;
        }
    }, {
        key: 'isSubnav',
        value: function isSubnav(navEl) {
            return Object(external__angular_["isDefined"])(navEl.sub);
        }
    }]);

    return AppTemplateController;
}();
var AppTemplateComponent = {
    transclude: {
        navContent: '?rcNav',
        navHeader: '?rcNavSlideMenuHeader',
        titleContent: '?rcAppTemplateTitle'
    },
    template: app_template_default.a,
    bindings: {
        footerContent: '<',
        pageTitle: '@',
        appTitle: '@',
        navContent: '<',
        logoLinkUrl: '@?',
        showUserId: '@',
        logout: '@?'
    },
    controller: app_template_component_AppTemplateController
};
/* harmony default export */ var app_template_component = (AppTemplateComponent);
// EXTERNAL MODULE: ./src/appTemplate/templates/header.html
var header = __webpack_require__(127);
var header_default = /*#__PURE__*/__webpack_require__.n(header);

// CONCATENATED MODULE: ./src/appTemplate/header.component.ts
var header_component__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function header_component__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var Header = function () {
    Header.$inject = ['rcSeamlessUi', 'rcUserId'];

    function Header(rcSeamlessUi, rcUserId) {
        'ngInject';

        header_component__classCallCheck(this, Header);

        this.rcSeamlessUi = rcSeamlessUi;
        this.rcUserId = rcUserId;
    }

    header_component__createClass(Header, [{
        key: 'showMiniMenu',
        value: function showMiniMenu() {
            return this.enableMiniMenu && this.isSUI && this.hasNavContent;
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            this.isSUI = this.rcSeamlessUi.isInSeamlessUIMode();
            this.initUserId();
        }
    }, {
        key: 'showNavBar',
        value: function showNavBar() {
            var showLogout = this.logout !== 'false';
            return this.hasNavContent || showLogout;
        }
    }, {
        key: 'initUserId',
        value: function initUserId() {
            var _this = this;

            if (this.showUserId) {
                this.rcUserId.get().then(function (_ref) {
                    var data = _ref.data;

                    _this.userObj = data;
                });
            }
        }
    }]);

    return Header;
}();
var HeaderComponent = {
    bindings: {
        pageTitle: '<',
        appTitle: '<',
        i18n: '<',
        showUserId: '<?',
        logoLinkUrl: '<',
        enableLogoLink: '<',
        hasNavContent: '<',
        enableMiniMenu: '<',
        logout: '<'
    },
    template: header_default.a,
    controller: Header,
    transclude: {
        content: '?navContent',
        header: '?navHeader',
        title: '?titleContent'
    }
};

/* harmony default export */ var header_component = (Header);
// EXTERNAL MODULE: ./src/appTemplate/templates/footer.html
var footer = __webpack_require__(128);
var footer_default = /*#__PURE__*/__webpack_require__.n(footer);

// CONCATENATED MODULE: ./src/appTemplate/footer.component.ts

var AppTemplateFooterComponent = {
    bindings: {
        footerContent: '<',
        showFooter: '<'
    },
    template: footer_default.a
};
/* harmony default export */ var footer_component = (AppTemplateFooterComponent);
// EXTERNAL MODULE: ./src/appTemplate/templates/title.html
var title = __webpack_require__(129);
var title_default = /*#__PURE__*/__webpack_require__.n(title);

// CONCATENATED MODULE: ./src/appTemplate/title.component.ts
function title_component__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var TitleController = function TitleController(Usage) {
    'ngInject';

    title_component__classCallCheck(this, TitleController);

    Usage.register('appTemplateTitle');
};
TitleController.$inject = ['Usage'];
var TitleComponent = {
    transclude: true,
    template: title_default.a,
    bindings: {
        appTitle: '<',
        pageTitle: '<'
    },
    controller: TitleController
};
/* harmony default export */ var title_component = (TitleComponent);
// CONCATENATED MODULE: ./src/appTemplate/app-template.feature-tests.ts
var PORTAL_CLASS = 'ric-portal';
var PREVENT_ZOOMABLE_FONT = 'prevent-zoomable-font';
var isIosDevice = function isIosDevice(ua) {
    return ua.match(/iPhone|iPad/) !== null;
};
var runFeatureTests = function runFeatureTests($document, $window, rcSeamlessUi, rcFeatureTests) {
    'ngInject';

    rcFeatureTests.runFeatureTests();
    // If in a portal, strip off header/footer
    if (rcSeamlessUi.isInSeamlessUIMode()) {
        $document.find('body').addClass(PORTAL_CLASS);
    }
    // SID#214618
    if (isIosDevice($window.navigator.userAgent)) {
        $document.find('body').addClass(PREVENT_ZOOMABLE_FONT);
    }
};
runFeatureTests.$inject = ['$document', '$window', 'rcSeamlessUi', 'rcFeatureTests'];
/* harmony default export */ var app_template_feature_tests = (runFeatureTests);

// CONCATENATED MODULE: ./src/appTemplate/nav/utils.ts

function mixinParentNav(nav, nestedParent, primaryParent) {
    var parentContainer = nestedParent ? nestedParent : primaryParent;
    nav.parentContainer = parentContainer;
    parentContainer.register(nav);
    nav.closeOtherNavs = function () {
        parentContainer.closeOthers(nav);
    };
}
function mixinChildNavs(navContainer) {
    navContainer.children = [];
    navContainer.register = function (childNav) {
        navContainer.children.push(childNav);
    };
    var existingClose = navContainer.close || external__angular_["noop"];
    navContainer.close = function () {
        existingClose.apply(navContainer);
        navContainer.children.forEach(function (c) {
            return c.close();
        });
    };
    navContainer.closeOthers = function (child) {
        navContainer.children.filter(function (e) {
            return e !== child;
        }).forEach(function (c) {
            return c.close();
        });
    };
    navContainer.triggerIcon = function () {
        navContainer.childIconClasses = {
            'child-has-icon': true
        };
    };
}

// CONCATENATED MODULE: ./src/appTemplate/nav/nav.ts
var nav__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function nav__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var nav_Nav = function () {
    Nav.$inject = ['NavState', '$injector'];

    function Nav(NavState, $injector) {
        'ngInject';

        nav__classCallCheck(this, Nav);

        this.NavState = NavState;
        this.$injector = $injector;
    }

    nav__createClass(Nav, [{
        key: '$onInit',
        value: function $onInit() {
            this.logoutLink = this.resolveLogoutLink();
            this.logoutText = lib_default.a.get('rc.appTemplate.logout');
            this.initInternationalizationToggle();
            this.NavState.register(this);
            mixinChildNavs(this);
        }
    }, {
        key: 'initInternationalizationToggle',
        value: function initInternationalizationToggle() {
            var languageServiceAvailable = this.$injector.has('LanguageService');
            this.i18nAvailable = this.rcNavMenus && !!this.rcNavMenus.i18n && languageServiceAvailable;
        }
    }, {
        key: 'hasRightAlignedItems',
        value: function hasRightAlignedItems() {
            if (this.rcNavMenus && this.rcNavMenus.inMiniMenu) {
                return false;
            }
            return this.i18nAvailable || this.logoutLink;
        }
    }, {
        key: 'resolveLogoutLink',
        value: function resolveLogoutLink() {
            if (this.rcNavMenus) {
                var logout = this.rcNavMenus.logout;

                if (logout === 'true') {
                    return RC_APP_TEMPLATE_LOGOUT_LINK;
                }
                if (logout === 'false') {
                    return null;
                }
                if (logout) {
                    return logout;
                }
                return RC_APP_TEMPLATE_LOGOUT_LINK;
            }
        }
    }, {
        key: 'close',
        value: function close() {
            // Do nothing?
        }
    }]);

    return Nav;
}();

/* harmony default export */ var nav = (nav_Nav);

var NavComponent = {
    template: '\n    <div class="nav-items nav-children" ng-class="::$ctrl.childIconClasses">\n        <ng-transclude></ng-transclude>\n        <rc-nav-menu-divider ng-if="$ctrl.hasRightAlignedItems()"></rc-nav-menu-divider>\n\n        <rc-nav-link ng-if="$ctrl.i18nAvailable" ng-if="$ctrl.hasRightAlignedItems()">\n            <cx-i18n></cx-i18n>\n        </rc-nav-link>\n\n        <rc-nav-link ng-if="!!$ctrl.logoutLink && $ctrl.hasRightAlignedItems()">\n            <a class="logout-link" ng-href="{{::$ctrl.logoutLink}}">\n                <rc-translatable-expression i18n-templates="$ctrl.logoutText"></rc-translatable-expression>\n            </a>\n        </rc-nav-link>\n    </div>',
    require: {
        rcNavMenus: '?^^rcNavMenus'
    },
    transclude: true,
    controller: nav_Nav
};

// CONCATENATED MODULE: ./src/appTemplate/nav/nav-menus.ts
var nav_menus__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function nav_menus__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var nav_menus_NavMenus = function () {
    NavMenus.$inject = ['$attrs'];

    function NavMenus($attrs) {
        'ngInject';

        nav_menus__classCallCheck(this, NavMenus);

        this.$attrs = $attrs;
    }

    nav_menus__createClass(NavMenus, [{
        key: '$onInit',
        value: function $onInit() {
            this.inMiniMenu = Object(external__angular_["isDefined"])(this.$attrs.miniMenu);
        }
    }]);

    return NavMenus;
}();

/* harmony default export */ var nav_menus = (nav_menus_NavMenus);

var NavMenusComponent = {
    template: '\n      <rc-nav-large-menu>\n          <div ng-transclude="content"></div>\n      </rc-nav-large-menu>\n      <rc-nav-slide-menu>\n          <slide-menu-header ng-transclude="header"></slide-menu-header>\n          <slide-menu-nav>\n              <div ng-transclude="content"></div>\n          <slide-menu-nav>\n      </rc-nav-slide-menu>\n    ',
    transclude: {
        header: '?navHeader',
        content: '?navContent'
    },
    bindings: {
        logout: '<',
        i18n: '<'
    },
    controller: nav_menus_NavMenus
};

// CONCATENATED MODULE: ./src/appTemplate/nav/nav-large-menu.ts
var NavLargeMenuComponent = {
    template: "<div ng-transclude class=\"large-menu\"></div>",
    transclude: true
};

// CONCATENATED MODULE: ./src/appTemplate/nav/nav-slide-menu.ts
var nav_slide_menu__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function nav_slide_menu__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NavSlideMenu = function () {
    NavSlideMenu.$inject = ['NavState'];

    function NavSlideMenu(NavState) {
        'ngInject';

        nav_slide_menu__classCallCheck(this, NavSlideMenu);

        this.NavState = NavState;
    }

    nav_slide_menu__createClass(NavSlideMenu, [{
        key: '$onInit',
        value: function $onInit() {
            this.isOpen = false;
            this.NavState.register(this);
        }
    }, {
        key: 'toggle',
        value: function toggle() {
            this.isOpen = !this.isOpen;
        }
    }, {
        key: 'close',
        value: function close() {
            this.isOpen = false;
        }
    }]);

    return NavSlideMenu;
}();

/* harmony default export */ var nav_slide_menu = (NavSlideMenu);

var NavSlideMenuComponent = {
    controller: NavSlideMenu,
    template: '\n    <button class="slidemenu-toggle" right ng-click="$ctrl.toggle()"></button>\n    <nav-small-menu-overlay ng-click="$ctrl.close()" ng-if="$ctrl.isOpen"></nav-small-menu-overlay>\n    <nav ng-if="$ctrl.isOpen" ng-attr-open="{{$ctrl.isOpen}}">\n        <div ng-transclude="header"></div>\n        <div ng-transclude="nav"></div>\n    </nav>',
    transclude: {
        nav: '?slideMenuNav',
        header: '?slideMenuHeader'
    }
};

// CONCATENATED MODULE: ./src/appTemplate/nav/nav-link.ts
var nav_link__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function nav_link__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var nav_link_NavLinkController = function () {
    NavLinkController.$inject = ['$document', '$element', '$attrs', '$scope', 'NavState'];

    function NavLinkController($document, $element, $attrs, $scope, NavState) {
        'ngInject';

        nav_link__classCallCheck(this, NavLinkController);

        this.$document = $document;
        this.$element = $element;
        this.$attrs = $attrs;
        this.$scope = $scope;
        this.NavState = NavState;
    }

    nav_link__createClass(NavLinkController, [{
        key: '$onInit',
        value: function $onInit() {
            mixinParentNav(this, this.rcNestedNav, this.rcNav);
            if (this.icon) {
                this.iconClasses = this.icon.split(' ').concat('icon');
                this.parentContainer.triggerIcon();
            }
        }
    }, {
        key: '$postLink',
        value: function $postLink() {
            var _this = this;

            if (this.target) {
                this.$element.find('a').attr('target', this.target);
            }
            if (this.$attrs.newWindow) {
                this.$element.find('a').attr('target', '_blank');
            }
            this.$element.on('mouseover', function () {
                _this.$scope.$apply(function () {
                    _this.closeOtherNavs();
                });
            });
            if (!this.$attrs.nestedNavLink) {
                this.$element.on('click', function () {
                    _this.$scope.$apply(function () {
                        _this.NavState.deactivate();
                    });
                });
            }
            this.$element.on('click', function () {
                var activeElement = _this.$document[0].activeElement;

                activeElement.blur();
            });
        }
    }, {
        key: 'close',
        value: function close() {
            // Do nothing?
        }
    }]);

    return NavLinkController;
}();

/* harmony default export */ var nav_link = (nav_link_NavLinkController);

var NavLinkComponent = {
    template: '\n        <ng-transclude>\n            <a ng-href="{{::$ctrl.url}}" ng-bind="::$ctrl.label" ng-class="::$ctrl.iconClasses"></a>\n        </ng-transclude>\n    ',
    bindings: {
        url: '@',
        target: '@',
        label: '@',
        icon: '@'
    },
    require: {
        rcNestedNav: '?^^',
        rcNav: '?^^'
    },
    transclude: true,
    controller: nav_link_NavLinkController
};

// CONCATENATED MODULE: ./src/appTemplate/nav/nested-nav.ts
var nested_nav__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function nested_nav__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var nested_nav_NestedNav = function () {
    NestedNav.$inject = ['$document', '$element', '$scope', 'NavState'];

    function NestedNav($document, $element, $scope, NavState) {
        'ngInject';

        nested_nav__classCallCheck(this, NestedNav);

        this.$document = $document;
        this.$element = $element;
        this.$scope = $scope;
        this.NavState = NavState;
    }

    nested_nav__createClass(NestedNav, [{
        key: '$onInit',
        value: function $onInit() {
            this.isOpen = false;
            this.inLargeMenu = !!this.rcNavLargeMenu;
            this.inSlideMenu = !!this.rcNavSlideMenu;
            mixinParentNav(this, this.rcNestedNav, this.rcNav);
            mixinChildNavs(this);
        }
        /*
         * I really don't like doing this, but here's the scoop:
         * On touch devices (iOS + Mobile Chrome, at least), we get these events on tap:
         * touchstart > mouseover > click
         * As such, mouseover will open() the menu, and click will toggle() it off
         * So, we disable the mouseover logic with this super-naive "mobile" check.
         * Tested on IE11, Chrome, Firefox, Edge, Chrome Mobile, Mobile Safari, Samsung Internet
         * Longer term it'd be nice to use Pointer Events to disable the 'mouseover' event on touch devices.
         * https://developers.google.com/web/updates/2016/10/pointer-events#browser_support
         */

    }, {
        key: 'hasTouch',
        value: function hasTouch() {
            return 'ontouchstart' in this.$document[0].documentElement;
        }
    }, {
        key: 'onMouseover',
        value: function onMouseover() {
            if (this.inLargeMenu && !this.hasTouch()) {
                if (this.NavState.isActive) {
                    this.open();
                }
            }
        }
    }, {
        key: 'keyboardNav',
        value: function keyboardNav($event) {
            var _this = this;

            var escapeHandler = function escapeHandler($docEvt) {
                switch ($docEvt.keyCode) {
                    case keyboard_codes["a" /* default */].ESC:
                        _this.$scope.$apply(function () {
                            _this.isOpen = false;
                        });
                        break;
                    default: // do nothing
                }
            };
            switch ($event.keyCode) {
                case keyboard_codes["a" /* default */].ENTER:
                case keyboard_codes["a" /* default */].SPACE:
                    $event.preventDefault();
                    this.toggle();
                    if (this.isOpen) {
                        this.$document.on('keydown', escapeHandler);
                    } else {
                        this.$document.off('keydown', escapeHandler);
                    }
                    break;
                default: // do nothing
            }
        }
    }, {
        key: 'open',
        value: function open() {
            this.isOpen = true;
            this.NavState.activate();
            this.closeOtherNavs();
        }
    }, {
        key: 'isOpened',
        value: function isOpened() {
            return this.isOpen && this.NavState.isActive;
        }
    }, {
        key: 'close',
        value: function close() {
            this.isOpen = false;
        }
    }, {
        key: 'toggle',
        value: function toggle() {
            if (this.isOpen) {
                this.close();
            } else {
                this.open();
            }
        }
    }]);

    return NestedNav;
}();

/* harmony default export */ var nested_nav = (nested_nav_NestedNav);

var NestedNavComponent = {
    template: '\n        <rc-nav-link class="rc-nested-nav-link" ng-attr-active="{{$ctrl.isOpened()}}"\n            ng-mouseover="$ctrl.onMouseover()" nested-nav-link="true">\n            <span ng-click="$ctrl.toggle()" tabindex="0" ng-keydown="$ctrl.keyboardNav($event)">{{::$ctrl.label}}</span>\n        </rc-nav-link>\n        <div class="nested" ng-class="::$ctrl.childIconClasses">\n          <rc-nav-link class="slide-menu-back-link" ng-if="$ctrl.inSlideMenu" nested-nav-link="true">\n              <span ng-click="$ctrl.close()">{{::$ctrl.label}}</span>\n          </rc-nav-link>\n          <ng-transclude></ng-transclude>\n        </div>\n  ',
    transclude: true,
    require: {
        rcNavLargeMenu: '?^^',
        rcNavSlideMenu: '?^^',
        rcNestedNav: '?^^',
        rcNav: '?^^'
    },
    bindings: {
        label: '@'
    },
    controller: nested_nav_NestedNav
};

// CONCATENATED MODULE: ./src/appTemplate/nav/nav-state.service.ts
var nav_state_service__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function nav_state_service__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NavState = function () {
    NavState.$inject = ['$window', '$rootScope'];

    function NavState($window, $rootScope) {
        'ngInject';

        nav_state_service__classCallCheck(this, NavState);

        this.$window = $window;
        this.$rootScope = $rootScope;
        this.isActive = false;
        this.closeableNavs = [];
        this.clickListen = this.clickListener.bind(this);
    }

    nav_state_service__createClass(NavState, [{
        key: 'clickListener',
        value: function clickListener(_ref) {
            var _this = this;

            var target = _ref.target;

            if (this.$isClickOutsideNav(target)) {
                this.$rootScope.$apply(function () {
                    _this.deactivate();
                });
            }
        }
    }, {
        key: 'activate',
        value: function activate() {
            if (!this.isActive) {
                this.isActive = true;
                this.$window.addEventListener('click', this.clickListen);
            }
        }
    }, {
        key: '$isClickOutsideNav',
        value: function $isClickOutsideNav(el) {
            while (el.parentNode) {
                if (el.parentNode.nodeName === 'RC-NAV') {
                    return false;
                }
                el = el.parentNode;
            }
            return true;
        }
    }, {
        key: 'register',
        value: function register(nav) {
            this.closeableNavs.push(nav);
        }
    }, {
        key: 'deactivate',
        value: function deactivate() {
            this.isActive = false;
            this.$window.removeEventListener('click', this.clickListen);
            this.closeableNavs.forEach(function (nav) {
                return nav.close();
            });
        }
    }]);

    return NavState;
}();

/* harmony default export */ var nav_state_service = (NavState);
// CONCATENATED MODULE: ./src/appTemplate/index.ts













// Navigation







/* harmony default export */ var appTemplate = (Object(external__angular_["module"])('rc.appTemplate', [hoverIntent, i18n["a" /* default */], keyboardNavigation["a" /* default */], seamlessUi, usage["b" /* default */], utils["a" /* default */]]).run(app_template_feature_tests).component('rcAppTemplate', app_template_component).component('rcAppTemplateHeader', HeaderComponent).component('rcAppTemplateFooter', footer_component).component('rcAppTemplateTitle', title_component).component('rcNav', NavComponent).component('rcNavLink', NavLinkComponent).component('rcNestedNav', NestedNavComponent).component('rcNavMenus', NavMenusComponent).component('rcNavLargeMenu', NavLargeMenuComponent).component('rcNavSlideMenu', NavSlideMenuComponent).service('$rcAppTemplateFooterService', footer_service).service('NavState', nav_state_service).name);
// EXTERNAL MODULE: ./src/bindHtml/index.ts + 2 modules
var bindHtml = __webpack_require__(25);

// EXTERNAL MODULE: ./src/mediaQuery/index.ts + 2 modules
var mediaQuery = __webpack_require__(20);

// EXTERNAL MODULE: ./src/position/index.ts + 4 modules
var position = __webpack_require__(17);

// EXTERNAL MODULE: ./src/validation/index.ts + 25 modules
var validation = __webpack_require__(49);

// EXTERNAL MODULE: ./src/autocomplete/templates/autocomplete-circ7.html
var autocomplete_circ7 = __webpack_require__(134);
var autocomplete_circ7_default = /*#__PURE__*/__webpack_require__.n(autocomplete_circ7);

// EXTERNAL MODULE: ./src/autocomplete/templates/autocomplete-city.html
var autocomplete_city = __webpack_require__(135);
var autocomplete_city_default = /*#__PURE__*/__webpack_require__.n(autocomplete_city);

// EXTERNAL MODULE: ./src/autocomplete/templates/autocomplete-customer.html
var autocomplete_customer = __webpack_require__(136);
var autocomplete_customer_default = /*#__PURE__*/__webpack_require__.n(autocomplete_customer);

// EXTERNAL MODULE: ./src/autocomplete/templates/autocomplete-person.html
var autocomplete_person = __webpack_require__(137);
var autocomplete_person_default = /*#__PURE__*/__webpack_require__.n(autocomplete_person);

// EXTERNAL MODULE: ./src/autocomplete/templates/autocomplete-splc.html
var autocomplete_splc = __webpack_require__(138);
var autocomplete_splc_default = /*#__PURE__*/__webpack_require__.n(autocomplete_splc);

// EXTERNAL MODULE: ./src/autocomplete/templates/autocomplete-stcc.html
var autocomplete_stcc = __webpack_require__(139);
var autocomplete_stcc_default = /*#__PURE__*/__webpack_require__.n(autocomplete_stcc);

// CONCATENATED MODULE: ./src/autocomplete/autocomplete.run.ts
AutocompleteRunBlock.$inject = ['$templateCache'];






var RC_AUTOCOMPLETE_SERVICE_TEMPLATES = {
    circ7: autocomplete_circ7_default.a,
    city: autocomplete_city_default.a,
    customer: autocomplete_customer_default.a,
    person: autocomplete_person_default.a,
    splc: autocomplete_splc_default.a,
    stcc: autocomplete_stcc_default.a
};
function AutocompleteRunBlock($templateCache) {
    'ngInject';

    for (var template in RC_AUTOCOMPLETE_SERVICE_TEMPLATES) {
        if (RC_AUTOCOMPLETE_SERVICE_TEMPLATES.hasOwnProperty(template)) {
            $templateCache.put('src/autocomplete/templates/autocomplete-' + template + '.html', RC_AUTOCOMPLETE_SERVICE_TEMPLATES[template]);
        }
    }
}
/* harmony default export */ var autocomplete_run = (AutocompleteRunBlock);
// CONCATENATED MODULE: ./src/autocomplete/autocomplete.config.ts
MatchRequiredConfig.$inject = ['rcValidationErrorMessagesProvider'];
function MatchRequiredConfig(rcValidationErrorMessagesProvider) {
    'ngInject';

    rcValidationErrorMessagesProvider.addErrorMessage('matchRequired');
}
// CONCATENATED MODULE: ./src/autocomplete/autocomplete.constants.ts

var AUTOCOMPLETE_SELECT_EVENT = 'autocompleteModelSelected';
/* TODO: Convert to actual service */
var AUTOCOMPLETE_SERVICES = {
    circ7: {
        url: '/uit/ricola/jas/services/station/v2/search',
        attributes: {
            templateUrl: 'src/autocomplete/templates/autocomplete-circ7.html',
            minLength: '2',
            placeholder: 'Circ-7'
        },
        buildListExpression: function buildListExpression(controllerId) {
            return 'station as station.circ7 for station in getRicolaServiceData(' + controllerId + ', $viewValue)';
        },
        getParameters: function getParameters(scope, attrs) {
            var parameters = {};
            if (Object(external__angular_["isDefined"])(attrs.routable)) {
                parameters.routable = scope.$eval(attrs.routable);
            }
            return parameters;
        }
    },
    city: {
        url: '/uit/ricola/jas/services/city/v3/search',
        attributes: {
            templateUrl: 'src/autocomplete/templates/autocomplete-city.html',
            minLength: '2',
            placeholder: 'City, State'
        },
        buildListExpression: function buildListExpression(controllerId) {
            return 'csc for csc in getRicolaServiceData(' + controllerId + ', $viewValue)';
        },
        format: {
            methodName: 'formatCityForInput',
            method: function method(csc) {
                var formatted = '';
                if (csc) {
                    formatted += csc.name || '';
                    if (csc.state && csc.state.abbreviation) {
                        formatted += formatted.length > 0 ? ', ' + csc.state.abbreviation : csc.state.abbreviation;
                    }
                }
                return formatted;
            }
        },
        getParameters: getCountryAndStateParams
    },
    customer: {
        url: '/uit/ricola/jas/services/customer/search',
        attributes: {
            templateUrl: 'src/autocomplete/templates/autocomplete-customer.html',
            minLength: '3',
            placeholder: 'Company City, ST'
        },
        buildListExpression: function buildListExpression(controllerId) {
            return 'customer as customer.firmNumber for customer in getRicolaServiceData(' + controllerId + ', $viewValue)';
        },
        getParameters: function getParameters(scope, attrs) {
            var parameters = {};
            if (attrs.locationType) {
                parameters.locationType = scope.$eval(attrs.locationType) || attrs.locationType;
            }
            if (attrs.ultimateFirmNumber) {
                parameters.ultimateFirmNumber = scope.$eval(attrs.ultimateFirmNumber) || attrs.ultimateFirmNumber;
            }
            return parameters;
        }
    },
    person: {
        url: '/uit/ricola/jas/services/person/v2/search',
        attributes: {
            templateUrl: 'src/autocomplete/templates/autocomplete-person.html',
            minLength: '3',
            placeholder: 'Name or Employee ID'
        },
        buildListExpression: function buildListExpression(controllerId) {
            return 'person as person.employeeId for person in getRicolaServiceData(' + controllerId + ', $viewValue)';
        },
        getParameters: function getParameters(scope, attrs) {
            return {};
        }
    },
    splc: {
        url: '/uit/ricola/jas/services/splc/search',
        attributes: {
            templateUrl: 'src/autocomplete/templates/autocomplete-splc.html',
            minLength: '2',
            placeholder: 'City, State or SPLC'
        },
        buildListExpression: function buildListExpression(controllerId) {
            return 'splc for splc in getRicolaServiceData(' + controllerId + ', $viewValue)';
        },
        format: {
            methodName: 'formatSplcForInput',
            method: function method(splc) {
                var formatted = '';
                if (splc) {
                    if (splc.name) {
                        formatted += splc.name;
                    }
                    if (splc.state && splc.state.abbreviation) {
                        formatted += formatted.length > 0 ? ', ' + splc.state.abbreviation : splc.state.abbreviation;
                    }
                }
                return formatted;
            }
        },
        getParameters: getCountryAndStateParams
    },
    stcc: {
        url: '/uit/ricola/jas/services/stcc/v2/search',
        attributes: {
            templateUrl: 'src/autocomplete/templates/autocomplete-stcc.html',
            minLength: '2',
            placeholder: 'Commodity Code'
        },
        buildListExpression: function buildListExpression(controllerId) {
            return 'commodity as commodity.stcc for commodity in getRicolaServiceData(' + controllerId + ', $viewValue)';
        },
        getParameters: function getParameters(scope, attrs) {
            var parameters = {};
            if (Object(external__angular_["isDefined"])(attrs.codeLengthOver)) {
                parameters.codeLengthOver = scope.$eval(attrs.codeLengthOver) || attrs.codeLengthOver;
            }
            if (Object(external__angular_["isDefined"])(attrs.codeLengthUnder)) {
                parameters.codeLengthUnder = scope.$eval(attrs.codeLengthUnder) || attrs.codeLengthUnder;
            }
            return parameters;
        }
    }
};
function getCountryAndStateParams(scope, attrs) {
    var parameters = { countryAbbreviation: 'US' };
    if (Object(external__angular_["isDefined"])(attrs.countries)) {
        parameters.countryAbbreviation = getStringArray(scope.$eval(attrs.countries) || attrs.countries);
    }
    if (Object(external__angular_["isDefined"])(attrs.states)) {
        parameters.stateName = getStringArray(scope.$eval(attrs.states) || attrs.states);
    }
    return parameters;
}
function getStringArray(value) {
    if (Object(external__angular_["isDefined"])(value)) {
        if (Object(external__angular_["isArray"])(value)) {
            return value;
        } else if (Object(external__angular_["isString"])(value)) {
            return value.split(',');
        }
    }
    return value;
}
// CONCATENATED MODULE: ./src/autocomplete/autocomplete.filters.ts
highlightFilter.$inject = ['$filter'];

function capitalizeFilter() {
    return function (input) {
        var lower = input.toLowerCase();
        return lower.substr(0, 1).toUpperCase() + lower.substr(1);
    };
}
/* TODO: This should be moved into a Regexp module instead burying here. */
function escapeRegexpFilter() {
    return function escapeRegexp(value) {
        if (Object(external__angular_["isString"])(value)) {
            return value.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
        }
        return value;
    };
}
/* TODO: This should be moved into a Hightlight module ($filterProvider?) instead of burying here. */
function highlightFilter($filter) {
    'ngInject';

    return function (str, query, caseSensitive, multiKeyDelimiter) {
        if (Object(external__angular_["isString"])(str) && query) {
            var escapedQuery = $filter('escapeRegexp')(query);
            var regexpOr = '|';
            var regexpString = multiKeyDelimiter ? escapedQuery.replace(multiKeyDelimiter, regexpOr) : escapedQuery;
            var regexpFlags = 'g' + (caseSensitive ? '' : 'i');
            var queryRegexp = new RegExp(regexpString, regexpFlags);
            return str.replace(queryRegexp, '<span class="highlight">$&</span>');
        }
        return str;
    };
}
// CONCATENATED MODULE: ./src/autocomplete/autocomplete.service.expression-parser.ts
AutocompleteExpressionParserService.$inject = ['$parse'];
/**
 * A helper service that can parse autocomplete's syntax (string provided by users)
 * Extracted to a separate service for ease of unit testing
 */
function AutocompleteExpressionParserService($parse) {
    'ngInject';

    var service = this;
    var AUTOCOMPLETE_REGEXP = /^\s*(.*?)(?:\s+as\s+(.*?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+(.*)$/;
    function throwParseError(expression) {
        throw new Error('Expected autocomplete specification in form of \'_modelValue_ (as _label_)? for _item_ in _collection_\' but got \'' + expression + '\'.');
    }
    service.parse = function (expression, intendedScope) {
        if (!expression) {
            throwParseError(expression);
        }
        var match = expression.match(AUTOCOMPLETE_REGEXP);
        if (!match) {
            throwParseError(expression);
        }
        var sourceParse = $parse(match[4]);
        var viewMapperParse = $parse(match[2] || match[1]);
        var modelMapperParse = $parse(match[1]);
        return {
            itemName: match[3],
            source: function source(locals) {
                return sourceParse(intendedScope, locals);
            },
            viewMapper: function viewMapper(locals) {
                return viewMapperParse(intendedScope, locals);
            },
            modelMapper: function modelMapper(locals) {
                return modelMapperParse(intendedScope, locals);
            }
        };
    };
}
/* harmony default export */ var autocomplete_service_expression_parser = (AutocompleteExpressionParserService);
// CONCATENATED MODULE: ./src/autocomplete/autocomplete.controller.service.ts
var autocomplete_controller_service__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function autocomplete_controller_service__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var autocomplete_controller_service_RcAutocompleteServiceController = function () {
    RcAutocompleteServiceController.$inject = ['$scope', '$attrs', '$http', 'rcMediaQuery'];

    function RcAutocompleteServiceController($scope, $attrs, $http, rcMediaQuery) {
        'ngInject';

        autocomplete_controller_service__classCallCheck(this, RcAutocompleteServiceController);

        this.$scope = $scope;
        this.$attrs = $attrs;
        this.$http = $http;
        this.serviceConfig = AUTOCOMPLETE_SERVICES[$attrs.rcService.toLowerCase() || ''];
        if (!this.serviceConfig) {
            throw new Error('There is no pre-defined \'' + $attrs.rcService + '\' Ricola service configuration.');
        }
        this.limit = rcMediaQuery.minSize('large') ? 100 : 10;
    }

    autocomplete_controller_service__createClass(RcAutocompleteServiceController, [{
        key: 'processInput',
        value: function processInput(input) {
            var parameters = this.serviceConfig.getParameters(this.$scope, this.$attrs);
            parameters.q = input;
            parameters.limit = parameters.limit || this.limit;
            return this.$http.get(this.serviceConfig.url, { params: parameters }).then(function (results) {
                return results.data;
            });
        }
    }]);

    return RcAutocompleteServiceController;
}();

/* harmony default export */ var autocomplete_controller_service = (autocomplete_controller_service_RcAutocompleteServiceController);
// CONCATENATED MODULE: ./src/autocomplete/autocomplete.directive.service.ts
AutocompleteServiceDirective.$inject = ['Usage', '$compile', '$http', 'rcMediaQuery', 'limitToFilter'];



var RicolaServiceControllerCache = {};
/*
 * TODO: Replace with controller-bound implementation (don't set element values, set acCtrl functions)
 * This must run before the rc-autocomplete directive to establish the necessary attributes on the element
 */
function AutocompleteServiceDirective(Usage, $compile, $http, rcMediaQuery, limitToFilter) {
    'ngInject';

    var identifier = 0;
    return {
        restrict: 'A',
        priority: 2,
        controller: autocomplete_controller_service,
        compile: AutocompleteServiceCompile
    };
    function AutocompleteServiceCompile(element, attrs) {
        var config = AUTOCOMPLETE_SERVICES[attrs.rcService.toLowerCase() || ''];
        if (!config) {
            throw new Error('There is no pre-defined \'' + attrs.rcService + '\' Ricola service configuration.');
        }
        setIfUndefined(attrs, 'templateUrl', config.attributes.templateUrl);
        setIfUndefined(attrs, 'minLength', config.attributes.minLength);
        setIfUndefined(attrs, 'waitMs', '50');
        if (!attrs.inputFormatter && config.format) {
            setIfUndefined(attrs, 'inputFormatter', config.format.methodName + '($model)');
        }
        return {
            pre: AutocompleteServiceLink
        };
    }
    function AutocompleteServiceLink(scope, element, attrs, controller) {
        Usage.register('autocomplete-services');
        var controllerId = ++identifier;
        var config = AUTOCOMPLETE_SERVICES[attrs.rcService.toLowerCase() || ''];
        if (Object(external__angular_["isDefined"])(config.format)) {
            scope[config.format.methodName] = config.format.method;
        }
        RicolaServiceControllerCache[controllerId] = controller;
        setIfUndefined(attrs, 'listExpression', config.buildListExpression(controllerId));
        /* A single scope may have multiple autocompletes */
        if (!scope.getRicolaServiceData) {
            scope.getRicolaServiceData = function (id, input) {
                return RicolaServiceControllerCache[id].processInput(input);
            };
        }
        /* Make sure the controller cache reference is removed if the element is destroyed */
        element.on('$destroy', function () {
            delete RicolaServiceControllerCache[controllerId];
        });
    }
    function setIfUndefined(attrs, name, value) {
        if (Object(external__angular_["isUndefined"])(attrs[name]) && Object(external__angular_["isDefined"])(value)) {
            attrs.$set(name, value);
        }
    }
}
/* harmony default export */ var autocomplete_directive_service = (AutocompleteServiceDirective);
// CONCATENATED MODULE: ./src/autocomplete/autocomplete.directive.input.ts
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

AutocompleteInputDirective.$inject = ['$parse', '$log', '$position', '$timeout'];

/*
 * This is used to overcome the issue of trying to do too many things in one directive. When composite directives are
 * eventually created to manage templating like this, then this can likely be removed (i.e. the composite directive
 * would already have the transcluded input as well as the service-configured placeholder which has to be on the element
 * before the link phase)
 */
function AutocompleteInputDirective($parse, $log, $position, $timeout) {
    'ngInject';

    return {
        restrict: 'E',
        scope: false,
        require: ['?ngModel', '?^rcAutocomplete'],
        priority: 2,
        compile: AutocompleteInputCompile
    };
    function AutocompleteInputCompile(element, attrs) {
        var childOf = function childOf(node, parentName) {
            if (!node) {
                return false;
            }
            if (node.nodeName === parentName) {
                return true;
            }
            return childOf(node.parentNode, parentName);
        };
        var parent = element[0].parentNode;
        if (!childOf(parent, 'RC-AUTOCOMPLETE')) {
            return;
        }
        if (attrs.ngModel.indexOf('.') === -1) {
            $log.warn('The rc-autocomplete is an isolate-scope element that transcludes the input. ' + ('If the model used does not have a dot (i.e. "controller.' + attrs.ngModel + '" vs just "' + attrs.ngModel + '"), ') + 'it may not function consistently. ' + 'Please read https://github.com/angular/angular.js/wiki/Understanding-Scopes for best practices.');
            $log.warn(parent);
        }
        // Disable HTML5 Autocomplete feature; as it will get in the way of the dropdown.
        element.attr('autocomplete', 'off');
        var serviceName = parent.getAttribute('rc-service');
        if (!attrs.placeholder && !attrs.rcPlaceholder && serviceName) {
            var config = AUTOCOMPLETE_SERVICES[serviceName ? serviceName.toLowerCase() : ''];
            attrs.$set('placeholder', config.attributes.placeholder);
        }
        return AutocompleteInputDirectiveLink;
    }
    function AutocompleteInputDirectiveLink(scope, element, attrs, controllers) {
        var _controllers = _slicedToArray(controllers, 2),
            modelCtrl = _controllers[0],
            autoCtrl = _controllers[1];

        if (modelCtrl && autoCtrl) {
            bindModelAccess();
            bindModelProcessors();
            bindDOMEvents();
            autoCtrl.focusInput = function () {
                $timeout(function () {
                    return element[0].focus();
                });
            };
            autoCtrl.getInputOffset = function () {
                var position = $position.offset(element);
                position.top = position.top + element.prop('offsetHeight');
                return position;
            };
        }
        function bindDOMEvents() {
            element.on('blur', function (event) {
                autoCtrl.onInputBlur(event);
            });
            element.on('keydown', function (event) {
                autoCtrl.onInputKeydown(event);
            });
        }
        function bindModelAccess() {
            autoCtrl.getInputModel = function () {
                return modelCtrl.$modelValue;
            };
            autoCtrl.getInputView = function () {
                return modelCtrl.$viewValue;
            };
            autoCtrl.hasValidators = function () {
                return Object.keys(modelCtrl.$validators).length > 0;
            };
            var setModel = $parse(attrs.ngModel).assign;
            autoCtrl.setInputModel = function (model) {
                setModel(scope, model);
                modelCtrl.$setDirty(true);
            };
        }
        function bindModelProcessors() {
            modelCtrl.$parsers.unshift(function (input) {
                return autoCtrl.parseUserInput(input);
            });
            modelCtrl.$formatters.push(function (model) {
                return autoCtrl.formatModel(model);
            });
            if (autoCtrl.matchRequired) {
                modelCtrl.$validators.matchRequired = function (modelValue, viewValue) {
                    return autoCtrl.matchSelected || modelCtrl.$isEmpty(viewValue);
                };
            }
            // Must run after everything is bound
            $timeout(function () {
                if (autoCtrl.openOnFocus) {
                    element.on('focus', function () {
                        scope.$apply(function () {
                            autoCtrl.parseUserInput(modelCtrl.$viewValue);
                        });
                    });
                }
            }, 0, false);
        }
    }
}
/* harmony default export */ var autocomplete_directive_input = (AutocompleteInputDirective);
// EXTERNAL MODULE: ./src/autocomplete/templates/autocomplete.html
var autocomplete = __webpack_require__(140);
var autocomplete_default = /*#__PURE__*/__webpack_require__.n(autocomplete);

// CONCATENATED MODULE: ./src/autocomplete/autocomplete.directive.ts
var autocomplete_directive__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

AutocompleteDirective.$inject = ['$document', '$log', '$compile', '$parse', '$timeout', '$window', 'Usage', 'AutocompleteExpressionParser'];


function AutocompleteDirective($document, $log, $compile, $parse, $timeout, $window, Usage, AutocompleteExpressionParser) {
    'ngInject';

    return {
        restrict: 'E',
        require: 'rcAutocomplete',
        scope: {
            loading: '=?',
            matchRequired: '@?matchRequired',
            minSearch: '@?minLength',
            waitMs: '@?',
            customFormatter: '&?inputFormatter',
            onRemove: '&?',
            onSelect: '&?'
        },
        template: autocomplete_default.a,
        transclude: true,
        controller: 'RcAutocompleteController',
        controllerAs: 'rcAcCtrl',
        bindToController: true,
        compile: AutocompleteCompile
    };
    function AutocompleteCompile(element, attrs) {
        // TODO: Remove in next breaking change and allow compile error
        if (element[0].hasAttribute('ng-model')) {
            $log.warn('Use of the \'ng-model\' on the <rc-autocomplete> element is deprecated. ' + 'If an <input> has _NOT_ been transcluded with its own \'ng-model\' attribute, ' + 'please use the \'rc-input-model\' attribute instead.');
            $log.warn(element[0]);
            if (!element[0].hasAttribute('rc-input-model')) {
                attrs.$set('rcInputModel', attrs.ngModel);
                element.attr('rc-input-model', attrs.ngModel);
            }
        }
        return AutocompleteLink;
    }
    function AutocompleteLink(scope, $element, attrs, autocompleteCtrl, transclude) {
        Usage.register('autocomplete');
        // Transclude provided input element or generate one using parent scope to keep within accessibility of controller
        transclude(function (clone) {
            var _getTranscludedInputE = getTranscludedInputElement(clone),
                _getTranscludedInputE2 = autocomplete_directive__slicedToArray(_getTranscludedInputE, 2),
                input = _getTranscludedInputE2[0],
                results = _getTranscludedInputE2[1];

            if (results.isInputField) {
                setInputAttributes(input, attrs);
            }
            $element.append(input);
            if (results.hasNoScope) {
                $compile(input)(scope.$parent);
            }
        });
        // TODO: Consider moving input-element-based logic to RcAutocompleteInputDirective as a link function with the AC-controller
        // Transcluded input element
        var inputElement = $element.find('input');
        inputElement.on('focus', addDropDownToBody);
        var dropdownEl = void 0;
        function addDropDownToBody() {
            scope.$apply(function () {
                dropdownEl = buildDropdown(attrs.templateUrl, scope);
                // IE (surprise!!) will fire the input's blur event when a user manually clicks the scroll bar
                // TODO: Verify in Edge and remove when no longer required.
                dropdownEl.on('mousedown scroll', function (event) {
                    if (event.target.nodeName === 'UL') {
                        autocompleteCtrl.falseIEBlur = event.type === 'mousedown';
                    }
                });
                $document.find('body').append(dropdownEl);
                inputElement.unbind('focus', addDropDownToBody);
            });
        }
        autocompleteCtrl.expressionParser = AutocompleteExpressionParser.parse(attrs.listExpression, scope.$parent);
        autocompleteCtrl.matchOnBlur = Object(external__angular_["isDefined"])(attrs.matchOnBlur);
        autocompleteCtrl.multiple = Object(external__angular_["isDefined"])(attrs.multiple);
        autocompleteCtrl.openOnFocus = $element[0].hasAttribute('open-on-focus');
        if (autocompleteCtrl.openOnFocus) {
            autocompleteCtrl.minSearch = 0;
        }
        /* Will set the model to the first available match */
        if (Object(external__angular_["isDefined"])(attrs.matchOnInit)) {
            // TODO: Move to controller $postLink method
            $timeout(autocompleteCtrl.matchToCurrentModel);
        }
        // Actions taken outside the autocomplete should dismiss the dropdown
        $document.bind('click mousewheel', dismissClickHandler);
        Object(external__angular_["element"])($window).bind('resize', dismissClickHandler);
        // cleanup
        scope.$on('$destroy', function () {
            $document.unbind('click mousewheel', dismissClickHandler);
            Object(external__angular_["element"])($window).unbind('resize', dismissClickHandler);
            if (dropdownEl) {
                dropdownEl.remove();
            }
        });
        // Keep reference to click handler to unbind it.
        function dismissClickHandler(event) {
            var target = event.target;
            if ($element[0] !== target && inputElement[0] !== target) {
                autocompleteCtrl.resetMatches();
                scope.$digest();
            }
        }
    }
    function buildDropdown(templateUrl, compileScope) {
        var dropdownEl = Object(external__angular_["element"])('<rc-autocomplete-dropdown></rc-autocomplete-dropdown>');
        dropdownEl.attr({
            matches: 'rcAcCtrl.matches',
            active: 'rcAcCtrl.activeIndex',
            'on-select': 'rcAcCtrl.select(activeIndex)',
            query: 'rcAcCtrl.query',
            position: 'rcAcCtrl.position'
        });
        // custom item template
        if (Object(external__angular_["isDefined"])(templateUrl)) {
            dropdownEl.attr('template-url', templateUrl);
        }
        return $compile(dropdownEl)(compileScope);
    }
    function findProvidedInput(clone) {
        for (var index = 0; index < clone.length; index++) {
            // This all feels like a hack. We'd prefer for the Autocomplete component
            // to *not* know about the thing it's decorating. In this case, it has to differentiate
            // between the <input> and <rc-input-*> tags.
            //
            // A better approach would probably be to decorate an input element directly. Or to
            // find a way to have <rc-input> transform itself before this code runs. No luck on the latter.
            if (clone[index].tagName === 'INPUT') {
                return [clone.eq(index), { isInputField: true }];
            }
            if (clone[index].nodeName.indexOf('RC-INPUT') === 0) {
                return [clone.eq(index), { isInputField: false }];
            }
        }
        return [null];
    }
    function getTranscludedInputElement(clone) {
        var _findProvidedInput = findProvidedInput(clone),
            _findProvidedInput2 = autocomplete_directive__slicedToArray(_findProvidedInput, 2),
            input = _findProvidedInput2[0],
            results = _findProvidedInput2[1];

        if (input) {
            return [input, results];
        }
        var generatedInput = Object(external__angular_["element"])('<input></input>');
        generatedInput.attr('type', 'text');
        return [generatedInput, { hasNoScope: true, isInputField: true }];
    }
    function setInputAttributes(input, attrs) {
        if (input) {
            var inputModel = input.attr('ng-model');
            // TODO: Remove in next breaking change and allow compile error
            if (Object(external__angular_["isUndefined"])(inputModel)) {
                if (Object(external__angular_["isUndefined"])(attrs.rcInputModel)) {
                    throw new Error('The \'rc-input-model\' attribute must be defined on the <rc-autocomplete> ' + 'if an input has not been transcluded.');
                } else {
                    input.attr('ng-model', attrs.rcInputModel);
                }
            } else if (Object(external__angular_["isDefined"])(inputModel) && Object(external__angular_["isDefined"])(attrs.rcInputModel) && inputModel !== attrs.rcInputModel) {
                $log.warn('The \'rc-input-model\' attribute of the <rc-autocomplete> "' + attrs.rcInputModel + '" does not reference ' + ('the same model as the transcluded <input>s \'ng-model\' "' + inputModel + '"'));
                $log.warn(input);
            }
        }
    }
}
/* harmony default export */ var autocomplete_directive = (AutocompleteDirective);
// EXTERNAL MODULE: ./src/autocomplete/templates/autocomplete-multiple.html
var autocomplete_multiple = __webpack_require__(141);
var autocomplete_multiple_default = /*#__PURE__*/__webpack_require__.n(autocomplete_multiple);

// CONCATENATED MODULE: ./src/autocomplete/autocomplete.directive.multiple.ts


/* Plugs into the rcAutocomplete modifying how it handles result selection and input display. */
function rcAutocompleteMultipleDirective() {
    'ngInject';

    return {
        restrict: 'E',
        require: ['rcAutocompleteMultiple', '^^rcAutocomplete'],
        template: autocomplete_multiple_default.a,
        scope: {},
        controller: 'RcAutocompleteMultipleController',
        controllerAs: 'rcAcMultiCtrl',
        link: AutocompleteMultipleLink
    };
    /* TODO:
        - accommodate `match-on-init` for an array
        - accommodate import of line-break delimited values
    */
    function AutocompleteMultipleLink(scope, element, attrs, controllers) {
        var multipleCtrl = controllers[0];
        var autocompleteCtrl = controllers[1];
        multipleCtrl.bindAutocompleteController(autocompleteCtrl);
        var input = element.parent().find('input').eq(0);
        input.bind('blur', multipleCtrl.handleInputOnBlurEvent);
        var inputModelCtrl = input.controller('ngModel');
        // Allow 'required' validation to function properly for an array
        // Base validation on the model not the display value
        inputModelCtrl.$isEmpty = function () {
            return !Array.isArray(inputModelCtrl.$modelValue);
        };
        // The existence of the multiple will ensure nothing is ever in the input after a selection is made
        inputModelCtrl.$formatters.push(multipleCtrl.inputFormatter);
        // If the model is already set, process it in the extended functionality by forcing a watch using a copy.
        // TODO: Find a better methodology to get things in sync
        if (inputModelCtrl.$modelValue) {
            autocompleteCtrl.setModel(Object(external__angular_["copy"])(inputModelCtrl.$modelValue));
        }
        scope.$on('$destroy', function () {
            input.unbind('blur', multipleCtrl.handleInputOnBlurEvent);
        });
    }
}
/* harmony default export */ var autocomplete_directive_multiple = (rcAutocompleteMultipleDirective);
// CONCATENATED MODULE: ./src/autocomplete/autocomplete.controller.ts
RcAutocompleteController.$inject = ['$scope', '$q', '$timeout'];


// TODO: Convert to class, reduce complexity
function RcAutocompleteController($scope, $q, $timeout) {
    'ngInject';

    var NAV_KEYS = [keyboard_codes["a" /* default */].TAB, keyboard_codes["a" /* default */].ENTER, keyboard_codes["a" /* default */].ESC, keyboard_codes["a" /* default */].UP, keyboard_codes["a" /* default */].DOWN];
    var enterOrTabPressed = void 0;
    var fetchingMatches = null;
    var hasFocus = false;
    var fetchTimeout = void 0;
    var ctrl = this;
    ctrl.activeIndex = -1;
    ctrl.expressionParser = external__angular_["noop"];
    ctrl.formatModel = formatModel;
    ctrl.matches = [];
    ctrl.matchToCurrentModel = matchToCurrentModel;
    ctrl.matchSelected = true;
    ctrl.minSearch = 1;
    ctrl.onInputBlur = onInputBlur;
    ctrl.onInputKeydown = onInputKeydown;
    ctrl.parseUserInput = parseUserInput;
    ctrl.resetMatches = resetMatches;
    ctrl.select = select;
    ctrl.setModel = setModel; // Can be overridden by other directives (like multiple)
    ctrl.setModelToFirstMatch = setModelToFirstMatch;
    // Find a way to move this to the multiple controller only
    ctrl.removeModel = function (modelValue) {
        if (Object(external__angular_["isFunction"])(ctrl.onRemove)) {
            ctrl.onRemove(formatForCallback(modelValue));
        }
    };
    function onInputBlur(event) {
        hasFocus = false;
        var hasInputButNoModel = function hasInputButNoModel() {
            return ctrl.getInputView() && !ctrl.getInputModel();
        };
        var inputEqualsModel = function inputEqualsModel() {
            return ctrl.getInputView() === ctrl.getInputModel();
        };
        if (ctrl.matchOnBlur && !ctrl.falseIEBlur) {
            /** validation runs before the blur which will leave the model empty */
            if (ctrl.hasValidators() && hasInputButNoModel() || inputEqualsModel()) {
                ctrl.setModelToFirstMatch(ctrl.getInputView());
            }
        }
        ctrl.resetMatches();
    }
    function formatForCallback(item) {
        var locals = {};
        locals[ctrl.expressionParser.itemName] = item;
        return {
            $item: item,
            $label: ctrl.expressionParser.viewMapper(locals),
            $model: ctrl.expressionParser.modelMapper(locals)
        };
    }
    function getAsyncMatches(inputValue) {
        var locals = { $viewValue: inputValue };
        setLoadingIndicator(true);
        // Parent scope will have the match information
        fetchingMatches = $q.when(ctrl.expressionParser.source(locals)).then(successHandler).catch(failureHandler);
        function successHandler(matched) {
            /* Multiple async queries may be in flight. Be sure to only display the current one. */
            if (inputValue === ctrl.getInputView() && hasFocus) {
                if (matched && matched.length > 0) {
                    ctrl.activeIndex = 0;
                    ctrl.matches.length = 0;
                    // transform labels
                    for (var i = 0; i < matched.length; i++) {
                        locals[ctrl.expressionParser.itemName] = matched[i];
                        ctrl.matches.push({
                            label: ctrl.expressionParser.viewMapper(locals),
                            model: matched[i]
                        });
                    }
                    ctrl.query = inputValue;
                    // reset dropdown position
                    ctrl.position = ctrl.getInputOffset();
                } else {
                    resetMatches();
                }
                /* Typing quickly and hitting enter or tab should take the very first 'match' and skip the display */
            } else if (!hasFocus && enterOrTabPressed) {
                if (matched && matched.length > 0) {
                    resetMatches();
                    ctrl.setModel(matched[0]);
                    if (Object(external__angular_["isFunction"])(ctrl.onSelect)) {
                        ctrl.onSelect(formatForCallback(matched[0]));
                    }
                }
            }
            fetchingMatches = null;
            setLoadingIndicator(false);
        }
        function failureHandler() {
            resetMatches();
            setLoadingIndicator(false);
        }
    }
    function onInputKeydown(event) {
        // autocomplete is open and an "interesting" key was pressed
        enterOrTabPressed = false;
        if (ctrl.matches.length === 0 || NAV_KEYS.indexOf(event.which) === -1) {
            return;
        }
        switch (event.which) {
            case keyboard_codes["a" /* default */].DOWN:
                event.preventDefault();
                ctrl.activeIndex = (ctrl.activeIndex + 1) % ctrl.matches.length;
                $scope.$digest();
                break;
            case keyboard_codes["a" /* default */].UP:
                event.preventDefault();
                ctrl.activeIndex = (ctrl.activeIndex ? ctrl.activeIndex : ctrl.matches.length) - 1;
                $scope.$digest();
                break;
            case keyboard_codes["a" /* default */].ENTER:
                event.preventDefault();
            /* falls through */
            case keyboard_codes["a" /* default */].TAB:
                enterOrTabPressed = true;
                if (ctrl.matches.length > 0 && fetchingMatches === null) {
                    $scope.$apply(function () {
                        ctrl.select(ctrl.activeIndex, event.key);
                    });
                } else {
                    hasFocus = false;
                }
                break;
            case keyboard_codes["a" /* default */].ESC:
                event.preventDefault();
                event.stopPropagation();
                resetMatches();
                $scope.$digest();
                break;
            default:
                break;
        }
    }
    function parseUserInput(inputValue) {
        hasFocus = true;
        if (!inputValue && ctrl.openOnFocus) {
            getAsyncMatches(inputValue);
        } else if (inputValue && inputValue.length >= ctrl.minSearch) {
            if ((ctrl.waitMs || 0) > 0) {
                if (fetchTimeout) {
                    $timeout.cancel(fetchTimeout);
                }
                fetchTimeout = $timeout(function () {
                    getAsyncMatches(inputValue);
                }, ctrl.waitMs);
            } else {
                getAsyncMatches(inputValue);
            }
        } else {
            setLoadingIndicator(false);
            resetMatches();
        }
        ctrl.matchSelected = !inputValue;
        return inputValue;
    }
    function matchToCurrentModel() {
        var model = ctrl.getInputModel();
        if (Object(external__angular_["isString"])(model) && model.trim().length > 0) {
            setModelToFirstMatch(model);
        }
    }
    function formatModel(modelValue) {
        if (Object(external__angular_["isFunction"])(ctrl.customFormatter)) {
            return ctrl.customFormatter({ $model: modelValue });
        }
        var locals = {};
        // we need to check for this situation and simply return model value if we can't apply custom formatting
        locals[ctrl.expressionParser.itemName] = modelValue;
        var candidateViewValue = ctrl.expressionParser.viewMapper(locals);
        locals[ctrl.expressionParser.itemName] = '';
        var emptyViewValue = ctrl.expressionParser.viewMapper(locals);
        return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
    }
    function resetMatches() {
        ctrl.matches = [];
        ctrl.activeIndex = -1;
    }
    function select(activeIndex, keyboardKey) {
        var formatted = formatForCallback(ctrl.matches[activeIndex].model);
        ctrl.matchSelected = true;
        ctrl.setModel(formatted.$model);
        resetMatches();
        // callback
        if (Object(external__angular_["isFunction"])(ctrl.onSelect)) {
            ctrl.onSelect(formatted);
        }
        // return focus to the input element unless tabbing
        keyboardKey !== 'Tab' && ctrl.focusInput();
    }
    function setLoadingIndicator(value) {
        ctrl.loading = value;
    }
    function setModel(modelValue) {
        ctrl.setInputModel(modelValue);
    }
    /* Shortcut method to avoid the dropdown popping up etc */
    function setModelToFirstMatch(inputValue) {
        if (inputValue) {
            $q.when(ctrl.expressionParser.source({ $viewValue: inputValue })).then(function (matches) {
                if (matches.length > 0) {
                    ctrl.matchSelected = true;
                    ctrl.setModel(matches[0]);
                }
            });
        }
    }
}
/* harmony default export */ var autocomplete_controller = (RcAutocompleteController);
// CONCATENATED MODULE: ./src/autocomplete/autocomplete.controller.multiple.ts
RcAutocompleteMultipleController.$inject = ['$scope'];


function RcAutocompleteMultipleController($scope) {
    'ngInject';

    var removeModelCallback = external__angular_["noop"];
    var setAutocompleteModel = external__angular_["noop"];
    var focusInput = external__angular_["noop"];
    var ctrl = this;
    ctrl.bindAutocompleteController = bindAutocompleteController;
    ctrl.handleInputOnBlurEvent = handleInputOnBlurEvent;
    ctrl.inputFormatter = inputFormatter;
    ctrl.items = [];
    ctrl.keyPressed = keyPressed;
    ctrl.removeItem = removeItem;
    function arrayContains(array, value) {
        if (Object(external__angular_["isArray"])(array)) {
            for (var i = 0; i < array.length; i++) {
                if (Object(external__angular_["equals"])(array[i], value)) {
                    return true;
                }
            }
        }
        return false;
    }
    function bindAutocompleteController(autocompleteCtrl) {
        var keydownAlias = autocompleteCtrl.onInputKeydown;
        autocompleteCtrl.onInputKeydown = function (event) {
            if (event.which === keyboard_codes["a" /* default */].TAB && autocompleteCtrl.matches.length > 0) {
                event.preventDefault();
            }
            keydownAlias(event);
        };
        /* Override original AutocompleteController.setModel */
        var setModelAlias = autocompleteCtrl.setModel;
        autocompleteCtrl.setModel = function (modelValue) {
            if (modelValue && !arrayContains(ctrl.items, modelValue)) {
                if (Object(external__angular_["isArray"])(modelValue)) {
                    ctrl.items = modelValue;
                } else {
                    ctrl.items.push(modelValue);
                }
            }
            if (ctrl.items.length > 0) {
                setModelAlias(ctrl.items);
            } else {
                setModelAlias();
            }
        };
        ctrl.formatForDisplay = function (modelValue) {
            return autocompleteCtrl.formatModel(modelValue);
        };
        removeModelCallback = autocompleteCtrl.removeModel;
        // Local use of overridden setModel
        setAutocompleteModel = autocompleteCtrl.setModel;
        focusInput = autocompleteCtrl.focusInput;
    }
    function handleInputOnBlurEvent() {
        setAutocompleteModel(ctrl.items);
        $scope.$apply();
    }
    /*
    * Taps into the $formatters array which fires after the input model is set (even outside the autocomplete).
    * When the model is manually set, the items array needs to be updated accordingly.
    */
    function inputFormatter(modelValue) {
        if (!modelValue || modelValue && modelValue !== ctrl.items) {
            ctrl.items = [];
            setAutocompleteModel(modelValue);
        }
        return '';
    }
    function keyPressed(event, index) {
        if (event.which === keyboard_codes["a" /* default */].DELETE) {
            removeItem(index);
        }
    }
    function removeItem(index) {
        if (ctrl.items.length > index) {
            var removedValue = ctrl.items.splice(index, 1);
            removeModelCallback(removedValue[0]);
        }
        if (ctrl.items.length === 0) {
            setAutocompleteModel(null);
            focusInput();
        }
    }
}
// EXTERNAL MODULE: ./src/autocomplete/templates/autocomplete-dropdown.html
var autocomplete_dropdown = __webpack_require__(142);
var autocomplete_dropdown_default = /*#__PURE__*/__webpack_require__.n(autocomplete_dropdown);

// EXTERNAL MODULE: ./src/utils/utils.events.ts
var utils_events = __webpack_require__(26);

// CONCATENATED MODULE: ./src/autocomplete/autocomplete.component.dropdown.ts
var autocomplete_component_dropdown__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function autocomplete_component_dropdown__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var autocomplete_component_dropdown_AutocompleteDropdownController = function () {
    AutocompleteDropdownController.$inject = ['$element', '$attrs'];

    function AutocompleteDropdownController($element, $attrs) {
        'ngInject';

        autocomplete_component_dropdown__classCallCheck(this, AutocompleteDropdownController);

        this.$element = $element;
        this.$attrs = $attrs;
    }

    autocomplete_component_dropdown__createClass(AutocompleteDropdownController, [{
        key: '$onInit',
        value: function $onInit() {
            this.templateUrl = this.$attrs.templateUrl;
            this.removeEventHandler = Object(utils_events["a" /* removableEventHandler */])(this.$element, 'mousewheel', function (event) {
                event.stopPropagation();
            });
        }
    }, {
        key: '$destroy',
        value: function $destroy() {
            this.removeEventHandler();
        }
    }, {
        key: 'showMatches',
        value: function showMatches() {
            return this.matches && this.matches.length > 0;
        }
    }, {
        key: 'isActive',
        value: function isActive(matchIdx) {
            return this.active === matchIdx;
        }
    }, {
        key: 'selectActive',
        value: function selectActive(matchIdx) {
            this.active = matchIdx;
        }
    }, {
        key: 'selectMatch',
        value: function selectMatch(activeIndex) {
            this.onSelect({ activeIndex: activeIndex });
        }
    }]);

    return AutocompleteDropdownController;
}();
var AutocompleteDropdownComponent = {
    bindings: {
        matches: '<',
        query: '<',
        active: '<',
        position: '<',
        onSelect: '&'
    },
    template: autocomplete_dropdown_default.a,
    controller: autocomplete_component_dropdown_AutocompleteDropdownController,
    controllerAs: 'rcAcDropCtrl'
};
/* harmony default export */ var autocomplete_component_dropdown = (AutocompleteDropdownComponent);
// EXTERNAL MODULE: ./src/autocomplete/templates/autocomplete-match.html
var autocomplete_match = __webpack_require__(143);
var autocomplete_match_default = /*#__PURE__*/__webpack_require__.n(autocomplete_match);

// CONCATENATED MODULE: ./src/autocomplete/autocomplete.component.match.ts
var autocomplete_component_match__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function autocomplete_component_match__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var autocomplete_component_match_AutocompleteMatchController = function () {
    AutocompleteMatchController.$inject = ['$scope', '$element', '$http', '$templateCache', '$compile'];

    function AutocompleteMatchController($scope, $element, $http, $templateCache, $compile) {
        'ngInject';

        autocomplete_component_match__classCallCheck(this, AutocompleteMatchController);

        this.$scope = $scope;
        this.$element = $element;
        this.$http = $http;
        this.$templateCache = $templateCache;
        this.$compile = $compile;
    }

    autocomplete_component_match__createClass(AutocompleteMatchController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            if (this.dropCtrl.templateUrl) {
                this.$http.get(this.dropCtrl.templateUrl, { cache: this.$templateCache }).then(function (_ref) {
                    var data = _ref.data;

                    _this._buildTemplate(data);
                }).catch(external__angular_["noop"]);
            } else {
                this._buildTemplate(autocomplete_match_default.a);
            }
            if (this.$scope) {
                /**
                 * Expose values in the current scope to maintain backwards-compatibility for custom
                 * elements. Might be good to simplify the template to:
                 * <rc-autocomplete-dropdown>
                 *    <rc-autocomplete-match ng-repeat="match in $ctrl.matches">
                 *      // use match, index & query as needed
                 *    </rc-autocomplete-match>
                 * <rc-autocomplete-dropdown>
                 */
                this.$scope.index = this.index;
                this.$scope.match = this.match;
                this.$scope.query = this.query;
            }
        }
    }, {
        key: '_buildTemplate',
        value: function _buildTemplate(template) {
            var replacement = this.$compile(template)(this.$scope);
            this.$element.replaceWith(replacement);
        }
    }]);

    return AutocompleteMatchController;
}();
var AutocompleteMatchComponent = {
    bindings: {
        index: '<',
        match: '<',
        query: '<'
    },
    require: {
        dropCtrl: '^rcAutocompleteDropdown'
    },
    controller: autocomplete_component_match_AutocompleteMatchController
};
/* harmony default export */ var autocomplete_component_match = (AutocompleteMatchComponent);
// CONCATENATED MODULE: ./src/autocomplete/index.ts




















/* harmony default export */ var src_autocomplete = (Object(external__angular_["module"])('rc.autocomplete', [bindHtml["a" /* default */], keyboardNavigation["a" /* default */], mediaQuery["b" /* default */], position["a" /* default */], usage["b" /* default */], validation["c" /* default */]]).run(autocomplete_run).config(MatchRequiredConfig).constant('AUTOCOMPLETE_SELECT_EVENT', AUTOCOMPLETE_SELECT_EVENT).constant('AUTOCOMPLETE_SERVICES', AUTOCOMPLETE_SERVICES).filter('capitalize', capitalizeFilter).filter('escapeRegexp', escapeRegexpFilter).filter('highlight', highlightFilter).service('AutocompleteExpressionParser', autocomplete_service_expression_parser).directive('rcService', autocomplete_directive_service).component('rcAutocompleteDropdown', autocomplete_component_dropdown).directive('input', autocomplete_directive_input).directive('rcAutocomplete', autocomplete_directive).component('rcAutocompleteMatch', autocomplete_component_match).directive('rcAutocompleteMultiple', autocomplete_directive_multiple).controller('RcAutocompleteController', autocomplete_controller).controller('RcAutocompleteMultipleController', RcAutocompleteMultipleController).name);
// CONCATENATED MODULE: ./src/button/button.directive.ts
buttonDirective.$inject = ['Usage'];
function buttonDirective(Usage) {
    'ngInject';

    return {
        restrict: 'EAC',
        link: function link() {
            Usage.register('button');
        }
    };
}
/* harmony default export */ var button_directive = (buttonDirective);
// CONCATENATED MODULE: ./src/button/index.ts



/* harmony default export */ var src_button = (Object(external__angular_["module"])('rc.button', [usage["b" /* default */]]).directive('button', button_directive).name);
// CONCATENATED MODULE: ./src/focus/focus.directive.ts
rcFocusDirective.$inject = ['$timeout', '$parse'];

function rcFocusDirective($timeout, $parse) {
    'ngInject';

    return {
        link: function link(scope, element, attrs) {
            var hasFocus = false,
                condition = $parse(attrs.rcFocus);
            /* can't use attrs.$observe because actual attribute value may not change */
            scope.$watch(function () {
                return condition(scope);
            }, function (focus) {
                if (focus) {
                    $timeout(setFocus);
                } else if (hasFocus) {
                    $timeout(removeFocus);
                }
            });
            element.bind('blur', removeFocus);
            function setFocus() {
                if (element[0].select) {
                    element[0].select();
                }
                element[0].focus();
                hasFocus = true;
            }
            function removeFocus() {
                var assignable = condition.assign;
                if (Object(external__angular_["isFunction"])(assignable)) {
                    assignable(scope, false);
                }
                element[0].blur(); /* Double fires on blur, but w/e */
                hasFocus = false;
            }
        }
    };
}
/* harmony default export */ var focus_directive = (rcFocusDirective);
// CONCATENATED MODULE: ./src/focus/index.ts


/* harmony default export */ var src_focus = (Object(external__angular_["module"])('rc.focus', []).directive('rcFocus', focus_directive).name);
// CONCATENATED MODULE: ./src/calendar/calendar.service.date.ts
var calendar_service_date__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function calendar_service_date__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
/* Provides calendar-specific data objects.
 * There is a bit of brittleness due to the getTime() comparisons but those should probably be private methods. */

var calendar_service_date_RcCalendarDateService = function () {
    RcCalendarDateService.$inject = ['rcDate', 'rcHoliday'];

    function RcCalendarDateService(rcDate, rcHoliday) {
        'ngInject';

        calendar_service_date__classCallCheck(this, RcCalendarDateService);

        this.rcDate = rcDate;
        this.rcHoliday = rcHoliday;
    }

    calendar_service_date__createClass(RcCalendarDateService, [{
        key: 'buildCalendarDay',
        value: function buildCalendarDay(date, upHolidayMap, customHolidayMap) {
            if (Object(external__angular_["isDate"])(date)) {
                var holidayMap = upHolidayMap || {};
                var customMap = customHolidayMap || {};
                return {
                    date: date,
                    isToday: this.rcDate.isToday(date),
                    isFirstOfMonth: date.getDate() === 1,
                    isLastOfMonth: isLastOfMonth(date),
                    isHoliday: Object(external__angular_["isDefined"])(holidayMap[date.getTime()]) || Object(external__angular_["isDefined"])(customMap[date.getTime()]),
                    title: this.buildCalendarTitle(date, holidayMap, customMap)
                };
            }
            return {};
        }
    }, {
        key: 'buildCalendarTitle',
        value: function buildCalendarTitle(date, upHolidayMap, customHolidayMap) {
            var title = '';
            if (this.rcDate.isToday(date)) {
                title += 'Today';
            }
            var upDay = upHolidayMap && upHolidayMap[date.getTime()];
            if (upDay) {
                title += title.length > 0 ? ' / ' + upDay : upDay;
            }
            var custom = customHolidayMap && customHolidayMap[date.getTime()];
            if (custom) {
                title += title.length > 0 ? ' / ' + custom : custom;
            }
            return title;
        }
    }, {
        key: 'buildCustomTimeMap',
        value: function buildCustomTimeMap(entries) {
            var map = {};
            if (entries && entries.length > 0) {
                for (var index = 0; index < entries.length; index++) {
                    var date = entries[index].date;
                    if (Object(external__angular_["isDate"])(date)) {
                        map[this.rcDate.normalizeTime(date).getTime()] = entries[index].name;
                    }
                }
            }
            return map;
        }
    }, {
        key: 'convertToCalendarDays',
        value: function convertToCalendarDays(dates, locals) {
            var days = [];
            if (Object(external__angular_["isArray"])(dates) && dates.length > 0) {
                var upHolidayMap = {};
                var customHolidayMap = {};
                if (locals) {
                    upHolidayMap = locals.includeUpHolidays === true ? this.rcHoliday.getUpHolidayTimeMap(dates[0]) : {};
                    customHolidayMap = this.buildCustomTimeMap(locals.customHolidays);
                }
                var indexDate = void 0;
                for (var index = 0; index < dates.length; index++) {
                    indexDate = dates[index];
                    days.push(this.buildCalendarDay(dates[index], upHolidayMap, customHolidayMap));
                }
            }
            return days;
        }
    }, {
        key: 'convertToCalendarWeeks',
        value: function convertToCalendarWeeks(calendarDays) {
            var weeks = [];
            if (Object(external__angular_["isArray"])(calendarDays) && calendarDays.length > 0) {
                // Prefix undefined values back to Sunday
                for (var prefix = calendarDays[0].date.getDay() - 1; prefix >= 0; prefix--) {
                    calendarDays.unshift(void 0);
                }
                // Postfix any missing days
                var suffix = 6 - calendarDays.length % 7;
                for (; suffix > -1 && suffix !== 6; suffix--) {
                    calendarDays.push(void 0);
                }
                for (var index = 0; index < calendarDays.length; index += 7) {
                    weeks.push(calendarDays.slice(index, index + 7));
                }
            }
            return weeks;
        }
    }, {
        key: 'getCalendarMonth',
        value: function getCalendarMonth(date, locals) {
            var calendarMonth = {};
            if (Object(external__angular_["isDate"])(date)) {
                var calendarDays = this.convertToCalendarDays(this.rcDate.monthFor(date), locals);
                calendarMonth.heading = MONTH_NAMES[date.getMonth()] + ' ' + date.getFullYear();
                calendarMonth.weeks = this.convertToCalendarWeeks(calendarDays);
            }
            return calendarMonth;
        }
    }]);

    return RcCalendarDateService;
}();

/* harmony default export */ var calendar_service_date = (calendar_service_date_RcCalendarDateService);

function isLastOfMonth(date) {
    if (Object(external__angular_["isDate"])(date)) {
        var end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        return date.getDate() === end.getDate();
    }
    return false;
}
// CONCATENATED MODULE: ./src/calendar/calendar.service.manager.ts
var calendar_service_manager__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function calendar_service_manager__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var RENDERING_CLASS = 'rendering';
/* Allows only one open calendar at a time */

var calendar_service_manager_RcCalendarManagerService = function () {
    RcCalendarManagerService.$inject = ['$document', '$compile', '$timeout', 'rcMediaQuery', 'rcCalendarPosition'];

    function RcCalendarManagerService($document, $compile, $timeout, rcMediaQuery, rcCalendarPosition) {
        'ngInject';

        calendar_service_manager__classCallCheck(this, RcCalendarManagerService);

        this.$compile = $compile;
        this.$timeout = $timeout;
        this.rcMediaQuery = rcMediaQuery;
        this.rcCalendarPosition = rcCalendarPosition;
        this.documentBody = $document.find('body');
        this.escapeKey = keyboard_codes["a" /* default */].ESC;
        this.current = null;
        this.bindWindowEvents();
    }

    calendar_service_manager__createClass(RcCalendarManagerService, [{
        key: 'bindWindowEvents',
        value: function bindWindowEvents() {
            var _this = this;

            var theWindow = Object(external__angular_["element"])(window);
            // Lightweight 'open' calendar closers :)
            theWindow.bind('resize', function () {
                if (_this.current !== null) {
                    _this.close(_this.current.scope);
                }
            });
            theWindow.bind('keydown', function (event) {
                if (event.keyCode === _this.escapeKey && _this.current !== null) {
                    _this.close(_this.current.scope);
                }
            });
        }
    }, {
        key: 'open',
        value: function open(scope, sourceElement, template) {
            var _this2 = this;

            if (this.current !== null) {
                this.close(this.current.scope);
            }
            var popup = Object(external__angular_["element"])(template);
            popup.addClass(RENDERING_CLASS); // hides while rendering
            this.current = {
                popup: popup,
                scope: scope,
                source: sourceElement,
                childScope: scope.$new()
            };
            this.documentBody.append(this.current.popup);
            this.$compile(this.current.popup)(this.current.childScope);
            if (this.rcMediaQuery.minSize('medium')) {
                // Must be measured after all rendering or measurements are incomplete
                this.$timeout(function () {
                    _this2.current.popup.css(_this2.rcCalendarPosition.getInlineCss(_this2.current.source, _this2.current.popup));
                    _this2.current.popup.removeClass(RENDERING_CLASS); // stops hiding
                });
            } else {
                this.current.popup.css(this.rcCalendarPosition.getInlineCss(this.current.source, this.current.popup));
                this.lockBodyForMobile();
                this.current.popup.removeClass(RENDERING_CLASS); // stops hiding
            }
        }
    }, {
        key: 'lockBodyForMobile',
        value: function lockBodyForMobile() {
            this.current.pagePosition = {
                top: this.documentBody[0].scrollTop,
                left: this.documentBody[0].scrollLeft
            };
            this.documentBody[0].scrollTop = 0;
            this.documentBody[0].scrollLeft = 0;
            this.documentBody.addClass('rc-calendar-open');
        }
    }, {
        key: 'unlockBodyForMobile',
        value: function unlockBodyForMobile() {
            if (this.current.pagePosition) {
                this.documentBody[0].scrollTop = this.current.pagePosition.top;
                this.documentBody[0].scrollLeft = this.current.pagePosition.left;
            }
            this.documentBody.removeClass('rc-calendar-open');
        }
    }, {
        key: 'isOpen',
        value: function isOpen(scope) {
            return scope && this.current && scope === this.current.scope;
        }
    }, {
        key: 'close',
        value: function close(scope) {
            if (this.isOpen(scope)) {
                this.current.childScope.$destroy();
                this.unlockBodyForMobile();
                this.current.popup.remove();
                this.current = null;
            }
        }
    }]);

    return RcCalendarManagerService;
}();

/* harmony default export */ var calendar_service_manager = (calendar_service_manager_RcCalendarManagerService);
// CONCATENATED MODULE: ./src/calendar/calendar.service.model.converter.ts
var calendar_service_model_converter__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function calendar_service_model_converter__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var SEPARATOR_REGEX = /\s*,\s*|\s*;\s*|\s*-\s+|\s+-\s*/g;
var DEFAULT_SEPARATOR = ' - ';

var calendar_service_model_converter_CalendarModelConverterService = function () {
    CalendarModelConverterService.$inject = ['rcDate'];

    function CalendarModelConverterService(rcDate) {
        'ngInject';

        calendar_service_model_converter__classCallCheck(this, CalendarModelConverterService);

        this.rcDate = rcDate;
    }

    calendar_service_model_converter__createClass(CalendarModelConverterService, [{
        key: 'formatStringForDisplay',
        value: function formatStringForDisplay(model) {
            // TODO ranges too
            if (Object(external__angular_["isString"])(model)) {
                var dateAsLocalTime = model.replace(/-/g, '/');
                return dateToString(new Date(dateAsLocalTime));
            }
            return '';
        }
    }, {
        key: 'formatForDisplay',
        value: function formatForDisplay(model) {
            if (Object(external__angular_["isDate"])(model)) {
                return dateToString(model);
            } else if (Object(external__angular_["isArray"])(model)) {
                var range = dateToString(model[0]);
                if (model.length > 1) {
                    range += DEFAULT_SEPARATOR + dateToString(model[1]);
                }
                return range;
            }
            return model;
        }
    }, {
        key: 'parseDate',
        value: function parseDate(inputString) {
            if (Object(external__angular_["isUndefined"])(inputString)) {
                return inputString;
            }
            /* Separator is either:
             * 1. comma or semicolon with 0+ spaces before and/or after,
             * 2. dash with 1+ spaces before and/or after, or
             * 3. dash if there's only one in the string. */
            var separator = inputString.match(SEPARATOR_REGEX);
            if (!separator) {
                separator = inputString.match(/-/g);
            }
            if (separator && separator.length === 1) {
                var dateRange = inputString.split(separator[0]);
                for (var i = 0; i < dateRange.length; i++) {
                    var newDate = this.rcDate.convertToDate(dateRange[i]);
                    if (Object(external__angular_["isDate"])(newDate) && newDate.toString() === 'Invalid Date') {
                        continue;
                    } else {
                        dateRange[i] = newDate;
                    }
                }
                return dateRange;
            }
            return this.rcDate.convertToDate(inputString);
        }
    }]);

    return CalendarModelConverterService;
}();

/* harmony default export */ var calendar_service_model_converter = (calendar_service_model_converter_CalendarModelConverterService);

function dateToString(date) {
    if (Object(external__angular_["isDate"])(date) && !isNaN(date.getTime())) {
        var year = date.getFullYear();
        var month = ('0' + (date.getMonth() + 1)).slice(-2);
        var day = ('0' + date.getDate()).slice(-2);
        return month + '/' + day + '/' + year;
    }
    return '';
}
// CONCATENATED MODULE: ./src/calendar/calendar.service.position.ts
var calendar_service_position__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function calendar_service_position__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RcCalendarPositionService = function () {
    RcCalendarPositionService.$inject = ['$window', '$position', 'rcMediaQuery'];

    function RcCalendarPositionService($window, $position, rcMediaQuery) {
        'ngInject';

        calendar_service_position__classCallCheck(this, RcCalendarPositionService);

        this.$window = $window;
        this.$position = $position;
        this.rcMediaQuery = rcMediaQuery;
    }

    calendar_service_position__createClass(RcCalendarPositionService, [{
        key: 'buildDesktopCss',
        value: function buildDesktopCss(calendarElement, popupElement) {
            var verticallyAdjusted = false;
            // div.button-addon element
            var target = calendarElement.children().eq(0);
            var offset = this.$position.offset(target);
            var css = {
                top: offset.top,
                left: offset.left
            };
            // Align below, else above, else adjust to vertical space
            if (this.$window.pageYOffset + this.$window.innerHeight - offset.top - offset.height > popupElement[0].offsetHeight) {
                css.top = offset.top + offset.height;
            } else if (offset.top - this.$window.pageYOffset > popupElement[0].offsetHeight) {
                css.top = offset.top - popupElement[0].offsetHeight;
            } else {
                this.sizeContentToAvailableSpace(popupElement);
                css.top = this.$window.pageYOffset;
                verticallyAdjusted = true;
            }
            /* 1. Right of the button
             * 2. Left of the button (overlay the input),
             * 3. Match the left of the input (overlays input and button) */
            if (verticallyAdjusted) {
                // grab span.buttonfix
                var buttonSpan = target.find('span');
                if (this.$window.innerWidth - offset.left - offset.width > popupElement[0].offsetWidth) {
                    css.left = offset.left + offset.width;
                } else if (offset.width - buttonSpan[0].offsetWidth > popupElement[0].offsetWidth) {
                    css.left = offset.left + offset.width - buttonSpan[0].offsetWidth - popupElement[0].offsetWidth;
                }
            } else {
                css.left = Math.min(offset.left, this.$window.innerWidth - popupElement[0].offsetWidth);
            }
            css.top = Math.ceil(css.top) + 'px';
            css.left = Math.ceil(css.left) + 'px';
            return css;
        }
    }, {
        key: 'buildMobileCss',
        value: function buildMobileCss(popupElement) {
            return {
                width: Math.floor(this.$window.innerWidth) + 'px',
                height: Math.floor(this.$window.innerHeight) + 'px'
            };
        }
    }, {
        key: 'getInlineCss',
        value: function getInlineCss(calendarElement, popupElement) {
            if (this.rcMediaQuery.minSize('medium')) {
                return this.buildDesktopCss(calendarElement, popupElement);
            } else {
                return this.buildMobileCss(popupElement);
            }
        }
    }, {
        key: 'sizeContentToAvailableSpace',
        value: function sizeContentToAvailableSpace(popup) {
            if (popup[0].offsetHeight > this.$window.innerHeight) {
                var header = popup.children().eq(0);
                var content = popup.children().eq(1).children().eq(0);
                content.css({
                    // 5 pixels seems to make the difference in IE, but only M$ knows why..... :-(
                    height: Math.floor(this.$window.innerHeight - header[0].offsetHeight - 5) + 'px'
                });
            }
        }
    }]);

    return RcCalendarPositionService;
}();

/* harmony default export */ var calendar_service_position = (RcCalendarPositionService);
// CONCATENATED MODULE: ./src/calendar/date.service.ts
var date_service__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function date_service__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


// Cache previously generated months
var MONTHS = {};
var DATE_REGEX = /^(0?[1-9]|1[012])[\\\-.: \/]?([^0-9][1-9]|0[1-9]|[12][0-9]|3[01])[\\\-.: \/]?([0-9]{2}|[0-9]{4})?$/;
/** Utility service for generating and normalizing date objects */

var date_service_RcDateService = function () {
    function RcDateService() {
        'ngInject';

        date_service__classCallCheck(this, RcDateService);
    }

    date_service__createClass(RcDateService, [{
        key: 'buildNormalizedDate',
        value: function buildNormalizedDate(year, month, day) {
            return new Date(year, month, day, 0, 0, 0, 0);
        }
    }, {
        key: 'convertToDate',
        value: function convertToDate(stringValue) {
            if (Object(external__angular_["isDefined"])(stringValue)) {
                var matches = stringValue.match(DATE_REGEX);
                if (matches) {
                    var first = scrubDigit(matches[1]);
                    var second = scrubDigit(matches[2]);
                    var year = scrubDigit(matches[3]);
                    if (Object(external__angular_["isUndefined"])(year)) {
                        year = new Date().getFullYear();
                    }
                    return this.normalizeTime(new Date(first + '/' + second + '/' + parseTwoDigitYear(year)));
                }
            }
            return stringValue;
        }
    }, {
        key: 'isToday',
        value: function isToday(date) {
            if (Object(external__angular_["isDate"])(date)) {
                return this.normalizeTime(new Date()).getTime() === this.normalizeTime(date).getTime();
            }
            return false;
        }
    }, {
        key: 'monthFor',
        value: function monthFor(date) {
            if (!Object(external__angular_["isDate"])(date)) {
                return [];
            }
            var month = MONTHS[date.getMonth() + '-' + date.getFullYear()] || [];
            if (month.length === 0) {
                var index = this.buildNormalizedDate(date.getFullYear(), date.getMonth(), 1);
                var monthEnd = this.buildNormalizedDate(date.getFullYear(), date.getMonth() + 1, 0).getTime();
                for (; index.getTime() <= monthEnd; index.setDate(index.getDate() + 1)) {
                    month.push(new Date(index));
                }
                MONTHS[date.getMonth() + '-' + date.getFullYear()] = month;
            }
            return month;
        }
    }, {
        key: 'normalizeTime',
        value: function normalizeTime(date) {
            if (Object(external__angular_["isDate"])(date)) {
                return this.buildNormalizedDate(date.getFullYear(), date.getMonth(), date.getDate());
            }
            return date;
        }
    }]);

    return RcDateService;
}();

/* harmony default export */ var date_service = (date_service_RcDateService);

function scrubDigit(value) {
    if (value) {
        return value.replace(/[^\d]/, '');
    }
    return value;
}
/*
 * JS engines are inconsistent on 2 digit year implementations:
 * Year value '00' for IE & FF is 1900 but in Chrome its 2000
 * Year value '50' for IE & FF is 1950 but in Chrome its 1950 <-- not handled yet
 * This pushes low numbers up and high numbers down with a rough, 30-year mechanism.
 * Lifted from Ricola 2!
 */
function parseTwoDigitYear(value) {
    if (Object(external__angular_["isString"])(value)) {
        value = parseInt(value, 10);
    }
    if (value > 99) {
        return value;
    }
    var year = new Date().getFullYear();
    // current year + 30 < value ? 19xx : 20xx
    return (Math.floor(year / 100) - (year % 100 + 30 < value ? 1 : 0)) * 100 + value;
}
// CONCATENATED MODULE: ./src/calendar/holiday.service.ts
var holiday_service__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function holiday_service__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


/* Cache of previously caculated holidays by year */
var HOLIDAYS = {};

var holiday_service_RcHolidayService = function () {
    RcHolidayService.$inject = ['rcDate'];

    function RcHolidayService(rcDate) {
        'ngInject';

        holiday_service__classCallCheck(this, RcHolidayService);

        this.rcDate = rcDate;
        this.onConstruct();
    }
    // Init cache with most likely year


    holiday_service__createClass(RcHolidayService, [{
        key: 'onConstruct',
        value: function onConstruct() {
            var today = new Date();
            HOLIDAYS[today.getFullYear()] = this.buildUpHolidayTimeMap(today.getFullYear());
        }
    }, {
        key: 'isUpHoliday',
        value: function isUpHoliday(date) {
            if (Object(external__angular_["isDate"])(date)) {
                var normalized = this.rcDate.normalizeTime(date);
                var map = this.getUpHolidayTimeMap(normalized);
                return Object(external__angular_["isDefined"])(map[normalized.getTime()]);
            }
            return false;
        }
    }, {
        key: 'getUpHolidayTimeMap',
        value: function getUpHolidayTimeMap(date) {
            if (Object(external__angular_["isDate"])(date)) {
                var yearOfHolidays = HOLIDAYS[date.getFullYear()];
                if (!yearOfHolidays) {
                    yearOfHolidays = this.buildUpHolidayTimeMap(date.getFullYear());
                    HOLIDAYS[date.getFullYear()] = yearOfHolidays;
                }
                return yearOfHolidays;
            }
            return {};
        }
        /* build a fresh map **/

    }, {
        key: 'buildUpHolidayTimeMap',
        value: function buildUpHolidayTimeMap(year) {
            var map = {};
            map[this.newYearsDay(year).getTime()] = 'New Year\'s Day';
            map[this.presidentsDay(year).getTime()] = 'President\'s Day';
            map[this.goodFriday(year).getTime()] = 'Good Friday';
            map[this.memorialDay(year).getTime()] = 'Memorial Day';
            map[this.independenceDay(year).getTime()] = 'Independence Day';
            map[this.laborDay(year).getTime()] = 'Labor Day';
            map[this.thanksgivingDay(year).getTime()] = 'Thanksgiving Day';
            map[this.thanksgivingFriday(year).getTime()] = 'Day After Thanksgiving';
            map[this.christmasEve(year).getTime()] = 'Christmas Eve';
            map[this.christmasDay(year).getTime()] = 'Christmas Day';
            map[this.newYearsEve(year).getTime()] = 'New Year\'s Eve';
            return map;
        }
    }, {
        key: 'christmasEve',
        value: function christmasEve(year) {
            return this.rcDate.buildNormalizedDate(year, 11, 24);
        }
    }, {
        key: 'christmasDay',
        value: function christmasDay(year) {
            return this.rcDate.buildNormalizedDate(year, 11, 25);
        }
        // Public domain per http://www.irt.org/utility/smprint.htm#software
        // Code from http://www.irt.org/articles/js052/index.htm

    }, {
        key: 'easter',
        value: function easter(year) {
            var C = Math.floor(year / 100);
            var N = year - 19 * Math.floor(year / 19);
            var K = Math.floor((C - 17) / 25);
            var I = C - Math.floor(C / 4) - Math.floor((C - K) / 3) + 19 * N + 15;
            var J = void 0;
            I = I - 30 * Math.floor(I / 30);
            I = I - Math.floor(I / 28) * (1 - Math.floor(I / 28) * Math.floor(29 / (I + 1)) * Math.floor((21 - N) / 11));
            J = year + Math.floor(year / 4) + I + 2 - C + Math.floor(C / 4);
            J = J - 7 * Math.floor(J / 7);
            var L = I - J;
            var month = 3 + Math.floor((L + 40) / 44);
            var day = L + 28 - 31 * Math.floor(month / 4);
            return this.rcDate.buildNormalizedDate(year, month - 1, day);
        }
    }, {
        key: 'goodFriday',
        value: function goodFriday(year) {
            var friday = new Date(this.easter(year));
            friday.setDate(friday.getDate() - 2);
            return this.rcDate.normalizeTime(friday);
        }
    }, {
        key: 'independenceDay',
        value: function independenceDay(year) {
            return this.rcDate.buildNormalizedDate(year, 6, 4);
        }
    }, {
        key: 'laborDay',
        value: function laborDay(year) {
            var labor = new Date();
            // First Monday of September
            for (var index = 1; index < 30; index++) {
                labor.setFullYear(year, 8, index);
                if (labor.getDay() === 1) {
                    return this.rcDate.normalizeTime(labor);
                }
            }
        }
    }, {
        key: 'memorialDay',
        value: function memorialDay(year) {
            // Work backwards from the month end to find last Monday
            var memDay = this.rcDate.buildNormalizedDate(year, 5, 0);
            for (var index = memDay.getDate(); index > 0; index--) {
                if (memDay.getDay() === 1) {
                    return memDay;
                }
                memDay.setDate(index);
            }
        }
    }, {
        key: 'newYearsEve',
        value: function newYearsEve(year) {
            return this.rcDate.buildNormalizedDate(year, 11, 31);
        }
    }, {
        key: 'newYearsDay',
        value: function newYearsDay(year) {
            return this.rcDate.buildNormalizedDate(year, 0, 1);
        }
    }, {
        key: 'presidentsDay',
        value: function presidentsDay(year) {
            var presDay = this.rcDate.buildNormalizedDate(year, 1, 1);
            // Third Monday of February
            for (var j = 1; j < 29; j++) {
                presDay.setDate(j);
                if (presDay.getDay() === 1) {
                    presDay.setFullYear(year, 1, j + 14);
                    return this.rcDate.normalizeTime(presDay);
                }
            }
        }
    }, {
        key: 'thanksgivingDay',
        value: function thanksgivingDay(year) {
            var turkey = new Date();
            // Fourth Thursday in November
            for (var j = 1; j < 31; j++) {
                turkey.setFullYear(year, 10, j);
                if (turkey.getDay() === 4) {
                    turkey.setFullYear(year, 10, j + 21);
                    return this.rcDate.normalizeTime(turkey);
                }
            }
        }
    }, {
        key: 'thanksgivingFriday',
        value: function thanksgivingFriday(year) {
            var leftovers = new Date(this.thanksgivingDay(year));
            leftovers.setDate(leftovers.getDate() + 1);
            return this.rcDate.normalizeTime(leftovers);
        }
    }]);

    return RcHolidayService;
}();

/* harmony default export */ var holiday_service = (holiday_service_RcHolidayService);
// EXTERNAL MODULE: ./src/calendar/templates/calendar-day.html
var calendar_day = __webpack_require__(144);
var calendar_day_default = /*#__PURE__*/__webpack_require__.n(calendar_day);

// CONCATENATED MODULE: ./src/calendar/calendar.component.day.ts
var calendar_component_day__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function calendar_component_day__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var SELECTED_CLASS = 'rc-calendar-selected';
var START_CLASS = 'rc-calendar-start';
var END_CLASS = 'rc-calendar-end';
function refreshSelectionClasses(element, time, lowerLimit, upperLimit) {
    if (time >= lowerLimit && time <= upperLimit) {
        element.addClass(SELECTED_CLASS);
        if (lowerLimit === upperLimit && lowerLimit === time) {
            element.addClass(START_CLASS);
            element.addClass(END_CLASS);
        } else {
            if (time === lowerLimit) {
                element.addClass(START_CLASS);
            } else {
                element.removeClass(START_CLASS);
            }
            if (time === upperLimit) {
                element.addClass(END_CLASS);
            } else {
                element.removeClass(END_CLASS);
            }
        }
    } else if (element.hasClass(SELECTED_CLASS)) {
        element.removeClass(SELECTED_CLASS);
        element.removeClass(START_CLASS);
        element.removeClass(END_CLASS);
    }
}
function addDayClasses(element, day, disabled) {
    if (Object(external__angular_["isDefined"])(day)) {
        element.addClass('rc-calendar-date');
        element.addClass(disabled === true ? 'rc-calendar-disabled' : '');
        element.addClass(day.isToday ? 'rc-calendar-today' : '');
        element.addClass(day.isHoliday ? 'rc-calendar-holiday' : '');
        element.addClass(day.isFirstOfMonth ? 'rc-calendar-fom' : '');
        element.addClass(day.isLastOfMonth ? 'rc-calendar-lom' : '');
    }
}
function addDayAttributes(element, day) {
    if (Object(external__angular_["isDefined"])(day)) {
        element.attr('tabindex', '0');
        element.attr('title', day.title);
    }
}
var calendar_component_day_CalendarDayController = function () {
    CalendarDayController.$inject = ['$scope', '$element', '$timeout'];

    function CalendarDayController($scope, $element, $timeout) {
        'ngInject';

        calendar_component_day__classCallCheck(this, CalendarDayController);

        this.$scope = $scope;
        this.$element = $element;
        this.$timeout = $timeout;
    }

    calendar_component_day__createClass(CalendarDayController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.day = this.item();
            this.disabled = this.popupCtrl.isDisabled(this.day);
            if (this.popupCtrl.isFocused(this.day)) {
                this.$timeout(function () {
                    _this.$element[0].focus();
                }, 0, false);
            }
            addDayClasses(this.$element, this.day, this.disabled);
            addDayAttributes(this.$element, this.day);
        }
    }, {
        key: '$postLink',
        value: function $postLink() {
            var _this2 = this;

            this.$element.on('click', function () {
                _this2.select();
            });
            this.$element.on('keydown', function (event) {
                switch (event.keyCode) {
                    case keyboard_codes["a" /* default */].ENTER:
                    // fall through
                    case keyboard_codes["a" /* default */].SPACE:
                        _this2.select();
                        event.preventDefault();
                        break;
                    default: // do nothing
                }
            });
            // Listen for parent selection changes to highlight elements
            this.$scope.$on('rcCalendarSelectionUpdate', function (event, data) {
                if (_this2.day && data.startTime && data.endTime) {
                    refreshSelectionClasses(_this2.$element, _this2.day.date.getTime(), data.startTime, data.endTime);
                }
            });
        }
    }, {
        key: 'number',
        value: function number() {
            return this.day && this.day.date.getDate() || '';
        }
    }, {
        key: 'select',
        value: function select() {
            var _this3 = this;

            if (!this.disabled) {
                this.$scope.$apply(function () {
                    _this3.popupCtrl.select(_this3.day);
                });
            }
        }
    }]);

    return CalendarDayController;
}();
var CalendarDayComponent = {
    bindings: {
        item: '&'
    },
    require: {
        popupCtrl: '^rcCalendarPopup'
    },
    controller: calendar_component_day_CalendarDayController,
    controllerAs: 'rcCalDayCtrl',
    template: calendar_day_default.a
};
/* harmony default export */ var calendar_component_day = (CalendarDayComponent);
// EXTERNAL MODULE: ./src/calendar/templates/calendar-month.html
var calendar_month = __webpack_require__(145);
var calendar_month_default = /*#__PURE__*/__webpack_require__.n(calendar_month);

// CONCATENATED MODULE: ./src/calendar/calendar.component.month.ts
var calendar_component_month__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function calendar_component_month__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var CalendarMonthController = function () {
    function CalendarMonthController() {
        'ngInject';

        calendar_component_month__classCallCheck(this, CalendarMonthController);
    }

    calendar_component_month__createClass(CalendarMonthController, [{
        key: '$onInit',
        value: function $onInit() {
            var item = this.item();
            this.heading = item.heading || '';
            this.weeks = item.weeks || [];
        }
    }]);

    return CalendarMonthController;
}();
var CalendarMonthComponent = {
    bindings: {
        item: '&'
    },
    controller: CalendarMonthController,
    controllerAs: 'rcCalMCtrl',
    template: calendar_month_default.a
};
/* harmony default export */ var calendar_component_month = (CalendarMonthComponent);
// EXTERNAL MODULE: ./src/calendar/templates/calendar-popup.html
var calendar_popup = __webpack_require__(146);
var calendar_popup_default = /*#__PURE__*/__webpack_require__.n(calendar_popup);

// CONCATENATED MODULE: ./src/calendar/calendar.component.popup.ts
var calendar_component_popup__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function calendar_component_popup__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




function getFirstEntry(month) {
    var week = month.weeks[0];
    for (var index = 0; index < week.length; index++) {
        if (week[index]) {
            return week[index].date;
        }
    }
}
function monthWithin(date, min, max) {
    if (Object(external__angular_["isDate"])(date)) {
        var year = date.getFullYear();
        if (year > max.getFullYear() || year < min.getFullYear()) {
            return false;
        }
        var month = date.getMonth();
        if (year === min.getFullYear() && month < min.getMonth()) {
            return false;
        } else if (year === max.getFullYear() && month > max.getMonth()) {
            return false;
        }
        return true;
    }
    return false;
}
function valueOutside(value, min, max) {
    return value < min || value > max;
}
var MAX_DATE = new Date(8640000000000000);
var MIN_DATE = new Date(-8640000000000000);
// TODO: decompose further...this still feels heavy?
var calendar_component_popup_CalendarPopupController = function () {
    CalendarPopupController.$inject = ['$scope', '$element', '$timeout', 'rcDate', 'rcCalendarDate'];

    function CalendarPopupController($scope, $element, $timeout, rcDate, rcCalendarDate) {
        'ngInject';

        calendar_component_popup__classCallCheck(this, CalendarPopupController);

        this.$scope = $scope;
        this.$element = $element;
        this.$timeout = $timeout;
        this.rcDate = rcDate;
        this.rcCalendarDate = rcCalendarDate;
    }

    calendar_component_popup__createClass(CalendarPopupController, [{
        key: '$onInit',
        value: function $onInit() {
            this.multiSelect = !!this.isRange();
            this.maxDate = this.rcDate.normalizeTime(this.maximumDate()) || MAX_DATE;
            this.minDate = this.rcDate.normalizeTime(this.minimumDate()) || MIN_DATE;
            this.disabledMap = this.buildDisabledMap(this.disabledDates());
            this.todayTranslation = lib_default.a.get('rc.calendar.today');
            this.okTranslation = lib_default.a.get('rc.calendar.ok');
        }
    }, {
        key: '$postLink',
        value: function $postLink() {
            var _this = this;

            /* Refresh depends on content controller being available. Must run after child initialization */
            this.$scope.$evalAsync(function () {
                _this.refreshDisplay();
            });
            this.$scope.$on('rcCalendarPopupRefresh', function () {
                _this.refreshDisplay();
            });
        }
    }, {
        key: 'buildDisabledMap',
        value: function buildDisabledMap(dates) {
            var _this2 = this;

            var disabled = {};
            if (Object(external__angular_["isArray"])(dates)) {
                dates.forEach(function (date) {
                    disabled[_this2.rcDate.normalizeTime(date).getTime()] = true;
                });
            }
            return disabled;
        }
        // TODO: Promise structure for cancel/complete?

    }, {
        key: 'cancel',
        value: function cancel() {
            this.onComplete({
                $selected: null
            });
        }
        // TODO: Promise structure for cancel/complete?

    }, {
        key: 'complete',
        value: function complete() {
            this.onComplete({
                $selected: this.selected
            });
        }
    }, {
        key: 'getMonth',
        value: function getMonth(date) {
            if (monthWithin(date, this.minDate, this.maxDate)) {
                return this.rcCalendarDate.getCalendarMonth(date, {
                    includeUpHolidays: this.upHolidays() || false,
                    customHolidays: this.customHolidays() || null
                });
            }
            return null;
        }
    }, {
        key: 'focusToday',
        value: function focusToday() {
            this.focused = this.rcDate.normalizeTime(new Date());
            this.contentCtrl.buildDateView(this.focused);
            this.updateSelectedHighlighting();
        }
    }, {
        key: 'isCompleteSelection',
        value: function isCompleteSelection() {
            if (this.multiSelect) {
                return Object(external__angular_["isArray"])(this.selected) && this.selected.length === 2 && this.selected.every(function (entry) {
                    return Object(external__angular_["isDate"])(entry);
                });
            }
            return Object(external__angular_["isDate"])(this.selected);
        }
    }, {
        key: 'isDisabled',
        value: function isDisabled(calendarDay) {
            if (calendarDay) {
                var time = calendarDay.date.getTime();
                return valueOutside(time, this.minDate.getTime(), this.maxDate.getTime()) || this.disabledMap[time] === true;
            }
            return false;
        }
    }, {
        key: 'isFocused',
        value: function isFocused(calendarDay) {
            if (calendarDay) {
                var time = Object(external__angular_["isDate"])(calendarDay) ? calendarDay.getTime() : calendarDay.date.getTime();
                return time === this.focused.getTime();
            }
            return false;
        }
    }, {
        key: 'refreshDisplay',
        value: function refreshDisplay() {
            this.selected = Object(external__angular_["copy"])(this.selectedDate());
            this.focused = this.rcDate.normalizeTime(
            // 1. selected date
            this.selected && this.selected[0] || this.selected ||
            // 2. focused-date
            this.focused ||
            // 3. today
            new Date());
            // ensure a date value is set (in case of bad input)
            if (!Object(external__angular_["isDate"])(this.focused)) {
                this.focused = this.rcDate.normalizeTime(new Date());
            }
            // ensure date is within boundaries
            if (this.focused.getTime() < this.minDate.getTime()) {
                this.focused = this.minDate;
            } else if (this.focused.getTime() > this.maxDate.getTime()) {
                // do not accidentally set the date to MIN_DATE
                this.focused = this.minDate.getTime() !== MIN_DATE.getTime() ? this.minDate : this.maxDate;
            }
            this.contentCtrl.buildDateView(this.focused);
            this.updateSelectedHighlighting();
        }
    }, {
        key: 'select',
        value: function select(calendarDay) {
            if (!calendarDay) {
                this.selected = null;
            } else if (this.multiSelect) {
                if (!Object(external__angular_["isArray"])(this.selected)) {
                    this.selected = [];
                }
                if (this.selected.length === 2) {
                    this.selected.length = 0;
                }
                if (this.selected.length === 1) {
                    if (this.selected[0].getTime() > calendarDay.date.getTime()) {
                        this.selected.unshift(calendarDay.date);
                    } else {
                        this.selected.push(calendarDay.date);
                    }
                } else {
                    this.selected.push(calendarDay.date);
                }
            } else {
                this.selected = calendarDay.date;
            }
            if (!this.okButton() && this.isCompleteSelection()) {
                this.complete();
            }
            this.updateSelectedHighlighting();
        }
    }, {
        key: 'setContentController',
        value: function setContentController(ctrl) {
            this.contentCtrl = ctrl;
        }
    }, {
        key: 'showOkButton',
        value: function showOkButton() {
            return !!this.okButton() && this.isCompleteSelection();
        }
    }, {
        key: 'updateSelectedHighlighting',
        value: function updateSelectedHighlighting() {
            var _this3 = this;

            // Must happen after render but does not require a $digest
            this.$timeout(function () {
                var data = {};
                if (_this3.multiSelect && Object(external__angular_["isArray"])(_this3.selected)) {
                    if (_this3.selected.length === 1) {
                        var firstTime = _this3.rcDate.normalizeTime(_this3.selected[0]).getTime();
                        data.startTime = firstTime;
                        data.endTime = firstTime;
                    } else if (_this3.selected.length === 2) {
                        data.startTime = _this3.rcDate.normalizeTime(_this3.selected[0]).getTime();
                        data.endTime = _this3.rcDate.normalizeTime(_this3.selected[1]).getTime();
                    }
                } else if (Object(external__angular_["isDate"])(_this3.selected)) {
                    var selectedTime = _this3.rcDate.normalizeTime(_this3.selected).getTime();
                    data.startTime = selectedTime;
                    data.endTime = selectedTime;
                }
                _this3.$scope.$broadcast('rcCalendarSelectionUpdate', data);
            }, 0, false);
        }
    }]);

    return CalendarPopupController;
}();
var CalendarPopupComponent = {
    // TODO: This feels a bit like a rehash of directive values. combine?
    bindings: {
        customHolidays: '&',
        disabledDates: '&',
        focusedDate: '&',
        isRange: '&',
        minimumDate: '&',
        maximumDate: '&',
        okButton: '&',
        onComplete: '&',
        selectedDate: '&',
        todayButton: '&',
        upHolidays: '&'
    },
    transclude: {
        controls: '?rc-calendar-controls',
        content: '?rc-calendar-content'
    },
    controller: calendar_component_popup_CalendarPopupController,
    controllerAs: 'rcCalPopCtrl',
    template: calendar_popup_default.a
};
/* harmony default export */ var calendar_component_popup = (CalendarPopupComponent);
// EXTERNAL MODULE: ./src/calendar/templates/calendar-scroll-content.html
var calendar_scroll_content = __webpack_require__(147);
var calendar_scroll_content_default = /*#__PURE__*/__webpack_require__.n(calendar_scroll_content);

// CONCATENATED MODULE: ./src/calendar/calendar.component.scroll.content.ts
var calendar_component_scroll_content__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function calendar_component_scroll_content__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var MAX_MONTHS = 2;
function calendar_component_scroll_content_getFirstEntry(month) {
    var week = month.weeks[0];
    for (var index = 0; index < week.length; index++) {
        if (week[index]) {
            return week[index].date;
        }
    }
}
/**
 * Calendar content-block. Highly dependent upon rc-calendar-popup controller.
 */
var calendar_component_scroll_content_ScrollContentController = function () {
    ScrollContentController.$inject = ['$scope', '$element', 'rcDate'];

    function ScrollContentController($scope, $element, rcDate) {
        'ngInject';

        calendar_component_scroll_content__classCallCheck(this, ScrollContentController);

        this.$scope = $scope;
        this.$element = $element;
        this.rcDate = rcDate;
    }

    calendar_component_scroll_content__createClass(ScrollContentController, [{
        key: '$onInit',
        value: function $onInit() {
            this.popupCtrl.setContentController(this);
        }
    }, {
        key: '$postLink',
        value: function $postLink() {
            var _this = this;

            /**
             * Single-run event handler to capture the focus of the day element and align the 3rd month
             * (which should contain the currently selected day) to the 'top' of the scrollable container
             * TODO: Find a way to accomplish this with in a non-jquery-esque methodology
             * @see SID#187940
             */
            var initialFocusHandler = function initialFocusHandler() {
                var focussed = document.activeElement;
                if (focussed && focussed.tagName.toLowerCase() === 'rc-calendar-day') {
                    // Fugly but it works in all browsers more than simply focussing the element
                    var focusMonth = focussed.parentElement.parentElement; // some shady maneuvers here
                    var months = _this.$element.find('rc-calendar-month');
                    var scrollTop = 0;
                    for (var i = 0; i < months.length; i++) {
                        if (months[i] !== focusMonth) {
                            scrollTop += months[0].offsetHeight;
                        } else {
                            break;
                        }
                    }
                    _this.$element.find('div')[0].scrollTop = scrollTop;
                }
                _this.$element.off('focusin', initialFocusHandler); // remove after initial setting
            };
            this.$element.on('focusin', initialFocusHandler);
        }
        // API used by the popup controller to set the data displayed

    }, {
        key: 'buildDateView',
        value: function buildDateView(date) {
            if (Object(external__angular_["isDate"])(date)) {
                this.months = [];
                // generate month, preceding and following months
                for (var index = MAX_MONTHS * -1; index <= MAX_MONTHS; index++) {
                    var seedDate = this.rcDate.buildNormalizedDate(date.getFullYear(), date.getMonth() + index, 1);
                    var month = this.popupCtrl.getMonth(seedDate);
                    if (month) {
                        this.months.push(month);
                    }
                }
            }
        }
    }, {
        key: 'cycleNextMonth',
        value: function cycleNextMonth() {
            var seedDate = new Date(calendar_component_scroll_content_getFirstEntry(this.months[this.months.length - 1]));
            seedDate.setMonth(seedDate.getMonth() + 1);
            seedDate.setDate(1);
            var month = this.popupCtrl.getMonth(seedDate);
            if (month) {
                this.popupCtrl.focused = seedDate;
                this.months.push(month);
                this.months.shift();
            }
        }
    }, {
        key: 'cyclePreviousMonth',
        value: function cyclePreviousMonth(focusLastDay) {
            var seedDate = new Date(calendar_component_scroll_content_getFirstEntry(this.months[0]));
            seedDate.setMonth(seedDate.getMonth() - 1);
            seedDate.setDate(1);
            var month = this.popupCtrl.getMonth(seedDate);
            if (month) {
                this.popupCtrl.focused = !focusLastDay ? seedDate : this.rcDate.buildNormalizedDate(seedDate.getFullYear(), seedDate.getMonth() + 1, 0);
                this.months.unshift(month);
                this.months.pop();
            }
        }
    }, {
        key: 'onBoundary',
        value: function onBoundary(boundary, event) {
            if (boundary === 'top') {
                this.cyclePreviousMonth(event.keyCode === keyboard_codes["a" /* default */].TAB && event.shiftKey === true);
            } else if (boundary === 'bottom') {
                this.cycleNextMonth();
            }
        }
    }]);

    return ScrollContentController;
}();
var CalendarScrollComponent = {
    bindings: {},
    require: {
        popupCtrl: '^rcCalendarPopup'
    },
    controller: calendar_component_scroll_content_ScrollContentController,
    controllerAs: 'rcCalScrlCtrl',
    template: calendar_scroll_content_default.a
};
/* harmony default export */ var calendar_component_scroll_content = (CalendarScrollComponent);
// EXTERNAL MODULE: ./src/calendar/templates/calendar-week.html
var calendar_week = __webpack_require__(148);
var calendar_week_default = /*#__PURE__*/__webpack_require__.n(calendar_week);

// CONCATENATED MODULE: ./src/calendar/calendar.component.week.ts
var calendar_component_week__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function calendar_component_week__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var CalendarWeekController = function () {
    CalendarWeekController.$inject = ['$element'];

    function CalendarWeekController($element) {
        'ngInject';

        calendar_component_week__classCallCheck(this, CalendarWeekController);

        this.$element = $element;
    }

    calendar_component_week__createClass(CalendarWeekController, [{
        key: '$onInit',
        value: function $onInit() {
            this.week = this.item() || [];
            this.$element.addClass('rc-calendar-week');
        }
    }]);

    return CalendarWeekController;
}();
var CalendarWeekComponent = {
    bindings: {
        item: '&'
    },
    template: calendar_week_default.a,
    controller: CalendarWeekController,
    controllerAs: 'rcCalWeekCtrl'
};
/* harmony default export */ var calendar_component_week = (CalendarWeekComponent);
// EXTERNAL MODULE: ./src/calendar/templates/calendar-week-headers.html
var calendar_week_headers = __webpack_require__(149);
var calendar_week_headers_default = /*#__PURE__*/__webpack_require__.n(calendar_week_headers);

// CONCATENATED MODULE: ./src/calendar/calendar.component.week.headers.ts
var calendar_component_week_headers__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function calendar_component_week_headers__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var CalendarWeekHeadersController = function () {
    function CalendarWeekHeadersController() {
        'ngInject';

        calendar_component_week_headers__classCallCheck(this, CalendarWeekHeadersController);
    }

    calendar_component_week_headers__createClass(CalendarWeekHeadersController, [{
        key: '$onInit',
        value: function $onInit() {
            this.days = DAY_NAMES;
        }
    }]);

    return CalendarWeekHeadersController;
}();
var CalendarWeekHeadersComponent = {
    bindings: {},
    controller: CalendarWeekHeadersController,
    controllerAs: 'rcCalWHCtrl',
    template: calendar_week_headers_default.a
};
/* harmony default export */ var calendar_component_week_headers = (CalendarWeekHeadersComponent);
// CONCATENATED MODULE: ./src/calendar/calendar.controller.ts
var calendar_controller__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function calendar_controller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


function getDefaultTemplate(includeCompact) {
    return '<rc-calendar-popup\n    class="noselect"\n    custom-holidays="rcCalCtrl.appHolidays()"\n    disabled-dates="rcCalCtrl.disabledDates"\n    focused-date="rcCalCtrl.focusedDate"\n    is-range="rcCalCtrl.pickRange"\n    minimum-date="rcCalCtrl.minDate()"\n    maximum-date="rcCalCtrl.maxDate()"\n    ok-button="rcCalCtrl.okButton"\n    on-complete="rcCalCtrl.onSelectionComplete($selected)"\n    selected-date="rcCalCtrl.$getInputModel()"\n    today-button="rcCalCtrl.todayButton"\n    up-holidays="rcCalCtrl.holidays()"' + (includeCompact ? ' rc-compact' : '') + '></rc-calendar-popup>';
}
/**
 * Manages the input model indformation between the calendar popup and the ng-model of
 * the <input> element
 */

var calendar_controller_RcCalendarController = function () {
    RcCalendarController.$inject = ['$element', '$scope', '$timeout', 'rcCalendarModelConverter', 'rcCalendarManager'];

    function RcCalendarController($element, $scope, $timeout, rcCalendarModelConverter, rcCalendarManager) {
        'ngInject';

        calendar_controller__classCallCheck(this, RcCalendarController);

        this.$element = $element;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.rcCalendarModelConverter = rcCalendarModelConverter;
        this.rcCalendarManager = rcCalendarManager;
        this.$getInputModel = external__angular_["noop"];
        this.$setInputModel = external__angular_["noop"];
        this.isInputDisabled = function () {
            return false;
        };
    }

    calendar_controller__createClass(RcCalendarController, [{
        key: '$onDestroy',
        value: function $onDestroy() {
            this.rcCalendarManager.close(this.$scope);
        }
        // Added to the modelController's $formatters array via input directive

    }, {
        key: '$dateFormatter',
        value: function $dateFormatter() {
            var _this = this;

            // Sync the displayed calendar to the model if it is manually set
            this.refreshPopup();
            if (this.customFormatter) {
                return function ($model) {
                    return _this.customFormatter({ $model: $model });
                };
            }
            if (this.isInputString()) {
                return function ($model) {
                    return _this.rcCalendarModelConverter.formatStringForDisplay($model);
                };
            }
            return function ($model) {
                return _this.rcCalendarModelConverter.formatForDisplay($model);
            };
        }
    }, {
        key: 'onSelectionComplete',
        value: function onSelectionComplete(selected) {
            this.togglePopup();
            if (selected) {
                this.setModel(selected);
            }
        }
    }, {
        key: 'refreshPopup',
        value: function refreshPopup() {
            var _this2 = this;

            if (this.rcCalendarManager.isOpen(this.$scope)) {
                this.$timeout(function () {
                    _this2.$scope.$broadcast('rcCalendarPopupRefresh');
                });
            }
        }
    }, {
        key: 'setModel',
        value: function setModel(model) {
            this.$setInputModel(model);
            this.onModelChange({ $model: model });
            this.refreshPopup();
        }
    }, {
        key: 'togglePopup',
        value: function togglePopup() {
            if (this.isInputDisabled() !== true) {
                var isOpen = this.rcCalendarManager.isOpen(this.$scope);
                if (isOpen) {
                    this.rcCalendarManager.close(this.$scope);
                } else {
                    var template = getDefaultTemplate(this.$element[0].hasAttribute('rc-compact'));
                    this.rcCalendarManager.open(this.$scope, this.$element, template);
                }
                this.focusCalendarButton = !isOpen;
            }
        }
    }, {
        key: 'isInputString',
        value: function isInputString() {
            return this.modelType === 'string';
        }
    }, {
        key: 'setInputString',
        value: function setInputString() {
            this.modelType = 'string';
        }
    }, {
        key: 'syncDisabledState',
        value: function syncDisabledState(isDisabled) {
            this.$element.attr('disabled', isDisabled);
            this.$element.find('button').attr('disabled', isDisabled);
            this.$element.find('input').attr('disabled', isDisabled);
            if (isDisabled) {
                this.rcCalendarManager.close(this.$scope);
            }
        }
    }]);

    return RcCalendarController;
}();

/* harmony default export */ var calendar_controller = (calendar_controller_RcCalendarController);
// EXTERNAL MODULE: ./src/calendar/templates/calendar.html
var calendar = __webpack_require__(150);
var calendar_default = /*#__PURE__*/__webpack_require__.n(calendar);

// CONCATENATED MODULE: ./src/calendar/calendar.directive.ts
rcCalendarDirective.$inject = ['$compile', '$log', 'Usage'];



/* TODO: Add button onclick attr to the rc-calendar to allow custom things for picker button. */
function rcCalendarDirective($compile, $log, Usage) {
    'ngInject';

    return {
        scope: {
            appHolidays: '&',
            customFormatter: '&?',
            disabledDates: '=?',
            focusedDate: '=?',
            holidays: '&',
            maxDate: '&',
            minDate: '&',
            okButton: '@',
            onModelChange: '&',
            pickRange: '@',
            modelType: '@',
            todayButton: '@'
        },
        restrict: 'E',
        transclude: true,
        template: calendar_default.a,
        controller: calendar_controller,
        controllerAs: 'rcCalCtrl',
        bindToController: true,
        compile: RcCalendarCompile
    };
    // The 'rc-input-model' is used as a non-bound, helper attribute to
    // set the generated input's 'ng-model' variable
    function RcCalendarCompile(element, attrs) {
        if (attrs.ngModel) {
            $log.warn('Use of the \'ng-model\' on the <rc-calendar> element is deprecated. ' + 'If an <input> has _NOT_ been transcluded with its own \'ng-model\' attribute, ' + 'please use the \'rc-input-model\' attribute instead.');
            $log.warn(element[0]);
            if (!element[0].hasAttribute('rc-input-model')) {
                attrs.$set('rcInputModel', attrs.ngModel);
                element.attr('rc-input-model', attrs.ngModel);
            }
        }
        return RcCalendarLink;
    }
    // Needs tightening up between conroller/directive functions
    function RcCalendarLink(scope, element, attrs, calendarCtrl, transclude) {
        Usage.register('calendar');
        transclude(function (clone) {
            var transcludedInput = getTranscludedInputElement(clone);
            setInputAttributes(transcludedInput, attrs);
            // Add to the DOM before compiling to allow proper rendering of other <input> templates (validation)
            var buttonAddon = element.children().eq(0);
            var buttonFixElement = buttonAddon.children().eq(0);
            buttonAddon[0].insertBefore(transcludedInput[0], buttonFixElement[0]);
            if (transcludedInput.hasNoScope === true) {
                delete transcludedInput.hasNoScope;
                $compile(transcludedInput)(scope.$parent);
            }
        });
        /* Disabled state can come from the calendar or the input but should apply to both at all times. */
        var inputElement = element.find('input');
        attrs.$observe('disabled', function (isDisabled) {
            calendarCtrl.syncDisabledState(isDisabled);
        });
    }
    function syncDisabledState(calendarEl, inputEl, buttonEl) {
        return function (state) {
            calendarEl.attr('disabled', state);
            inputEl.attr('disabled', state);
            buttonEl.attr('disabled', state);
        };
    }
    function getTranscludedInputElement(clone) {
        var transcludedInput = findProvidedInput(clone);
        if (!transcludedInput) {
            transcludedInput = Object(external__angular_["element"])('<input>');
            transcludedInput.attr({
                type: 'text',
                placeholder: 'MM/DD/YYYY',
                size: 17
            });
            transcludedInput.hasNoScope = true;
        }
        return transcludedInput;
    }
    function findProvidedInput(clone) {
        var transcluded = void 0;
        for (var index = 0; index < clone.length; index++) {
            if (clone[index].tagName === 'INPUT') {
                transcluded = clone.eq(index);
            }
        }
        return transcluded;
    }
    function setInputAttributes(input, attrs) {
        if (input) {
            var inputModel = input.attr('ng-model');
            if (Object(external__angular_["isUndefined"])(inputModel)) {
                if (Object(external__angular_["isUndefined"])(attrs.rcInputModel)) {
                    throw new Error('The \'rc-input-model\' attribute must be defined on the <rc-calendar> ' + 'if an input has not been transcluded.');
                } else {
                    input.attr('ng-model', attrs.rcInputModel);
                }
            } else if (Object(external__angular_["isDefined"])(inputModel) && Object(external__angular_["isDefined"])(attrs.rcInputModel) && inputModel !== attrs.rcInputModel) {
                $log.warn('The \'rc-input-model\' attribute of the <rc-calendar> "' + attrs.rcInputModel + '" does not reference ' + ('the same model as the transcluded <input>s \'ng-model\' "' + inputModel + '"'));
                $log.warn(input);
            }
            // Disable HTML5 Autocomplete feature; as it will get in the way of the dropdown.
            input.attr('autocomplete', 'off');
        }
    }
}
// CONCATENATED MODULE: ./src/calendar/calendar.directive.input.ts
RcCalendarInputDirective.$inject = ['$parse', 'rcCalendarModelConverter'];

/*
 * Provides access to ng-model by augmenting the calendar controller functionality
 */
function RcCalendarInputDirective($parse, rcCalendarModelConverter) {
    'ngInject';

    return {
        require: {
            modelCtrl: '?ngModel',
            calendarCtrl: '?^^rcCalendar'
        },
        link: RcCalendarInputLink
    };
    function RcCalendarInputLink(scope, element, attrs, ctrl) {
        var modelCtrl = ctrl.modelCtrl,
            calendarCtrl = ctrl.calendarCtrl;

        if (!modelCtrl || !calendarCtrl) {
            return;
        }
        if (Object(external__angular_["isString"])($parse(attrs.ngModel)(scope))) {
            calendarCtrl.setInputString();
        }
        // Add formatters
        modelCtrl.$formatters.push(calendarCtrl.$dateFormatter());
        // Formatter runs after the model is set. Track previous values for onBlur check.
        modelCtrl.$formatters.push(function (model) {
            calendarCtrl.$previousModel = model;
            return model;
        });
        var asNonIsoDateString = function asNonIsoDateString(isoDateString) {
            return Object(external__angular_["isString"])(isoDateString) ? isoDateString.replace(/-/g, '/') : isoDateString;
        };
        calendarCtrl.$getInputModel = function () {
            var $modelValue = modelCtrl.$modelValue;

            if (Object(external__angular_["isDefined"])($modelValue) && calendarCtrl.isInputString()) {
                // TODO date is off by one
                var dt = new Date(asNonIsoDateString($modelValue));
                if (!isNaN(dt)) {
                    return dt;
                }
            }
            return $modelValue;
        };
        var assignInputModel = $parse(attrs.ngModel).assign;
        calendarCtrl.$setInputModel = function (value) {
            if (calendarCtrl.isInputString() && Object(external__angular_["isDate"])(value)) {
                var valueAsString = value.toISOString().substring(0, 10);
                assignInputModel(scope, valueAsString);
            } else {
                assignInputModel(scope, value);
            }
            modelCtrl.$setDirty(true);
        };
        calendarCtrl.isInputDisabled = function () {
            return element[0].disabled;
        };
        element.bind('blur', function () {
            if (modelCtrl.$dirty) {
                var $modelValue = modelCtrl.$modelValue,
                    $viewValue = modelCtrl.$viewValue;

                var parsedValue = rcCalendarModelConverter.parseDate($viewValue);
                /* If a user manually sets the date string or clears the value,
                 * it may not execute the calendarCtrl.setModel which manages the on-model-change.
                 * @see SID#201878 */
                if (calendarCtrl.$previousModel && !Object(external__angular_["equals"])(calendarCtrl.$previousModel, $modelValue) || !Object(external__angular_["equals"])(parsedValue, $modelValue)) {
                    scope.$apply(function () {
                        return calendarCtrl.setModel(parsedValue);
                    });
                }
            }
        });
        attrs.$observe('disabled', function (isDisabled) {
            calendarCtrl.syncDisabledState(isDisabled);
        });
    }
}
// CONCATENATED MODULE: ./src/calendar/isolate-scroll.directive.ts
RcIsolateScroll.$inject = ['$parse'];

var BOUNDS = {
    top: 'top',
    bottom: 'bottom'
};
// TODO: Abstract to global directive? Kinda calendar-specific right now
function RcIsolateScroll($parse) {
    'ngInject';

    return {
        link: RcIsolateScrollLink
    };
    function RcIsolateScrollLink(scope, element, attrs) {
        var onBoundary = $parse(attrs.rcIsolateScroll);
        offsetTop();
        // Manage manual scrollbar interaction, otherwise do not interfere with scrolling
        var mouseKeyDown = false;
        element.on('mousedown', function (event) {
            mouseKeyDown = true;
        });
        element.on('mouseup', function (event) {
            mouseKeyDown = false;
        });
        element.on('scroll', function (event) {
            if (mouseKeyDown) {
                if (distanceToTopEdge() === 0) {
                    topEdgeHit(event);
                    offsetTop();
                } else if (distanceToBottomEdge() === 0) {
                    bottomEdgeHit(event);
                    offsetBottom();
                }
            }
        });
        element.on('touchmove', function (event) {
            // This needs some smoothing/debouncing
            if (distanceToTopEdge() === 0) {
                stopEvent(event);
                topEdgeHit(event);
                offsetTop();
            } else if (distanceToBottomEdge() === 0) {
                stopEvent(event);
                bottomEdgeHit(event);
                offsetBottom();
            }
        });
        element.on('wheel', function (event) {
            var delta = event.deltaY;
            if (delta < 0 && distanceToTopEdge() <= 0) {
                stopEvent(event);
                topEdgeHit(event);
            } else if (delta > 0 && distanceToBottomEdge() >= 0) {
                stopEvent(event);
                bottomEdgeHit(event);
            }
        });
        /* IE Strikes Again! >:-(
         * Although IE fires both the 'wheel' & 'mousewheel' events, the mousewheel causes IE
         * to bleed scrolling outside its container. Simplest solution would seem that the containing
         * element kill all mousewheel events, but unfortunately IE needs it to scroll properly.
         * Go figure....
         *
         * Other browsers do not use this non-standard event.
         * https://developer.mozilla.org/en-US/docs/Web/Events/mousewheel */
        element.on('mousewheel', function (event) {
            var delta = event.wheelDelta;
            if (Math.abs(delta) > 120) {
                stopEvent(event);
                // 50 is an arbitrary number that seems to function. Values are ~35 towards top or bottom edge.
            } else if (delta > 0 && distanceToTopEdge() < 50) {
                stopEvent(event);
                topEdgeHit(event);
                // animation frame smooths IE issues with scroll bar jumping
                window.requestAnimationFrame(function () {
                    offsetTop();
                });
            } else if (delta < 0 && distanceToBottomEdge() > -50) {
                stopEvent(event);
                bottomEdgeHit(event);
                // animation frame smooths IE issues with scroll bar jumping
                window.requestAnimationFrame(function () {
                    offsetBottom();
                });
            }
        });
        element.on('keydown', function (event) {
            var keyCode = event.keyCode;
            var topDistance = distanceToTopEdge();
            var bottomDistance = distanceToBottomEdge();
            if (topDistance === 0 && keyCode === keyboard_codes["a" /* default */].UP) {
                stopEvent(event);
                topEdgeHit(event);
            } else if (bottomDistance === 0 && keyCode === keyboard_codes["a" /* default */].DOWN) {
                stopEvent(event);
                bottomEdgeHit(event);
            } else if (keyCode === keyboard_codes["a" /* default */].TAB) {
                if (event.shiftKey) {
                    handleShiftTab(event, topDistance, bottomDistance);
                } else if (bottomDistance === 0 && hasClassName(event.target, 'rc-calendar-lom')) {
                    stopEvent(event);
                    bottomEdgeHit(event);
                }
            }
        });
        function handleShiftTab(event, topDistance, bottomDistance) {
            // Adjust to top as the user reverse-tabs
            if (topDistance < 100 && topDistance > 0 && event.target.offsetTop < 200) {
                element[0].scrollTop = 0;
            } else if (topDistance === 0 && hasClassName(event.target, 'rc-calendar-fom') && inFirstWeek(event.target)) {
                stopEvent(event);
                topEdgeHit(event);
            }
        }
        function hasClassName(el, name) {
            return el.className.indexOf(name) !== -1;
        }
        function inFirstWeek(target) {
            var days = element.find('rc-calendar-day');
            for (var index = 0; index < 7; index++) {
                if (days[index] === target) {
                    return true;
                }
            }
            return false;
        }
        function offsetBottom() {
            element[0].scrollTop = element[0].scrollHeight - element[0].offsetHeight - 1;
        }
        function offsetTop() {
            element[0].scrollTop = 1;
        }
        function distanceToBottomEdge() {
            return element[0].scrollTop + element[0].offsetHeight - element[0].scrollHeight;
        }
        function distanceToTopEdge() {
            return element[0].scrollTop;
        }
        function stopEvent(event) {
            event.stopPropagation();
            event.preventDefault();
            event.returnValue = false;
        }
        function bottomEdgeHit(event) {
            applyForBoundary(BOUNDS.bottom, event);
        }
        function topEdgeHit(event) {
            applyForBoundary(BOUNDS.top, event);
        }
        function applyForBoundary(boundary, event) {
            scope.$apply(function () {
                onBoundary(scope, {
                    $boundary: boundary,
                    $event: event
                });
            });
        }
    }
}
// CONCATENATED MODULE: ./src/calendar/calendar.filter.firstLetter.ts

/* harmony default export */ var calendar_filter_firstLetter = (function () {
    return function firstLetterFilter(value) {
        if (Object(external__angular_["isString"])(value) && value.length >= 1) {
            return value.slice(0, 1);
        }
        return value;
    };
});
// CONCATENATED MODULE: ./src/calendar/index.ts
























/* harmony default export */ var src_calendar = (Object(external__angular_["module"])('rc.calendar', [src_focus, i18n["a" /* default */], keyboardNavigation["a" /* default */], mediaQuery["b" /* default */], position["a" /* default */], usage["b" /* default */], utils["a" /* default */]]).component('rcCalendarDay', calendar_component_day).component('rcCalendarMonth', calendar_component_month).component('rcCalendarPopup', calendar_component_popup).component('rcCalendarScrollContent', calendar_component_scroll_content).component('rcCalendarWeek', calendar_component_week).component('rcCalendarWeekHeaders', calendar_component_week_headers).directive('input', RcCalendarInputDirective).directive('rcCalendar', rcCalendarDirective).directive('rcIsolateScroll', RcIsolateScroll).filter('firstLetter', calendar_filter_firstLetter).service('rcCalendarDate', calendar_service_date).service('rcCalendarManager', calendar_service_manager).service('rcCalendarModelConverter', calendar_service_model_converter).service('rcCalendarPosition', calendar_service_position).service('rcDate', date_service).service('rcHoliday', holiday_service).name);
// EXTERNAL MODULE: ./src/checkbox/templates/checkbox.html
var templates_checkbox = __webpack_require__(151);
var checkbox_default = /*#__PURE__*/__webpack_require__.n(templates_checkbox);

// CONCATENATED MODULE: ./src/checkbox/checkbox.component.ts
var checkbox_component__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function checkbox_component__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var CHECKED_CLASS = 'rc-checkbox-checked';
var DISABLED_CLASS = 'rc-checkbox-disabled';
var FOCUS_CLASS = 'rc-checkbox-focus';
/* Mainly provides CSS class changes to reflect element state child changes */
var checkbox_component_CheckboxController = function () {
    CheckboxController.$inject = ['$element'];

    function CheckboxController($element) {
        'ngInject';

        checkbox_component__classCallCheck(this, CheckboxController);

        this.$element = $element;
    }

    checkbox_component__createClass(CheckboxController, [{
        key: '$onInit',
        value: function $onInit() {
            // Prevent hidden template label click from escaping checkbox (SID #186479)
            this.$element.on('click', function (event) {
                if (event.target.nodeName === 'LABEL') {
                    event.stopPropagation(); // preventDefault() breaks the link to the input
                }
            });
        }
    }, {
        key: 'setCheckedState',
        value: function setCheckedState(state) {
            if (state === true) {
                this.$element.addClass(CHECKED_CLASS);
            } else {
                this.$element.removeClass(CHECKED_CLASS);
            }
        }
    }, {
        key: 'setDisabledState',
        value: function setDisabledState(state) {
            if (state === true) {
                this.$element.addClass(DISABLED_CLASS);
            } else {
                this.$element.removeClass(DISABLED_CLASS);
            }
        }
    }, {
        key: 'setFocusState',
        value: function setFocusState(state) {
            if (state === true) {
                this.$element.addClass(FOCUS_CLASS);
            } else {
                this.$element.removeClass(FOCUS_CLASS);
            }
        }
    }, {
        key: 'setInputType',
        value: function setInputType(type) {
            if (Object(external__angular_["isString"])(type)) {
                this.$element.addClass('type-' + type);
            }
        }
    }]);

    return CheckboxController;
}();
var CheckboxComponent = {
    bindings: {},
    controller: checkbox_component_CheckboxController,
    controllerAs: 'chkCtrl',
    template: checkbox_default.a,
    transclude: true
};
/* harmony default export */ var checkbox_component = (CheckboxComponent);
// CONCATENATED MODULE: ./src/checkbox/checkbox.directive.input.ts
var checkbox_directive_input__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var checkboxDirectiveInput = function checkboxDirectiveInput($timeout, Usage) {
    'ngInject';

    return {
        require: ['?ngModel', '?^rcCheckbox'],
        link: CheckboxInputLink
    };
    function CheckboxInputLink(scope, element, attrs, controllers) {
        var _controllers = checkbox_directive_input__slicedToArray(controllers, 2),
            modelCtrl = _controllers[0],
            checkCtrl = _controllers[1];

        if (checkCtrl) {
            Usage.register('checkbox');
            checkCtrl.setInputType(attrs.type);
            bindDOMChangeHandlers();
            if (modelCtrl) {
                bindModelChangeHandlers();
            }
        }
        function bindDOMChangeHandlers() {
            attrs.$observe('disabled', function (value) {
                checkCtrl.setDisabledState(value);
            });
            element.on('focus blur', function (event) {
                checkCtrl.setFocusState(event.type === 'focus');
            });
        }
        function bindModelChangeHandlers() {
            var toggle = function toggle() {
                if (checkCtrl.$debouncedState) {
                    $timeout.cancel(checkCtrl.$debouncedState);
                }
                checkCtrl.$debouncedState = $timeout(function () {
                    checkCtrl.setCheckedState(element[0].checked);
                }, 0, false);
            };
            // Handles user input state changes
            modelCtrl.$viewChangeListeners.push(toggle);
            // Captures programmatic state changes
            modelCtrl.$formatters.push(function (model) {
                toggle();
                return model;
            });
        }
    }
};
checkboxDirectiveInput.$inject = ['$timeout', 'Usage'];
/* harmony default export */ var checkbox_directive_input = (checkboxDirectiveInput);
// CONCATENATED MODULE: ./src/checkbox/index.ts




/* harmony default export */ var src_checkbox = (Object(external__angular_["module"])('rc.checkbox', [usage["b" /* default */]]).component('rcCheckbox', checkbox_component).directive('input', checkbox_directive_input).name);
// CONCATENATED MODULE: ./src/clearable/clearable.directive.ts
clearableDirective.$inject = ['Usage'];

function clearableDirective(Usage) {
    'ngInject';

    var getClearableItem = function getClearableItem($element) {
        return Object(external__angular_["element"])($element.parent()[0].querySelector('.rc-clearable-icon'));
    };
    var hasButton = function hasButton(element) {
        return getClearableItem(element).length;
    };
    var hasNoButton = function hasNoButton(element) {
        return !hasButton(element);
    };
    var clearInput = function clearInput(element) {
        element.val('');
        element.triggerHandler('input');
        getClearableItem(element).parent().remove();
    };
    var addCloseButton = function addCloseButton(element) {
        element.after('<div class="close-touch-area noselect"><a class="inverted close icon rc-clearable-icon"></a></div>');
        element.next().bind('click', function () {
            clearInput(element);
        });
    };
    function isEnabled(attrs) {
        if (attrs.rcClearable === 'no') {
            return false;
        } else if (attrs.type !== 'text') {
            return false;
        }
        return true;
    }
    return {
        restrict: 'E',
        require: '?ngModel',
        priority: 0,
        link: function link(scope, element, attrs, ctrl) {
            if (!ctrl) {
                return;
            }
            if (!isEnabled(attrs)) {
                return;
            }
            Usage.register('clearable');
            element.parent().addClass('rc-clearable');
            var clearableIconCheck = function clearableIconCheck() {
                var value = ctrl.$viewValue;
                if (value && hasNoButton(element)) {
                    addCloseButton(element);
                } else if (!value && hasButton(element)) {
                    clearInput(element);
                }
            };
            ctrl.$viewChangeListeners.push(clearableIconCheck);
        }
    };
}
/* harmony default export */ var clearable_directive = (clearableDirective);
// CONCATENATED MODULE: ./src/clearable/index.ts



/* harmony default export */ var clearable = (Object(external__angular_["module"])('rc.clearable', [usage["b" /* default */]]).directive('input', clearable_directive).name);
// CONCATENATED MODULE: ./src/command/command.constants.ts
var COMMAND_URL = '/myup/loadMenu';
// CONCATENATED MODULE: ./src/command/command.service.ts
var command_service__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function command_service__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var command_service_Command = function () {
    Command.$inject = ['$http', '$q', 'Usage'];

    function Command($http, $q, Usage) {
        'ngInject';

        command_service__classCallCheck(this, Command);

        this.$http = $http;
        this.$q = $q;
        this.Usage = Usage;
    }

    command_service__createClass(Command, [{
        key: 'lookup',
        value: function lookup(command, params, options) {
            this.Usage.register('command');
            var errorReply = void 0;
            var parmList = params;
            var deferred = this.$q.defer(); // todo checkme
            if (typeof command === 'undefined' || command === '') {
                errorReply = {
                    message: 'Required command parameter is undefined.',
                    status: 400
                };
                deferred.reject(errorReply);
                return deferred.promise;
            }
            parmList.suiFunctionCommand = command;
            var promise = this.$http.get(COMMAND_URL, { params: parmList });
            var reply = {};
            promise.then(function (response) {
                if (response.data.result !== '0') {
                    errorReply = {
                        message: 'Bad result returned from service',
                        status: response.data.result
                    };
                    deferred.reject(errorReply);
                }
                if (response.data.data[0]) {
                    reply.label = response.data.data[0].label;
                    reply.url = response.data.data[0].url;
                    deferred.resolve(reply);
                } else {
                    reply.label = '';
                    reply.url = '';
                    deferred.resolve(reply);
                }
            }, function (reason) {
                errorReply = {
                    message: reason.data,
                    status: reason.status
                };
                deferred.reject(errorReply);
            });
            reply.$promise = promise;
            return deferred.promise;
        }
    }]);

    return Command;
}();

/* harmony default export */ var command_service = (command_service_Command);
// CONCATENATED MODULE: ./src/command/index.ts




/* harmony default export */ var src_command = (Object(external__angular_["module"])('rc.command', [usage["b" /* default */]]).constant('COMMAND_URL', COMMAND_URL).service('commandFactory', command_service).name);
// CONCATENATED MODULE: ./src/compact/compact.directive.ts
rcCompactDirective.$inject = ['$parse', 'Usage'];
function rcCompactDirective($parse, Usage) {
    'ngInject';

    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            Usage.register('compact');
            if (attrs.rcCompact) {
                scope.$watch(function () {
                    return $parse(attrs.rcCompact)(scope);
                }, function (bool) {
                    addClass(!!bool);
                });
            } else {
                addClass(true);
            }
            function addClass(isCompact) {
                if (isCompact) {
                    element.addClass('compact');
                } else {
                    element.removeClass('compact');
                }
            }
        }
    };
}
/* harmony default export */ var compact_directive = (rcCompactDirective);
// CONCATENATED MODULE: ./src/compact/index.ts



/* harmony default export */ var compact = (Object(external__angular_["module"])('rc.compact', [usage["b" /* default */]]).directive('rcCompact', compact_directive).name);
// CONCATENATED MODULE: ./src/hoverStop/hoverStop.directive.ts
/*
While hover states shouldn't be used to trigger essential features, they're still nice to help
provide feedback to the user on non-touch devices.  The problem is that hover states get in the way
of touch devices (they appear to be sticky).

This directive will manage a class on the HTML element so that we can stop hover from showing on
touch-enabled devices.  Dual-mode (touch- AND mouse-enabled) devices are supported too:  hover will
be disabled for touchstart but remain enabled for mouseenter.

To stop hover on touch-enabled devices, add a ".hover-stop :hover" selector to the styles applied to
the normal state of the element.  This will override the normal hover styles so the element looks
exactly like its default state.
    Refer to this example:
        ** BEFORE (hover fails by being sticky on touch-enabled devices) **
            a {
                background: $normal-bg;
                &:hover {
                    background: $hover-bg;
                }
                &:active {
                    background: $active-bg;
                }
            }
        ** AFTER (hover fixed by mimicking normal state on touch-enabled devices) **
            a {
                @include hover-stop {
                    background: $normal-bg;
                }
                &:hover {
                    background: $hover-bg;
                }
                &:active {
                    background: $active-bg;
                }
            }

The directive works by presuming these events:
    TOUCH-ENABLED   MOUSE-ENABLED
    -------------   -------------
    touchstart      -
    touchmove       -
    touchend        -
    mouseover       mouseover
    mousemove       mousemove
    mousedown       mousedown
    mouseup         mouseup
    click           click
*/
function hoverStopDirective() {
    var STOP_CLASS = 'hover-stop';
    return {
        restrict: 'A',
        link: function link(scope, element) {
            scope.isMouseEnabled = true;
            element.bind('touchstart', function () {
                /* Next mouseenter is from touch, so skip adding the class. */
                scope.isMouseEnabled = false;
                element.addClass(STOP_CLASS);
            });
            element.bind('mouseenter', function () {
                if (scope.isMouseEnabled) {
                    element.removeClass(STOP_CLASS);
                }
                scope.isMouseEnabled = false;
            });
        }
    };
}
/* harmony default export */ var hoverStop_directive = (hoverStopDirective);
// CONCATENATED MODULE: ./src/hoverStop/index.ts


/* harmony default export */ var hoverStop = (Object(external__angular_["module"])('rc.hoverStop', []).directive('hoverStop', hoverStop_directive).name);
// CONCATENATED MODULE: ./src/icon/index.ts

/* harmony default export */ var icon = (Object(external__angular_["module"])('rc.icon', []).name);
// EXTERNAL MODULE: ./src/infiniteScroll/index.ts + 1 modules
var infiniteScroll = __webpack_require__(72);

// EXTERNAL MODULE: ./src/inputFieldWrapper/index.ts + 2 modules
var inputFieldWrapper = __webpack_require__(71);

// EXTERNAL MODULE: ./src/loading/index.ts + 3 modules
var loading = __webpack_require__(73);

// CONCATENATED MODULE: ./src/migration/index.ts

var migration = Object(external__angular_["module"])('rc.migration', []);
var components = ['rcAppTemplate', 'rcAccordion', 'rcAccordionPanel', 'rcAddRemove', 'rcAlert', 'rcAlerts', 'rcAutocomplete', 'rcCalendar', 'rcCheckbox', 'rcGroupbox', 'rcModal', 'rcOverlay', 'rcSlideMenu', 'rcSmartMenu', 'rcTable', 'rcTabset', 'rcTab', 'rcWizard', 'rcWizardStep'];
components.forEach(function (component) {
    migration.directive(component, ['$log', function ($log) {
        'ngInject';

        return {
            restrict: 'A',
            link: function link() {
                $log.warn('Compatibility Warning: Ricola component \'' + component + '\' is declared as an attribute. It should be declared as an element.');
            }
        };
    }]);
});
/* harmony default export */ var src_migration = (migration.name);
// EXTERNAL MODULE: ./src/modal/index.ts + 8 modules
var modal = __webpack_require__(31);

// EXTERNAL MODULE: ./src/overlay/index.ts + 2 modules
var overlay = __webpack_require__(50);

// CONCATENATED MODULE: ./src/placeholder/placeholder.directive.ts
var placeholder_directive__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

PlaceholderDirective.$inject = ['$log'];

function placeholder_directive__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var HIDE_CLASS = 'hide-placeholder';
var MOVE_CLASS = 'move-placeholder';
var FOCUS_EVENT = 'focus';
var BLUR_EVENT = 'blur';
var placeholder_directive_PlaceholderController = function () {
    PlaceholderController.$inject = ['$scope', '$element', '$attrs', '$timeout'];

    function PlaceholderController($scope, $element, $attrs, $timeout) {
        'ngInject';

        placeholder_directive__classCallCheck(this, PlaceholderController);

        this.$scope = $scope;
        this.$element = $element;
        this.$attrs = $attrs;
        this.$timeout = $timeout;
    }

    placeholder_directive__createClass(PlaceholderController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.eventCleanup = [];
            // Has to run AFTER input wrapper
            this.placeholder = Object(external__angular_["element"])('<rc-placeholder tabindex="-1">' + (this.$attrs.rcPlaceholder || '') + '</rc-placeholder>');
            this.$timeout(function () {
                _this.$element.after(_this.placeholder);
            }, 0, false);
        }
    }, {
        key: '$postLink',
        value: function $postLink() {
            // Possibly move to $onInit?
            this.$bindWatcher();
            this.$bindHandlers();
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.eventCleanup.forEach(function (remove) {
                return remove();
            });
            this.eventCleanup.length = 0;
        }
    }, {
        key: '$doCheck',
        value: function $doCheck() {
            var _this2 = this;

            // Keep the width of the element in sync with the <input>.
            // Avoiding use of window.on('resize') for now.
            if (this.$debouncedMaxWith) {
                this.$timeout.cancel(this.$debouncedMaxWith);
            }
            this.$debouncedMaxWith = this.$timeout(function () {
                var offsetWidth = _this2.$element[0].offsetWidth;
                if (_this2.placeholder && _this2.placeholder[0].style.maxWidth !== offsetWidth + 'px') {
                    _this2.placeholder[0].style.maxWidth = offsetWidth + 'px';
                }
            }, 50, false);
        }
    }, {
        key: '$addEventHandler',
        value: function $addEventHandler(element, eventName, handler) {
            this.eventCleanup.push(Object(utils_events["a" /* removableEventHandler */])(element, eventName, handler));
        }
    }, {
        key: '$updateStyles',
        value: function $updateStyles() {
            if (this.focused) {
                this.placeholder.removeClass(HIDE_CLASS);
                if (this.isSelectElement || this.modelCtrl.$viewValue) {
                    this.placeholder.addClass(MOVE_CLASS);
                } else {
                    this.placeholder.removeClass(MOVE_CLASS);
                }
            } else {
                this.placeholder.removeClass(MOVE_CLASS);
                if (this.modelCtrl.$viewValue) {
                    this.placeholder.addClass(HIDE_CLASS);
                } else {
                    this.placeholder.removeClass(HIDE_CLASS);
                }
            }
        }
    }, {
        key: '$bindWatcher',
        value: function $bindWatcher() {
            var _this3 = this;

            this.$scope.$watch(this.$attrs.ngModel, function () {
                _this3.$updateStyles();
            });
        }
    }, {
        key: '$bindHandlers',
        value: function $bindHandlers() {
            var _this4 = this;

            this.$addEventHandler(this.$element, FOCUS_EVENT, function () {
                _this4.focused = true;
                _this4.$updateStyles();
            });
            this.$addEventHandler(this.$element, BLUR_EVENT, function () {
                _this4.focused = false;
                _this4.$updateStyles();
            });
        }
    }, {
        key: 'isSelectElement',
        get: function get() {
            return this.$element[0].nodeName === 'SELECT';
        }
    }]);

    return PlaceholderController;
}();
function PlaceholderDirective($log) {
    'ngInject';

    return {
        restrict: 'A',
        scope: false,
        require: { modelCtrl: 'ngModel' },
        controller: placeholder_directive_PlaceholderController,
        compile: PlaceholderCompile,
        bindToController: true
    };
    function PlaceholderCompile(element, attrs) {
        if (element[0].nodeName === 'SELECT') {
            // Add "empty" option for 'no' choice
            element.prepend('<option></option>');
        }
        if (attrs.placeholder && attrs.rcPlaceholder) {
            $log.warn('Using both placeholder and rc-placeholder. It is recommended to choose one or the other.');
        }
        return external__angular_["noop"];
    }
}
// CONCATENATED MODULE: ./src/placeholder/index.ts



/* harmony default export */ var placeholder = (Object(external__angular_["module"])('rc.placeholder', [usage["b" /* default */]]).directive('rcPlaceholder', PlaceholderDirective).name);
// EXTERNAL MODULE: ./src/reauthenticate/index.ts + 4 modules
var reauthenticate = __webpack_require__(74);

// CONCATENATED MODULE: ./src/ric2compat/ric2compat.log.ts
aliasRicolaLogs.$inject = ['rcUtils'];

function aliasRicolaLogs(rcUtils) {
    'ngInject';

    var Ricola = rcUtils.Ricola;
    Ricola.log = {
        debug: external__angular_["noop"],
        error: external__angular_["noop"],
        fatal: external__angular_["noop"],
        info: external__angular_["noop"],
        init: external__angular_["noop"],
        trace: external__angular_["noop"],
        warn: external__angular_["noop"]
    };
}
/* harmony default export */ var ric2compat_log = (aliasRicolaLogs);
// CONCATENATED MODULE: ./src/ric2compat/ric2compat.jbus.ts
var ric2compat_jbus__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ric2compat_jbus__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


// This is a port of the jbus functionality from Ricola 2.
// Note: we're disabling a number of linter rules here. This file
// is considered a one-off and we shouldn't willy-nilly disable rules
// in other locations!
/* tslint:disable:variable-name */
/* eslint max-depth: 0*/
/* eslint angular/json-functions: 0*/
/* eslint angular/typecheck-string: 0*/
/* eslint angular/typecheck-object: 0*/
/* eslint angular/interval-service: 0*/
/* eslint curly: 0*/
/* !
* jQuery postMessage - v1.0 - 8/26/2011
*
* Copyright (c) 2011 "zachleat" Zach Leatherman
* Copyright (c) 2009 "Cowboy" Ben Alman
* Dual licensed under the MIT and GPL licenses.
* http://jquery.org/license
*/
/* Forked from http://benalman.com/projects/jquery-postmessage-plugin/
* http://benalman.com/about/license/
*/
// Script: jQuery postMessage: Cross-domain scripting goodness
//
// *Version: 1.0, Last updated: 8/24/2011*
//
// Project Home - http://benalman.com/projects/jquery-postmessage-plugin/
// GitHub       - http://github.com/cowboy/jquery-postmessage/
// Source       - http://github.com/cowboy/jquery-postmessage/raw/master/jquery.ba-postmessage.js
// (Minified)   - http://github.com/cowboy/jquery-postmessage/raw/master/jquery.ba-postmessage.min.js (0.9kb)
//
// About: License
//
// Copyright (c) 2009 "Cowboy" Ben Alman,
// Dual licensed under the MIT and GPL licenses.
// http://benalman.com/about/license/
//
// About: Examples
//
// This working example, complete with fully commented code, illustrates one
// way in which this plugin can be used.
//
// Iframe resizing - http://benalman.com/code/projects/jquery-postmessage/examples/iframe/
//
// About: Support and Testing
//
// Information about what version or versions of jQuery this plugin has been
// tested with and what browsers it has been tested in.
//
// jQuery Versions - 1.3.2
// Browsers Tested - Internet Explorer 6-8, Firefox 3, Safari 3-4, Chrome, Opera 9.
//
// About: Release History
//
// 0.6 - (8/24/2011) Using window.name instead of hash, added queueing (otherwise limited to one per 100ms delay)
// 0.5 - (9/11/2009) Improved cache-busting
// 0.4 - (8/25/2009) Initial release

var ric2compatModule = void 0;
(function () {
    var jqmock = {};
    // $.param
    // Modified from Zepto.js
    // https://github.com/madrobby/zepto/blob/master/src/ajax.js#L345
    function serialize(params, obj, traditional, scope) {
        var type,
            array = Object(external__angular_["isArray"])(obj),
            hash = Object(external__angular_["isObject"])(obj);
        Object(external__angular_["forEach"])(obj, function (value, key) {
            // CHANGE: Replace jQuery.type with youmightnotneedjquery approach
            type = Object.prototype.toString.call(value).replace(/^\[object (.+)\]$/, '$1').toLowerCase();
            if (scope) {
                key = traditional ? scope : scope + '[' + (hash || type === 'object' || type === 'array' ? key : '') + ']';
            }
            // handle data in serializeArray() format
            if (!scope && array) {
                params.add(value.name, value.value);
            } else if (type === 'array' || !traditional && type === 'object') {
                // recurse into nested objects
                serialize(params, value, traditional, key);
            } else {
                params.add(key, value);
            }
        });
    }

    var ParamArray = function (_Array) {
        _inherits(ParamArray, _Array);

        function ParamArray() {
            ric2compat_jbus__classCallCheck(this, ParamArray);

            return _possibleConstructorReturn(this, (ParamArray.__proto__ || Object.getPrototypeOf(ParamArray)).apply(this, arguments));
        }

        ric2compat_jbus__createClass(ParamArray, [{
            key: 'add',
            value: function add(k, v) {
                this.push(encodeURI(k) + '=' + encodeURI(v));
            }
        }]);

        return ParamArray;
    }(Array);

    jqmock.param = function (obj, traditional) {
        var params = new ParamArray();
        serialize(params, obj, traditional, null);
        return params.join('&').replace(/%20/g, '+');
    };
    '$:nomunge'; // Used by YUI compressor.
    // A few vars used in non-awesome browsers.
    var receive_interval_id;
    var send_interval_id;
    var targets = [];
    var message_queue = {};
    // A var used in awesome browsers.
    var rm_callback;
    // A few convenient shortcuts.
    var FALSE = !1;
    // Reused internal strings.
    var postMessage = 'postMessage';
    var addEventListener = 'addEventListener';
    var _p_receiveMessage;
    // I couldn't get window.postMessage to actually work in Opera 9.64!
    // CHANGE - Removed Opera sniff
    var has_postMessage = window[postMessage];
    // Method: jQuery.postMessage
    //
    // This method will call window.postMessage if available, setting the
    // targetOrigin parameter to the base of the target_url parameter for maximum
    // security in browsers that support it. If window.postMessage is not available,
    // the target window's location.hash will be used to pass the message. If an
    // object is passed as the message param, it will be serialized into a string
    // using the jQuery.param method.
    //
    // Usage:
    //
    // > jQuery.postMessage( message, target_url [, target ] );
    //
    // Arguments:
    //
    //  message - (String) A message to be passed to the other frame.
    //  message - (Object) An object to be serialized into a params string, using
    //    the jQuery.param method.
    //  target_url - (String) The URL of the other frame this window is
    //    attempting to communicate with. This must be the exact URL (including
    //    any query string) of the other window for this script to work in
    //    browsers that don't support window.postMessage.
    //  target - (Object) A reference to the other frame this window is
    //    attempting to communicate with. If omitted, defaults to `parent`.
    //
    // Returns:
    //
    //  Nothing.
    jqmock[postMessage] = function (message, target_origin, target, delay) {
        if (!target_origin) {
            return;
        }
        // Serialize the message if not a string. Note that this is the only real
        // jQuery dependency for this script. If removed, this script could be
        // written as very basic JavaScript.
        message = typeof message === 'string' ? message : jqmock.param(message);
        // Default to parent if unspecified.
        target = target || parent;
        if (has_postMessage) {
            // The browser supports window.postMessage, so call it with a targetOrigin
            // set appropriately, based on the target_url parameter.
            target[postMessage](message, target_origin);
        } else {
            // The browser does not support window.postMessage, so set the location
            // of the target to target_url#message. A bit ugly, but it works! A cache
            // bust parameter is added to ensure that repeat messages trigger the
            // callback.
            var index = -1;
            for (var j = 0, k = targets.length; j < k; j++) {
                if (targets[j] === target) {
                    index = j;
                    break;
                }
            }
            if (index === -1) {
                index = targets.length;
                targets.push(target);
            }
            if (!message_queue[index]) {
                message_queue[index] = [];
            }
            message_queue[index].push({
                source: location.href,
                message: message
            });
            send_interval_id && clearInterval(send_interval_id);
            send_interval_id = null;
            send_interval_id = setInterval(function () {
                var i;
                for (i in message_queue) {
                    targets[i].name = JSON.stringify(message_queue[i]);
                }
                // reset
                targets = [];
                message_queue = {};
            }, delay);
        }
    };
    // Method: jQuery.receiveMessage
    //
    // Register a single callback for either a window.postMessage call, if
    // supported, or if unsupported, for any change in the current window
    // location.hash. If window.postMessage is supported and source_origin is
    // specified, the source window will be checked against this for maximum
    // security. If window.postMessage is unsupported, a polling loop will be
    // started to watch for changes to the location.hash.
    //
    // Note that for simplicity's sake, only a single callback can be registered
    // at one time. Passing no params will unbind this event (or stop the polling
    // loop), and calling this method a second time with another callback will
    // unbind the event (or stop the polling loop) first, before binding the new
    // callback.
    //
    // Also note that if window.postMessage is available, the optional
    // source_origin param will be used to test the event.origin property. From
    // the MDC window.postMessage docs: This string is the concatenation of the
    // protocol and "://", the host name if one exists, and ":" followed by a port
    // number if a port is present and differs from the default port for the given
    // protocol. Examples of typical origins are https://example.org (implying
    // port 443), http://example.net (implying port 80), and http://example.com:8080.
    //
    // Usage:
    //
    // > jQuery.receiveMessage( callback [, source_origin ] [, delay ] );
    //
    // Arguments:
    //
    //  callback - (Function) This callback will execute whenever a <jQuery.postMessage>
    //    message is received, provided the source_origin matches. If callback is
    //    omitted, any existing receiveMessage event bind or polling loop will be
    //    canceled.
    //  source_origin - (String) If window.postMessage is available and this value
    //    is not equal to the event.origin property, the callback will not be
    //    called.
    //  source_origin - (Function) If window.postMessage is available and this
    //    function returns false when passed the event.origin property, the
    //    callback will not be called.
    //  delay - (Number) An optional zero-or-greater delay in milliseconds at
    //    which the polling loop will execute (for browser that don't support
    //    window.postMessage). If omitted, defaults to 100.
    //
    // Returns:
    //
    //  Nothing!
    jqmock.receiveMessage = _p_receiveMessage = function p_receiveMessage(callback, source_origin, delay, retrieve_window) {
        if (has_postMessage) {
            // Since the browser supports window.postMessage, the callback will be
            // bound to the actual event associated with window.postMessage.
            if (callback) {
                // Unbind an existing callback if it exists.
                rm_callback && _p_receiveMessage();
                // Bind the callback. A reference to the callback is stored for ease of
                // unbinding.
                rm_callback = function rm_callback(e) {
                    if (typeof source_origin === 'string' && e.origin !== source_origin || Object(external__angular_["isFunction"])(source_origin) && source_origin(e.origin) === FALSE) {
                        return FALSE;
                    }
                    callback(e);
                };
            }
            if (window[addEventListener]) {
                window[callback ? addEventListener : 'removeEventListener']('message', rm_callback, FALSE);
            } else {
                window[callback ? 'attachEvent' : 'detachEvent']('onmessage', rm_callback);
            }
        } else {
            // Since the browser sucks, a polling loop will be started, and the
            // callback will be called whenever window.name changes.
            receive_interval_id && clearInterval(receive_interval_id);
            receive_interval_id = null;
            if (callback) {
                delay = delay || 100;
                receive_interval_id = setInterval(function () {
                    var raw_messages = window.name;
                    if (raw_messages) {
                        window.name = '';
                        var messages = JSON.parse(raw_messages),
                            source;
                        for (var j = 0, k = messages.length; j < k; j++) {
                            source = retrieve_window(messages[j].source);
                            if (source !== false) {
                                callback({
                                    source: source,
                                    data: messages[j].message
                                });
                            }
                        }
                    }
                }, delay);
            }
        }
    };
    // CHANGE: Bind to window, so jbus can use it
    window.$jbusjquery = jqmock;
})();
// JBUS Code
(function () {
    /*
    Pass in a window object, like window, window.top, window.self, window.parent.
    Returns whether or not you have JavaScript access to the context.
    RETURNS FALSE IF THE CONTEXTS ARE THE SAME
    */
    // TODO Test
    var $canUseContext = function $canUseContext(compareTo, objName) {
        if (window.self === compareTo) {
            return false;
        } else {
            var names = (objName || 'location.href').split('.');
            try {
                for (var j = 0, k = names.length; j < k; j++) {
                    if (!compareTo[names[j]]) {
                        // must EXIST
                        return false;
                    }
                    compareTo = compareTo[names[j]];
                }
                return true;
            } catch (e) {
                return false;
            }
        }
    };
    // CHANGE: Swap out Ricola.log for angular.noop. We could use $log later if we want.
    var conlog = external__angular_["noop"];
    // TODO:
    // Add Angular hooks
    /*
    * Limitations:
    * In IE7 and prior requires unique URLS on iframes when sending from a child to top.
    */
    // Can access top window (top != window) & Ricola exists there (use top jbus)
    var ricolajbus;
    ricolajbus = $canUseContext(top, 'Ricola') ? top.Ricola.jbus : function () {
        var events = {};
        var xDomain = {
            // These properties are for IE<8 support
            POSTMESSAGE_INTERVAL: 50,
            // Warning, this must be > POSTMESSAGE_INTERVAL * 2
            POSTMESSAGE_BATCH_SEND_DELAY: 50,
            isListening: false,
            targets: {},
            targetsCounter: 0,
            trigger: function trigger(eventName, data, excludeWindow // optional
            ) {
                // make sure data is not an HTML node
                if (data && !data.nodeType && xDomain.targetsCounter > 0) {
                    var windows = xDomain.targets;
                    var message = eventName + ',' + JSON.stringify(data);
                    for (var domain in windows) {
                        for (var j = 0, k = windows[domain].length; j < k; j++) {
                            if (windows[domain][j] !== excludeWindow) {
                                window.$jbusjquery.postMessage(message, domain, windows[domain][j], xDomain.POSTMESSAGE_BATCH_SEND_DELAY);
                            }
                        }
                    }
                } else {
                    conlog('Trigger data must be object literal for cross-domain.');
                }
            },
            listen: function listen() {
                xDomain.isListening = true;
                window.$jbusjquery.receiveMessage(function (event) {
                    var parsed = xDomain.parseMessage(event.data);
                    // Make sure the message fits our format
                    if (parsed) {
                        ricolajbus.triggerFromCrossDomain(parsed.eventName, event.source, parsed.data);
                    }
                },
                // urls to allow messages from
                function (sourceDomain) {
                    var windows = xDomain.targets;
                    for (var domain in windows) {
                        if (domain.indexOf(sourceDomain) === 0) {
                            return true;
                        }
                    }
                    return false;
                }, xDomain.POSTMESSAGE_INTERVAL,
                // Used only by IE<8.
                function (url) {
                    // retrieve window from URL
                    var source = window.$('iframe').filter(function () {
                        var iframeUrl = window.$(this).attr('src');
                        if (url !== iframeUrl) {
                            return false;
                        }
                        return true;
                    });
                    if (source.length > 1) {
                        // Could make this slightly better by making event.source return an array of windows in this case.
                        // Then excludeWindow would be an array.
                        conlog('jbus: Cross domain requires unique urls on iframes, but a duplicate url was found (' + url + '). Callback cancelled.');
                        return false;
                    }
                    // if no source iframe is found on this page, assume the message came from the top.
                    return source.length ? source.get(0).contentWindow : top;
                });
            },
            parseMessage: function parseMessage(message) {
                // eventName,json-encoded-data
                var match = message.match(/([^,]*),(.*)/i);
                if (match && match.length >= 3) {
                    return {
                        eventName: match[1],
                        data: JSON.parse(match[2])
                    };
                }
                return null;
            },
            registerTarget: function registerTarget(targetDomain, iframes) {
                var t = xDomain.targets;
                if (window !== top) {
                    // upstream to top level jbus only
                    t[targetDomain] = [top];
                    xDomain.targetsCounter++;
                } else {
                    // make sure this runs after DOM available.
                    // could use event.origin but not available in IE7
                    if (!t[targetDomain]) {
                        t[targetDomain] = [];
                    }
                    window.$(iframes).filter('iframe').onEmpty(function () {}).each(function () {
                        t[targetDomain].push(this.contentWindow);
                        xDomain.targetsCounter++;
                    });
                }
                // Start listening for requests, if we haven't started already
                if ($canUseContext(top, 'Ricola')) {
                    // Can access top window (top != window) & Ricola exists there (use top jbus)
                } else if ($canUseContext(top, null)) {
                    // Can access top window (top != window) but Ricola does not exist there (use own jbus)
                    //      OR top == window
                } else if (xDomain.targetsCounter > 0 && !xDomain.isListening) {
                    // x-domain: parent and child window
                    xDomain.listen();
                }
            }
        };
        /* clear out any previous window.name messages
        * only for IE7, see postmessage.js
        * See: http://git-dev.uit.tla.uprr.com:9080/user-experience/ricola3/issues/284#note_5581
        if (window.name && xDomain.parseMessage(window.name.replace(/^\d+&/, ''))) {
        window.name = '';
        }
        */
        function _trigger(event, excludeWindow, args) {
            if (events[event]) {
                // Cross Domain Triggering!
                // first argument only
                xDomain.trigger(event, args[0], excludeWindow);
                // go backwards
                for (var i = events[event].length - 1; i >= 0; i--) {
                    var evt = events[event][i];
                    if (evt) {
                        var ret;
                        try {
                            ret = evt[0].apply({ id: i, event: event, key: evt[1] }, args);
                        } catch (e) {
                            // "Cannot execute code from a freed script"
                            // This try/catch is just precautionairy.  The i-frames should unsubscribe jbus events onunload.
                            conlog('jbus: trigger ERROR.  A destroyed i-frame may not have fired its unload event.', e);
                            ret = null;
                        }
                        if (ret === false) {
                            return false;
                        }
                    }
                }
            }
        }
        return {
            addCrossDomain: xDomain.registerTarget,
            getEvents: function getEvents() {
                return events;
            },
            subscribe: function subscribe(event, callback, key) {
                if (!events[event]) {
                    events[event] = [];
                }
                var id = events[event].length;
                events[event].push([callback, key]);
                return id;
            },
            triggerFromCrossDomain: function triggerFromCrossDomain(event, excludeWindow) {
                return _trigger(event, excludeWindow, Array.prototype.slice.call(arguments, 2));
            },
            trigger: function trigger(event) {
                return _trigger(event, null, Array.prototype.slice.call(arguments, 1));
            },
            unsubscribe: function unsubscribe(event, callbackOrKey // arg can match against the callback, OR the key provided in subscribe (usually the window)
            ) {
                if (events[event]) {
                    // if !arg, then match against currentWindow / window
                    var callbackOrKeyIndex = Object(external__angular_["isFunction"])(callbackOrKey) ? 0 : 1;
                    for (var i = 0; i < events[event].length; i++) {
                        if (events[event][i] && events[event][i][callbackOrKeyIndex] === callbackOrKey) {
                            delete events[event][i];
                        }
                    }
                }
            },
            unsubscribeAll: function unsubscribeAll(currentWindow // delete all events which match window
            ) {
                Object(external__angular_["forEach"])(events, function (val, event) {
                    ricolajbus.unsubscribe(event, currentWindow);
                });
            }
        };
    }();
    // Modification - use Angular
    Object(external__angular_["element"])(window).on('unload', function () {
        ricolajbus.unsubscribeAll(window);
    });
    // Integrate into Angular
    ric2compatModule = Object(external__angular_["module"])('rc.ric2compat.jbus', [utils["a" /* default */]]).run(['rcUtils', function (rcUtils) {
        'ngInject';

        var ric = rcUtils.Ricola;
        ric.jbus = ricolajbus;
    }]).run(['$rootScope', '$timeout', function ($rootScope, $timeout) {
        'ngInject';
        // Construct and send JBUS events. Used by MyUP Portal

        $timeout(function () {
            $rootScope.$on('rc.smartmenu.selected', function (event, data) {
                var item = data.item;
                var elementToSend = Object(external__angular_["element"])('<a href="' + item.url + '">' + item.label + '</a>')[0];
                var ret = ricolajbus.trigger('ricolaSmartMenuSelected', elementToSend);
                if (ret === false) {
                    data.event.preventDefault();
                    data.event.stopPropagation();
                }
            });
        });
    }]).factory('jbus', function () {
        return ricolajbus;
    });
})();
/* harmony default export */ var ric2compat_jbus = (ric2compatModule.name);
// CONCATENATED MODULE: ./src/ric2compat/index.ts




/* harmony default export */ var ric2compat = (Object(external__angular_["module"])('rc.ric2compat', [utils["a" /* default */], ric2compat_jbus]).run(ric2compat_log).name);
// CONCATENATED MODULE: ./src/scroll/scroll.controller.ts
ScrollerCtrl.$inject = ['$scope', '$element'];
function ScrollerCtrl($scope, $element) {
    'ngInject';

    var ctrl = this;
    ctrl.isScrollable = function (elem) {
        var s = elem[0].style;
        return s.overflowY === 'scroll' || s.overflowY === 'auto';
    };
    ctrl.scrollIntoView = function (targetElem) {
        var e = targetElem[0];
        var s = $element[0];
        var isAbove = e.offsetTop < s.scrollTop;
        var isBelow = e.offsetTop + e.offsetHeight > s.scrollTop + s.offsetHeight;
        if (isBelow) {
            s.scrollTop = e.offsetTop + e.offsetHeight - s.offsetHeight;
        } else if (isAbove) {
            s.scrollTop = e.offsetTop;
        }
    };
}
/* harmony default export */ var scroll_controller = (ScrollerCtrl);
// CONCATENATED MODULE: ./src/scroll/scroll.directives.ts
rcScrollDirective.$inject = ['$parse'];
function rcScrollDirective($parse) {
    'ngInject';

    return {
        restrict: 'A',
        compile: function compile($element, attrs) {
            var fn = $parse(attrs.rcScroll);
            return function rcEventHandler(scope, element) {
                /* TODO: We should probably throw in a convient way to adjust throttle and set it by default. */
                element.on('scroll', function (event) {
                    scope.$apply(function () {
                        fn(scope, {
                            $event: event
                        });
                    });
                });
            };
        }
    };
}
function rcScrollerDirective() {
    return {
        restrict: 'A',
        controller: 'ScrollerController'
    };
}
function rcScrollIfDirective() {
    return {
        restrict: 'A',
        require: '^rcScroller',
        link: function link(scope, elem, attrs, scrollerCtrl) {
            scope.$watch(attrs.rcScrollIf, function (conditionMet) {
                if (conditionMet) {
                    scrollerCtrl.scrollIntoView(elem);
                }
            });
        }
    };
}
// CONCATENATED MODULE: ./src/scroll/scroll.directive.isolate.ts
ScrollIsolateDirective.$inject = ['$parse', '$timeout'];
/*
 * Minimum mousewheel distance to report edge hit for IE.
 * '40' is an arbitrary threshold that seems to function decently.
 * Values are ~35 towards top or bottom edge.
 */
var IE_MWHEEL_MIN_DISTANCE = 40;
var IE_MIN_WHEEL_DELTA = 120;
var scroll_directive_isolate_BOUNDS = {
    top: 'top',
    bottom: 'bottom'
};
/**
 * Isolates scroll events to the element it is placed on to avoid page-scrolling when
 * the end of the scrollable container is reached until the user clicks/touches
 * something outside the container. Will only fire if the element is scrollable.
 *
 * Also has an output for further event handling with the following event object:
 *  - $event : {
 *      boundary: String - 'top' or 'bottom',
 *      event: DOM event object (not debounced)
 *    }
 *
 * Attributes:
 *  - rc-scroll-isolate: directive
 * Uses:
 *  - <ANY rc-scroll-isolate></ANY>
 *  - <ANY rc-scroll-isolate="$ctrl.myHandling($event)"></ANY>
 *
 */
function ScrollIsolateDirective($parse, $timeout) {
    'ngInject';

    return {
        restrict: 'A',
        scope: false,
        link: ScrollIsolateLink
    };
    function ScrollIsolateLink(scope, element, attrs) {
        var parsedAttribute = $parse(attrs.rcScrollIsolate);
        var onBoundary = function onBoundary(value) {
            parsedAttribute(scope, value);
        };
        element.on('scroll', function (event) {
            /* Key navigation and scrollbar actions register on the container */
            if (element[0] === event.target) {
                // Ensure we don't create an endless 1px adjustment from bottom to top to bottom to.....
                var offset = totalScrollable(element) > 1 ? 1 : 0;
                // offset scrollHeight by 1 to avoid scrolling outside once '0' achieved
                if (scroll_directive_isolate_distanceToTopEdge(element) <= 0) {
                    element[0].scrollTop = offset;
                    topEdgeHit(event);
                } else if (scroll_directive_isolate_distanceToBottomEdge(element) >= 0) {
                    element[0].scrollTop = element[0].scrollHeight - element[0].offsetHeight - offset;
                    bottomEdgeHit(event);
                }
            }
        });
        var initialTouchYPosition = void 0;
        element.on('touchstart', function (event) {
            var firstTouch = event.changedTouches[0];
            if (firstTouch) {
                initialTouchYPosition = firstTouch.pageY;
            }
        });
        element.on('touchmove', function (event) {
            var firstTouch = event.changedTouches[0];
            var pageY = firstTouch.pageY;

            var yDelta = initialTouchYPosition - pageY;
            // This may need some smoothing/debouncing
            if (canScroll(element)) {
                if (scroll_directive_isolate_distanceToTopEdge(element) === 0 && yDelta < 0) {
                    topEdgeHit(event);
                } else if (scroll_directive_isolate_distanceToBottomEdge(element) === 0 && yDelta > 0) {
                    bottomEdgeHit(event);
                }
            }
        });
        element.on('touchend', function (e) {
            initialTouchYPosition = null;
        });
        element.on('wheel', function (event) {
            if (canScroll(element)) {
                var delta = event.deltaY;
                if (delta < 0 && scroll_directive_isolate_distanceToTopEdge(element) <= 0) {
                    topEdgeHit(event);
                } else if (delta > 0 && scroll_directive_isolate_distanceToBottomEdge(element) >= 0) {
                    bottomEdgeHit(event);
                }
            }
        });
        /* IE Strikes Again! >:-(
         * Although IE fires both the 'wheel' & 'mousewheel' events, the mousewheel causes IE
         * to bleed scrolling outside its container. Simplest solution would seem that the containing
         * element kill all 'mousewheel'' events, but unfortunately IE requires it to scroll at all.
         *
         * Go figure....
         *
         * Other browsers do not use this non-standard event. Kill it when Edge is the norm.
         * https://developer.mozilla.org/en-US/docs/Web/Events/mousewheel */
        element.on('mousewheel', function (event) {
            if (canScroll(element)) {
                var delta = event.wheelDelta;
                if (Math.abs(delta) > IE_MIN_WHEEL_DELTA) {
                    // too fast....kill it!
                    var maxUpdate = element[0].scrollHeight - element[0].offsetHeight;
                    // standardize movement to not exceed IE_MIN_WHEEL_DELTA per event
                    if (delta < 0) {
                        var downTo = element[0].scrollTop + IE_MIN_WHEEL_DELTA;
                        element[0].scrollTop = downTo < maxUpdate ? downTo : maxUpdate;
                    } else {
                        var upTo = element[0].scrollTop - IE_MIN_WHEEL_DELTA;
                        element[0].scrollTop = upTo < 0 ? 0 : upTo;
                    }
                    event.stopPropagation();
                    event.preventDefault();
                    event.returnValue = false;
                } else if (delta > 0 && scroll_directive_isolate_distanceToTopEdge(element) < IE_MWHEEL_MIN_DISTANCE) {
                    // Manually go the rest of the way since IE cannot figure it out
                    element[0].scrollTop = 0;
                    topEdgeHit(event);
                } else if (delta < 0 && scroll_directive_isolate_distanceToBottomEdge(element) > -IE_MWHEEL_MIN_DISTANCE) {
                    // Manually go the rest of the way since IE cannot figure it out
                    element[0].scrollTop = element[0].scrollHeight - element[0].offsetHeight;
                    bottomEdgeHit(event);
                }
            }
        });
        function bottomEdgeHit(event) {
            applyForBoundary(scroll_directive_isolate_BOUNDS.bottom, event);
        }
        function topEdgeHit(event) {
            applyForBoundary(scroll_directive_isolate_BOUNDS.top, event);
        }
        function applyForBoundary(boundary, event) {
            onBoundary({ $event: { boundary: boundary, event: event } });
        }
    }
}
function canScroll(element) {
    // Normally the scroll height and offset can be directly compared....but then there's IE
    return totalScrollable(element) > 1;
}
function totalScrollable(element) {
    return Math.round(element[0].scrollHeight - element[0].offsetHeight);
}
/* Zoomed screens may start reporting fractional values. For simplicity, round them out.
 * @see SID#197627 */
function scroll_directive_isolate_distanceToBottomEdge(element) {
    return Math.round(element[0].scrollTop + element[0].offsetHeight - element[0].scrollHeight);
}
function scroll_directive_isolate_distanceToTopEdge(element) {
    return Math.round(element[0].scrollTop);
}
// CONCATENATED MODULE: ./src/scroll/index.ts





/* harmony default export */ var src_scroll = (Object(external__angular_["module"])('rc.scroll', [utils["a" /* default */]]).controller('ScrollerController', scroll_controller).directive('rcScroll', rcScrollDirective).directive('rcScroller', rcScrollerDirective).directive('rcScrollIf', rcScrollIfDirective).directive('rcScrollIsolate', ScrollIsolateDirective).name);
// CONCATENATED MODULE: ./src/select/select.directive.ts


function selectDirective() {
    'ngInject';

    return {
        restrict: 'E',
        require: '?^^form',
        link: function link(scope, $element, attrs, formController) {
            if (formController) {
                var $formElement = Object(external__angular_["element"])($element[0].form);
                $element.on('keydown', function (event) {
                    if (event.which === keyboard_codes["a" /* default */].ENTER) {
                        event.preventDefault();
                        if (formController.$valid) {
                            $formElement.triggerHandler('submit');
                        }
                    }
                });
            }
        }
    };
}
/* harmony default export */ var select_directive = (selectDirective);
// CONCATENATED MODULE: ./src/select/index.ts



/* harmony default export */ var src_select = (Object(external__angular_["module"])('rc.select', [keyboardNavigation["a" /* default */]]).directive('select', select_directive).name);
// CONCATENATED MODULE: ./src/smartAnchor/smartAnchor.directive.ts
SmartAnchorDirective.$inject = ['rcSeamlessUi', '$rcModal', 'Usage'];

function SmartAnchorDirective(rcSeamlessUi, $rcModal, Usage) {
    'ngInject';

    return {
        restrict: 'A',
        // TODO: This really should be tightened up and not have an isolate scope....
        scope: {
            href: '@',
            target: '@',
            title: '@',
            modalConfig: '&'
        },
        link: SmartAnchorLink
    };
    function SmartAnchorLink(scope, element, attrs) {
        Usage.register('smart-anchor');
        if (Object(external__angular_["isUndefined"])(attrs.modalConfig)) {
            validateTarget();
            setupSeamless();
        } else {
            setupModal();
        }
        function validateTarget() {
            if (scope.target === void 0) {
                element.attr('target', '_blank');
            } else if (scope.target !== '_blank') {
                var firstChar = scope.target.slice(0, 1);
                if (firstChar === '_') {
                    throw new Error("rcSmartAnchor only accepts target attr of '_blank' or new window name.");
                }
            }
        }
        function setupSeamless() {
            if (rcSeamlessUi.isInSeamlessUIMode()) {
                element.addClass('rc-smart-anchor-seamless');
                element.on('click', function (e) {
                    e.preventDefault();
                    var url = element.attr('href');
                    rcSeamlessUi.openUrl(url, element.attr('title') || url);
                });
            }
        }
        function setupModal() {
            var defaultModalConfig = {
                templateUrl: scope.href,
                title: scope.title || scope.href
            };
            element.on('click', function (e) {
                e.preventDefault();
                $rcModal.open(scope.modalConfig() || defaultModalConfig);
            });
        }
    }
}
// CONCATENATED MODULE: ./src/smartAnchor/index.ts





/* harmony default export */ var smartAnchor = (Object(external__angular_["module"])('rc.smartAnchor', [usage["b" /* default */], modal["a" /* default */], seamlessUi]).directive('rcSmartAnchor', SmartAnchorDirective).name);
// CONCATENATED MODULE: ./src/utils/utils.factory.alternate-transclude.ts
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Creates a directive that will use the $transclude function to render the contents in a chosen location
 * which may differ from the original binding location.
 *
 * @param attributeName - Name of the attribute that will be used to bind the transclude function before
 * excecution. This must be the same name of the directive created. This creates an isolate scope, so it should
 * not be placed on component elements.
 * @param transcludedSlotName - Named slot whose content should be rendered
 */
function AlternativeTranscludeFactory(attributeName, transcludedSlotName) {
    return function () {
        return {
            restrict: 'A',
            scope: _defineProperty({}, attributeName, '<?'),
            link: AlternativeContentLink
        };
        function AlternativeContentLink(scope, element) {
            var transcludeFn = scope[attributeName];
            if (transcludeFn) {
                transcludeFn(function (content) {
                    element.empty();
                    element.append(content);
                }, null, transcludedSlotName);
            }
        }
    };
}
// EXTERNAL MODULE: ./src/smartMenu/templates/smart-menu.html
var smart_menu = __webpack_require__(157);
var smart_menu_default = /*#__PURE__*/__webpack_require__.n(smart_menu);

// CONCATENATED MODULE: ./src/smartMenu/constants.ts
var SMART_MENU_URL = '/myup/secure/jas/loadMenu';
var RICOLA_SERVICE_URL = '/uit/ricola/jas/services/';
var SMART_MENU_SERVICES = {
    circ7: 'circ7',
    equipmentid: 'equipmentId',
    firm: 'firm',
    locomotiveid: 'locomotiveId',
    trainid: 'trainId',
    userid: 'userId',
    yardtrack: 'yardTrack'
};
var SMART_MENU_SUMMARY_SERVICES = {
    circ7: 'circ7',
    trainid: 'train',
    userid: 'person'
};
var SMART_MENU_ERROR = {
    INVALID_TYPE: 'The rc-smart-menu directive requires a valid type. Please refer to the documentation and choose a valid type.',
    INVALID_SUMMARY_ATTR: 'The summary attribute is only valid with trainId, userId, or circ7.',
    INVALID_GENERIC_USAGE: 'The generic smartmenu requires custom content. Please use the menu-additions or summary-additions attributes to pass content to the directive.'
};
// CONCATENATED MODULE: ./src/smartMenu/smart-menu.component.ts
var smart_menu_component__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function smart_menu_component__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var LOADING_CLASS = 'rc-smart-menu-loading';
var smart_menu_component_SmartMenuController = function () {
    SmartMenuController.$inject = ['$scope', '$rootScope', '$q', '$element', '$transclude', '$rcSmartMenu', '$smartMenuMediator', 'Usage'];

    function SmartMenuController($scope, $rootScope, $q, $element, $transclude, $rcSmartMenu, $smartMenuMediator, Usage) {
        'ngInject';

        smart_menu_component__classCallCheck(this, SmartMenuController);

        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$q = $q;
        this.$element = $element;
        this.$transclude = $transclude;
        this.$rcSmartMenu = $rcSmartMenu;
        this.$smartMenuMediator = $smartMenuMediator;
        Usage.register('smartmenu');
    }

    smart_menu_component__createClass(SmartMenuController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$validateControllerAttributes();
            this.$scope.$watch(function () {
                return _this.value;
            }, function (current, previous) {
                if (current !== previous) {
                    _this.$resetAllItems();
                }
            });
            this.isOpen = false;
            this.$resetAllItems();
            this.$smartMenuMediator.onOpen(function () {
                _this.$element.removeClass(LOADING_CLASS);
            });
            this.$smartMenuMediator.onClose(function () {
                _this.$element.removeClass(LOADING_CLASS);
                if (_this.isOpen) {
                    _this.isOpen = false;
                    if (_this.onClose) {
                        _this.onClose();
                    }
                }
            });
            if (this.$transclude.isSlotFilled('altSummary')) {
                this.altSummary = this.$transclude;
            }
        }
    }, {
        key: '$resetAllItems',
        value: function $resetAllItems() {
            this.summaryContent = this.summaryAdditions() || [];
            this.menuItems = this.menuItems || [];
        }
    }, {
        key: 'toggleSmartMenu',
        value: function toggleSmartMenu(event) {
            var _this2 = this;

            if (this.$rcSmartMenu.shouldNotToggleMenu(event)) {
                return;
            }
            event.stopPropagation();
            // Signal the smart menu is opening
            this.$rootScope.$emit('rc.smartmenu.opening', this.$scope.$id); // isolate to service
            if (this.isOpen) {
                this.$smartMenuMediator.close();
            } else {
                this.$element.addClass(LOADING_CLASS);
                this.$q.resolve(this.onOpen ? this.onOpen() : null).then(function () {
                    _this2.$smartMenuMediator.open(_this2);
                    _this2.isOpen = true;
                });
            }
        }
    }, {
        key: '$validateControllerAttributes',
        value: function $validateControllerAttributes() {
            if (this.type !== 'generic' && !this.$rcSmartMenu.serviceExists(this.type)) {
                throw new Error(SMART_MENU_ERROR.INVALID_TYPE);
                // TODO: Does this matter if the summary attribute is '=' ?
            } else if (this.showSummary && !this.$rcSmartMenu.summaryExists(this.type)) {
                throw new Error(SMART_MENU_ERROR.INVALID_SUMMARY_ATTR);
            }
        }
    }]);

    return SmartMenuController;
}();
var SmartmenuComponent = {
    bindings: {
        type: '@',
        value: '@',
        menuAdditions: '&',
        summaryAdditions: '&',
        showSummary: '<',
        additionalParams: '<',
        callback: '&?',
        onOpen: '&?',
        onClose: '&?'
    },
    transclude: {
        altSummary: '?rcSmartMenuSummary'
    },
    template: smart_menu_default.a,
    controller: smart_menu_component_SmartMenuController
};
/* harmony default export */ var smart_menu_component = (SmartmenuComponent);
// EXTERNAL MODULE: ./src/smartMenu/templates/smart-menu-popup.html
var smart_menu_popup = __webpack_require__(158);
var smart_menu_popup_default = /*#__PURE__*/__webpack_require__.n(smart_menu_popup);

// CONCATENATED MODULE: ./src/smartMenu/smart-menu-popup.component.ts
var smart_menu_popup_component__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function smart_menu_popup_component__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var smart_menu_popup_component_SmartMenuPopupController = function () {
    SmartMenuPopupController.$inject = ['$rcSmartMenu', '$element'];

    function SmartMenuPopupController($rcSmartMenu, $element) {
        'ngInject';

        smart_menu_popup_component__classCallCheck(this, SmartMenuPopupController);

        this.$rcSmartMenu = $rcSmartMenu;
        this.$element = $element;
    }

    smart_menu_popup_component__createClass(SmartMenuPopupController, [{
        key: '$onInit',
        value: function $onInit() {
            this.$element.bind('click', function (event) {
                event.stopPropagation();
            });
        }
    }, {
        key: 'hasSummaryContent',
        value: function hasSummaryContent() {
            return this.summaryContent && this.summaryContent.length > 0 || Object(external__angular_["isDefined"])(this.altSummary);
        }
    }, {
        key: 'handleCallback',
        value: function handleCallback($event, item) {
            if (this.$rcSmartMenu.shouldNotToggleMenu($event)) {
                return;
            }
            if (Object(external__angular_["isDefined"])(this.callback)) {
                this.callback({ item: item });
            }
            if (item.closeOnClick || Object(external__angular_["isString"])(item.closeOnClick) && item.closeOnClick.toLowerCase() === 'true') {
                this.closeMenu();
            }
        }
    }, {
        key: 'publishClick',
        value: function publishClick($event, item) {
            this.onItemSelected({ $event: $event, item: item });
        }
    }, {
        key: 'closeMenu',
        value: function closeMenu() {
            this.onClose();
        }
    }]);

    return SmartMenuPopupController;
}();
var SmartMenuPopupComponent = {
    bindings: {
        altSummary: '<?',
        callback: '<?',
        onItemSelected: '&',
        onClose: '&',
        menuItems: '<',
        menuAdditions: '<',
        summaryContent: '<'
    },
    template: smart_menu_popup_default.a,
    controller: smart_menu_popup_component_SmartMenuPopupController,
    controllerAs: 'smartMenuPopup'
};
/* harmony default export */ var smart_menu_popup_component = (SmartMenuPopupComponent);
// CONCATENATED MODULE: ./src/smartMenu/smart-menu-popup-container.component.ts
var smart_menu_popup_container_component__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function smart_menu_popup_container_component__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SmartMenuPopupContainerController = function () {
    SmartMenuPopupContainerController.$inject = ['$smartMenuMediator', '$element', '$timeout', '$rootScope', '$smartMenuPositioner'];

    function SmartMenuPopupContainerController($smartMenuMediator, $element, $timeout, $rootScope, $smartMenuPositioner) {
        'ngInject';

        smart_menu_popup_container_component__classCallCheck(this, SmartMenuPopupContainerController);

        this.$smartMenuMediator = $smartMenuMediator;
        this.$element = $element;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.$smartMenuPositioner = $smartMenuPositioner;
    }

    smart_menu_popup_container_component__createClass(SmartMenuPopupContainerController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$dimensions = { width: 0, height: 0 };
            this.$smartMenuMediator.onOpen(function (_ref) {
                var type = _ref.type,
                    menuItems = _ref.menuItems,
                    summaryItems = _ref.summaryItems,
                    menuAdditions = _ref.menuAdditions,
                    $element = _ref.$element,
                    callback = _ref.callback,
                    altSummary = _ref.altSummary;

                _this.type = type;
                _this.menuItems = menuItems;
                _this.summaryContent = summaryItems;
                _this.menuAdditions = menuAdditions;
                _this.$smartMenu = $element;
                _this.callback = callback;
                _this.isOpen = true;
                _this.altSummary = altSummary;
            });
            this.$smartMenuMediator.onClose(function () {
                _this.isOpen = false;
                delete _this.type;
                delete _this.popupPosition;
                delete _this.nubPosition;
                delete _this.menuItems;
                delete _this.summaryContent;
                delete _this.menuAdditions;
                delete _this.callback;
                delete _this.altSummary;
            });
        }
    }, {
        key: '$doCheck',
        value: function $doCheck() {
            if (this.isOpen) {
                this.$adjustPositioning();
            }
        }
    }, {
        key: '$asPx',
        value: function $asPx(coordinates) {
            return {
                top: coordinates.top + 'px',
                left: coordinates.left + 'px'
            };
        }
    }, {
        key: '$adjustPositioning',
        value: function $adjustPositioning() {
            var _this2 = this;

            if (this.$smartMenu) {
                if (this.$debounced) {
                    this.$timeout.cancel(this.$debounced);
                }
                this.$debounced = this.$timeout(function () {
                    var popup = _this2.$element.find('rc-smart-menu-popup');
                    var menuCoordinates = _this2.$smartMenuPositioner.position(_this2.$smartMenu, popup);
                    var pixels = _this2.$asPx(menuCoordinates);
                    popup[0].style.top = pixels.top;
                    popup[0].style.left = pixels.left;
                    return menuCoordinates;
                    // Do not need another $watch cycle
                }, 0, false).then(function (menuCoordinates) {
                    var nub = _this2.$element.find('smart-menu-popup-nub');
                    var pixels = _this2.$asPx(_this2.$smartMenuPositioner.calculateNubPosition(_this2.$smartMenu, menuCoordinates));
                    nub.attr('alignment', menuCoordinates.alignment);
                    nub[0].style.top = pixels.top;
                    nub[0].style.left = pixels.left;
                });
            }
        }
    }, {
        key: '$calculateNubPosition',
        value: function $calculateNubPosition($menuElement, popupPosition) {
            return this.$smartMenuPositioner.calculateNubPosition($menuElement, popupPosition);
        }
    }, {
        key: 'handleClose',
        value: function handleClose() {
            this.$smartMenuMediator.close();
        }
    }, {
        key: 'handleItemSelected',
        value: function handleItemSelected(event, item) {
            this.$rootScope.$emit('rc.smartmenu.selected', { event: event, item: item });
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(isolate) {
            // scrolling outside the container will close it
            var event = isolate.event;
            event.preventDefault();
            event.stopPropagation();
        }
    }]);

    return SmartMenuPopupContainerController;
}();
var SmartMenuPopupContainerComponent = {
    controller: SmartMenuPopupContainerController,
    template: '<div class="rc-smart-menu-popup-container" ng-if="$ctrl.isOpen">\n        <rc-smart-menu-popup\n        additional-items="$ctrl.menuAdditions"\n        menu-items="$ctrl.menuItems"\n        callback="$ctrl.callback"\n        summary-content="$ctrl.summaryContent"\n        on-item-selected="$ctrl.handleItemSelected($event, item)"\n        on-close="$ctrl.handleClose()"\n        rc-scroll-isolate="$ctrl.handleScroll($event)"\n        alt-summary="$ctrl.altSummary"\n        ></rc-smart-menu-popup>\n        <smart-menu-popup-nub></smart-menu-popup-nub>\n    </div>'
};
/* harmony default export */ var smart_menu_popup_container_component = (SmartMenuPopupContainerComponent);
// CONCATENATED MODULE: ./src/smartMenu/closeable-popup.directive.ts
CloseablePopup.$inject = ['$document', '$window', '$timeout', '$rootScope', '$position', '$smartMenuMediator'];


function CloseablePopup($document, $window, $timeout, $rootScope, $position, $smartMenuMediator) {
    'ngInject';

    var $body = $document.find('body');
    var NAV_KEYS = [keyboard_codes["a" /* default */].UP, keyboard_codes["a" /* default */].DOWN, keyboard_codes["a" /* default */].PAGEUP, keyboard_codes["a" /* default */].PAGEDOWN];
    var CLOSE_EVENTS = 'click scroll mousewheel wheel keyup';
    return {
        link: function link($scope, $element) {
            var activeElement = void 0;
            var cachedPosition = void 0;
            // Close when another smart menu opens
            var deregister = $rootScope.$on('rc.smartmenu.opening', function (event, scopeId) {
                if (scopeId !== $scope.$id) {
                    $smartMenuMediator.close();
                }
            });
            var $wrappedWindow = Object(external__angular_["element"])($window);
            var debouncedHideMenu = function debouncedHideMenu($event) {
                return makeDebouncedHideMenu($event);
            };
            $wrappedWindow.on('resize', debouncedHideMenu);
            $body.on(CLOSE_EVENTS, debouncedHideMenu);
            deregister();
            $scope.$on('$destroy', function () {
                $body.unbind(CLOSE_EVENTS, debouncedHideMenu);
                $wrappedWindow.unbind('resize', debouncedHideMenu);
            });
            function buildDebouncedHidePromise(validatingCallback) {
                var callback = Object(external__angular_["isFunction"])(validatingCallback) ? validatingCallback : function () {
                    return true;
                };
                return $timeout(function () {
                    if (callback()) {
                        $smartMenuMediator.close();
                    }
                }, 30);
            }
            var debouncedHidePromise = void 0;
            var makeDebouncedHideMenu = function makeDebouncedHideMenu(event) {
                if (debouncedHidePromise) {
                    $timeout.cancel(debouncedHidePromise);
                }
                if ($smartMenuMediator.isOpen()) {
                    if (event.type === 'resize' || event.type === 'click') {
                        debouncedHidePromise = buildDebouncedHidePromise();
                    } else if (mayCauseScroll(event)) {
                        debouncedHidePromise = buildDebouncedHidePromise(hasChangedPosition);
                    }
                }
            };
            var hasChangedPosition = function hasChangedPosition() {
                var newLinkPosition = $position.offset(activeElement);
                // Another IE design win. This can be a straight comparison if Edge fixes it.
                // IE does not consistently provide the same values for the position of an element but stays within 1 pixel
                if (Math.abs(cachedPosition.top - newLinkPosition.top) > 1) {
                    cachedPosition = newLinkPosition;
                    return true;
                }
                return false;
            };
            function mayCauseScroll(event) {
                return event.type === 'scroll' || event.type === 'mousewheel' || event.type === 'wheel' || NAV_KEYS.indexOf(event.which) > -1;
            }
            $smartMenuMediator.onOpen(function (data) {
                activeElement = data.$element;
                cachedPosition = $position.offset(activeElement);
            });
        }
    };
}
// CONCATENATED MODULE: ./src/smartMenu/smart-menu.service.ts
var smart_menu_service__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function smart_menu_service__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var smart_menu_service_SmartMenuInvoker = function () {
    function SmartMenuInvoker($http, type, key, additionalParams) {
        smart_menu_service__classCallCheck(this, SmartMenuInvoker);

        this.$http = $http;
        this.type = type;
        this.key = key;
        this.additionalParams = additionalParams;
    }

    smart_menu_service__createClass(SmartMenuInvoker, [{
        key: 'getMenuItems',
        value: function getMenuItems() {
            return this.$http.get(SMART_MENU_URL, this.$buildMenuParams());
        }
    }, {
        key: 'getSummaryItems',
        value: function getSummaryItems() {
            var url = '' + RICOLA_SERVICE_URL + SMART_MENU_SUMMARY_SERVICES[this.type] + '/summary';
            return this.$http.get(url, {
                // This is easy, but is it the right place to handle caching?
                cache: true,
                params: {
                    id: this.key
                }
            });
        }
    }, {
        key: '$buildMenuParams',
        value: function $buildMenuParams() {
            var parameters = {
                // This is easy, but is it the right place to handle caching?
                cache: true,
                params: {}
            };
            parameters.params[SMART_MENU_SERVICES[this.type]] = this.key;
            if (Object(external__angular_["isObject"])(this.additionalParams)) {
                /* The MyUP smart menu service requires the 'suiSmartMenu' to respond properly
                 * when additional parameters are included to know which is the primary type */
                parameters.params.suiSmartMenu = SMART_MENU_SERVICES[this.type];
                Object(external__angular_["forEach"])(this.additionalParams, function (value, paramKey) {
                    parameters.params[paramKey] = value;
                });
            }
            return parameters;
        }
    }]);

    return SmartMenuInvoker;
}();

var smart_menu_service_SmartMenuService = function () {
    SmartMenuService.$inject = ['$http'];

    function SmartMenuService($http) {
        'ngInject';

        smart_menu_service__classCallCheck(this, SmartMenuService);

        this.$http = $http;
    }

    smart_menu_service__createClass(SmartMenuService, [{
        key: 'buildInvokerFor',
        value: function buildInvokerFor(type, key, additionalParams) {
            return new smart_menu_service_SmartMenuInvoker(this.$http, this.$normalizeType(type), key, additionalParams);
        }
    }, {
        key: 'serviceExists',
        value: function serviceExists(type) {
            return this.$caseInsensitiveMatch(type, SMART_MENU_SERVICES);
        }
    }, {
        key: 'summaryExists',
        value: function summaryExists(type) {
            return this.$caseInsensitiveMatch(type, SMART_MENU_SUMMARY_SERVICES);
        }
    }, {
        key: 'shouldNotToggleMenu',
        value: function shouldNotToggleMenu($event) {
            return $event.type === 'keyup' && [keyboard_codes["a" /* default */].ENTER, keyboard_codes["a" /* default */].SPACE].indexOf($event.which) === -1;
        }
    }, {
        key: '$caseInsensitiveMatch',
        value: function $caseInsensitiveMatch(type, services) {
            if (!type) {
                return false;
            }
            var serviceUrl = services[this.$normalizeType(type)];
            return Object(external__angular_["isDefined"])(serviceUrl);
        }
    }, {
        key: '$normalizeType',
        value: function $normalizeType(type) {
            return type.toLowerCase();
        }
    }]);

    return SmartMenuService;
}();

/* harmony default export */ var smart_menu_service = (smart_menu_service_SmartMenuService);
// CONCATENATED MODULE: ./src/smartMenu/smart-menu-mediator.service.ts
var smart_menu_mediator_service__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function smart_menu_mediator_service__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var smart_menu_mediator_service_SmartMenuMediator = function () {
    SmartMenuMediator.$inject = ['$rcSmartMenu', '$q', '$document', '$compile', '$rootScope'];

    function SmartMenuMediator($rcSmartMenu, $q, $document, $compile, $rootScope) {
        'ngInject';

        smart_menu_mediator_service__classCallCheck(this, SmartMenuMediator);

        this.$rcSmartMenu = $rcSmartMenu;
        this.$q = $q;
        this.$document = $document;
        this.$compile = $compile;
        this.$rootScope = $rootScope;
        this.openCallbacks = [];
        this.closeCallbacks = [];
        this.menuIsOpen = false;
    }

    smart_menu_mediator_service__createClass(SmartMenuMediator, [{
        key: '$resolveMenuItems',
        value: function $resolveMenuItems(invoker, config) {
            if (this.$menuDataRequired(config)) {
                return invoker.getMenuItems().then(function (results) {
                    return results.data.data || [];
                }).then(function (data) {
                    if (data.length === 0) {
                        // Handle an empty result from the service
                        // Do we ever actually get HTTP failures from this??
                        return [{
                            error: true,
                            label: 'An error has occurred.' // TODO: i18n
                        }];
                    }
                    return data;
                });
            }
            return this.$q.resolve([]);
        }
    }, {
        key: '$resolveSummaryItems',
        value: function $resolveSummaryItems(invoker, config) {
            if (this.$summaryDataRequired(config)) {
                return invoker.getSummaryItems().then(function (results) {
                    return results.data.data || [];
                }, function () {
                    return [];
                });
            }
            return this.$q.resolve([]);
        }
    }, {
        key: '$summaryDataRequired',
        value: function $summaryDataRequired(_ref) {
            var showSummary = _ref.showSummary,
                type = _ref.type;

            return showSummary && this.$rcSmartMenu.summaryExists(type);
        }
    }, {
        key: '$menuDataRequired',
        value: function $menuDataRequired(_ref2) {
            var type = _ref2.type;

            return type !== 'generic' && this.$rcSmartMenu.serviceExists(type);
        }
    }, {
        key: '$invokeOpenCallbacks',
        value: function $invokeOpenCallbacks(config) {
            this.openCallbacks.forEach(function (callback) {
                callback(config);
            });
        }
    }, {
        key: '$invokeCloseCallbacks',
        value: function $invokeCloseCallbacks(config) {
            this.closeCallbacks.forEach(function (callback) {
                callback(config);
            });
        }
    }, {
        key: 'open',
        value: function open(config) {
            var _this = this;

            this.close(); // Close any currently open menu
            if (!this.$contentEl) {
                var bodyEl = this.$document.find('body');
                this.$contentEl = Object(external__angular_["element"])('<rc-smart-menu-popup-container>');
                this.$contentScope = this.$rootScope.$new();
                bodyEl.append(this.$compile(this.$contentEl)(this.$contentScope));
            }
            var type = config.type,
                value = config.value,
                additionalParams = config.additionalParams,
                menuAdditions = config.menuAdditions,
                summaryAdditions = config.summaryAdditions;

            if (type === 'generic') {
                this.validateGenericAttributes(menuAdditions, summaryAdditions);
            }
            var invoker = this.$rcSmartMenu.buildInvokerFor(type, value, additionalParams);
            var menuAdditionsPromise = this.$q.resolve(menuAdditions());
            var menuItemsPromise = this.$resolveMenuItems(invoker, config);
            var summaryAdditionsPromise = this.$q.resolve(summaryAdditions());
            var summaryItemsPromise = this.$resolveSummaryItems(invoker, config);
            return this.$q.all({
                menuItemsPromise: menuItemsPromise,
                menuAdditionsPromise: menuAdditionsPromise,
                summaryItemsPromise: summaryItemsPromise,
                summaryAdditionsPromise: summaryAdditionsPromise
            }).then(function (data) {
                var menuItems = (data.menuAdditionsPromise || []).concat(data.menuItemsPromise);
                var summaryItems = (data.summaryAdditionsPromise || []).concat(data.summaryItemsPromise);
                var dataForService = {
                    type: type,
                    menuItems: menuItems,
                    summaryItems: summaryItems,
                    menuAdditions: data.menuAdditionsPromise,
                    callback: config.callback,
                    $element: config.$element,
                    altSummary: config.altSummary
                };
                return dataForService;
            }).then(function (dataForService) {
                _this.$invokeOpenCallbacks(dataForService);
                _this.menuIsOpen = true;
                return dataForService;
            }).catch(function (error) {
                // If something fails, bail!
                _this.close();
            });
        }
    }, {
        key: 'validateGenericAttributes',
        value: function validateGenericAttributes(menuAdditions, summaryAdditions) {
            var isEmpty = function isEmpty(arrayOrPromise) {
                if (arrayOrPromise) {
                    return Object(external__angular_["isArray"])(arrayOrPromise) ? arrayOrPromise.length === 0 : false;
                }
                return false;
            };
            if (isEmpty(menuAdditions) && isEmpty(summaryAdditions)) {
                throw new Error(SMART_MENU_ERROR.INVALID_GENERIC_USAGE);
            }
        }
    }, {
        key: 'close',
        value: function close() {
            this.$invokeCloseCallbacks();
            this.$contentEl && this.$contentEl.remove();
            this.$contentScope && this.$contentScope.$destroy();
            delete this.$contentEl;
            delete this.$contentScope;
            this.menuIsOpen = false;
        }
    }, {
        key: 'isOpen',
        value: function isOpen() {
            return this.menuIsOpen;
        }
    }, {
        key: 'onOpen',
        value: function onOpen(callback) {
            this.openCallbacks.push(callback);
        }
    }, {
        key: 'onClose',
        value: function onClose(callback) {
            this.closeCallbacks.push(callback);
        }
    }]);

    return SmartMenuMediator;
}();

/* harmony default export */ var smart_menu_mediator_service = (smart_menu_mediator_service_SmartMenuMediator);
// CONCATENATED MODULE: ./src/smartMenu/menu-positioner.service.ts
var menu_positioner_service__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function menu_positioner_service__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var STRATEGIES = ['bottom-left', 'right-middle', 'left-middle'];

var menu_positioner_service_MenuPositioner = function () {
    MenuPositioner.$inject = ['$position', '$window', 'rcMediaQuery', '$strategicPositioner'];

    function MenuPositioner($position, $window, rcMediaQuery, $strategicPositioner) {
        'ngInject';

        menu_positioner_service__classCallCheck(this, MenuPositioner);

        this.$position = $position;
        this.$window = $window;
        this.rcMediaQuery = rcMediaQuery;
        this.nubOffset = 7;
        this.nubVerticalOffset = 2;
        this.nubHorizontalOffset = 10;
        this.strategicPositioner = $strategicPositioner.positionerFor(STRATEGIES, this.nubOffset);
    }

    menu_positioner_service__createClass(MenuPositioner, [{
        key: 'position',
        value: function position($smartMenu, $popup) {
            if (this.rcMediaQuery.minSize('medium')) {
                return this.$sizeForLargeScreens($smartMenu, $popup);
            }
            return this.$sizeForSmallScreens($smartMenu, $popup);
        }
    }, {
        key: '$sizeForLargeScreens',
        value: function $sizeForLargeScreens($smartMenu, $popup) {
            return this.strategicPositioner.position($smartMenu, $popup);
        }
        // TODO This is probably a good candidate to extract & genericize
        // Other components (tooltip, autocomplete) might be able to reuse

    }, {
        key: 'calculateNubPosition',
        value: function calculateNubPosition($smartMenu, popupCoordinates) {
            var alignment = popupCoordinates.alignment;

            var smartMenuOffset = this.$position.offset($smartMenu);
            var left = smartMenuOffset.left,
                top = smartMenuOffset.top;

            if (alignment === 'below') {
                left = popupCoordinates.left + smartMenuOffset.width / 2 - this.nubOffset;
                top += smartMenuOffset.height;
            }
            if (alignment === 'right') {
                left += smartMenuOffset.width;
                top += this.nubVerticalOffset;
            }
            if (alignment === 'left') {
                left -= this.nubHorizontalOffset;
                top += this.nubVerticalOffset;
            }
            return { top: top, left: left };
        }
    }, {
        key: '$sizeForSmallScreens',
        value: function $sizeForSmallScreens($smartMenu, $popup) {
            // Place directly below the smart menu, flush against left edge
            var smartMenuOffset = this.$position.offset($smartMenu);
            var popupPosition = Object(external__angular_["copy"])(smartMenuOffset);
            popupPosition.top += smartMenuOffset.height + this.nubOffset;
            popupPosition.left = 0;
            popupPosition.alignment = 'below';
            return popupPosition;
        }
    }]);

    return MenuPositioner;
}();

/* harmony default export */ var menu_positioner_service = (menu_positioner_service_MenuPositioner);
// CONCATENATED MODULE: ./src/smartMenu/keyboard-shortcuts.run.ts
bindKeyboardShortcuts.$inject = ['$document', '$rootScope', '$smartMenuMediator'];

function bindKeyboardShortcuts($document, $rootScope, $smartMenuMediator) {
    'ngInject';

    var closeOnEscape = function closeOnEscape($evt) {
        if ($evt.which === keyboard_codes["a" /* default */].ESC) {
            $rootScope.$apply(function () {
                $smartMenuMediator.close();
            });
        }
    };
    $smartMenuMediator.onOpen(function () {
        $document.on('keydown', closeOnEscape);
    });
    $smartMenuMediator.onClose(function () {
        $document.off('keydown', closeOnEscape);
    });
}
// CONCATENATED MODULE: ./src/smartMenu/index.ts















/* harmony default export */ var smartMenu = (Object(external__angular_["module"])('rc.smartMenu', [keyboardNavigation["a" /* default */], mediaQuery["b" /* default */], position["a" /* default */], src_scroll, usage["b" /* default */]]).component('rcSmartMenu', smart_menu_component).run(bindKeyboardShortcuts).service('$rcSmartMenu', smart_menu_service).service('$smartMenuMediator', smart_menu_mediator_service).service('$smartMenuPositioner', menu_positioner_service).component('rcSmartMenuPopup', smart_menu_popup_component).component('rcSmartMenuPopupContainer', smart_menu_popup_container_component).directive('rcSmartMenuPopupContainer', CloseablePopup).directive('alternateSummary', AlternativeTranscludeFactory('alternateSummary', 'altSummary')).name);
// EXTERNAL MODULE: ./src/table/index.ts + 9 modules
var table = __webpack_require__(75);

// EXTERNAL MODULE: ./src/tabs/templates/tab.html
var tab = __webpack_require__(164);
var tab_default = /*#__PURE__*/__webpack_require__.n(tab);

// CONCATENATED MODULE: ./src/tabs/tabs.component.tab.ts
var tabs_component_tab__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function tabs_component_tab__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var tabs_component_tab_TabController = function () {
    TabController.$inject = ['$scope', '$element', '$transclude', '$timeout'];

    function TabController($scope, $element, $transclude, $timeout) {
        'ngInject';

        tabs_component_tab__classCallCheck(this, TabController);

        this.$scope = $scope;
        this.$element = $element;
        this.$transclude = $transclude;
        this.$timeout = $timeout;
    }

    tabs_component_tab__createClass(TabController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            var initState = this.initActive();
            // Only modify active if defined and true
            if (this.active !== initState) {
                this.active = initState;
            }
            // See transclude-tab-header.directive for details
            if (this.$transclude.isSlotFilled('tabHeading')) {
                this.headerTranscludeFn = this.$transclude;
            }
            this.tabsetCtrl.add(this);
            this.$element.addClass('rc-tab');
            this.$element.on('click', function () {
                _this.tabsetCtrl.scrollToActiveHeader();
            });
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.tabsetCtrl.remove(this);
        }
    }, {
        key: '$postLink',
        value: function $postLink() {
            // Remove the poorly-named attribute which confuses IE now that everything is bound.
            // @see SID#198940
            this.$element.removeAttr('disabled');
        }
    }, {
        key: 'setHeading',
        value: function setHeading(heading) {
            this.heading = heading;
        }
    }, {
        key: 'active',
        get: function get() {
            return Object(external__angular_["isDefined"])(this._active) ? this._active : false;
        },
        set: function set(active) {
            // Use active in comparison to avoid undefined triggering deselect
            if (typeof active === 'boolean' && this.active !== active) {
                this._active = active;
                if (this._active === true) {
                    this.onSelect && this.onSelect();
                    this.tabsetCtrl && this.tabsetCtrl.scrollToActiveHeader();
                }
                if (this._active === false) {
                    this.onDeselect && this.onDeselect();
                }
            }
        }
    }]);

    return TabController;
}();
var TabComponent = {
    bindings: {
        initActive: '&',
        active: '=?',
        disabled: '<?',
        heading: '@?',
        //TODO: Merge these to an 'on-active-change' attribute?
        onSelect: '&select',
        onDeselect: '&deselect'
    },
    controller: tabs_component_tab_TabController,
    controllerAs: 'rcTabCtrl',
    require: {
        tabsetCtrl: '^rcTabset'
    },
    template: tab_default.a,
    transclude: {
        tabHeading: '?rcTabHeading'
    }
};
/* harmony default export */ var tabs_component_tab = (TabComponent);
// EXTERNAL MODULE: ./src/tabs/templates/tabset.html
var tabset = __webpack_require__(165);
var tabset_default = /*#__PURE__*/__webpack_require__.n(tabset);

// CONCATENATED MODULE: ./src/tabs/tabs.component.tabset.ts
var tabs_component_tabset__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function tabs_component_tabset__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


/**
 * The tab index is not always correct due to slow-priority directives like ng-repeat.
 * This _should_ provide a rough cut of where in the rendered order the tab should go
 * when it is added.
 */
function indexOfChildElement(tabsetElement, tabElement) {
    var tabElements = tabsetElement.find('rc-tab');
    for (var index = 0; index < tabElements.length; index++) {
        if (tabElement[0] === tabElements[index]) {
            return index;
        }
    }
    return -1;
}
var TabsetController = function () {
    TabsetController.$inject = ['$scope', '$element', '$timeout', 'Usage', 'RcTabsetHeaderScroll'];

    function TabsetController($scope, $element, $timeout, Usage, RcTabsetHeaderScroll) {
        'ngInject';

        tabs_component_tabset__classCallCheck(this, TabsetController);

        this.$scope = $scope;
        this.$element = $element;
        this.$timeout = $timeout;
        this.RcTabsetHeaderScroll = RcTabsetHeaderScroll;
        this.tabs = [];
        Usage.register('tabs');
    }

    tabs_component_tabset__createClass(TabsetController, [{
        key: '$onInit',
        value: function $onInit() {
            this.$element.addClass('rc-tabset');
        }
    }, {
        key: 'add',
        value: function add(tabCtrl) {
            var _this = this;

            var index = indexOfChildElement(this.$element, tabCtrl.$element);
            if (index >= this.tabs.length) {
                this.tabs.push(tabCtrl);
            } else {
                this.tabs.splice(index, 0, tabCtrl);
            }
            // To manage both manual and ng-repeat tab additions, use $timeout to avoid setting
            // the active tab until all tabs have been added/iterated
            if (this.$debounced) {
                this.$timeout.cancel(this.$debounced);
            }
            this.$debounced = this.$timeout(function () {
                _this.$setActiveTab();
            });
        }
        // Implies user interaction, do not use for 'activating'

    }, {
        key: 'select',
        value: function select(tabCtrl) {
            tabCtrl.active = true;
            this.tabs.forEach(function (tab) {
                if (tab.active && tab !== tabCtrl) {
                    tab.active = false;
                }
            });
        }
    }, {
        key: '$setActiveTab',
        value: function $setActiveTab() {
            var alreadyActive = this.tabs.some(function (tabCtrl) {
                return tabCtrl.active;
            });
            if (!alreadyActive && this.tabs.length > 0) {
                this.tabs[0].active = true;
            }
            this.scrollToActiveHeader();
        }
    }, {
        key: 'remove',
        value: function remove(tabCtrl) {
            var index = this.tabs.indexOf(tabCtrl);
            if (index < 1) {
                this.tabs.length = 0;
            } else {
                this.tabs.splice(index, 1);
                var hasActive = this.tabs.some(function (tab) {
                    return tab.active;
                });
                if (!hasActive) {
                    var nextActive = this.tabs.length > index ? index : this.tabs.length - 1;
                    this.tabs[nextActive].active = true;
                }
            }
        }
    }, {
        key: 'scrollToActiveHeader',
        value: function scrollToActiveHeader() {
            var tabsetHeader = this.$element.find('rc-tabset-header').eq(0);
            this.RcTabsetHeaderScroll.setScrollLeftToActiveHeading(tabsetHeader);
        }
    }]);

    return TabsetController;
}();
/* harmony default export */ var tabs_component_tabset = ({
    bindings: {},
    controller: TabsetController,
    controllerAs: 'rcTabsetCtrl',
    template: tabset_default.a,
    transclude: true
});
// EXTERNAL MODULE: ./src/tabs/templates/tabset.header.html
var tabset_header = __webpack_require__(166);
var tabset_header_default = /*#__PURE__*/__webpack_require__.n(tabset_header);

// CONCATENATED MODULE: ./src/tabs/tabs.component.tabset.header.ts
var tabs_component_tabset_header__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function tabs_component_tabset_header__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var ENABLE_SCROLL = 'rc-tab-headings-scrollable';
var WINDOW_EVENT = 'resize';
var SCROLL_PROP = 'scrollLeft';
var tabs_component_tabset_header_TabsetHeaderController = function () {
    TabsetHeaderController.$inject = ['$scope', '$element', '$window', '$timeout', 'RcTabsetHeaderScroll'];

    function TabsetHeaderController($scope, $element, $window, $timeout, RcTabsetHeaderScroll) {
        'ngInject';

        tabs_component_tabset_header__classCallCheck(this, TabsetHeaderController);

        this.$scope = $scope;
        this.$element = $element;
        this.$window = $window;
        this.$timeout = $timeout;
        this.RcTabsetHeaderScroll = RcTabsetHeaderScroll;
    }

    tabs_component_tabset_header__createClass(TabsetHeaderController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$scope.$watch(external__angular_["noop"], function () {
                _this.setDebouncedAdjustment();
            });
            this.$element.addClass('rc-tabset-header');
            this.$element.on('click', function (event) {
                var clickedElement = Object(external__angular_["element"])(event.target);
                if (clickedElement.hasClass('rc-tabset-scroll-right')) {
                    _this.RcTabsetHeaderScroll.setNextScrollLeft(_this.$element);
                } else if (clickedElement.hasClass('rc-tabset-scroll-left')) {
                    _this.RcTabsetHeaderScroll.setPreviousScrollLeft(_this.$element);
                }
            });
            this.clearWindowBindings = Object(utils_events["a" /* removableEventHandler */])(this.$window, WINDOW_EVENT, function () {
                return _this.setDebouncedAdjustment();
            });
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.clearWindowBindings();
        }
    }, {
        key: 'select',
        value: function select(tab) {
            if (!tab.disabled) {
                this.tabsetCtrl.select(tab);
                this.RcTabsetHeaderScroll.setScrollLeftToActiveHeading(this.$element);
            }
        }
    }, {
        key: 'setDebouncedAdjustment',
        value: function setDebouncedAdjustment() {
            var _this2 = this;

            if (this.debouncedAdjustment) {
                this.$timeout.cancel(this.debouncedAdjustment);
            }
            this.debouncedAdjustment = this.$timeout(function () {
                if (_this2.RcTabsetHeaderScroll.headingsExceedWidth(_this2.$element)) {
                    _this2.$element.addClass(ENABLE_SCROLL);
                } else {
                    _this2.$element.removeClass(ENABLE_SCROLL);
                }
                _this2.RcTabsetHeaderScroll.setScrollLeftToActiveHeading(_this2.$element);
            }, 50, false);
        }
    }]);

    return TabsetHeaderController;
}();
var TabsetheaderComponent = {
    bindings: {
        tabs: '&'
    },
    controller: tabs_component_tabset_header_TabsetHeaderController,
    controllerAs: 'rcTsHdrCtrl',
    require: {
        tabsetCtrl: '^rcTabset'
    },
    template: tabset_header_default.a
};
/* harmony default export */ var tabs_component_tabset_header = (TabsetheaderComponent);
// CONCATENATED MODULE: ./src/tabs/tabs.service.tabset.header.ts
var tabs_service_tabset_header__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function tabs_service_tabset_header__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SCROLL_LEFT = 'scrollLeft';
var debounceMap = new Map();
// TODO: Work in requestAnimationFrame maneuvers to smooth the transistions

var RcTabsetHeaderScrollService = function () {
    RcTabsetHeaderScrollService.$inject = ['$timeout'];

    function RcTabsetHeaderScrollService($timeout) {
        'ngInject';

        tabs_service_tabset_header__classCallCheck(this, RcTabsetHeaderScrollService);

        this.$timeout = $timeout;
    }

    tabs_service_tabset_header__createClass(RcTabsetHeaderScrollService, [{
        key: 'findActive',
        value: function findActive(tabsetHeader) {
            var headings = tabsetHeader.find('div');
            for (var i = 0; i < headings.length; i++) {
                if (headings.eq(i).hasClass('active')) {
                    return headings.eq(i);
                }
            }
        }
    }, {
        key: 'headingsExceedWidth',
        value: function headingsExceedWidth(tabsetHeader) {
            var children = tabsetHeader.children();
            var width = tabsetHeader[0].offsetWidth;
            var heading = void 0;
            for (var index = 0; index < children.length; index++) {
                heading = children.eq(index);
                if (heading.hasClass('rc-tab-heading')) {
                    width -= heading[0].offsetWidth;
                }
            }
            return width < 0;
        }
    }, {
        key: 'setNextScrollLeft',
        value: function setNextScrollLeft(tabsetHeader) {
            var currentValue = tabsetHeader[0].scrollLeft;
            var headings = tabsetHeader.find('div');
            var nextValue = 0;
            for (var index = 0; index < headings.length; index++) {
                if (nextValue <= currentValue) {
                    nextValue += headings[index].offsetWidth;
                }
            }
            scrollHeaderTo(tabsetHeader, nextValue);
        }
    }, {
        key: 'setPreviousScrollLeft',
        value: function setPreviousScrollLeft(tabsetHeader) {
            var currentValue = tabsetHeader[0].scrollLeft;
            var headings = tabsetHeader.find('div');
            var previousValue = 0;
            for (var index = 0; index < headings.length; index++) {
                previousValue += headings[index].offsetWidth;
                if (previousValue >= currentValue) {
                    // back off by 1 element width
                    previousValue -= headings[index].offsetWidth;
                    index = headings.length;
                }
            }
            scrollHeaderTo(tabsetHeader, previousValue);
        }
    }, {
        key: 'setScrollLeftToActiveHeading',
        value: function setScrollLeftToActiveHeading(tabsetHeader) {
            var _this = this;

            var promise = debounceMap.get(tabsetHeader[0]);
            if (promise) {
                this.$timeout.cancel(promise);
                debounceMap.delete(tabsetHeader[0]);
            }
            promise = this.$timeout(function () {
                var currentValue = tabsetHeader[0].scrollLeft;
                var scrollLeft = currentValue;
                if (tabsetHeader.hasClass('rc-tab-headings-scrollable')) {
                    var headings = tabsetHeader.find('div');
                    // first heading should be offset by button width
                    var buttonWidth = headings[0].offsetLeft;
                    var active = _this.findActive(tabsetHeader);
                    // Under the left button: align left
                    if (active[0].offsetLeft - buttonWidth < currentValue) {
                        scrollLeft = active[0].offsetLeft - buttonWidth;
                        // Under the right button
                    } else if (active[0].offsetLeft + active[0].offsetWidth > currentValue + tabsetHeader[0].offsetWidth - buttonWidth) {
                        // Heading too wide: align left
                        if (active[0].offsetWidth > tabsetHeader[0].offsetWidth) {
                            scrollLeft = active[0].offsetLeft - buttonWidth;
                            // Align right
                        } else {
                            scrollLeft = active[0].offsetLeft + active[0].offsetWidth + buttonWidth - tabsetHeader[0].offsetWidth;
                        }
                    }
                }
                scrollHeaderTo(tabsetHeader, scrollLeft);
            }, 10, false);
            debounceMap.set(tabsetHeader, promise);
        }
    }]);

    return RcTabsetHeaderScrollService;
}();

/* harmony default export */ var tabs_service_tabset_header = (RcTabsetHeaderScrollService);

function scrollHeaderTo(element, left) {
    var previous = void 0;
    window.requestAnimationFrame(smoothTransition);
    function smoothTransition() {
        var current = element[0].scrollLeft;
        if (current !== previous) {
            previous = current;
            if (Math.abs(current - left) <= 6) {
                element.prop(SCROLL_LEFT, left);
            } else {
                var increment = current < left ? 6 : -6;
                element.prop(SCROLL_LEFT, element[0].scrollLeft + increment);
                window.requestAnimationFrame(smoothTransition);
            }
        }
    }
}
// CONCATENATED MODULE: ./src/tabs/index.ts







/* harmony default export */ var tabs = (Object(external__angular_["module"])('rc.tabs', [usage["b" /* default */]]).component('rcTab', tabs_component_tab).component('rcTabset', tabs_component_tabset).component('rcTabsetHeader', tabs_component_tabset_header).directive('rcTranscludeHeaderFor', AlternativeTranscludeFactory('rcTranscludeHeaderFor', 'tabHeading')).service('RcTabsetHeaderScroll', tabs_service_tabset_header).name);
// EXTERNAL MODULE: ./src/tooltip/index.ts + 6 modules
var tooltip = __webpack_require__(76);

// EXTERNAL MODULE: ./src/watchCount/watchCountTemplate.html
var watchCountTemplate = __webpack_require__(169);
var watchCountTemplate_default = /*#__PURE__*/__webpack_require__.n(watchCountTemplate);

// CONCATENATED MODULE: ./src/watchCount/watchCount.component.ts
var watchCount_component__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function watchCount_component__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var WatchCount = function () {
    WatchCount.$inject = ['Usage'];

    function WatchCount(Usage) {
        'ngInject';

        watchCount_component__classCallCheck(this, WatchCount);

        this.Usage = Usage;
        Usage.register('watchCount');
    }

    watchCount_component__createClass(WatchCount, [{
        key: '$onInit',
        value: function $onInit() {
            this.setPosition();
        }
    }, {
        key: 'setPosition',
        value: function setPosition() {
            if (this.wcPosition) {
                this.wcPosition = this.wcPosition.split('-');
                this.top = this.wcPosition[0] === 'top' ? 0 : 'auto';
                this.bottom = this.wcPosition[0] === 'bottom' ? 0 : 'auto';
                this.left = this.wcPosition[1] === 'left' ? 0 : 'auto';
                this.right = this.wcPosition[1] === 'right' ? 0 : 'auto';
            } else {
                this.right = 0;
                this.bottom = 0;
            }
        }
    }, {
        key: 'getWatchers',
        value: function getWatchers() {
            this.numWatchers = this.calcWatchers();
            return this.numWatchers;
        }
    }, {
        key: 'calcWatchers',
        value: function calcWatchers() {
            var root = angular.element(document.documentElement);
            var watchers = [];
            function findWatcher(element) {
                angular.forEach(['$scope', '$isolateScope'], function (scopeProperty) {
                    if (element.data() && element.data().hasOwnProperty(scopeProperty)) {
                        angular.forEach(element.data()[scopeProperty].$$watchers, function (watcher) {
                            watchers.push(watcher);
                        });
                    }
                });
                angular.forEach(element.children(), function (childElement) {
                    findWatcher(angular.element(childElement));
                });
            }
            findWatcher(root);
            // Remove duplicate watchers
            var watchersWithoutDuplicates = [];
            angular.forEach(watchers, function (item) {
                if (watchersWithoutDuplicates.indexOf(item) < 0) {
                    watchersWithoutDuplicates.push(item);
                }
            });
            return watchersWithoutDuplicates.length;
        }
    }]);

    return WatchCount;
}();
var WatchCountComponent = {
    bindings: {
        wcPosition: '@'
    },
    controller: WatchCount,
    controllerAs: 'wcCtrl',
    template: watchCountTemplate_default.a
};
/* harmony default export */ var watchCount_component = (WatchCountComponent);
// CONCATENATED MODULE: ./src/watchCount/index.ts


/* harmony default export */ var watchCount = (Object(external__angular_["module"])('rc.watchCount', []).component('rcWatchCount', watchCount_component).name);
// CONCATENATED MODULE: ./src/wizard/wizard.controller.ts
var wizard_controller__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function wizard_controller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 * All navigation and indexes are managed according to 'enabled' steps only.
 */

var wizard_controller_WizardController = function () {
    WizardController.$inject = ['$scope', '$timeout'];

    function WizardController($scope, $timeout) {
        'ngInject';

        wizard_controller__classCallCheck(this, WizardController);

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.allSteps = [];
        this.enabledScopeIds = []; // Tracking mechanism for enabled state changes. Different than enabledSteps.
        this.currentStep = 0;
    }

    wizard_controller__createClass(WizardController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.translations = lib_default.a;
            this.refreshEnabledSteps();
            var unbindStepWatch = this.$scope.$watch(function () {
                return _this.currentStep;
            }, function () {
                return _this.watchHandleStepChange();
            });
            var unbindEnabledWatch = this.$scope.$watchCollection(function () {
                return _this.watchEnabledScopeIds();
            }, function () {
                return _this.refreshEnabledSteps();
            });
            this.$scope.$on('destroy', function () {
                unbindStepWatch();
                unbindEnabledWatch();
            });
            if (typeof this.currentStep === 'undefined') {
                this.currentStep = 0;
            }
        }
    }, {
        key: 'addStep',
        value: function addStep(stepScope) {
            this.allSteps.push(stepScope);
            this.refreshEnabledSteps();
        }
    }, {
        key: 'finish',
        value: function finish() {
            this.triggerStepSubmit();
            if (this.validateStep(this.enabledSteps[this.currentStep]) && Object(external__angular_["isFunction"])(this.onFinish)) {
                this.onFinish();
            }
        }
    }, {
        key: 'nextStep',
        value: function nextStep() {
            this.triggerStepSubmit();
            if (this.validateStep(this.enabledSteps[this.currentStep])) {
                this.setActive(this.currentStep + 1);
            }
        }
    }, {
        key: 'previousStep',
        value: function previousStep() {
            if (this.validateStep(this.enabledSteps[this.currentStep - 1])) {
                this.setActive(this.currentStep - 1);
            }
        }
    }, {
        key: 'refreshEnabledSteps',
        value: function refreshEnabledSteps() {
            this.enabledSteps = this.allSteps.filter(function (step) {
                return !!step.enabled;
            });
        }
    }, {
        key: 'removeStep',
        value: function removeStep(stepScope) {
            this.allSteps.splice(this.allSteps.indexOf(stepScope), 1);
            this.refreshEnabledSteps();
        }
    }, {
        key: 'setActive',
        value: function setActive(index) {
            if (this.enabledSteps[index] && (this.validUpTo(index) || this.currentStep > index)) {
                this.refreshEnabledSteps();
                this.currentStep = index;
            }
        }
    }, {
        key: 'triggerStepSubmit',
        value: function triggerStepSubmit() {
            var step = this.enabledSteps[this.currentStep];
            if (Object(external__angular_["isFunction"])(step.submitStep)) {
                step.submitStep();
            }
        }
    }, {
        key: 'watchHandleStepChange',
        value: function watchHandleStepChange(value) {
            if (Object(external__angular_["isNumber"])(value)) {
                this.setActive(value);
            }
        }
    }, {
        key: 'watchEnabledScopeIds',
        value: function watchEnabledScopeIds() {
            this.enabledScopeIds.length = 0;
            for (var i = 0; i < this.allSteps.length; i++) {
                if (this.allSteps[i].enabled) {
                    this.enabledScopeIds.push(this.allSteps[i].$id);
                }
            }
            return this.enabledScopeIds;
        }
    }, {
        key: 'validateStep',
        value: function validateStep(stepScope) {
            return stepScope && stepScope.nextStep() && stepScope.isValid;
        }
    }, {
        key: 'validUpTo',
        value: function validUpTo(index) {
            for (var i = 0; i < index; i++) {
                if (!this.enabledSteps[i].isValid) {
                    return false;
                }
            }
            return true;
        }
    }]);

    return WizardController;
}();

/* harmony default export */ var wizard_controller = (wizard_controller_WizardController);
// EXTERNAL MODULE: ./src/wizard/templates/wizard.html
var wizard = __webpack_require__(170);
var wizard_default = /*#__PURE__*/__webpack_require__.n(wizard);

// CONCATENATED MODULE: ./src/wizard/wizard.directive.ts
rcWizardDirective.$inject = ['Usage'];


function rcWizardDirective(Usage) {
    'ngInject';

    return {
        restrict: 'EA',
        scope: {
            onFinish: '=?',
            startStep: '=?',
            currentStep: '=?'
        },
        template: wizard_default.a,
        transclude: true,
        controller: 'rcWizardController',
        controllerAs: 'rcWzCtrl',
        bindToController: true,
        compile: rcWizardCompile
    };
    function rcWizardCompile(element, attributes) {
        element.addClass('rc-wizard');
        return rcWizardPostLink;
    }
    function rcWizardPostLink(scope, element, attrs, wizardCtrl) {
        Usage.register('wizard');
        // force a one-time evaluation after all non-ng-if steps have been added
        scope.$evalAsync(function () {
            if (Object(external__angular_["isDefined"])(wizardCtrl.startStep)) {
                wizardCtrl.currentStep = wizardCtrl.startStep;
            }
        });
    }
}
// EXTERNAL MODULE: ./src/wizard/templates/wizard.prev-next.html
var wizard_prev_next = __webpack_require__(171);
var wizard_prev_next_default = /*#__PURE__*/__webpack_require__.n(wizard_prev_next);

// CONCATENATED MODULE: ./src/wizard/wizard.prev-next.component.ts
var wizard_prev_next_component__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function wizard_prev_next_component__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var wizard_prev_next_component_PrevNextController = function () {
    function PrevNextController() {
        wizard_prev_next_component__classCallCheck(this, PrevNextController);
    }

    wizard_prev_next_component__createClass(PrevNextController, [{
        key: '$onInit',
        value: function $onInit() {
            this.back = lib_default.a.get('rc.wizard.back');
            this.next = lib_default.a.get('rc.wizard.next');
            this.submit = lib_default.a.get('rc.wizard.submit');
        }
    }, {
        key: 'isLastStep',
        value: function isLastStep() {
            if (this.rcWizard.enabledSteps && this.rcWizard.enabledSteps.length > 0) {
                return this.rcWizard.enabledSteps[this.rcWizard.enabledSteps.length - 1].isActive();
            } else {
                return false;
            }
        }
    }]);

    return PrevNextController;
}();
/* harmony default export */ var wizard_prev_next_component = ({
    require: {
        rcWizard: '^rcWizard'
    },
    controller: wizard_prev_next_component_PrevNextController,
    template: wizard_prev_next_default.a
});
// EXTERNAL MODULE: ./src/wizard/templates/wizard.step.html
var wizard_step = __webpack_require__(172);
var wizard_step_default = /*#__PURE__*/__webpack_require__.n(wizard_step);

// CONCATENATED MODULE: ./src/wizard/wizard.directive.step.ts
rcWizardStepDirective.$inject = ['$parse', '$timeout'];


function rcWizardStepDirective($parse, $timeout) {
    'ngInject';

    return {
        restrict: 'EA',
        require: '^rcWizard',
        template: wizard_step_default.a,
        transclude: true,
        scope: {
            enabled: '=?',
            heading: '@',
            nextStep: '&?' // This may be confusing due to rcWizardCtrl.nextStep() function. Rename?
        },
        link: rcWizardStepPostLink
    };
    function rcWizardStepPostLink(scope, $element, attrs, wizardCtrl) {
        var form = Object(external__angular_["element"])($element.find('form'));
        // no form = always valid formCtrl
        var formCtrl = form.length ? form.controller('form') : { $valid: true };
        scope.isActive = isActive;
        scope.submitStep = submitStep;
        scope.nextStep = scope.nextStep || truthyNoop;
        scope.enabled = scope.enabled || true;
        scope.$on('$destroy', destroyHandler);
        scope.$watch(watcher, watchHandler); // Validity watcher for next step
        wizardCtrl.addStep(scope);
        function destroyHandler() {
            wizardCtrl.removeStep(scope);
        }
        // Synchronizes manual changes to the currentStep
        function isActive() {
            return wizardCtrl.enabledSteps.indexOf(scope) === wizardCtrl.currentStep;
        }
        function submitStep() {
            if (form.length) {
                $timeout(function () {
                    form.triggerHandler('submit');
                    // Required to display form errors on submission or parent form submission (SID ticket #171713 and related SID #158053)
                    formCtrl.$setSubmitted();
                });
            }
        }
        function watcher() {
            return scope.nextStep() && formCtrl.$valid;
        }
        function watchHandler(isValid) {
            scope.isValid = isValid;
        }
    }
    function truthyNoop() {
        return true;
    }
}
// CONCATENATED MODULE: ./src/wizard/index.ts







/* harmony default export */ var src_wizard = (Object(external__angular_["module"])('rc.wizard', [i18n["a" /* default */], usage["b" /* default */]]).controller('rcWizardController', wizard_controller).directive('rcWizard', rcWizardDirective).component('rcWizardPrevNext', wizard_prev_next_component).directive('rcWizardStep', rcWizardStepDirective).name);
// CONCATENATED MODULE: ./src/component-modules.ts













































/* harmony default export */ var component_modules = __webpack_exports__["default"] = ({
    accordion: src_accordion,
    addRemove: addRemove,
    alert: src_alert,
    alerts: alerts["c" /* default */],
    appTemplate: appTemplate,
    autocomplete: src_autocomplete,
    bindHtml: bindHtml["a" /* default */],
    button: src_button,
    calendar: src_calendar,
    checkbox: src_checkbox,
    clearable: clearable,
    command: src_command,
    compact: compact,
    focus: src_focus,
    groupbox: src_groupbox,
    hoverIntent: hoverIntent,
    hoverStop: hoverStop,
    i18n: i18n["a" /* default */],
    icon: icon,
    infiniteScroll: infiniteScroll["a" /* default */],
    inputFieldWrapper: inputFieldWrapper["a" /* default */],
    keyboardNavigation: keyboardNavigation["a" /* default */],
    listview: listview,
    loading: loading["a" /* default */],
    mediaQuery: mediaQuery["b" /* default */],
    migration: src_migration,
    modal: modal["a" /* default */],
    overlay: overlay["a" /* default */],
    placeholder: placeholder,
    position: position["a" /* default */],
    reauthenticate: reauthenticate["b" /* default */],
    ric2compat: ric2compat,
    scroll: src_scroll,
    seamlessUi: seamlessUi,
    select: src_select,
    smartAnchor: smartAnchor,
    smartMenu: smartMenu,
    table: table["a" /* default */],
    tabs: tabs,
    tooltip: tooltip["a" /* default */],
    usage: usage["b" /* default */],
    utils: utils["a" /* default */],
    validation: validation["c" /* default */],
    watchCount: watchCount,
    wizard: src_wizard
});

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,r){if(true)module.exports=r();else if("function"==typeof define&&define.amd)define([],r);else{var n=r();for(var t in n)("object"==typeof exports?exports:e)[t]=n[t]}}(this,function(){return function(e){function r(t){if(n[t])return n[t].exports;var i=n[t]={exports:{},id:t,loaded:!1};return e[t].call(i.exports,i,i.exports,r),i.loaded=!0,i.exports}var n={};return r.m=e,r.c=n,r.p="./",r(0)}([function(e,r,n){e.exports=n(3)},function(e,r){"use strict";function n(e,r){if(!(e instanceof r))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(r,"__esModule",{value:!0});var t=function(){function e(e,r){var n=[],t=!0,i=!1,o=void 0;try{for(var a,s=e[Symbol.iterator]();!(t=(a=s.next()).done)&&(n.push(a.value),!r||n.length!==r);t=!0);}catch(u){i=!0,o=u}finally{try{!t&&s["return"]&&s["return"]()}finally{if(i)throw o}}return n}return function(r,n){if(Array.isArray(r))return r;if(Symbol.iterator in Object(r))return e(r,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),i=function(){function e(e,r){for(var n=0;n<r.length;n++){var t=r[n];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}return function(r,n,t){return n&&e(r.prototype,n),t&&e(r,t),r}}(),o=function(){function e(r,t,i,o,a){"ngInject";n(this,e),this.$agf=r,this.$rootScope=t,this.$location=i,this.$window=o,this.settings=a,this.$init()}return e.$inject=["$upAngelfish","$rootScope","$location","$window","settings"],i(e,[{key:"$pageview",value:function(e){this.settings.enabled&&this.$agf.pageview({page:e})}},{key:"$settings",value:function(){return this.settings}},{key:"pageview",value:function(){var e=this.$location.absUrl(),r=e.substring(e.indexOf(this.$window.location.pathname));this.$pageview(r)}},{key:"$init",value:function(){var e=this;this.settings.enableOnServerLoad&&this.pageview(),this.$rootScope.$on("$locationChangeSuccess",function(r,n,i){var o=function(){var e=[n,i].map(function(e){return e.split("?")[0]}),r=t(e,2),o=r[0],a=r[1];return o!==a};i&&!o()||e.pageview()})}}]),e}(),a=function(){function e(){n(this,e);var r=!window.jasmine;this.settings={enabled:r,enableOnServerLoad:!0}}return i(e,[{key:"disable",value:function(){this.settings.enabled=!1}},{key:"enable",value:function(){this.settings.enabled=!0}},{key:"disableOnServerLoad",value:function(){this.settings.enableOnServerLoad=!1}},{key:"enableOnServerLoad",value:function(){this.enableOnServerLoadCalled=!0,this.settings.enableOnServerLoad=!0}},{key:"$get",value:["$upAngelfish","$rootScope","$location","$window","$log",function(e,r,n,t,i){"ngInject";return this.enableOnServerLoadCalled&&i.warn("AngelfishAnalyticsProvider.enableOnServerLoad is now on by default.This API will be removed in the next release."),new o(e,r,n,t,this.settings)}]}]),e}();r["default"]=a,e.exports=r["default"]},function(e,r,n){"use strict";function t(e){return e&&e.__esModule?e:{"default":e}}Object.defineProperty(r,"__esModule",{value:!0});var i=n(5),o=t(i);r["default"]=o["default"],e.exports=r["default"]},function(e,r,n){"use strict";function t(e){return e&&e.__esModule?e:{"default":e}}Object.defineProperty(r,"__esModule",{value:!0});var i=n(2),o=t(i),a=n(1),s=t(a);r["default"]=angular.module("uprr-angular-analytics",[]).constant("$upAngelfish",o["default"]).provider("AngelfishAnalytics",s["default"]).run(["AngelfishAnalytics",function(e){}]).name,e.exports=r["default"]},function(e,r){var n=!0,t=null,i=!1;Array.prototype.indexOf||(Array.prototype.indexOf=function(e,r){var n=this.length>>>0,t=Number(r)||0,t=0>t?Math.ceil(t):Math.floor(t);for(0>t&&(t+=n);n>t;t++)if(t in this&&this[t]===e)return t;return-1});var o="040";!function(e,r,a,s,u){function c(e){if(!e||!e.url)return n;var r=escape(e.q?e.q:s.i),r=r+("="+T.visitorId+"."+T.visitStartTime),r=r+("."+f(q.source.replace(/\&/g,""))+"%26"+f(q.medium.replace(/\&/g,""))+"%26"+f(q.campaign.replace(/\&/g,""))+"%26"+f(q.keyword.replace(/\&/g,""))+"%26"+f(q.content.replace(/\&/g,"")));return e.url.indexOf("?")>0?e.url+"&"+r:e.url+"?"+r}function f(e){return encodeURIComponent(decodeURIComponent(e.toString()))}function l(e,r){if(e&&0!==e.length&&"function"==typeof r)for(var n in e)if(e.hasOwnProperty(n)&&r(n)===i)break}function d(e,n,t,i){var o=e+"="+C("auto"!=s.d?s.d:r.domain)+"."+n+";";if(t){if("session"!==t){var a="";i&&(a=new Date,a.setTime(a.getTime()+i*("min"===t?6e4:864e5)),a=a.toUTCString()),o+="expires="+a+";"}}else o+="expires=Thu, 01-Jan-1970 00:00:01 GMT;";s.j&&(o+="path="+s.j+";"),"auto"!=s.d&&(o+="domain="+s.d+";"),r.cookie=o,M[e]=n}function g(){return Math.ceil((new Date).getTime()/1e3)}function m(){var e=(q.keyword||"").replace(/\&/g,""),e=q.ie?e:f(e),e=T.visitorId+"&"+T.visitStartTime+"&"+T.lastActivityTime+"&"+f((q.source||"").replace(/\&/g,""))+"&"+f((q.medium||"").replace(/\&/g,""))+"&"+f((q.campaign||"").replace(/\&/g,""))+"&"+e+"&"+f((q.content||"").replace(/\&/g,""))+"&"+f((T.referrer||"").replace(/\&/g,""))+"&"+f((T.username||"").replace(/\&/g,""));d(s.e.sessionInfo,e,"day",s.w),M[s.e.sessionTimeout]||p()}function p(){d(s.e.sessionTimeout,T.visitorId,"session")}function h(){if(!M[s.e.sessionInfo])return T.visitorType="new",i;var e=M[s.e.sessionInfo].split("&");return"undefined"==e[0]?(T.visitorType="new",i):(T.visitorId=e[0],T.visitorType="returning",T.visitStartTime=parseInt(e[1],10),T.visitId=f(T.visitorId+(T.visitStartTime?T.visitStartTime:g()).toString()),T.lastActivityTime=e[2],T.referrer=e[8],T.username=e[9],q.source=e[3],q.medium=e[4],q.campaign=e[5],q.keyword=e[6],q.content=e[7],M[s.e.userDefined]?(e=M[s.e.userDefined].split("&"),e[0]==T.visitId&&(T.userDefined=e[1])):T.userDefined=t,n)}function v(){if(!P[s.i])return i;var e,r,t,o;return e=P[s.i],r=e.indexOf("."),r>0?(t=e.substring(0,r),o=e.indexOf(".",r+1),o>0?(r=e.substring(r+1,o),e=e.substr(o+1),e=e.split("&"),5!=e.length?i:(T.visitorId=t,T.visitStartTime=r,T.visitId=f(T.visitorId+(parseInt(T.visitStartTime,10)?parseInt(T.visitStartTime,10):g()).toString()),q.source=unescape(e[0]),q.medium=unescape(e[1]),q.campaign=unescape(e[2]),q.keyword=unescape(e[3]),q.content=unescape(e[4]),n)):i):i}function b(){v()||(h()?parseInt(T.lastActivityTime,10)+60*s.o<g()?y():M[s.e.sessionTimeout]||y():y()),T.lastActivityTime=g(),m()}function y(){if(!T.visitorId){var e,r=0;for(e=0;e<$.hostname.length;e++)r+=$.hostname.charCodeAt(e);T.visitorId=f((r+Math.floor(1e8*Math.random())).toString()),p()}T.visitStartTime=g(),T.lastActivityTime=T.visitStartTime,T.visitId=f(T.visitorId+(T.visitStartTime?T.visitStartTime:g()).toString()),T.pageviewCount=0,delete T.username,1===s.u&&q.source||(r=A(),q=r.campaign,T.referrer=r.referrer)}function w(e){if(!e)return{hostname:"",queryParams:[],stem:""};var r,n,t,o="",a=[];return r=e.indexOf("://"),-1===r?{r:i}:(r+=3,n=e.indexOf("/",r),-1===n?(n=e.indexOf("?",r),-1===n?t=e.substring(r):(t=e.substring(r,n),a=e.substring(n+1).split("&"))):(t=e.substring(r,n),r=n+1,n=e.indexOf("?",r),n>-1?(o=e.substring(r,n),a=e.substr(n+1).split("&")):o=e.substr(r)),(r=t.indexOf(":"))>-1&&(t=t.substring(0,r)),{hostname:t,queryParams:a,stem:"/"+o})}function k(e){var r,o,a,u,c,f,d="",g=i;if(!e)return{r:i};var m=w(e);if(a=m.hostname,u=m.queryParams,d=a,a=a.split("."),0===a.length)return{r:i};for(e=0;e<a.length-1;e++)o=a[e],s.f[o]&&(d=e+1<a.length?o+"."+a[e+1]:o,g=n,c=B[o.toLowerCase()]?o.toLowerCase():i,f=i,l(u,function(e){return e=u[e].split("="),c&&e[0]===B[c].B&&(f=e[1].toLowerCase(),r)?i:e[0]===s.f[o]&&(d=o,r=e[1],!c||f)?i:n}),c&&!f&&(f=B[c]["default"]),!r||c&&"utf8"!=f&&"utf-8"!=f||(r=decodeURIComponent(r),f=c=i));return g&&r!=t?(g={r:g,kw:r,hn:d},f&&(g.h=f),g):g&&a.join(".").match(/search\.yahoo\.com$/i)?{r:g,hn:"yahoo",kw:"(not provided)"}:{r:g,hn:m.hostname}}function A(){var n,o,a,u={campaign:{},referrer:""},c=r.referrer.replace(/\+/g,"%20"),f=w(r.referrer.replace(/\+/g,"%20")),l={};for(n in s.g)if(s.g.hasOwnProperty(n)!=i){l[n]=t;for(o in s.g[n])if(s.g[n].hasOwnProperty(o)!=i&&(a=s.g[n][o],P[a])){l[n]=P[a];break}}if(l.source&&l.medium&&l.campaign)u.campaign={source:l.source,medium:l.medium,campaign:l.campaign,keyword:"",content:l.content||""},l.keyword?u.campaign.keyword=l.keyword:(c=k(c),c.r&&"string"==typeof c.kw&&(u.campaign.keyword=c.kw)),u.referrer=f.hostname&&f.hostname==e.location.hostname?"":f.stem;else{if(0===s.sourceOverwrite&&q.source&&q.medium)return{campaign:q,referrer:T.referrer};if(u.referrer=f.hostname&&f.hostname==e.location.hostname?"":f.stem,c=k(c),c.hn&&(c.hn==e.location.hostname||s.d&&"auto"!=s.d&&c.hn.match(RegExp(s.d+"$"))))return q.source||(q.source="direct"),q.medium||(q.medium="(none)"),q.campaign||(q.campaign=""),q.keyword||(q.keyword=""),q.content||(q.content=""),T.referrer||(T.referrer=""),{campaign:q,referrer:T.referrer};c.r&&"google"===c.hn&&"string"==typeof P.gclid?u.campaign={source:"google",medium:"cpc",campaign:"adwords",keyword:c.kw,content:""}:c.r?"string"==typeof c.kw?(u.campaign={source:c.hn,medium:"organic",campaign:"(organic)",keyword:c.kw||"(not provided)",content:""},c.h&&(u.campaign.h=c.h)):u.campaign={source:c.hn,medium:"referral",campaign:"(referral)",keyword:"",content:""}:u.campaign=c.hn?{source:c.hn,medium:"referral",campaign:"(referral)",keyword:"",content:""}:{source:"direct",medium:"(none)",campaign:"",keyword:"",content:""}}return u.campaign.h||(u.campaign.keyword=u.campaign.keyword.toLowerCase()),u}function S(r){var n,i=[];return n="auto"===s.l?$.protocol+"//":s.l?"https://":"http://",n+="auto"==s.n?e.location.host:s.n,n+=s.p,r.vi=T.visitorId,r.vs=T.visitId,r._=Math.floor(1e6*Math.random()),r.v=o,l(s.k,function(e){e=s.k[e],M[e]&&i.push(f(e+"="+M[e]))}),r.ck=i.join(";"),i=t,n+="?"+x(r),n.replace(/%20/g,"+"),n}function x(e){var r=[];return l(e,function(n){e[n]&&("ie"==n||"kw"==n&&e.h?r.push(n+"="+e[n]):r.push(f(n)+"="+f(e[n])))}),r.join("&")}function O(){if(!a||!a.userAgent)return{name:t,version:t};var e,r=a.userAgent,n=a.platform;return(e=r.match(/Windows\sNT\s(\d+\.\d+)/i))&&e.length>0?(r=parseFloat(e[1]),5===r?{name:"Windows",version:2e3}:5.1===r?{name:"Windows",version:"XP"}:5.2===r?{name:"Windows",version:"XP Professional"}:6===r?{name:"Windows",version:"Vista"}:6.1===r?{name:"Windows",version:7}:6.2===r?{name:"Windows",version:8}:6.3===r?{name:"Windows",version:8.1}:10===r?{name:"Windows",version:10}:{name:"Windows",version:r||"-"}):(e=r.match(/Windows\sPhone\s(\d+\.\d+)/i))&&e.length>0?{name:"Windows Phone",version:parseFloat(e[1])}:(e=r.match(/(iPod|iPad|iPhone).*?OS\s([0-9\_]+)/i))&&e.length>0?{name:e[1],version:e[2].replace(/_/g,".")}:r.indexOf("PSP (PlayStation Portable)")>-1?{name:"PSP"}:r.indexOf("PLAYSTATION 3")>-1?{name:"Playstation 3"}:r.toLowerCase().indexOf("xbox")>-1?{name:"XBox"}:r.toLowerCase().indexOf("googletv")>-1?{name:"Google TV"}:(e=r.match(/Android\s(\d+\.\d+)/i))&&e.length>0?(r=parseFloat(e[1]),{name:"Android",version:r}):(e=r.match(/BlackBerry[0-9]{4}[a-zA-Z]?\/([.0-9]+)/i))&&e.length>0?{name:"BlackBerry",version:e[1]}:(e=r.match(/(BlackBerry|BB10).*Version\/([.0-9]+)/i))&&e.length>0?{name:"BlackBerry",version:e[2]}:(e=r.match(/CrOS\s\S+\s([0-9.]+)/i))&&e.length>0?{name:"Chrome OS",version:e[1]}:(e=n.match(/Linux\s(.+)/i))&&e.length>0?{name:"Linux",version:e[1]}:(e=r.match(/Mac OS\s?X ((\d\.?)+)/i))&&e.length>0?{name:"Mac OS X",version:e[1]}:{name:n}}function C(e){function r(e,r){var n,t,i,o,a;return i=2147483648&e,o=2147483648&r,n=1073741824&e,t=1073741824&r,a=(1073741823&e)+(1073741823&r),n&t?2147483648^a^i^o:n|t?1073741824&a?3221225472^a^i^o:1073741824^a^i^o:a^i^o}function n(e,n,t,i,o,a,s){return e=r(e,r(r(n&t|~n&i,o),s)),r(e<<a|e>>>32-a,n)}function t(e,n,t,i,o,a,s){return e=r(e,r(r(n&i|t&~i,o),s)),r(e<<a|e>>>32-a,n)}function i(e,n,t,i,o,a,s){return e=r(e,r(r(n^t^i,o),s)),r(e<<a|e>>>32-a,n)}function o(e,n,t,i,o,a,s){return e=r(e,r(r(t^(n|~i),o),s)),r(e<<a|e>>>32-a,n)}function a(e){var r,n="",t="";for(r=0;3>=r;r++)t=e>>>8*r&255,t="0"+t.toString(16),n+=t.substr(t.length-2,2);return n}var s,u,c,f,l,d,g,m,p=[],e=function(e){for(var e=e.replace(/\r\n/g,"\n"),r="",n=0;n<e.length;n++){var t=e.charCodeAt(n);128>t?r+=String.fromCharCode(t):(t>127&&2048>t?r+=String.fromCharCode(t>>6|192):(r+=String.fromCharCode(t>>12|224),r+=String.fromCharCode(t>>6&63|128)),r+=String.fromCharCode(63&t|128))}return r}(e),p=function(e){var r,n=e.length;r=n+8;for(var t=16*((r-r%64)/64+1),i=Array(t-1),o=0,a=0;n>a;)r=(a-a%4)/4,o=a%4*8,i[r]=i[r]|e.charCodeAt(a)<<o,a++;return r=(a-a%4)/4,i[r]=i[r]|128<<a%4*8,i[t-2]=n<<3,i[t-1]=n>>>29,i}(e);for(l=1732584193,d=4023233417,g=2562383102,m=271733878,e=0;e<p.length;e+=16)s=l,u=d,c=g,f=m,l=n(l,d,g,m,p[e+0],7,3614090360),m=n(m,l,d,g,p[e+1],12,3905402710),g=n(g,m,l,d,p[e+2],17,606105819),d=n(d,g,m,l,p[e+3],22,3250441966),l=n(l,d,g,m,p[e+4],7,4118548399),m=n(m,l,d,g,p[e+5],12,1200080426),g=n(g,m,l,d,p[e+6],17,2821735955),d=n(d,g,m,l,p[e+7],22,4249261313),l=n(l,d,g,m,p[e+8],7,1770035416),m=n(m,l,d,g,p[e+9],12,2336552879),g=n(g,m,l,d,p[e+10],17,4294925233),d=n(d,g,m,l,p[e+11],22,2304563134),l=n(l,d,g,m,p[e+12],7,1804603682),m=n(m,l,d,g,p[e+13],12,4254626195),g=n(g,m,l,d,p[e+14],17,2792965006),d=n(d,g,m,l,p[e+15],22,1236535329),l=t(l,d,g,m,p[e+1],5,4129170786),m=t(m,l,d,g,p[e+6],9,3225465664),g=t(g,m,l,d,p[e+11],14,643717713),d=t(d,g,m,l,p[e+0],20,3921069994),l=t(l,d,g,m,p[e+5],5,3593408605),m=t(m,l,d,g,p[e+10],9,38016083),g=t(g,m,l,d,p[e+15],14,3634488961),d=t(d,g,m,l,p[e+4],20,3889429448),l=t(l,d,g,m,p[e+9],5,568446438),m=t(m,l,d,g,p[e+14],9,3275163606),g=t(g,m,l,d,p[e+3],14,4107603335),d=t(d,g,m,l,p[e+8],20,1163531501),l=t(l,d,g,m,p[e+13],5,2850285829),m=t(m,l,d,g,p[e+2],9,4243563512),g=t(g,m,l,d,p[e+7],14,1735328473),d=t(d,g,m,l,p[e+12],20,2368359562),l=i(l,d,g,m,p[e+5],4,4294588738),m=i(m,l,d,g,p[e+8],11,2272392833),g=i(g,m,l,d,p[e+11],16,1839030562),d=i(d,g,m,l,p[e+14],23,4259657740),l=i(l,d,g,m,p[e+1],4,2763975236),m=i(m,l,d,g,p[e+4],11,1272893353),g=i(g,m,l,d,p[e+7],16,4139469664),d=i(d,g,m,l,p[e+10],23,3200236656),l=i(l,d,g,m,p[e+13],4,681279174),m=i(m,l,d,g,p[e+0],11,3936430074),g=i(g,m,l,d,p[e+3],16,3572445317),d=i(d,g,m,l,p[e+6],23,76029189),l=i(l,d,g,m,p[e+9],4,3654602809),m=i(m,l,d,g,p[e+12],11,3873151461),g=i(g,m,l,d,p[e+15],16,530742520),d=i(d,g,m,l,p[e+2],23,3299628645),l=o(l,d,g,m,p[e+0],6,4096336452),m=o(m,l,d,g,p[e+7],10,1126891415),g=o(g,m,l,d,p[e+14],15,2878612391),d=o(d,g,m,l,p[e+5],21,4237533241),l=o(l,d,g,m,p[e+12],6,1700485571),m=o(m,l,d,g,p[e+3],10,2399980690),g=o(g,m,l,d,p[e+10],15,4293915773),d=o(d,g,m,l,p[e+1],21,2240044497),l=o(l,d,g,m,p[e+8],6,1873313359),m=o(m,l,d,g,p[e+15],10,4264355552),g=o(g,m,l,d,p[e+6],15,2734768916),d=o(d,g,m,l,p[e+13],21,1309151649),l=o(l,d,g,m,p[e+4],6,4149444226),m=o(m,l,d,g,p[e+11],10,3174756917),g=o(g,m,l,d,p[e+2],15,718787259),d=o(d,g,m,l,p[e+9],21,3951481745),l=r(l,s),d=r(d,u),g=r(g,c),m=r(m,f);return(a(l)+a(d)+a(g)+a(m)).toLowerCase()}String.prototype.trim=function(){return this.replace(/^[\s\xA0]+/,"").replace(/[\s\xA0]+$/,"")};var I=n,T={},q={},M={},P={agfoff:0,agf_off:0,gclid:t},$=r.location,j=1,B={baidu:{"default":"gb2312",parameter:"ie"},google:{"default":"utf-8",parameter:"ie"}};e[u]={enable:function(){return I=n},disable:function(){return I=i,n},setUsername:function(e){return"undefined"==typeof e?i:(T.username=e,m(),n)},setTrackingFile:function(e){return e?(s.p=e,n):i},setTrackingHost:function(e){return e?(s.n=e,n):i},setCookiePath:function(e){return e?(s.j=e,n):i},setCookieDomain:function(e){if(!e)return i;s.d=e;var t,o,a=RegExp(C("auto"!=s.d?s.d:r.domain)+"\\.");for(t=r.cookie.split(";"),e=0;e<t.length;e++)if(o=t[e].split("="),2==o.length&&o[1].match(a)){o[1]=o[1].replace(a,"");var u=M,c=o[0].trim();o=o[1].trim(),u[c]=decodeURIComponent(o)}return b(),n},setQueryDelimiter:function(e){return!e||"?"!=e&&"#"!=e?i:(s.m=e,n)},putCookiesInQuery:function(e){return"object"==typeof e&&e.length?(s.k=e,n):i},setHttps:function(e){return"boolean"!=typeof e&&"auto"!=e?i:(s.l=e,n)},addOrganicReferrer:function(e,r){return e&&r?(s.f[e]=r,n):i},removeOrganicReferrer:function(e){return e&&s.f[e]?(delete s.f[e],n):i},addQueryExclude:function(e){return e?(s.s.push(e),n):i},pageview:function(i){"object"!=typeof i&&(i={}),parseInt(T.lastActivityTime,10)+60*s.o<g()&&b();var o,u,c;o=i.page||$.pathname,c=o.indexOf(s.m),c>0&&(o=o.substr(0,c)),(u=s.m)||(u="?"),c="?"==u?"#":"?";var f=i.page||$.href;if(u=f.lastIndexOf(u),u>0?(f=f.substr(u+1),f=f.split(c),c=f[0]):c="",o={t:"pv",pv:o,tt:i.title||r.title,qr:c},"username"in T&&"undefined"!=typeof T.username&&(o.un=T.username),o.vt=T.visitorType,o.udv=T.userDefined,o.rp=T.referrer,o.sc=q.source,o.md=q.medium,o.cp=q.campaign,o.kw=q.keyword,o.cn=q.content,q.ie&&(o.ie=q.ie),c=o,a&&(c.je=a.javaEnabled()?1:0),e&&e.screen&&(c.dp=e.screen.colorDepth,c.sh=e.screen.height,c.sw=e.screen.width),f=c=t,a&&a.userAgent)for(var l=[{source:a.userAgent,a:/BlackBerry[0-9]+.*MIDP/,c:"MIDP",b:"BlackBerry"},{source:a.userAgent,a:/BlackBerry|BB10/,c:"AppleWebKit",b:"BlackBerry"},{source:a.userAgent,a:/Version\/[.0-9]+ Mobile(\/[.A-Za-z0-9]+)? Safari/,c:"Version",b:"Mobile Safari"},{source:a.userAgent,a:/IEMobile\/[.0-9]+/,c:"IEMobile",b:"Internet Explorer Mobile"},{source:a.userAgent,a:/Mobile.+Edge\/[.0-9]+/,c:"Edge",b:"Microsoft Edge Mobile"},{source:a.userAgent,a:/Chrome\/[.0-9]+ Mobile Safari\//,c:"Chrome",b:"Chrome Mobile"},{source:a.userAgent,a:/CriOS\/[.0-9]+ Mobile/,c:"CriOS",b:"Chrome Mobile"},{source:a.userAgent,a:/Opera Mobi\//,c:"Version",b:"Opera Mobile"},{source:a.userAgent,a:/Opera Mini\//,c:"Version",b:"Opera Mini"},{source:a.userAgent,a:/Mobile; rv:[.0-9]+\) Gecko\/[.0-9]+ Firefox\/[.0-9]+/,c:"Firefox",b:"Mobile Firefox"},{source:a.userAgent,a:/Edge\/[.0-9]+/,c:"Edge",b:"Microsoft Edge"},{source:a.userAgent,a:/Chrome\/[.0-9]+ Safari\//,c:"Chrome",b:"Chrome"},{source:a.userAgent,a:/rekonq\/[.0-9]+ Safari\//,c:"rekonq",b:"Rekonq"},{source:a.userAgent,a:/OmniWeb/,c:"OmniWeb/",b:"OmniWeb"},{source:a.userAgent,a:/Version\/[.0-9]+ Safari\//,c:"Version",b:"Safari"},{source:a.userAgent,a:/Opera\/[.0-9]+/,c:"Version",b:"Opera"},{source:a.userAgent,a:/iCab\/[.0-9]+/,c:"iCab",b:"iCab"},{source:a.userAgent,a:/Konqueror\/[.0-9]+/,c:"Konqueror",b:"Konqueror"},{source:a.userAgent,a:/Firefox\/[.0-9]+/,c:"Firefox",b:"Firefox"},{source:a.userAgent,a:/Camino\/[.0-9]+/,c:"Camino",b:"Camino"},{source:a.userAgent,a:/Netscape\/[.0-9]+/,c:"Netscape",b:"Netscape"},{source:a.userAgent,a:/MSIE/,c:"MSIE",b:"Internet Explorer"},{source:a.userAgent,a:/Trident\/[.0-9]+/,c:"rv",b:"Internet Explorer"},{source:a.userAgent,a:/Gecko\/[.0-9]+/,c:"rv",b:"Mozilla"},{source:a.userAgent,a:/YaBrowser\/[.0-9]+/,c:"YaBrowser",b:"Yandex"}],d=0;d<l.length;d++){var p=l[d].source;if(u=l[d].c,p&&p.match(l[d].a)&&(c=l[d].b),c){l=a.userAgent.indexOf(u),-1==l?(l=a.appVersion.indexOf(u),-1!=l&&(f=parseFloat(a.appVersion.substring(l+u.length+1)))):f=parseFloat(a.userAgent.substring(l+u.length+1));break}}return u=O(),o.bn=c,o.bv=f,o.pn=u.name,u.version&&(o.pr=u.version),o.bl=a.language?a.language.toLowerCase():a.userLanguage?a.userLanguage.toLowerCase():"",o.js=j,o.hn=$.hostname||"-",c=o=S(o),I&&(f="undefined"!=typeof XDomainRequest?new XDomainRequest:new XMLHttpRequest,f.open("GET",c.replace(/%20/g,"+")),f.send()),"function"==typeof i.callback&&(c=i.callback,delete i.callback,i.hit=o,c(i)),T.pageviewCount++,T.lastActivityTime=g(),m(),n},setUserDefined:function(e){return"object"==typeof e&&"udv"in e?(void 0===e.udv&&(e.udv=""),T.userDefined=e.udv,e=T.visitId+"&"+f(T.userDefined.replace(/\&/g,"")),d(s.e.userDefined,e,"day",180),n):i},getVisitInfo:function(){return T?T:{}},getMarketingVariables:function(){return q?q:{}},saveMarketingVariables:function(e){return e.source&&(q.source=e.source),e.medium&&(q.medium=e.medium),e.campaign&&(q.campaign=e.campaign),e.keyword&&(q.keyword=e.keyword),e.content&&(q.content=e.content),q.source||(q.source=""),q.medium||(q.medium=""),q.campaign||(q.campaign=""),q.keyword||(q.keyword=""),q.content||(q.content=""),m(),n},resetVisit:function(){return y(),m(),n},setTransferQuery:function(e){return e?(s.i=e,n):i},getTransferUrl:c,transferVisitor:function(r){return r&&r.url?(e.location=c(r),i):n},setJSVersion:function(e){return e&&!isNaN(e)&&e>j?(j=parseFloat(e),n):i}},function(){var e,t,o=$.search.substring(1).split("&"),a=RegExp(C("auto"!=s.d?s.d:r.domain)+"\\."),u=[s.e.sessionInfo,s.e.sessionTimeout,s.e.userDefined];for(t=s.f.split(","),s.f={},e=0;e<t.length;e++){var c=t[e].split(":");s.f[c[0].trim()]=c[1].trim()}for(e=0;e<o.length;e++)t=o[e].split("="),P[t[0]]=decodeURIComponent(t[1]);if(P.A||P.z)return i;for(o=r.cookie.split(";"),e=0;e<o.length;e++)if(t=o[e].split("="),2==t.length&&(-1==u.indexOf(t[0].trim())||t[1].match(a))){t[1]=-1==u.indexOf(t[0].trim())?t[1]:t[1].replace(a,"");var c=M,f=t[0].trim();t=t[1].trim(),c[f]=decodeURIComponent(t)}for(e=[1.1,1.2,1.3,1.4,1.5,1.6,1.7,1.8,1.9],a=0;a<e.length;a++)u=r.getElementsByTagName("script")[0],o=r.createElement("script"),o.setAttribute("Language","Javascript"+e[a]),o.text="agf.setJSVersion("+e[a]+")",u.parentNode.insertBefore(o,u);return n}()&&b()}(window,document,navigator,{p:"/web-analytics/angelfish/agf.png",n:"auto",m:"?",k:[],l:"auto",f:"google:q,yahoo:p,msn:q,aol:q,lycos:query,ask:q,altavista:q,bing:q,netscape:query,cnn:query,looksmart:qt,about:terms,mamma:query,alltheweb:q,gigablast:q,voila:rdata,virgilio:qs,live:q,baidu:wd,alice:qs,yandex:text,najdi:q,club-internet:q,mama:query,seznam:q,search:q,wp:szukaj,onet:qt,netsprint:q,google.interia:q,szukacz:q,yam:k,pchome:q,duckduckgo:q",s:[],g:{source:["agfs"],medium:["agfm"],campaign:["agfc"],keyword:["agfk"],content:["agfr"]},u:0,e:{sessionInfo:"agfs",sessionTimeout:"agft",userDefined:"agfudv"},j:"/",d:"auto",o:30,w:180,i:"agfv"},"agf")},function(e,r,n){n(4);var t=window.agf;delete window.agf,e.exports=t}])});
//# sourceMappingURL=uprr-angular-analytics.js.map

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports = "<div class=\"rc-accordion rc-container\" ng-transclude></div>\n";

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports = "<span class=\"rc-accordion-heading noselect\"\n    tabindex=\"0\"\n    ng-keyup=\"rcAccPnlCtrl.handleEvent($event)\"\n    ng-click=\"rcAccPnlCtrl.handleEvent($event)\"\n    ng-transclude=\"accordionHeading\">{{::rcAccPnlCtrl.heading}}</span>\n<div class=\"rc-accordion-content\" ng-transclude></div>\n\n";

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/commons/debounce.js
function debounce(func, time) {
    var timeout;
    return function () {
        var _this = this;
        var args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            timeout = null;
            func.apply(_this, args);
        }, time);
    };
}


//# sourceMappingURL=debounce.js.map

// CONCATENATED MODULE: ./node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { if (o[n]) i[n] = function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; }; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator];
    return m ? m.call(o) : typeof __values === "function" ? __values(o) : o[Symbol.iterator]();
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/commons/emit.js

var defaultOptions = {
    bubbles: true,
    cancelable: true,
    composed: false
};
/** Bold-face copy from skatejs 5.x */
function emit(element, name, opts) {
    var options = __assign({}, defaultOptions, opts);
    var event;
    if ('composed' in CustomEvent.prototype) {
        event = new CustomEvent(name, options);
    }
    else {
        event = document.createEvent('CustomEvent');
        event.initCustomEvent(name, options.bubbles, options.cancelable, options.detail);
        Object.defineProperty(event, 'composed', { value: options.composed });
    }
    element.dispatchEvent(event);
}


//# sourceMappingURL=emit.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/commons/removeable-listener.js
/**
 * Attaches the listener to the provided EventTarget returning an function that will remove the listener when executed.
 */
function removeableEventListener(element, type, listener) {
    element.addEventListener(type, listener);
    return function () {
        element && element.removeEventListener(type, listener);
    };
}


//# sourceMappingURL=removeable-listener.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/commons/strings.js
function normalizeWhiteSpace(value, replaceWith) {
    return (value &&
        value
            .replace(/(\r\n|\n|\r)/g, ' ')
            .replace(/\s+/g, replaceWith || ' ')
            .trim());
}


//# sourceMappingURL=strings.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/commons/index.js





//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/services/media-query.js
var BREAKPOINTS = {
    SMALL: '0px',
    MEDIUM: '501px',
    LARGE: '751px',
    XLARGE: '1025px',
    XXLARGE: '1201px'
};
var MediaQuery = /** @class */ (function () {
    function MediaQuery() {
    }
    MediaQuery.minWidth = function (query) {
        return window.matchMedia(query).matches;
    };
    MediaQuery.minSize = function (size) {
        if (size) {
            return (pxToNumber(BREAKPOINTS[size.toUpperCase() || 'LARGE']) >=
                pxToNumber(MediaQuery.getCurrentPixels()));
        }
        return false;
    };
    MediaQuery.getCurrentPixels = function () {
        return window.getComputedStyle(document.body, ':before').width;
    };
    return MediaQuery;
}());
function pxToNumber(pixels) {
    return parseInt(pixels, 10);
}


//# sourceMappingURL=media-query.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/services/style-cache.js
var STYLE_CACHE = new Map();
var StyleCache = {
    add: function (cssFileName, value) {
        var entry = STYLE_CACHE.get(cssFileName);
        if (entry) {
            console.error("An entry for " + cssFileName + " already exists in the StyleCache.\n                The filename acts as the key for the component css configuration\n                and should be unique.");
        }
        else {
            STYLE_CACHE.set(cssFileName, value);
        }
    },
    get: function (cssFileName) {
        var entry = STYLE_CACHE.get(cssFileName);
        if (!entry) {
            console.warn("Unable to locate a StyleEntry for " + cssFileName + ".");
        }
        return entry || {};
    }
};


//# sourceMappingURL=style-cache.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/services/window-css.js

var PREFIX = 'up-elements-css';
var ID = PREFIX + "-custom-properties";
var WARNING = "/** DO NOT MODIFY THE CONTENTS: This is a dynamically managed. */";
var PROPS_CACHE = new Map();
function buildStyleTag(identifier, content) {
    var style = document.createElement('style');
    style.type = 'text/css';
    style.setAttribute('id', "" + identifier);
    style.innerHTML = "" + content;
    return style;
}
var window_css_CustomPropertiesManager = /** @class */ (function () {
    function CustomPropertiesManager() {
        var _this = this;
        this._refresh = debounce(function () { return _this._outputUpdatedProps(); }, 10);
    }
    CustomPropertiesManager.prototype.add = function (elementName, properties) {
        var value = properties ? properties.trim() : '';
        if (!PROPS_CACHE.has(elementName) && value.length > 0) {
            PROPS_CACHE.set(elementName, value);
            this._refresh();
        }
    };
    CustomPropertiesManager.prototype._buildPropsList = function () {
        var allProps = '';
        PROPS_CACHE.forEach(function (entry) {
            allProps += entry + '\n';
        });
        return allProps;
    };
    CustomPropertiesManager.prototype._outputUpdatedProps = function () {
        var root = document.head.querySelector("style#" + ID);
        var customProps = WARNING + "\n:root { " + this._buildPropsList() + " }";
        if (!root) {
            root = buildStyleTag(ID, customProps);
            document.head.insertAdjacentElement('afterbegin', root);
        }
        else {
            root.innerHTML = customProps;
        }
    };
    return CustomPropertiesManager;
}());
var StylesheetManager = /** @class */ (function () {
    function StylesheetManager() {
    }
    StylesheetManager.prototype.add = function (elementName, compliantCss) {
        var id = PREFIX + "-" + elementName;
        if (document.head.querySelectorAll("style#" + id).length === 0) {
            var style = buildStyleTag(id, WARNING + "\n" + compliantCss);
            document.head.insertAdjacentElement('afterbegin', style);
        }
    };
    return StylesheetManager;
}());
var WindowCss = {
    customProperties: new window_css_CustomPropertiesManager(),
    stylesheets: new StylesheetManager()
};


//# sourceMappingURL=window-css.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/services/index.js




//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/decorators/custom-element-css.js

function customElementCss(Base, tagName) {
    var proto = Base.prototype;
    var customProperties = WindowCss.customProperties, stylesheets = WindowCss.stylesheets;
    var connectedCallback = proto.connectedCallback;
    // Custom Elements do not isolate css and are added to the page
    Object.defineProperty(proto, 'connectedCallback', {
        configurable: true,
        value: function () {
            var cached = StyleCache.get(tagName);
            if (cached) {
                stylesheets.add(tagName, cached.style);
                customProperties.add(tagName, cached.custProps);
            }
            connectedCallback && connectedCallback.apply(this);
        }
    });
    return Base;
}


//# sourceMappingURL=custom-element-css.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/mixins/activate.js


var ACTIVATED_STATE = 'is-active';
var ACTIVE_STATE_CHANGE_EVENT = 'up-element-active-state-change';
/**
 * Adds a attribute-based approach to determining whether the element is active or not.
 * When active, the 'is-active' attribute is present on the element.
 * @param Base
 */
function ActivateMixin(Base) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.emitActiveStateChange = true;
            return _this;
        }
        Object.defineProperty(class_1.prototype, "isActive", {
            get: function () {
                return this.hasAttribute(ACTIVATED_STATE);
            },
            set: function (isActive) {
                if (isActive !== this.isActive) {
                    if (isActive === true) {
                        this.setAttribute(ACTIVATED_STATE, '');
                    }
                    else {
                        this.removeAttribute(ACTIVATED_STATE);
                    }
                    this.emitActiveStateChange &&
                        emit(this, ACTIVE_STATE_CHANGE_EVENT, {
                            detail: { isActive: isActive }
                        });
                }
            },
            enumerable: true,
            configurable: true
        });
        class_1.prototype.activate = function () {
            this.isActive = true;
        };
        class_1.prototype.deactivate = function () {
            this.isActive = false;
        };
        return class_1;
    }(Base));
}


//# sourceMappingURL=activate.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/mixins/components/with-rendering.js

/**
 * Provides a render cycle which is currently plugged into the skateJS
 * propsChangedCallback method.
 * preRender() -> render() -> postRender()
 * @param Base
 */
function withRendering(Base) {
    var RenderBase = /** @class */ (function (_super) {
        __extends(RenderBase, _super);
        function RenderBase() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(RenderBase.prototype, "_templateRoot", {
            get: function () {
                return this.shadowRoot ? this.shadowRoot : this;
            },
            enumerable: true,
            configurable: true
        });
        //skatejs plugin point
        RenderBase.prototype.propsChangedCallback = function () {
            // @ts-ignore: Property does not exist on parent
            _super.prototype.propsChangedCallback && _super.prototype.propsChangedCallback.call(this);
            this.render();
        };
        RenderBase.prototype.render = function () {
            var _this = this;
            this.preRender && this.preRender();
            this.renderer &&
                this.renderer(this._templateRoot, function () { return _this.template && _this.template(); });
            this.postRender && this.postRender();
        };
        return RenderBase;
    }(Base));
    return RenderBase;
}


//# sourceMappingURL=with-rendering.js.map

// EXTERNAL MODULE: ./node_modules/hyperhtml/min.js
var min = __webpack_require__(118);
var min_default = /*#__PURE__*/__webpack_require__.n(min);

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/mixins/components/renderer-hyperHTML.js


function withHyperHtml(Base) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        // Allows modifying the template for shadowDOM CSS
        class_1.prototype.toHtml = function (template) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            return { template: template, args: args };
        };
        class_1.prototype.renderer = function (root, template) {
            if (!this._hyperBinding) {
                this._hyperBinding = min_default.a.bind(root);
            }
            var output = template();
            this._hyperBinding.apply(this, [output.template].concat(output.args));
        };
        return class_1;
    }(Base));
}


//# sourceMappingURL=renderer-hyperHTML.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/mixins/components/with-shadow.js

/**
 * Automatially adds an open mode shadowRoot
 * @param Base
 */
function withShadowRoot(Base) {
    return /** @class */ (function (_super) {
        __extends(ShadowBase, _super);
        function ShadowBase() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _this = _super.apply(this, args) || this;
            _this.attachShadow({ mode: 'open' });
            return _this;
        }
        return ShadowBase;
    }(Base));
}


//# sourceMappingURL=with-shadow.js.map

// EXTERNAL MODULE: ./node_modules/skatejs/umd/index.js
var umd = __webpack_require__(69);
var umd_default = /*#__PURE__*/__webpack_require__.n(umd);

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/mixins/components/with-props.js

/**
 * Adds the actual implemented methods of the withProp
 * @param Base
 */
function withProperties(Base) {
    return Object(umd["withProps"])(Object(umd["withUnique"])(Base));
}


//# sourceMappingURL=with-props.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/mixins/components/hyper.js





var hyper_HyperComponent = /** @class */ (function (_super) {
    __extends(HyperComponent, _super);
    function HyperComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return HyperComponent;
}(withHyperHtml(withRendering(withShadowRoot(withProperties(HTMLElement))))));


//# sourceMappingURL=hyper.js.map

// CONCATENATED MODULE: ./node_modules/preact/dist/preact.esm.js
/** Virtual DOM Node */
function VNode() {}

/** Global options
 *	@public
 *	@namespace options {Object}
 */
var preact_esm_options = {

	/** If `true`, `prop` changes trigger synchronous component updates.
  *	@name syncComponentUpdates
  *	@type Boolean
  *	@default true
  */
	//syncComponentUpdates: true,

	/** Processes all created VNodes.
  *	@param {VNode} vnode	A newly-created VNode to normalize/process
  */
	//vnode(vnode) { }

	/** Hook invoked after a component is mounted. */
	// afterMount(component) { }

	/** Hook invoked after the DOM is updated with a component's latest render. */
	// afterUpdate(component) { }

	/** Hook invoked immediately before a component is unmounted. */
	// beforeUnmount(component) { }
};

var stack = [];

var EMPTY_CHILDREN = [];

/**
 * JSX/hyperscript reviver.
 * @see http://jasonformat.com/wtf-is-jsx
 * Benchmarks: https://esbench.com/bench/57ee8f8e330ab09900a1a1a0
 *
 * Note: this is exported as both `h()` and `createElement()` for compatibility reasons.
 *
 * Creates a VNode (virtual DOM element). A tree of VNodes can be used as a lightweight representation
 * of the structure of a DOM tree. This structure can be realized by recursively comparing it against
 * the current _actual_ DOM structure, and applying only the differences.
 *
 * `h()`/`createElement()` accepts an element name, a list of attributes/props,
 * and optionally children to append to the element.
 *
 * @example The following DOM tree
 *
 * `<div id="foo" name="bar">Hello!</div>`
 *
 * can be constructed using this function as:
 *
 * `h('div', { id: 'foo', name : 'bar' }, 'Hello!');`
 *
 * @param {string} nodeName	An element name. Ex: `div`, `a`, `span`, etc.
 * @param {Object} attributes	Any attributes/props to set on the created element.
 * @param rest			Additional arguments are taken to be children to append. Can be infinitely nested Arrays.
 *
 * @public
 */
function h(nodeName, attributes) {
	var children = EMPTY_CHILDREN,
	    lastSimple,
	    child,
	    simple,
	    i;
	for (i = arguments.length; i-- > 2;) {
		stack.push(arguments[i]);
	}
	if (attributes && attributes.children != null) {
		if (!stack.length) stack.push(attributes.children);
		delete attributes.children;
	}
	while (stack.length) {
		if ((child = stack.pop()) && child.pop !== undefined) {
			for (i = child.length; i--;) {
				stack.push(child[i]);
			}
		} else {
			if (typeof child === 'boolean') child = null;

			if (simple = typeof nodeName !== 'function') {
				if (child == null) child = '';else if (typeof child === 'number') child = String(child);else if (typeof child !== 'string') simple = false;
			}

			if (simple && lastSimple) {
				children[children.length - 1] += child;
			} else if (children === EMPTY_CHILDREN) {
				children = [child];
			} else {
				children.push(child);
			}

			lastSimple = simple;
		}
	}

	var p = new VNode();
	p.nodeName = nodeName;
	p.children = children;
	p.attributes = attributes == null ? undefined : attributes;
	p.key = attributes == null ? undefined : attributes.key;

	// if a "vnode hook" is defined, pass every created VNode to it
	if (preact_esm_options.vnode !== undefined) preact_esm_options.vnode(p);

	return p;
}

/**
 *  Copy all properties from `props` onto `obj`.
 *  @param {Object} obj		Object onto which properties should be copied.
 *  @param {Object} props	Object from which to copy properties.
 *  @returns obj
 *  @private
 */
function extend(obj, props) {
  for (var i in props) {
    obj[i] = props[i];
  }return obj;
}

/**
 * Call a function asynchronously, as soon as possible. Makes
 * use of HTML Promise to schedule the callback if available,
 * otherwise falling back to `setTimeout` (mainly for IE<11).
 *
 * @param {Function} callback
 */
var defer = typeof Promise == 'function' ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;

/**
 * Clones the given VNode, optionally adding attributes/props and replacing its children.
 * @param {VNode} vnode		The virutal DOM element to clone
 * @param {Object} props	Attributes/props to add when cloning
 * @param {VNode} rest		Any additional arguments will be used as replacement children.
 */
function cloneElement(vnode, props) {
  return h(vnode.nodeName, extend(extend({}, vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
}

// DOM properties that should NOT have "px" added when numeric
var IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;

/** Managed queue of dirty components to be re-rendered */

var items = [];

function enqueueRender(component) {
	if (!component._dirty && (component._dirty = true) && items.push(component) == 1) {
		(preact_esm_options.debounceRendering || defer)(rerender);
	}
}

function rerender() {
	var p,
	    list = items;
	items = [];
	while (p = list.pop()) {
		if (p._dirty) renderComponent(p);
	}
}

/**
 * Check if two nodes are equivalent.
 *
 * @param {Node} node			DOM Node to compare
 * @param {VNode} vnode			Virtual DOM node to compare
 * @param {boolean} [hyrdating=false]	If true, ignores component constructors when comparing.
 * @private
 */
function isSameNodeType(node, vnode, hydrating) {
  if (typeof vnode === 'string' || typeof vnode === 'number') {
    return node.splitText !== undefined;
  }
  if (typeof vnode.nodeName === 'string') {
    return !node._componentConstructor && isNamedNode(node, vnode.nodeName);
  }
  return hydrating || node._componentConstructor === vnode.nodeName;
}

/**
 * Check if an Element has a given nodeName, case-insensitively.
 *
 * @param {Element} node	A DOM Element to inspect the name of.
 * @param {String} nodeName	Unnormalized name to compare against.
 */
function isNamedNode(node, nodeName) {
  return node.normalizedNodeName === nodeName || node.nodeName.toLowerCase() === nodeName.toLowerCase();
}

/**
 * Reconstruct Component-style `props` from a VNode.
 * Ensures default/fallback values from `defaultProps`:
 * Own-properties of `defaultProps` not present in `vnode.attributes` are added.
 *
 * @param {VNode} vnode
 * @returns {Object} props
 */
function getNodeProps(vnode) {
  var props = extend({}, vnode.attributes);
  props.children = vnode.children;

  var defaultProps = vnode.nodeName.defaultProps;
  if (defaultProps !== undefined) {
    for (var i in defaultProps) {
      if (props[i] === undefined) {
        props[i] = defaultProps[i];
      }
    }
  }

  return props;
}

/** Create an element with the given nodeName.
 *	@param {String} nodeName
 *	@param {Boolean} [isSvg=false]	If `true`, creates an element within the SVG namespace.
 *	@returns {Element} node
 */
function createNode(nodeName, isSvg) {
	var node = isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName);
	node.normalizedNodeName = nodeName;
	return node;
}

/** Remove a child node from its parent if attached.
 *	@param {Element} node		The node to remove
 */
function removeNode(node) {
	var parentNode = node.parentNode;
	if (parentNode) parentNode.removeChild(node);
}

/** Set a named attribute on the given Node, with special behavior for some names and event handlers.
 *	If `value` is `null`, the attribute/handler will be removed.
 *	@param {Element} node	An element to mutate
 *	@param {string} name	The name/key to set, such as an event or attribute name
 *	@param {any} old	The last value that was set for this name/node pair
 *	@param {any} value	An attribute value, such as a function to be used as an event handler
 *	@param {Boolean} isSvg	Are we currently diffing inside an svg?
 *	@private
 */
function setAccessor(node, name, old, value, isSvg) {
	if (name === 'className') name = 'class';

	if (name === 'key') {
		// ignore
	} else if (name === 'ref') {
		if (old) old(null);
		if (value) value(node);
	} else if (name === 'class' && !isSvg) {
		node.className = value || '';
	} else if (name === 'style') {
		if (!value || typeof value === 'string' || typeof old === 'string') {
			node.style.cssText = value || '';
		}
		if (value && typeof value === 'object') {
			if (typeof old !== 'string') {
				for (var i in old) {
					if (!(i in value)) node.style[i] = '';
				}
			}
			for (var i in value) {
				node.style[i] = typeof value[i] === 'number' && IS_NON_DIMENSIONAL.test(i) === false ? value[i] + 'px' : value[i];
			}
		}
	} else if (name === 'dangerouslySetInnerHTML') {
		if (value) node.innerHTML = value.__html || '';
	} else if (name[0] == 'o' && name[1] == 'n') {
		var useCapture = name !== (name = name.replace(/Capture$/, ''));
		name = name.toLowerCase().substring(2);
		if (value) {
			if (!old) node.addEventListener(name, eventProxy, useCapture);
		} else {
			node.removeEventListener(name, eventProxy, useCapture);
		}
		(node._listeners || (node._listeners = {}))[name] = value;
	} else if (name !== 'list' && name !== 'type' && !isSvg && name in node) {
		setProperty(node, name, value == null ? '' : value);
		if (value == null || value === false) node.removeAttribute(name);
	} else {
		var ns = isSvg && name !== (name = name.replace(/^xlink\:?/, ''));
		if (value == null || value === false) {
			if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase());else node.removeAttribute(name);
		} else if (typeof value !== 'function') {
			if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase(), value);else node.setAttribute(name, value);
		}
	}
}

/** Attempt to set a DOM property to the given value.
 *	IE & FF throw for certain property-value combinations.
 */
function setProperty(node, name, value) {
	try {
		node[name] = value;
	} catch (e) {}
}

/** Proxy an event to hooked event handlers
 *	@private
 */
function eventProxy(e) {
	return this._listeners[e.type](preact_esm_options.event && preact_esm_options.event(e) || e);
}

/** Queue of components that have been mounted and are awaiting componentDidMount */
var mounts = [];

/** Diff recursion count, used to track the end of the diff cycle. */
var diffLevel = 0;

/** Global flag indicating if the diff is currently within an SVG */
var isSvgMode = false;

/** Global flag indicating if the diff is performing hydration */
var hydrating = false;

/** Invoke queued componentDidMount lifecycle methods */
function flushMounts() {
	var c;
	while (c = mounts.pop()) {
		if (preact_esm_options.afterMount) preact_esm_options.afterMount(c);
		if (c.componentDidMount) c.componentDidMount();
	}
}

/** Apply differences in a given vnode (and it's deep children) to a real DOM Node.
 *	@param {Element} [dom=null]		A DOM node to mutate into the shape of the `vnode`
 *	@param {VNode} vnode			A VNode (with descendants forming a tree) representing the desired DOM structure
 *	@returns {Element} dom			The created/mutated element
 *	@private
 */
function diff(dom, vnode, context, mountAll, parent, componentRoot) {
	// diffLevel having been 0 here indicates initial entry into the diff (not a subdiff)
	if (!diffLevel++) {
		// when first starting the diff, check if we're diffing an SVG or within an SVG
		isSvgMode = parent != null && parent.ownerSVGElement !== undefined;

		// hydration is indicated by the existing element to be diffed not having a prop cache
		hydrating = dom != null && !('__preactattr_' in dom);
	}

	var ret = idiff(dom, vnode, context, mountAll, componentRoot);

	// append the element if its a new parent
	if (parent && ret.parentNode !== parent) parent.appendChild(ret);

	// diffLevel being reduced to 0 means we're exiting the diff
	if (! --diffLevel) {
		hydrating = false;
		// invoke queued componentDidMount lifecycle methods
		if (!componentRoot) flushMounts();
	}

	return ret;
}

/** Internals of `diff()`, separated to allow bypassing diffLevel / mount flushing. */
function idiff(dom, vnode, context, mountAll, componentRoot) {
	var out = dom,
	    prevSvgMode = isSvgMode;

	// empty values (null, undefined, booleans) render as empty Text nodes
	if (vnode == null || typeof vnode === 'boolean') vnode = '';

	// Fast case: Strings & Numbers create/update Text nodes.
	if (typeof vnode === 'string' || typeof vnode === 'number') {

		// update if it's already a Text node:
		if (dom && dom.splitText !== undefined && dom.parentNode && (!dom._component || componentRoot)) {
			/* istanbul ignore if */ /* Browser quirk that can't be covered: https://github.com/developit/preact/commit/fd4f21f5c45dfd75151bd27b4c217d8003aa5eb9 */
			if (dom.nodeValue != vnode) {
				dom.nodeValue = vnode;
			}
		} else {
			// it wasn't a Text node: replace it with one and recycle the old Element
			out = document.createTextNode(vnode);
			if (dom) {
				if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
				recollectNodeTree(dom, true);
			}
		}

		out['__preactattr_'] = true;

		return out;
	}

	// If the VNode represents a Component, perform a component diff:
	var vnodeName = vnode.nodeName;
	if (typeof vnodeName === 'function') {
		return buildComponentFromVNode(dom, vnode, context, mountAll);
	}

	// Tracks entering and exiting SVG namespace when descending through the tree.
	isSvgMode = vnodeName === 'svg' ? true : vnodeName === 'foreignObject' ? false : isSvgMode;

	// If there's no existing element or it's the wrong type, create a new one:
	vnodeName = String(vnodeName);
	if (!dom || !isNamedNode(dom, vnodeName)) {
		out = createNode(vnodeName, isSvgMode);

		if (dom) {
			// move children into the replacement node
			while (dom.firstChild) {
				out.appendChild(dom.firstChild);
			} // if the previous Element was mounted into the DOM, replace it inline
			if (dom.parentNode) dom.parentNode.replaceChild(out, dom);

			// recycle the old element (skips non-Element node types)
			recollectNodeTree(dom, true);
		}
	}

	var fc = out.firstChild,
	    props = out['__preactattr_'],
	    vchildren = vnode.children;

	if (props == null) {
		props = out['__preactattr_'] = {};
		for (var a = out.attributes, i = a.length; i--;) {
			props[a[i].name] = a[i].value;
		}
	}

	// Optimization: fast-path for elements containing a single TextNode:
	if (!hydrating && vchildren && vchildren.length === 1 && typeof vchildren[0] === 'string' && fc != null && fc.splitText !== undefined && fc.nextSibling == null) {
		if (fc.nodeValue != vchildren[0]) {
			fc.nodeValue = vchildren[0];
		}
	}
	// otherwise, if there are existing or new children, diff them:
	else if (vchildren && vchildren.length || fc != null) {
			innerDiffNode(out, vchildren, context, mountAll, hydrating || props.dangerouslySetInnerHTML != null);
		}

	// Apply attributes/props from VNode to the DOM Element:
	diffAttributes(out, vnode.attributes, props);

	// restore previous SVG mode: (in case we're exiting an SVG namespace)
	isSvgMode = prevSvgMode;

	return out;
}

/** Apply child and attribute changes between a VNode and a DOM Node to the DOM.
 *	@param {Element} dom			Element whose children should be compared & mutated
 *	@param {Array} vchildren		Array of VNodes to compare to `dom.childNodes`
 *	@param {Object} context			Implicitly descendant context object (from most recent `getChildContext()`)
 *	@param {Boolean} mountAll
 *	@param {Boolean} isHydrating	If `true`, consumes externally created elements similar to hydration
 */
function innerDiffNode(dom, vchildren, context, mountAll, isHydrating) {
	var originalChildren = dom.childNodes,
	    children = [],
	    keyed = {},
	    keyedLen = 0,
	    min = 0,
	    len = originalChildren.length,
	    childrenLen = 0,
	    vlen = vchildren ? vchildren.length : 0,
	    j,
	    c,
	    f,
	    vchild,
	    child;

	// Build up a map of keyed children and an Array of unkeyed children:
	if (len !== 0) {
		for (var i = 0; i < len; i++) {
			var _child = originalChildren[i],
			    props = _child['__preactattr_'],
			    key = vlen && props ? _child._component ? _child._component.__key : props.key : null;
			if (key != null) {
				keyedLen++;
				keyed[key] = _child;
			} else if (props || (_child.splitText !== undefined ? isHydrating ? _child.nodeValue.trim() : true : isHydrating)) {
				children[childrenLen++] = _child;
			}
		}
	}

	if (vlen !== 0) {
		for (var i = 0; i < vlen; i++) {
			vchild = vchildren[i];
			child = null;

			// attempt to find a node based on key matching
			var key = vchild.key;
			if (key != null) {
				if (keyedLen && keyed[key] !== undefined) {
					child = keyed[key];
					keyed[key] = undefined;
					keyedLen--;
				}
			}
			// attempt to pluck a node of the same type from the existing children
			else if (!child && min < childrenLen) {
					for (j = min; j < childrenLen; j++) {
						if (children[j] !== undefined && isSameNodeType(c = children[j], vchild, isHydrating)) {
							child = c;
							children[j] = undefined;
							if (j === childrenLen - 1) childrenLen--;
							if (j === min) min++;
							break;
						}
					}
				}

			// morph the matched/found/created DOM child to match vchild (deep)
			child = idiff(child, vchild, context, mountAll);

			f = originalChildren[i];
			if (child && child !== dom && child !== f) {
				if (f == null) {
					dom.appendChild(child);
				} else if (child === f.nextSibling) {
					removeNode(f);
				} else {
					dom.insertBefore(child, f);
				}
			}
		}
	}

	// remove unused keyed children:
	if (keyedLen) {
		for (var i in keyed) {
			if (keyed[i] !== undefined) recollectNodeTree(keyed[i], false);
		}
	}

	// remove orphaned unkeyed children:
	while (min <= childrenLen) {
		if ((child = children[childrenLen--]) !== undefined) recollectNodeTree(child, false);
	}
}

/** Recursively recycle (or just unmount) a node and its descendants.
 *	@param {Node} node						DOM node to start unmount/removal from
 *	@param {Boolean} [unmountOnly=false]	If `true`, only triggers unmount lifecycle, skips removal
 */
function recollectNodeTree(node, unmountOnly) {
	var component = node._component;
	if (component) {
		// if node is owned by a Component, unmount that component (ends up recursing back here)
		unmountComponent(component);
	} else {
		// If the node's VNode had a ref function, invoke it with null here.
		// (this is part of the React spec, and smart for unsetting references)
		if (node['__preactattr_'] != null && node['__preactattr_'].ref) node['__preactattr_'].ref(null);

		if (unmountOnly === false || node['__preactattr_'] == null) {
			removeNode(node);
		}

		removeChildren(node);
	}
}

/** Recollect/unmount all children.
 *	- we use .lastChild here because it causes less reflow than .firstChild
 *	- it's also cheaper than accessing the .childNodes Live NodeList
 */
function removeChildren(node) {
	node = node.lastChild;
	while (node) {
		var next = node.previousSibling;
		recollectNodeTree(node, true);
		node = next;
	}
}

/** Apply differences in attributes from a VNode to the given DOM Element.
 *	@param {Element} dom		Element with attributes to diff `attrs` against
 *	@param {Object} attrs		The desired end-state key-value attribute pairs
 *	@param {Object} old			Current/previous attributes (from previous VNode or element's prop cache)
 */
function diffAttributes(dom, attrs, old) {
	var name;

	// remove attributes no longer present on the vnode by setting them to undefined
	for (name in old) {
		if (!(attrs && attrs[name] != null) && old[name] != null) {
			setAccessor(dom, name, old[name], old[name] = undefined, isSvgMode);
		}
	}

	// add new & update changed attributes
	for (name in attrs) {
		if (name !== 'children' && name !== 'innerHTML' && (!(name in old) || attrs[name] !== (name === 'value' || name === 'checked' ? dom[name] : old[name]))) {
			setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
		}
	}
}

/** Retains a pool of Components for re-use, keyed on component name.
 *	Note: since component names are not unique or even necessarily available, these are primarily a form of sharding.
 *	@private
 */
var components = {};

/** Reclaim a component for later re-use by the recycler. */
function collectComponent(component) {
	var name = component.constructor.name;
	(components[name] || (components[name] = [])).push(component);
}

/** Create a component. Normalizes differences between PFC's and classful Components. */
function createComponent(Ctor, props, context) {
	var list = components[Ctor.name],
	    inst;

	if (Ctor.prototype && Ctor.prototype.render) {
		inst = new Ctor(props, context);
		Component.call(inst, props, context);
	} else {
		inst = new Component(props, context);
		inst.constructor = Ctor;
		inst.render = doRender;
	}

	if (list) {
		for (var i = list.length; i--;) {
			if (list[i].constructor === Ctor) {
				inst.nextBase = list[i].nextBase;
				list.splice(i, 1);
				break;
			}
		}
	}
	return inst;
}

/** The `.render()` method for a PFC backing instance. */
function doRender(props, state, context) {
	return this.constructor(props, context);
}

/** Set a component's `props` (generally derived from JSX attributes).
 *	@param {Object} props
 *	@param {Object} [opts]
 *	@param {boolean} [opts.renderSync=false]	If `true` and {@link options.syncComponentUpdates} is `true`, triggers synchronous rendering.
 *	@param {boolean} [opts.render=true]			If `false`, no render will be triggered.
 */
function setComponentProps(component, props, opts, context, mountAll) {
	if (component._disable) return;
	component._disable = true;

	if (component.__ref = props.ref) delete props.ref;
	if (component.__key = props.key) delete props.key;

	if (!component.base || mountAll) {
		if (component.componentWillMount) component.componentWillMount();
	} else if (component.componentWillReceiveProps) {
		component.componentWillReceiveProps(props, context);
	}

	if (context && context !== component.context) {
		if (!component.prevContext) component.prevContext = component.context;
		component.context = context;
	}

	if (!component.prevProps) component.prevProps = component.props;
	component.props = props;

	component._disable = false;

	if (opts !== 0) {
		if (opts === 1 || preact_esm_options.syncComponentUpdates !== false || !component.base) {
			renderComponent(component, 1, mountAll);
		} else {
			enqueueRender(component);
		}
	}

	if (component.__ref) component.__ref(component);
}

/** Render a Component, triggering necessary lifecycle events and taking High-Order Components into account.
 *	@param {Component} component
 *	@param {Object} [opts]
 *	@param {boolean} [opts.build=false]		If `true`, component will build and store a DOM node if not already associated with one.
 *	@private
 */
function renderComponent(component, opts, mountAll, isChild) {
	if (component._disable) return;

	var props = component.props,
	    state = component.state,
	    context = component.context,
	    previousProps = component.prevProps || props,
	    previousState = component.prevState || state,
	    previousContext = component.prevContext || context,
	    isUpdate = component.base,
	    nextBase = component.nextBase,
	    initialBase = isUpdate || nextBase,
	    initialChildComponent = component._component,
	    skip = false,
	    rendered,
	    inst,
	    cbase;

	// if updating
	if (isUpdate) {
		component.props = previousProps;
		component.state = previousState;
		component.context = previousContext;
		if (opts !== 2 && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === false) {
			skip = true;
		} else if (component.componentWillUpdate) {
			component.componentWillUpdate(props, state, context);
		}
		component.props = props;
		component.state = state;
		component.context = context;
	}

	component.prevProps = component.prevState = component.prevContext = component.nextBase = null;
	component._dirty = false;

	if (!skip) {
		rendered = component.render(props, state, context);

		// context to pass to the child, can be updated via (grand-)parent component
		if (component.getChildContext) {
			context = extend(extend({}, context), component.getChildContext());
		}

		var childComponent = rendered && rendered.nodeName,
		    toUnmount,
		    base;

		if (typeof childComponent === 'function') {
			// set up high order component link

			var childProps = getNodeProps(rendered);
			inst = initialChildComponent;

			if (inst && inst.constructor === childComponent && childProps.key == inst.__key) {
				setComponentProps(inst, childProps, 1, context, false);
			} else {
				toUnmount = inst;

				component._component = inst = createComponent(childComponent, childProps, context);
				inst.nextBase = inst.nextBase || nextBase;
				inst._parentComponent = component;
				setComponentProps(inst, childProps, 0, context, false);
				renderComponent(inst, 1, mountAll, true);
			}

			base = inst.base;
		} else {
			cbase = initialBase;

			// destroy high order component link
			toUnmount = initialChildComponent;
			if (toUnmount) {
				cbase = component._component = null;
			}

			if (initialBase || opts === 1) {
				if (cbase) cbase._component = null;
				base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, true);
			}
		}

		if (initialBase && base !== initialBase && inst !== initialChildComponent) {
			var baseParent = initialBase.parentNode;
			if (baseParent && base !== baseParent) {
				baseParent.replaceChild(base, initialBase);

				if (!toUnmount) {
					initialBase._component = null;
					recollectNodeTree(initialBase, false);
				}
			}
		}

		if (toUnmount) {
			unmountComponent(toUnmount);
		}

		component.base = base;
		if (base && !isChild) {
			var componentRef = component,
			    t = component;
			while (t = t._parentComponent) {
				(componentRef = t).base = base;
			}
			base._component = componentRef;
			base._componentConstructor = componentRef.constructor;
		}
	}

	if (!isUpdate || mountAll) {
		mounts.unshift(component);
	} else if (!skip) {
		// Ensure that pending componentDidMount() hooks of child components
		// are called before the componentDidUpdate() hook in the parent.
		// Note: disabled as it causes duplicate hooks, see https://github.com/developit/preact/issues/750
		// flushMounts();

		if (component.componentDidUpdate) {
			component.componentDidUpdate(previousProps, previousState, previousContext);
		}
		if (preact_esm_options.afterUpdate) preact_esm_options.afterUpdate(component);
	}

	if (component._renderCallbacks != null) {
		while (component._renderCallbacks.length) {
			component._renderCallbacks.pop().call(component);
		}
	}

	if (!diffLevel && !isChild) flushMounts();
}

/** Apply the Component referenced by a VNode to the DOM.
 *	@param {Element} dom	The DOM node to mutate
 *	@param {VNode} vnode	A Component-referencing VNode
 *	@returns {Element} dom	The created/mutated element
 *	@private
 */
function buildComponentFromVNode(dom, vnode, context, mountAll) {
	var c = dom && dom._component,
	    originalComponent = c,
	    oldDom = dom,
	    isDirectOwner = c && dom._componentConstructor === vnode.nodeName,
	    isOwner = isDirectOwner,
	    props = getNodeProps(vnode);
	while (c && !isOwner && (c = c._parentComponent)) {
		isOwner = c.constructor === vnode.nodeName;
	}

	if (c && isOwner && (!mountAll || c._component)) {
		setComponentProps(c, props, 3, context, mountAll);
		dom = c.base;
	} else {
		if (originalComponent && !isDirectOwner) {
			unmountComponent(originalComponent);
			dom = oldDom = null;
		}

		c = createComponent(vnode.nodeName, props, context);
		if (dom && !c.nextBase) {
			c.nextBase = dom;
			// passing dom/oldDom as nextBase will recycle it if unused, so bypass recycling on L229:
			oldDom = null;
		}
		setComponentProps(c, props, 1, context, mountAll);
		dom = c.base;

		if (oldDom && dom !== oldDom) {
			oldDom._component = null;
			recollectNodeTree(oldDom, false);
		}
	}

	return dom;
}

/** Remove a component from the DOM and recycle it.
 *	@param {Component} component	The Component instance to unmount
 *	@private
 */
function unmountComponent(component) {
	if (preact_esm_options.beforeUnmount) preact_esm_options.beforeUnmount(component);

	var base = component.base;

	component._disable = true;

	if (component.componentWillUnmount) component.componentWillUnmount();

	component.base = null;

	// recursively tear down & recollect high-order component children:
	var inner = component._component;
	if (inner) {
		unmountComponent(inner);
	} else if (base) {
		if (base['__preactattr_'] && base['__preactattr_'].ref) base['__preactattr_'].ref(null);

		component.nextBase = base;

		removeNode(base);
		collectComponent(component);

		removeChildren(base);
	}

	if (component.__ref) component.__ref(null);
}

/** Base Component class.
 *	Provides `setState()` and `forceUpdate()`, which trigger rendering.
 *	@public
 *
 *	@example
 *	class MyFoo extends Component {
 *		render(props, state) {
 *			return <div />;
 *		}
 *	}
 */
function Component(props, context) {
	this._dirty = true;

	/** @public
  *	@type {object}
  */
	this.context = context;

	/** @public
  *	@type {object}
  */
	this.props = props;

	/** @public
  *	@type {object}
  */
	this.state = this.state || {};
}

extend(Component.prototype, {

	/** Returns a `boolean` indicating if the component should re-render when receiving the given `props` and `state`.
  *	@param {object} nextProps
  *	@param {object} nextState
  *	@param {object} nextContext
  *	@returns {Boolean} should the component re-render
  *	@name shouldComponentUpdate
  *	@function
  */

	/** Update component state by copying properties from `state` to `this.state`.
  *	@param {object} state		A hash of state properties to update with new values
  *	@param {function} callback	A function to be called once component state is updated
  */
	setState: function setState(state, callback) {
		var s = this.state;
		if (!this.prevState) this.prevState = extend({}, s);
		extend(s, typeof state === 'function' ? state(s, this.props) : state);
		if (callback) (this._renderCallbacks = this._renderCallbacks || []).push(callback);
		enqueueRender(this);
	},


	/** Immediately perform a synchronous re-render of the component.
  *	@param {function} callback		A function to be called after component is re-rendered.
  *	@private
  */
	forceUpdate: function forceUpdate(callback) {
		if (callback) (this._renderCallbacks = this._renderCallbacks || []).push(callback);
		renderComponent(this, 2);
	},


	/** Accepts `props` and `state`, and returns a new Virtual DOM tree to build.
  *	Virtual DOM is generally constructed via [JSX](http://jasonformat.com/wtf-is-jsx).
  *	@param {object} props		Props (eg: JSX attributes) received from parent element/component
  *	@param {object} state		The component's current state
  *	@param {object} context		Context object (if a parent component has provided context)
  *	@returns VNode
  */
	render: function render() {}
});

/** Render JSX into a `parent` Element.
 *	@param {VNode} vnode		A (JSX) VNode to render
 *	@param {Element} parent		DOM element to render into
 *	@param {Element} [merge]	Attempt to re-use an existing DOM tree rooted at `merge`
 *	@public
 *
 *	@example
 *	// render a div into <body>:
 *	render(<div id="hello">hello!</div>, document.body);
 *
 *	@example
 *	// render a "Thing" component into #foo:
 *	const Thing = ({ name }) => <span>{ name }</span>;
 *	render(<Thing name="one" />, document.querySelector('#foo'));
 */
function render(vnode, parent, merge) {
  return diff(merge, vnode, {}, false, parent, false);
}

var preact = {
	h: h,
	createElement: h,
	cloneElement: cloneElement,
	Component: Component,
	render: render,
	rerender: rerender,
	options: preact_esm_options
};


/* harmony default export */ var preact_esm = (preact);
//# sourceMappingURL=preact.esm.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/mixins/components/renderer-preact.js


function withPreact(Base) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.renderer = function (root, template) {
            this._preactDom = render(template(), root, this._preactDom || root.children[0]);
        };
        return class_1;
    }(Base));
}


//# sourceMappingURL=renderer-preact.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/mixins/components/preact.js






var preact_PreactComponent = /** @class */ (function (_super) {
    __extends(PreactComponent, _super);
    function PreactComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PreactComponent;
}(withPreact(withRendering(withShadowRoot(withProperties(HTMLElement))))));


//# sourceMappingURL=preact.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/mixins/components/with-component.js



function withComponent(Base) {
    return withRendering(withShadowRoot(withProperties(Base)));
}


//# sourceMappingURL=with-component.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/mixins/components/index.js







//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/mixins/listener-cleanup.js

/**
 * Provides method to register event listeners to elements. When the component is disconnected,
 * all event listeners added through this interface will be removed. Good for classes that add
 * event listeners to elements that are outside itself (i.e. document or window).
 *
 * @param Base
 */
function ListenerCleanupMixin(Base) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this._cleanupActions = [];
            return _this;
        }
        class_1.prototype.addEventHandler = function (element, type, listener) {
            element.addEventListener(type, listener);
            this._cleanupActions.push(function () {
                return element.removeEventListener(type, listener);
            });
        };
        class_1.prototype.disconnectedCallback = function () {
            this._cleanupActions.forEach(function (remover) { return remover(); });
            _super.prototype.disconnectedCallback && _super.prototype.disconnectedCallback.call(this);
        };
        return class_1;
    }(Base));
}


//# sourceMappingURL=listener-cleanup.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/mixins/index.js





//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/decorators/constants.js
var attachShadow = HTMLElement.prototype.attachShadow;
var hasNativeShadowDom = attachShadow && attachShadow.toString().indexOf('native code') > -1;


//# sourceMappingURL=constants.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/decorators/shadow-element-css.js
// FIXME: This should not be in decorators......



function shadowElementCss(Base, tagName) {
    var customProperties = WindowCss.customProperties, stylesheets = WindowCss.stylesheets;
    var proto = Base.prototype;
    var template = proto.template;
    // Native shadowDOM should add CSS to the template directly
    Object.defineProperty(proto, 'template', {
        configurable: true,
        value: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var cached = StyleCache.get(tagName);
            var vdom = template.apply(this, args);
            if (cached) {
                if (hasNativeShadowDom && vdom.children.splice) {
                    vdom.children.splice(0, 0, h('style', {}, cached.shadow));
                }
                else {
                    stylesheets.add(tagName, cached.style);
                }
                customProperties.add(tagName, cached.custProps);
            }
            return vdom;
        }
    });
    return Base;
}


//# sourceMappingURL=shadow-element-css.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/decorators/slot-element.js
function slotElement(Base, slotName) {
    var proto = Base.prototype;
    var connectedCallback = proto.connectedCallback;
    Object.defineProperty(proto, 'connectedCallback', {
        configurable: true,
        value: function () {
            this.setAttribute('slot', slotName);
            connectedCallback && connectedCallback.apply(this);
        }
    });
    return Base;
}


//# sourceMappingURL=slot-element.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/decorators/up-component.js



/**
 * Registers the element and defines the out methodology of the CSS: shadoDOM
 * vs global.
 * @param config
 */
function UPComponent(config) {
    if (config === void 0) { config = {}; }
    return function (Target) {
        var tagName = Target.is;
        if (typeof tagName === 'undefined') {
            throw new Error("The 'is' property must be implemented to identify the element tag.\n                Please implement the static property on " + Target);
        }
        if (typeof config.slotName === 'string') {
            slotElement(Target, config.slotName);
        }
        if (config.shadowDOM === true) {
            shadowElementCss(Target, tagName);
        }
        else {
            customElementCss(Target, tagName);
        }
        // TODO: Possibly debounce in a service to allow object decoration to
        // complete without worrying about decorator order.
        window.customElements.define(tagName, Target);
    };
}


//# sourceMappingURL=up-component.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/decorators/index.js


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/core/index.js





//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/generated.styles.js
/** DO NOT MODIFY. This is a build-generated file. */

StyleCache.add('up-groupbox-header', {
    shadow: 'up-groupbox-header { align-self: flex-top; background-color: var(--groupbox-header-bg-color); border-radius: 0.5rem 0.5rem 0 0; font-weight: bold; line-height: 1; order: 0; overflow: hidden; padding: 0.6em 0.8rem; margin-top: -0.8rem; margin-left: -0.8rem; margin-right: -0.8rem; margin-bottom: 0.8rem; text-overflow: ellipsis; white-space: nowrap; } .compact up-groupbox-header { padding: 0.33em 0.8rem; } up-groupbox[light-styling] > up-groupbox-header { background: none; border-bottom: 1px solid var(--groupbox-header-border-color); }',
    style: 'up-groupbox-header { align-self: flex-top; background-color: #eae1d3; background-color: var(--groupbox-header-bg-color); border-radius: 0.5rem 0.5rem 0 0; font-weight: bold; line-height: 1; order: 0; overflow: hidden; padding: 0.6em 0.8rem; margin-top: -0.8rem; margin-left: -0.8rem; margin-right: -0.8rem; margin-bottom: 0.8rem; text-overflow: ellipsis; white-space: nowrap; } .compact up-groupbox-header { padding: 0.33em 0.8rem; } up-groupbox[light-styling] > up-groupbox-header { background: none; border-bottom: 1px solid #dac9b0; border-bottom: 1px solid var(--groupbox-header-border-color); } @media print, screen and (max-width: 500px) { up-groupbox-header { border-radius: 0; } up-groupbox up-groupbox up-groupbox-header { border-radius: 0.5rem 0.5rem 0 0; } }',
    custProps: '--groupbox-header-bg-color: #eae1d3; --groupbox-header-border-color: #dac9b0;'
});
StyleCache.add('up-groupbox', {
    shadow: 'up-groupbox { border: 1px solid var(--groupbox-border-color); border-radius: 0.5rem; display: flex; flex-direction: column; margin-bottom: 0.8rem; padding: 0.8rem 0.8rem 0 0.8rem; } up-groupbox[light-styling] { border: 0; }',
    style: 'up-groupbox { border: 1px solid #dac9b0; border: 1px solid var(--groupbox-border-color); border-radius: 0.5rem; display: flex; flex-direction: column; margin-bottom: 0.8rem; padding: 0.8rem 0.8rem 0 0.8rem; } up-groupbox[light-styling] { border: 0; } @media print, screen and (max-width: 500px) { up-groupbox { border-radius: 0; margin-left: -0.8rem; margin-right: -0.8rem; border-width: 1px 0; } up-groupbox up-groupbox { margin-left: 0; margin-right: 0; border-width: 1px; border-radius: 0.5rem; } }',
    custProps: '--groupbox-border-color: #dac9b0;'
});

//# sourceMappingURL=generated.styles.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/groupbox-header.js


var groupbox_header_GroupboxHeader = /** @class */ (function (_super) {
    __extends(GroupboxHeader, _super);
    function GroupboxHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(GroupboxHeader, "is", {
        get: function () {
            return 'up-groupbox-header';
        },
        enumerable: true,
        configurable: true
    });
    GroupboxHeader = __decorate([
        UPComponent()
    ], GroupboxHeader);
    return GroupboxHeader;
}(HTMLElement));
/* harmony default export */ var groupbox_header = (groupbox_header_GroupboxHeader);

//# sourceMappingURL=groupbox-header.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/groupbox.js



var groupbox_Groupbox = /** @class */ (function (_super) {
    __extends(Groupbox, _super);
    function Groupbox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Groupbox, "is", {
        get: function () {
            return 'up-groupbox';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Groupbox.prototype, "header", {
        // TODO: Sanitize?
        set: function (header) {
            var current = this.querySelector(groupbox_header.is);
            if (!current) {
                current = document.createElement(groupbox_header.is);
                this.insertAdjacentElement('afterbegin', current);
            }
            current.innerHTML = header;
        },
        enumerable: true,
        configurable: true
    });
    Groupbox.prototype.connectedCallback = function () {
        if (this.hasAttribute('header')) {
            this.header = this.getAttribute('header');
        }
    };
    Groupbox = __decorate([
        UPComponent()
    ], Groupbox);
    return Groupbox;
}(HTMLElement));
/* harmony default export */ var groupbox = (groupbox_Groupbox);

//# sourceMappingURL=groupbox.js.map

// CONCATENATED MODULE: ./node_modules/@up-elements/groupbox/dist/esm/index.js



/* harmony default export */ var esm = __webpack_exports__["default"] = ({
    Groupbox: groupbox,
    GroupboxHeader: groupbox_header
});

//# sourceMappingURL=index.js.map


/***/ }),
/* 118 */
/***/ (function(module, exports) {

var hyperHTML=function(e,t){"use strict";function n(e){return arguments.length<2?null==e?X("html"):"string"==typeof e?i(null,e):"raw"in e?X("html")(e):"nodeType"in e?r(e):Z(e,"html"):("raw"in e?X("html"):i).apply(null,arguments)}function r(e){return c.bind(e)}function i(e,t){return arguments.length<1?X("html"):null==e?X(t||"html"):Z(e,t||"html")}function o(){}function a(e,n){return this.node=e,this.childNodes=n,t.aura(this,n)}function c(e){var t=_e.get(this);return t&&t.template===le(e)?q.apply(t.updates,arguments):F.apply(this,arguments),this}function l(e,t,n){var r,i,o,a=e.ownerElement,c="data"===n,l=!c&&/^on/.test(n),u=c||S(a,n)&&!Y.test(n),s=l?n.slice(2):"",f=u||l,h=u&&(c||n in a);return(l||h)&&(t.push(a,n),l&&(s===fe||s===he?Me.add(a):n.toLowerCase()in a&&(s=s.toLowerCase()))),u&&(h||(o=$e.get(a),o||(o={_:Object.create(null),$:function(){$e.delete(a);for(var e in this._)this._[e].$()}},$e.set(a,o)),o._[n]={_:null,$:function(){h=!0,i(this._)}}),i=function(t){h?r!==t&&(r=t,a[n]!==t&&(null==t?(a[n]=null,a.removeAttribute(n)):a[n]=t)):(e.value=t,o._[n]._=t,n in a&&o.$())}),l?function(e){r!==e&&(r&&a.removeEventListener(s,r,!1),r=e,e&&a.addEventListener(s,e,!1))}:u?i:function(t){r!==t&&(r=t,e.value!==t&&(null==t?f||(f=!0,a.removeAttributeNode(e)):(e.value=t,f&&(f=!1,a.setAttributeNode(e)))))}}function u(e){var t;return function(n){n!==t&&(t=n,e.textContent=n)}}function s(e,t,n){var r;return function i(a){switch(typeof a){case"string":case"number":case"boolean":var c=t.length;1===c&&t[0].nodeType===G?r!==a&&(r=a,t[0].textContent=a):(r=a,c?n.splice(0,c,w(e,a)):t[0]=e.parentNode.insertBefore(w(e,a),e));break;case"function":i(a(e.parentNode,t,0));break;case"object":case"undefined":if(null==a){r=a,i("");break}a instanceof o&&(a=a.render());default:if(r=a,ge(a)){var c=a.length;if(0===c)n.splice(0);else switch(typeof a[0]){case"string":case"number":case"boolean":i({html:a});break;case"function":for(var l=e.parentNode,u=0;u<c;u++)a[u]=a[u](l,t,u);i(a.concat.apply([],a));break;case"object":if(ge(a[0])&&(a=a.concat.apply([],a)),A(a[0])){Promise.all(a).then(i);break}for(var u=0,c=a.length;u<c;u++)a[u]instanceof o&&(a[u]=a[u].render());default:M(n,a)}}else if(k(a))M(n,a.nodeType===K?ue.call(a.childNodes):[a]);else if(A(a))a.then(i);else if("placeholder"in a)C(a,i);else if("text"in a)i(String(a.text));else if("any"in a)i(a.any);else if("html"in a){var s=[].concat(a.html).join("");n.splice(0);var f=m(e,s);t.push.apply(t,f.childNodes),e.parentNode.insertBefore(f,e)}else i("length"in a?ue.call(a):T(a,i))}}}function f(e,t,n){for(var r,i,o,a,c=Object.create(null),l=e.attributes,u=0,s=l.length;u<s;u++)a=l[u],a.value===te&&(r=a.name,r in c?(e.removeAttributeNode(a),c[r].value="",e.setAttributeNode(c[r]),s--,u--):(i=n.shift().replace(/^(?:|[\S\s]*?\s)(\S+?)=['"]?$/,"$1"),o=e.attributes,c[r]=o[i]||o[i.toLowerCase()],t.push(D("attr",c[r],i))))}function h(e,t,n){for(var r,i=e.childNodes,o=i.length,a=0;a<o;a++)switch(r=i[a],r.nodeType){case z:f(r,t,n),h(r,t,n);break;case J:r.textContent===te&&(n.shift(),t.push(D("any",r)));break;case G:ee.test(e.nodeName)&&me.call(r.textContent)===ne&&(n.shift(),t.push(D("text",e)))}}function d(e){return se[e]}function p(e){return{html:e}}function v(e){for(var t,n=[],r=e.childNodes,i=0,o=r.length;i<o;i++)t=r[i],t.nodeType!==z&&0===me.call(t.textContent).length||n.push(t);return 1===n.length?n[0]:n}function g(e){return e.createDocumentFragment()}function m(e,t){return(Q in e?b:y)(e,t.replace(Te,Ae))}function y(e,t){var n,r=e.ownerDocument,i=r.createElement(/<(a-\w+)[\s\S]*?>[\s\S]*?<\/\1>/.test(t)?"div":"template"),o="content"in i,a=!1;if(o||(n=g(r),a=/^[^\S]*?<(col(?:group)?|t(?:head|body|foot|r|d|h))/i.test(t)),a){var c=RegExp.$1;i.innerHTML="<table>"+t+"</table>",Ee(n,ue.call(i.querySelectorAll(c)))}else i.innerHTML=t,o?n=i.content:Ee(n,ue.call(i.childNodes));return n}function b(e,t){var n=e.ownerDocument,r=g(n);if(ae||ce){var i=n.createElement("div");i.innerHTML='<svg xmlns="'+U+'">'+t+"</svg>",Ee(r,ue.call(i.firstChild.childNodes))}else{var i=n.createElementNS(U,"svg");i.innerHTML=t,Ee(r,ue.call(i.childNodes))}return r}function w(e,t){return e.ownerDocument.createTextNode(t)}function N(e,t){for(var n,r,i=t===fe,o=0,a=e.length;o<a;o++)r=e[o],r.nodeType===z&&(n=E(r,i,t,n))}function E(e,t,n,r){if(Me.has(e))e.dispatchEvent(r||(r=new re(n)));else if(t&&$e.has(e))$e.get(e).$();else for(var i=xe(e),o=0,a=i.length;o<a;o++)r=E(i[o],t,n,r);return r}function x(e){var t=n.document,r=t.customElements||t.defaultView.customElements;return r&&r.get(e.nodeName.toLowerCase())}function S(e,t){var n=!(Q in e);if(n&&/-/.test(e.nodeName)){var r=x(e);r&&(e=r.prototype)}return n&&t in e}function C(e,t){t(e.placeholder),"text"in e?Promise.resolve(e.text).then(String).then(t):"any"in e?Promise.resolve(e.any).then(t):"html"in e?Promise.resolve(e.html).then(p).then(t):Promise.resolve(T(e,t)).then(t)}function T(e,t){for(var n,r=0,i=we.length;r<i;r++)if(n=we[r],e.hasOwnProperty(n))return be[n](e[n],t)}function k(e){return"ELEMENT_NODE"in e}function A(e){return null!=e&&"then"in e}function L(e,t){var n="_"+e+"$";return{get:function(){return this[n]||(this[e]=t.call(this,e))},set:function(e){ye(this,n,{configurable:!0,value:e})}}}function M(e,r){var i=0,o=e.length;if(r.length!==o)t(e,r,n.MAX_LIST_SIZE);else for(;i<o--;i++)if(e[o]!==r[o]||e[i]!==r[i])return void t(e,r,n.MAX_LIST_SIZE)}function _(e){for(var t=0,n=e.length;t<n;t++)e[t++].removeAttribute(e[t])}function O(e,t,n,r){var i;switch(e.type){case"any":i=s(t,r,new a(t,r));break;case"attr":i=l(t,n,e.name);break;case"text":i=u(t)}return i}function D(e,t,n){return{type:e,path:B(t),name:n}}function $(e){var t="_"+e.join(ne);return Ne[t]||(Ne[t]=e)}function j(e,t){var n=t.previousSibling;n&&n.nodeType===G&&(e.removeChild(n),j(e,t))}function I(e,t,n){n?e.insertBefore(t,n):e.appendChild(t)}function P(e,t,n,r){for(var i=e,o=e.ownerDocument,a=n.path,c=Se(t,a),l=0,u=a.length;l<u;l++)switch(a[l++]){case"attributes":var s=c.name;e.hasAttribute(s)||e.setAttribute(s,""),i=e.attributes[s];break;case"childNodes":var f=xe(e),h=xe(c.parentNode);i=He(c);var d=i?a.indexOf.call(h,i)+1:-1;i=Pe(c);var p=i?a.indexOf.call(h,i):-1;switch(i=o.createComment(te),!0){case p<0:p=f.length;break;case d<0:d=0;default:p=-(h.length-p)}r.push.apply(r,ue.call(f,d,p)),r.length?I(e,i,Pe(r[r.length-1])):I(e,i,ue.call(f,p)[0]),0===r.length&&j(e,i);break;default:i=xe(e)[a[l]]||e.appendChild(e.ownerDocument.createElement(Se(t,a.slice(0,l+1)).nodeName)),e=i}return i}function H(e,t){for(var n,r,i=[],o=[],a=0,c=t.length;a<c;a++)r=[],n=t[a],i[a]=O(n,P(this,e,n,r),o,r);return _(o),i}function R(e){var t=[],n=m(this,e.join(ne)),r={fragment:n,paths:t};return h(n,t,e.slice()),De.set(e,r),r}function B(e){var t,n=[];switch(e.nodeType){case z:case K:t=e;break;case J:t=e.parentNode,n.unshift("childNodes",n.indexOf.call(t.childNodes,e));break;case V:default:t=e.ownerElement,n.unshift("attributes",e.name)}for(e=t;t=t.parentNode;e=t)n.unshift("children",n.indexOf.call(xe(t),e));return n}function W(e,t){for(var n,r=[],i=[],o=0,a=t.length;o<a;o++)n=t[o],r[o]=O(n,Se(e,n.path),i,[]);return _(i),r}function q(){for(var e=1,t=arguments.length;e<t;e++)this[e-1](arguments[e])}function F(e){e=le(e);var t,n=De.get(e)||R.call(this,e);if(je){var r=Ie(n.fragment);t=W.call(this,r,n.paths),_e.set(this,{template:e,updates:t}),q.apply(t,arguments),this.textContent="",this.appendChild(r)}else t=H.call(this,n.fragment,n.paths),_e.set(this,{template:e,updates:t}),q.apply(t,arguments)}function X(e){function t(t){l=g(t),c="svg"===e?t.createElementNS(U,"svg"):l,u=r(c)}function i(){return s&&(s=!1,"svg"===e&&Ee(l,ue.call(c.childNodes)),a=v(l)),a}var o,a,c,l,u,s,f;return"adopt"===e?function(r){var a=arguments;return r=le(r),f!==r&&(s=!0,f=r,o=function(r,o,f){return s&&(f<o.length?(c=o[f],l={ownerDocument:c.ownerDocument,childNodes:[c],children:[c]},u=n.adopt(l)):(Q in r&&(e="svg"),t(r.ownerDocument))),u.apply(null,a),i()}),o}:function(e){return e=le(e),f!==e&&(s=!0,f=e,t(n.document)),u.apply(null,arguments),i()}}function Z(e,t){var n=Oe.get(e),r=t.indexOf(":"),i=t;return-1<r&&(i=t.slice(r+1),t=t.slice(0,r)||"html"),n||(n={},Oe.set(e,n)),n[i]||(n[i]=X(t))}/*! (c) 2017 Andrea Giammarchi @WebReflection, (ISC) */
n.document=e,n.hyper=n,n.adopt=function(e){return function(){return je=!1,c.apply(e,arguments),je=!0,e}},n.bind=r,n.define=function(e,t){e in be||we.push(e),be[e]=t},n.escape=function(e){return e.replace(/[&<>'"]/g,d)},n.wire=i,n.Component=o,Object.defineProperties(o.prototype,{handleEvent:{value:function(e){var t=e.currentTarget;this["getAttribute"in t&&t.getAttribute("data-call")||"on"+e.type](e)}},html:L("html",X),svg:L("svg",X),state:L("state",function(){return this.defaultState}),defaultState:{get:function(){return{}}},setState:{value:function(e){var t=this.state,n="function"==typeof e?e.call(this,t):e;for(var r in n)t[r]=n[r];this.render()}}});var z=1,V=2,G=3,J=8,K=11,Q="ownerSVGElement",U="http://www.w3.org/2000/svg",Y=/^style$/i,ee=/^style|textarea$/i,te="_hyper: "+(Math.random()*new Date|0)+";",ne="\x3c!--"+te+"--\x3e";a.prototype.splice=function(e){for(var t,n=this.node,r=this.childNodes,i=r[e+(arguments[1]||0)]||n,o=r.splice.apply(r,arguments),a=n.parentNode,c=0,l=o.length;c<l;c++)t=o[c],r.indexOf(t)<0&&a.removeChild(t);if(c=2,l=arguments.length,c<l){if(l-c==1)t=arguments[c];else for(t=g(a.ownerDocument);c<l;)t.appendChild(arguments[c++]);a.insertBefore(t,i)}return o};var re,ie=g(e),oe="object"==typeof navigator&&/Firefox\/(\d+)/.test(navigator.userAgent)&&parseFloat(RegExp.$1)<55,ae=function(){var t=e.createElement("p");return t.innerHTML='<i data-i="" class=""></i>',/class/i.test(t.firstChild.attributes[0].name)}(),ce=!("children"in ie),le=function(e){return(le=e.propertyIsEnumerable("raw")||oe?$:function(e){return e})(e)},ue=[].slice,se={"&":"&amp;","<":"&lt;",">":"&gt;","'":"&#39;",'"':"&quot;"},fe="connected",he="dis"+fe;try{new Event(fe),re=Event}catch(e){re=function(e){var t=n.document.createEvent("Event");return t.initEvent(e,!1,!1),t}}try{new MutationObserver(function(e){for(var t,n=0,r=e.length;n<r;n++)t=e[n],N(t.removedNodes,he),N(t.addedNodes,fe)}).observe(e,{subtree:!0,childList:!0})}catch(t){e.addEventListener("DOMNodeInserted",function(e){N([e.target],fe)},!1),e.addEventListener("DOMNodeRemoved",function(e){N([e.target],he)},!1)}var $,de=typeof WeakMap==typeof de?function(){return{delete:function(e){delete e[te]},get:function(e){return e[te]},has:function(e){return te in e},set:function(e,t){Object.defineProperty(e,te,{configurable:!0,value:t})}}}:WeakMap,pe=typeof WeakSet==typeof pe?function(){var e=new de;return{add:function(t){e.set(t,!0)},has:function(t){return!0===e.get(t)}}}:WeakSet,ve=typeof Map==typeof ve?function(){var e=[],t=[];return{get:function(n){return t[e.indexOf(n)]},set:function(n,r){t[e.push(n)-1]=r}}}:Map,ge=Array.isArray||function(){var e={}.toString,t=e.call([]);return function(n){return e.call(n)===t}}(),me="_hyper: ".trim||function(){return this.replace(/^\s+|\s+$/g,"")},ye=Object.defineProperty,be={},we=[],Ne={},Ee="append"in ie?function(e,t){e.append.apply(e,t)}:function(e,t){for(var n=0,r=t.length;n<r;n++)e.appendChild(t[n])},xe=ce||ae?function(e){for(var t,n=[],r=e.childNodes,i=0,o=0,a=r.length;o<a;o++)t=r[o],t.nodeType===z&&(n[i++]=t);return n}:function(e){return e.children},Se=ae||ce?function(e,t){for(var n,r=0,i=t.length;r<i;r++)switch(n=t[r++]){case"children":e=xe(e)[t[r]];break;default:e=e[n][t[r]]}return e}:function(e,t){for(var n=0,r=t.length;n<r;n++)e=e[t[n++]][t[n]];return e},Ce="[^\\S]+[^ \\f\\n\\r\\t\\/>\"'=]+",Te=new RegExp("(<[a-z]+[a-z0-9:_-]*)((?:"+Ce+"(?:=(?:'.*?'|\".*?\"|<.+?>|\\S+))?)+)([^\\S]*/?>)","gi"),ke=new RegExp("("+Ce+"=)(['\"]?)"+ne+"\\2","gi"),Ae=function(e,t,n,r){return t+n.replace(ke,Le)+r},Le=function(e,t,n){return t+(n||'"')+te+(n||'"')},Me=new pe,_e=new de,Oe=new de,De=new ve,$e=new de,je=!0,Ie=function(){return ie.appendChild(w(ie,"g")),ie.appendChild(w(ie,"")),1===ie.cloneNode(!0).childNodes.length?function(e){for(var t=e.cloneNode(),n=e.childNodes||[],r=0,i=n.length;r<i;r++)t.appendChild(Ie(n[r]));return t}:function(e){return e.cloneNode(!0)}}(),Pe=ae?function(e){for(;e=e.nextSibling;)if(e.nodeType===z)return e}:function(e){return e.nextElementSibling},He=ae?function(e){for(;e=e.previousSibling;)if(e.nodeType===z)return e}:function(e){return e.previousElementSibling};return n.MAX_LIST_SIZE=1e3,n}(document,function(){"use strict";function e(e,n,o){var a=e.length,c=n.length,l=(o||1/0)<Math.sqrt((a||1)*(c||1));return a<1||l?void((c||l)&&e.splice.apply(e,[0,a].concat(n))):c<1?void e.splice(0):void i(e,r(e,n,t(e,n)))}function t(e,t){var n,r,i,o=e.length+1,a=t.length+1,c=o*a,u=0,s=0,f=0,h=0,d=0,p=0,v=new l(c);for(v[0]=0;++u<a;)v[u]=u;for(;++s<o;){for(f=u=0,p=d,d=s*a,v[d+u]=s;++u<a;)n=v[p+u]+1,r=v[d+f]+1,i=v[p+f]+(e[h]==t[f]?0:1),v[d+u]=n<r?n<i?n:i:r<i?r:i,++f;h=s}return v}function n(e,t,n,r,i,o){e.unshift({type:t,x:n,y:r,count:i,items:o})}function r(e,t,r){for(var i,l,u,s,f,h,d=[],p=e.length+1,v=t.length+1,g=p-1,m=v-1;m&&g;)f=g*v+m,h=f-v,i=r[f],l=r[h],u=r[f-1],s=r[h-1],s<=u&&s<=l&&s<=i?(m--,g--,s<i&&n(d,c,m,g,1,[t[m]])):u<=l&&u<=i?(m--,n(d,a,m,g,0,[t[m]])):(g--,n(d,o,m,g,1,[]));for(;m--;)n(d,a,m,g,0,[t[m]]);for(;g--;)n(d,o,m,g,1,[]);return d}function i(e,t){var n,r,i,c=0,l=1,u=t.length;if(u){for(i=r=t[0];l<u;)n=t[l++],r.type===n.type&&n.x-r.x<=1&&n.y-r.y<=1?(i.count+=n.count,i.items=i.items.concat(n.items)):(e.splice.apply(e,[i.y+c,i.count].concat(i.items)),c+=i.type===a?i.items.length:i.type===o?-i.count:0,i=n),r=n;e.splice.apply(e,[i.y+c,i.count].concat(i.items))}}/*! Copyright (c) 2017, Andrea Giammarchi, @WebReflection */
var o="del",a="ins",c="sub",l=/^u/.test(typeof Int32Array)?Array:Int32Array;return e.aura=function(e,t){var n=t.splice;return t.splice=function r(){t.splice=n;var i=e.splice.apply(e,arguments);return t.splice=r,i},t},e}());try{module.exports=hyperHTML}catch(e){}

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = "<up-groupbox>\n    <up-groupbox-header ng-transclude=\"header\">{{::$ctrl.heading}}</up-groupbox-header>\n    <ng-transclude></ng-transclude>\n</up-groupbox>";

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = "<div class=\"small show-for-small-only\" rc-add-remove-small ></div>\n<div class=\"large show-for-medium-up\" rc-add-remove-large ></div>\n";

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n    <div class=\"columns\">\n        <rc-accordion class=\"available\">\n            <rc-accordion-panel is-open=\"true\">\n                <rc-accordion-heading>\n                    <span><rc-translatable-expression i18n-templates=\"addRemove.availableTranslation\"></rc-translatable-expression></span>\n                    <span class=\"badge\" ng-bind=\"addRemove.available.length\"></span>\n                </rc-accordion-heading>\n                <ul rc-listview inset=\"false\" ng-show=\"addRemove.available && addRemove.available.length\">\n                    <li class=\"item\" ng-repeat=\"item in addRemove.available | orderBy:'toString()'\">\n                        <a ng-click=\"addRemove.makeSelected(item)\" ng-bind=\"(item[addRemove.property] || item)\"></a>\n                    </li>\n                </ul>\n                <button class=\"add-all\" ng-click=\"addRemove.addAll()\" ng-show=\"addRemove.available.length\">Add All</button>\n            </rc-accordion-panel>\n        </rc-accordion>\n    </div>\n    <div class=\"columns\">\n        <rc-accordion class=\"selected\">\n            <rc-accordion-panel is-open=\"true\">\n                <rc-accordion-heading>\n                    <span><rc-translatable-expression i18n-templates=\"addRemove.selectedTranslation\"></rc-translatable-expression></span>\n                    <span class=\"badge\" ng-bind=\"addRemove.selected.length\"></span>\n                </rc-accordion-heading>\n                <ul rc-listview inset=\"false\" ng-show=\"addRemove.selected.length\">\n                    <li class=\"item\" ng-repeat=\"item in addRemove.selected | orderBy:'toString()'\">\n                        <a ng-click=\"addRemove.makeAvailable(item)\" ng-bind=\"(item[addRemove.property] || item)\"></a>\n                    </li>\n                </ul>\n                <button class=\"remove-all\" ng-click=\"addRemove.removeAll()\" ng-show=\"addRemove.selected.length\">Remove All</button>\n            </rc-accordion-panel>\n        </rc-accordion>\n    </div>\n</div>\n";

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n    <div class=\"medium-5 columns\">\n        <up-groupbox>\n            <up-groupbox-header>\n                <span><rc-translatable-expression i18n-templates=\"addRemove.availableTranslation\"></rc-translatable-expression></span>\n                <span class=\"badge\" ng-bind=\"addRemove.available.length\"></span>\n            </up-groupbox-header>\n            <select class=\"available\"\n                ng-model=\"addRemove.addRem\"\n                ng-options=\"(item[addRemove.displayProperty] || item) for item in addRemove.available | orderBy:'toString()'\"\n                multiple=\"multiple\"\n                size=\"7\">\n            </select>\n        </up-groupbox>\n    </div>\n    <div class=\"actions medium-2 columns\">\n        <button type=\"button\"\n            class=\"make-selected\"\n            ng-click=\"addRemove.makeAllSelected()\">&#8594;</button>\n        <button type=\"button\"\n            class=\"make-available\"\n            ng-click=\"addRemove.makeAllAvailable()\">&#8592;</button>\n        <button type=\"button\" ng-click=\"addRemove.addAll()\">&#8649;</button>\n        <button type=\"button\" ng-click=\"addRemove.removeAll()\">&#8647;</button>\n    </div>\n    <div class=\"medium-5 columns\">\n        <up-groupbox>\n            <up-groupbox-header>\n                <span><rc-translatable-expression i18n-templates=\"addRemove.selectedTranslation\"></rc-translatable-expression></span>\n                <span class=\"badge\" ng-bind=\"addRemove.selected.length\"></span>\n            </up-groupbox-header>\n            <select class=\"selected\"\n                ng-model=\"addRemove.addSel\"\n                ng-options=\"(item[addRemove.displayProperty] || item) for item in addRemove.selected | orderBy:'toString()'\"\n                multiple=\"multiple\"\n                size=\"7\">\n            </select>\n        </up-groupbox>\n    </div>\n</div>\n";

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = "<div class=\"rc-alert\" ng-class=\"rcAlertCtrl.getAlertClasses()\">\n    <a href class=\"close-button\" ng-click=\"rcAlertCtrl.close()\" ng-if=\"rcAlertCtrl.isClosable()\">&times;</a>\n    <div class=\"details\" ng-transclude></div>\n    <rc-alert-oss tla=\"rcAlertCtrl.ossInfo()\"></rc-alert-oss>\n    <div class=\"icon\">\n        <span ng-class=\"rcAlertCtrl.getTypeClass()\"></span>\n    </div>\n</div>\n";

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = "<div class=\"oss-info\" ng-if=\"rcAlertOssCtrl.display()\">\n    Contact OSS at 1 (800) 621-8953 or (402) 544-5555 Option 1,1\n    <span ng-if=\"rcAlertOssCtrl.isTla()\"> and reference {{ rcAlertOssCtrl.tla() }}.</span>\n</div>\n";

/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports = "<div class=\"wrapper\" ng-class=\"rcAlertsCtrl.getAlertsClasses()\">\n    <rc-alert\n        ng-repeat=\"alert in rcAlertsCtrl.alerts\"\n        type=\"{{ ::alert.type }}\"\n        close-button=\"::alert.closeButton\"\n        timeout=\"{{ alert.timeout }}\"\n        oss-info=\"::alert.tla\"\n        show-icon=\"::alert.icon\"\n        on-close=\"alert.onClose($index)\"\n        focus=\"alert.focus\">\n        <p>\n            <strong ng-if=\"alert.title\" ng-bind=\"::alert.title\"></strong>\n            <span compile=\"true\" rc-bind-html-unsafe=\"::alert.message\"></span>\n        </p>\n    </rc-alert>\n</div>\n";

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports = "<rc-app-template-header\n    app-title=\"$ctrl.appTitle\"\n    page-title=\"$ctrl.pageTitle\"\n    logo-link-url=\"::$ctrl.logoLinkUrl\"\n    enable-logo-link=\"::$ctrl.enableLogoLink\"\n    show-nav-bar=\"::$ctrl.showNavBar\"\n    show-user-id=\"::$ctrl.showUserId\"\n    has-nav-content=\"::$ctrl.doesNavContentExist()\"\n    enable-mini-menu=\"::$ctrl.enableMiniMenu\"\n    i18n=\"::$ctrl.i18n\"\n    logout=\"::$ctrl.logout\">\n    <title-content ng-transclude=\"titleContent\">\n        <rc-app-template-title app-title=\"$ctrl.appTitle\" page-title=\"$ctrl.pageTitle\" ></rc-app-template-title>\n    </title-content>\n    <nav-header ng-transclude=\"navHeader\"></nav-header>\n    <nav-content ng-transclude=\"navContent\">\n        <rc-nav>\n            <div class=\"list-repeat\" ng-repeat=\"content in $ctrl.navContent\">\n                <rc-nested-nav label=\"{{content.label}}\" ng-if=\"$ctrl.isSubnav(content)\">\n                    <span class=\"list-repeat\" ng-repeat=\"subContent in content.sub\">\n                        <rc-nested-nav label=\"{{subContent.label}}\" ng-if=\"$ctrl.isSubnav(subContent)\">\n                            <span class=\"list-repeat\" ng-repeat=\"nestedSubContent in subContent.sub\">\n                                <rc-nav-link\n                                    url=\"{{nestedSubContent.url}}\"\n                                    target=\"{{nestedSubContent.target}}\"\n                                    icon=\"{{nestedSubContent.icon}}\"\n                                    label=\"{{nestedSubContent.label}}\"></rc-nav-link>\n                            </span>\n                        </rc-nested-nav>\n                        <rc-nav-link ng-if=\"!$ctrl.isSubnav(subContent)\"\n                            url=\"{{subContent.url}}\"\n                            target=\"{{subContent.target}}\"\n                            icon=\"{{subContent.icon}}\"\n                            label=\"{{subContent.label}}\"></rc-nav-link>\n                    </span>\n                </rc-nested-nav>\n                <rc-nav-link ng-if=\"!$ctrl.isSubnav(content)\"\n                    url=\"{{content.url}}\"\n                    target=\"{{content.target}}\"\n                    icon=\"{{content.icon}}\"\n                    label=\"{{content.label}}\"></rc-nav-link>\n\n            </div>\n        </rc-nav>\n    </nav-content>\n</rc-app-template-header>\n<main class=\"rc-app-template-body row\">\n    <div class=\"column\">\n        <div ng-transclude></div>\n    </div>\n</main>\n<rc-app-template-footer footer-content=\"::$ctrl.footerContent\" show-footer=\"$ctrl.showFooter\"></rc-app-template-footer>\n";

/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports = "<header class=\"rc-app-template-header icon-app-header\" ng-class=\"{ 'noNav': !$ctrl.showNavBar }\" ng-if=\"!$ctrl.isSUI\">\n    <div class=\"rc-app-template-header-outer-wrapper\">\n        <div class=\"rc-app-template-header-wrapper\">\n            <a class=\"rc-app-template-logo-link\" ng-href=\"{{::$ctrl.logoLinkUrl}}\" ng-if=\"$ctrl.enableLogoLink\">\n                <div class=\"rc-app-template-logo-link-target\"></div>\n            </a>\n            <ng-transclude ng-transclude-slot=\"title\"></ng-transclude>\n            <div class=\"user-id\" ng-if=\"$ctrl.userObj\">\n                <span ng-bind=\"::$ctrl.userObj.userId\"></span>\n            </div>\n            <rc-nav-menus ng-if=\"$ctrl.showNavBar()\" i18n=\"::$ctrl.i18n\" logout=\"::$ctrl.logout\">\n                <nav-header ng-transclude=\"header\"></nav-header>\n                <nav-content ng-transclude=\"content\"></nav-content>\n            </rc-nav-menus>\n        </div>\n    </div>\n</header>\n<rc-nav-menus ng-if=\"$ctrl.showMiniMenu()\" mini-menu i18n=\"::$ctrl.i18n\" logout=\"::$ctrl.logout\">\n    <nav-header ng-transclude=\"header\"></nav-header>\n    <nav-content ng-transclude=\"content\"></nav-content>\n</rc-nav-menus>\n";

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports = "<footer class=\"rc-app-template-footer\" ng-if=\"$ctrl.showFooter && $ctrl.footerContent\">\n    <div>\n        <section>\n            <ul>\n                <li ng-repeat=\"link in $ctrl.footerContent\" ng-switch=\"link.filter && link.filter.length > 0\">\n                    <a ng-href=\"{{ link.url }}\" ng-bind=\"link.label\" ng-attr-target=\"{{ link.target }}\"></a>\n                </li>\n            </ul>\n        </section>\n    </div>\n</footer>\n";

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = "<span ng-bind=\"$ctrl.appTitle\" class=\"application-title\"></span>\n<span ng-bind=\"$ctrl.pageTitle\" class=\"page-title\"></span>\n<ng-transclude class=\"customized-title\"></ng-transclude>";

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(131);
module.exports = 'ngMessages';


/***/ }),
/* 131 */
/***/ (function(module, exports) {

/**
 * @license AngularJS v1.6.6
 * (c) 2010-2017 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

var forEach;
var isArray;
var isString;
var jqLite;

/**
 * @ngdoc module
 * @name ngMessages
 * @description
 *
 * The `ngMessages` module provides enhanced support for displaying messages within templates
 * (typically within forms or when rendering message objects that return key/value data).
 * Instead of relying on JavaScript code and/or complex ng-if statements within your form template to
 * show and hide error messages specific to the state of an input field, the `ngMessages` and
 * `ngMessage` directives are designed to handle the complexity, inheritance and priority
 * sequencing based on the order of how the messages are defined in the template.
 *
 * Currently, the ngMessages module only contains the code for the `ngMessages`, `ngMessagesInclude`
 * `ngMessage` and `ngMessageExp` directives.
 *
 * # Usage
 * The `ngMessages` directive allows keys in a key/value collection to be associated with a child element
 * (or 'message') that will show or hide based on the truthiness of that key's value in the collection. A common use
 * case for `ngMessages` is to display error messages for inputs using the `$error` object exposed by the
 * {@link ngModel ngModel} directive.
 *
 * The child elements of the `ngMessages` directive are matched to the collection keys by a `ngMessage` or
 * `ngMessageExp` directive. The value of these attributes must match a key in the collection that is provided by
 * the `ngMessages` directive.
 *
 * Consider the following example, which illustrates a typical use case of `ngMessages`. Within the form `myForm` we
 * have a text input named `myField` which is bound to the scope variable `field` using the {@link ngModel ngModel}
 * directive.
 *
 * The `myField` field is a required input of type `email` with a maximum length of 15 characters.
 *
 * ```html
 * <form name="myForm">
 *   <label>
 *     Enter text:
 *     <input type="email" ng-model="field" name="myField" required maxlength="15" />
 *   </label>
 *   <div ng-messages="myForm.myField.$error" role="alert">
 *     <div ng-message="required">Please enter a value for this field.</div>
 *     <div ng-message="email">This field must be a valid email address.</div>
 *     <div ng-message="maxlength">This field can be at most 15 characters long.</div>
 *   </div>
 * </form>
 * ```
 *
 * In order to show error messages corresponding to `myField` we first create an element with an `ngMessages` attribute
 * set to the `$error` object owned by the `myField` input in our `myForm` form.
 *
 * Within this element we then create separate elements for each of the possible errors that `myField` could have.
 * The `ngMessage` attribute is used to declare which element(s) will appear for which error - for example,
 * setting `ng-message="required"` specifies that this particular element should be displayed when there
 * is no value present for the required field `myField` (because the key `required` will be `true` in the object
 * `myForm.myField.$error`).
 *
 * ### Message order
 *
 * By default, `ngMessages` will only display one message for a particular key/value collection at any time. If more
 * than one message (or error) key is currently true, then which message is shown is determined by the order of messages
 * in the HTML template code (messages declared first are prioritised). This mechanism means the developer does not have
 * to prioritize messages using custom JavaScript code.
 *
 * Given the following error object for our example (which informs us that the field `myField` currently has both the
 * `required` and `email` errors):
 *
 * ```javascript
 * <!-- keep in mind that ngModel automatically sets these error flags -->
 * myField.$error = { required : true, email: true, maxlength: false };
 * ```
 * The `required` message will be displayed to the user since it appears before the `email` message in the DOM.
 * Once the user types a single character, the `required` message will disappear (since the field now has a value)
 * but the `email` message will be visible because it is still applicable.
 *
 * ### Displaying multiple messages at the same time
 *
 * While `ngMessages` will by default only display one error element at a time, the `ng-messages-multiple` attribute can
 * be applied to the `ngMessages` container element to cause it to display all applicable error messages at once:
 *
 * ```html
 * <!-- attribute-style usage -->
 * <div ng-messages="myForm.myField.$error" ng-messages-multiple>...</div>
 *
 * <!-- element-style usage -->
 * <ng-messages for="myForm.myField.$error" multiple>...</ng-messages>
 * ```
 *
 * ## Reusing and Overriding Messages
 * In addition to prioritization, ngMessages also allows for including messages from a remote or an inline
 * template. This allows for generic collection of messages to be reused across multiple parts of an
 * application.
 *
 * ```html
 * <script type="text/ng-template" id="error-messages">
 *   <div ng-message="required">This field is required</div>
 *   <div ng-message="minlength">This field is too short</div>
 * </script>
 *
 * <div ng-messages="myForm.myField.$error" role="alert">
 *   <div ng-messages-include="error-messages"></div>
 * </div>
 * ```
 *
 * However, including generic messages may not be useful enough to match all input fields, therefore,
 * `ngMessages` provides the ability to override messages defined in the remote template by redefining
 * them within the directive container.
 *
 * ```html
 * <!-- a generic template of error messages known as "my-custom-messages" -->
 * <script type="text/ng-template" id="my-custom-messages">
 *   <div ng-message="required">This field is required</div>
 *   <div ng-message="minlength">This field is too short</div>
 * </script>
 *
 * <form name="myForm">
 *   <label>
 *     Email address
 *     <input type="email"
 *            id="email"
 *            name="myEmail"
 *            ng-model="email"
 *            minlength="5"
 *            required />
 *   </label>
 *   <!-- any ng-message elements that appear BEFORE the ng-messages-include will
 *        override the messages present in the ng-messages-include template -->
 *   <div ng-messages="myForm.myEmail.$error" role="alert">
 *     <!-- this required message has overridden the template message -->
 *     <div ng-message="required">You did not enter your email address</div>
 *
 *     <!-- this is a brand new message and will appear last in the prioritization -->
 *     <div ng-message="email">Your email address is invalid</div>
 *
 *     <!-- and here are the generic error messages -->
 *     <div ng-messages-include="my-custom-messages"></div>
 *   </div>
 * </form>
 * ```
 *
 * In the example HTML code above the message that is set on required will override the corresponding
 * required message defined within the remote template. Therefore, with particular input fields (such
 * email addresses, date fields, autocomplete inputs, etc...), specialized error messages can be applied
 * while more generic messages can be used to handle other, more general input errors.
 *
 * ## Dynamic Messaging
 * ngMessages also supports using expressions to dynamically change key values. Using arrays and
 * repeaters to list messages is also supported. This means that the code below will be able to
 * fully adapt itself and display the appropriate message when any of the expression data changes:
 *
 * ```html
 * <form name="myForm">
 *   <label>
 *     Email address
 *     <input type="email"
 *            name="myEmail"
 *            ng-model="email"
 *            minlength="5"
 *            required />
 *   </label>
 *   <div ng-messages="myForm.myEmail.$error" role="alert">
 *     <div ng-message="required">You did not enter your email address</div>
 *     <div ng-repeat="errorMessage in errorMessages">
 *       <!-- use ng-message-exp for a message whose key is given by an expression -->
 *       <div ng-message-exp="errorMessage.type">{{ errorMessage.text }}</div>
 *     </div>
 *   </div>
 * </form>
 * ```
 *
 * The `errorMessage.type` expression can be a string value or it can be an array so
 * that multiple errors can be associated with a single error message:
 *
 * ```html
 *   <label>
 *     Email address
 *     <input type="email"
 *            ng-model="data.email"
 *            name="myEmail"
 *            ng-minlength="5"
 *            ng-maxlength="100"
 *            required />
 *   </label>
 *   <div ng-messages="myForm.myEmail.$error" role="alert">
 *     <div ng-message-exp="'required'">You did not enter your email address</div>
 *     <div ng-message-exp="['minlength', 'maxlength']">
 *       Your email must be between 5 and 100 characters long
 *     </div>
 *   </div>
 * ```
 *
 * Feel free to use other structural directives such as ng-if and ng-switch to further control
 * what messages are active and when. Be careful, if you place ng-message on the same element
 * as these structural directives, Angular may not be able to determine if a message is active
 * or not. Therefore it is best to place the ng-message on a child element of the structural
 * directive.
 *
 * ```html
 * <div ng-messages="myForm.myEmail.$error" role="alert">
 *   <div ng-if="showRequiredError">
 *     <div ng-message="required">Please enter something</div>
 *   </div>
 * </div>
 * ```
 *
 * ## Animations
 * If the `ngAnimate` module is active within the application then the `ngMessages`, `ngMessage` and
 * `ngMessageExp` directives will trigger animations whenever any messages are added and removed from
 * the DOM by the `ngMessages` directive.
 *
 * Whenever the `ngMessages` directive contains one or more visible messages then the `.ng-active` CSS
 * class will be added to the element. The `.ng-inactive` CSS class will be applied when there are no
 * messages present. Therefore, CSS transitions and keyframes as well as JavaScript animations can
 * hook into the animations whenever these classes are added/removed.
 *
 * Let's say that our HTML code for our messages container looks like so:
 *
 * ```html
 * <div ng-messages="myMessages" class="my-messages" role="alert">
 *   <div ng-message="alert" class="some-message">...</div>
 *   <div ng-message="fail" class="some-message">...</div>
 * </div>
 * ```
 *
 * Then the CSS animation code for the message container looks like so:
 *
 * ```css
 * .my-messages {
 *   transition:1s linear all;
 * }
 * .my-messages.ng-active {
 *   // messages are visible
 * }
 * .my-messages.ng-inactive {
 *   // messages are hidden
 * }
 * ```
 *
 * Whenever an inner message is attached (becomes visible) or removed (becomes hidden) then the enter
 * and leave animation is triggered for each particular element bound to the `ngMessage` directive.
 *
 * Therefore, the CSS code for the inner messages looks like so:
 *
 * ```css
 * .some-message {
 *   transition:1s linear all;
 * }
 *
 * .some-message.ng-enter {}
 * .some-message.ng-enter.ng-enter-active {}
 *
 * .some-message.ng-leave {}
 * .some-message.ng-leave.ng-leave-active {}
 * ```
 *
 * {@link ngAnimate Click here} to learn how to use JavaScript animations or to learn more about ngAnimate.
 */
angular.module('ngMessages', [], function initAngularHelpers() {
  // Access helpers from angular core.
  // Do it inside a `config` block to ensure `window.angular` is available.
  forEach = angular.forEach;
  isArray = angular.isArray;
  isString = angular.isString;
  jqLite = angular.element;
})
  .info({ angularVersion: '1.6.6' })

  /**
   * @ngdoc directive
   * @module ngMessages
   * @name ngMessages
   * @restrict AE
   *
   * @description
   * `ngMessages` is a directive that is designed to show and hide messages based on the state
   * of a key/value object that it listens on. The directive itself complements error message
   * reporting with the `ngModel` $error object (which stores a key/value state of validation errors).
   *
   * `ngMessages` manages the state of internal messages within its container element. The internal
   * messages use the `ngMessage` directive and will be inserted/removed from the page depending
   * on if they're present within the key/value object. By default, only one message will be displayed
   * at a time and this depends on the prioritization of the messages within the template. (This can
   * be changed by using the `ng-messages-multiple` or `multiple` attribute on the directive container.)
   *
   * A remote template can also be used to promote message reusability and messages can also be
   * overridden.
   *
   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-message="stringValue">...</ANY>
   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
   *   <ANY ng-message-exp="expressionValue">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-message when="stringValue">...</ng-message>
   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
   *   <ng-message when-exp="expressionValue">...</ng-message>
   * </ng-messages>
   * ```
   *
   * @param {string} ngMessages an angular expression evaluating to a key/value object
   *                 (this is typically the $error object on an ngModel instance).
   * @param {string=} ngMessagesMultiple|multiple when set, all messages will be displayed with true
   *
   * @example
   * <example name="ngMessages-directive" module="ngMessagesExample"
   *          deps="angular-messages.js"
   *          animations="true" fixBase="true">
   *   <file name="index.html">
   *     <form name="myForm">
   *       <label>
   *         Enter your name:
   *         <input type="text"
   *                name="myName"
   *                ng-model="name"
   *                ng-minlength="5"
   *                ng-maxlength="20"
   *                required />
   *       </label>
   *       <pre>myForm.myName.$error = {{ myForm.myName.$error | json }}</pre>
   *
   *       <div ng-messages="myForm.myName.$error" style="color:maroon" role="alert">
   *         <div ng-message="required">You did not enter a field</div>
   *         <div ng-message="minlength">Your field is too short</div>
   *         <div ng-message="maxlength">Your field is too long</div>
   *       </div>
   *     </form>
   *   </file>
   *   <file name="script.js">
   *     angular.module('ngMessagesExample', ['ngMessages']);
   *   </file>
   * </example>
   */
  .directive('ngMessages', ['$animate', function($animate) {
    var ACTIVE_CLASS = 'ng-active';
    var INACTIVE_CLASS = 'ng-inactive';

    return {
      require: 'ngMessages',
      restrict: 'AE',
      controller: ['$element', '$scope', '$attrs', function NgMessagesCtrl($element, $scope, $attrs) {
        var ctrl = this;
        var latestKey = 0;
        var nextAttachId = 0;

        this.getAttachId = function getAttachId() { return nextAttachId++; };

        var messages = this.messages = {};
        var renderLater, cachedCollection;

        this.render = function(collection) {
          collection = collection || {};

          renderLater = false;
          cachedCollection = collection;

          // this is true if the attribute is empty or if the attribute value is truthy
          var multiple = isAttrTruthy($scope, $attrs.ngMessagesMultiple) ||
                         isAttrTruthy($scope, $attrs.multiple);

          var unmatchedMessages = [];
          var matchedKeys = {};
          var messageItem = ctrl.head;
          var messageFound = false;
          var totalMessages = 0;

          // we use != instead of !== to allow for both undefined and null values
          while (messageItem != null) {
            totalMessages++;
            var messageCtrl = messageItem.message;

            var messageUsed = false;
            if (!messageFound) {
              forEach(collection, function(value, key) {
                if (!messageUsed && truthy(value) && messageCtrl.test(key)) {
                  // this is to prevent the same error name from showing up twice
                  if (matchedKeys[key]) return;
                  matchedKeys[key] = true;

                  messageUsed = true;
                  messageCtrl.attach();
                }
              });
            }

            if (messageUsed) {
              // unless we want to display multiple messages then we should
              // set a flag here to avoid displaying the next message in the list
              messageFound = !multiple;
            } else {
              unmatchedMessages.push(messageCtrl);
            }

            messageItem = messageItem.next;
          }

          forEach(unmatchedMessages, function(messageCtrl) {
            messageCtrl.detach();
          });

          if (unmatchedMessages.length !== totalMessages) {
            $animate.setClass($element, ACTIVE_CLASS, INACTIVE_CLASS);
          } else {
            $animate.setClass($element, INACTIVE_CLASS, ACTIVE_CLASS);
          }
        };

        $scope.$watchCollection($attrs.ngMessages || $attrs['for'], ctrl.render);

        // If the element is destroyed, proactively destroy all the currently visible messages
        $element.on('$destroy', function() {
          forEach(messages, function(item) {
            item.message.detach();
          });
        });

        this.reRender = function() {
          if (!renderLater) {
            renderLater = true;
            $scope.$evalAsync(function() {
              if (renderLater && cachedCollection) {
                ctrl.render(cachedCollection);
              }
            });
          }
        };

        this.register = function(comment, messageCtrl) {
          var nextKey = latestKey.toString();
          messages[nextKey] = {
            message: messageCtrl
          };
          insertMessageNode($element[0], comment, nextKey);
          comment.$$ngMessageNode = nextKey;
          latestKey++;

          ctrl.reRender();
        };

        this.deregister = function(comment) {
          var key = comment.$$ngMessageNode;
          delete comment.$$ngMessageNode;
          removeMessageNode($element[0], comment, key);
          delete messages[key];
          ctrl.reRender();
        };

        function findPreviousMessage(parent, comment) {
          var prevNode = comment;
          var parentLookup = [];

          while (prevNode && prevNode !== parent) {
            var prevKey = prevNode.$$ngMessageNode;
            if (prevKey && prevKey.length) {
              return messages[prevKey];
            }

            // dive deeper into the DOM and examine its children for any ngMessage
            // comments that may be in an element that appears deeper in the list
            if (prevNode.childNodes.length && parentLookup.indexOf(prevNode) === -1) {
              parentLookup.push(prevNode);
              prevNode = prevNode.childNodes[prevNode.childNodes.length - 1];
            } else if (prevNode.previousSibling) {
              prevNode = prevNode.previousSibling;
            } else {
              prevNode = prevNode.parentNode;
              parentLookup.push(prevNode);
            }
          }
        }

        function insertMessageNode(parent, comment, key) {
          var messageNode = messages[key];
          if (!ctrl.head) {
            ctrl.head = messageNode;
          } else {
            var match = findPreviousMessage(parent, comment);
            if (match) {
              messageNode.next = match.next;
              match.next = messageNode;
            } else {
              messageNode.next = ctrl.head;
              ctrl.head = messageNode;
            }
          }
        }

        function removeMessageNode(parent, comment, key) {
          var messageNode = messages[key];

          var match = findPreviousMessage(parent, comment);
          if (match) {
            match.next = messageNode.next;
          } else {
            ctrl.head = messageNode.next;
          }
        }
      }]
    };

    function isAttrTruthy(scope, attr) {
     return (isString(attr) && attr.length === 0) || //empty attribute
            truthy(scope.$eval(attr));
    }

    function truthy(val) {
      return isString(val) ? val.length : !!val;
    }
  }])

  /**
   * @ngdoc directive
   * @name ngMessagesInclude
   * @restrict AE
   * @scope
   *
   * @description
   * `ngMessagesInclude` is a directive with the purpose to import existing ngMessage template
   * code from a remote template and place the downloaded template code into the exact spot
   * that the ngMessagesInclude directive is placed within the ngMessages container. This allows
   * for a series of pre-defined messages to be reused and also allows for the developer to
   * determine what messages are overridden due to the placement of the ngMessagesInclude directive.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-messages-include="remoteTplString">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-messages-include src="expressionValue1">...</ng-messages-include>
   * </ng-messages>
   * ```
   *
   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
   *
   * @param {string} ngMessagesInclude|src a string value corresponding to the remote template.
   */
  .directive('ngMessagesInclude',
    ['$templateRequest', '$document', '$compile', function($templateRequest, $document, $compile) {

    return {
      restrict: 'AE',
      require: '^^ngMessages', // we only require this for validation sake
      link: function($scope, element, attrs) {
        var src = attrs.ngMessagesInclude || attrs.src;
        $templateRequest(src).then(function(html) {
          if ($scope.$$destroyed) return;

          if (isString(html) && !html.trim()) {
            // Empty template - nothing to compile
            replaceElementWithMarker(element, src);
          } else {
            // Non-empty template - compile and link
            $compile(html)($scope, function(contents) {
              element.after(contents);
              replaceElementWithMarker(element, src);
            });
          }
        });
      }
    };

    // Helpers
    function replaceElementWithMarker(element, src) {
      // A comment marker is placed for debugging purposes
      var comment = $compile.$$createComment ?
          $compile.$$createComment('ngMessagesInclude', src) :
          $document[0].createComment(' ngMessagesInclude: ' + src + ' ');
      var marker = jqLite(comment);
      element.after(marker);

      // Don't pollute the DOM anymore by keeping an empty directive element
      element.remove();
    }
  }])

  /**
   * @ngdoc directive
   * @name ngMessage
   * @restrict AE
   * @scope
   *
   * @description
   * `ngMessage` is a directive with the purpose to show and hide a particular message.
   * For `ngMessage` to operate, a parent `ngMessages` directive on a parent DOM element
   * must be situated since it determines which messages are visible based on the state
   * of the provided key/value map that `ngMessages` listens on.
   *
   * More information about using `ngMessage` can be found in the
   * {@link module:ngMessages `ngMessages` module documentation}.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-message="stringValue">...</ANY>
   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-message when="stringValue">...</ng-message>
   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
   * </ng-messages>
   * ```
   *
   * @param {expression} ngMessage|when a string value corresponding to the message key.
   */
  .directive('ngMessage', ngMessageDirectiveFactory())


  /**
   * @ngdoc directive
   * @name ngMessageExp
   * @restrict AE
   * @priority 1
   * @scope
   *
   * @description
   * `ngMessageExp` is the same as {@link directive:ngMessage `ngMessage`}, but instead of a static
   * value, it accepts an expression to be evaluated for the message key.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression">
   *   <ANY ng-message-exp="expressionValue">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression">
   *   <ng-message when-exp="expressionValue">...</ng-message>
   * </ng-messages>
   * ```
   *
   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
   *
   * @param {expression} ngMessageExp|whenExp an expression value corresponding to the message key.
   */
  .directive('ngMessageExp', ngMessageDirectiveFactory());

function ngMessageDirectiveFactory() {
  return ['$animate', function($animate) {
    return {
      restrict: 'AE',
      transclude: 'element',
      priority: 1, // must run before ngBind, otherwise the text is set on the comment
      terminal: true,
      require: '^^ngMessages',
      link: function(scope, element, attrs, ngMessagesCtrl, $transclude) {
        var commentNode = element[0];

        var records;
        var staticExp = attrs.ngMessage || attrs.when;
        var dynamicExp = attrs.ngMessageExp || attrs.whenExp;
        var assignRecords = function(items) {
          records = items
              ? (isArray(items)
                  ? items
                  : items.split(/[\s,]+/))
              : null;
          ngMessagesCtrl.reRender();
        };

        if (dynamicExp) {
          assignRecords(scope.$eval(dynamicExp));
          scope.$watchCollection(dynamicExp, assignRecords);
        } else {
          assignRecords(staticExp);
        }

        var currentElement, messageCtrl;
        ngMessagesCtrl.register(commentNode, messageCtrl = {
          test: function(name) {
            return contains(records, name);
          },
          attach: function() {
            if (!currentElement) {
              $transclude(function(elm, newScope) {
                $animate.enter(elm, null, element);
                currentElement = elm;

                // Each time we attach this node to a message we get a new id that we can match
                // when we are destroying the node later.
                var $$attachId = currentElement.$$attachId = ngMessagesCtrl.getAttachId();

                // in the event that the element or a parent element is destroyed
                // by another structural directive then it's time
                // to deregister the message from the controller
                currentElement.on('$destroy', function() {
                  if (currentElement && currentElement.$$attachId === $$attachId) {
                    ngMessagesCtrl.deregister(commentNode);
                    messageCtrl.detach();
                  }
                  newScope.$destroy();
                });
              });
            }
          },
          detach: function() {
            if (currentElement) {
              var elm = currentElement;
              currentElement = null;
              $animate.leave(elm);
            }
          }
        });
      }
    };
  }];

  function contains(collection, key) {
    if (collection) {
      return isArray(collection)
          ? collection.indexOf(key) >= 0
          : collection.hasOwnProperty(key);
    }
  }
}


})(window, window.angular);


/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports = "<rc-alert class=\"rc-form-errors\" type=\"error\" close-button=\"false\" ng-show=\"rcFormErrors.showErrors\">\n    <h2 class=\"rc-form-errors-header\">\n        <rc-translatable-expression\n            i18n-templates=\"rcFormErrors.headerTranslations\"></rc-translatable-expression>\n    </h2>\n    <div class=\"rc-form-errors-container\">\n    </div>\n</rc-alert>\n";

/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports = "<ul class=\"rc-input-field-errors-list\"\n    ng-class=\"{ 'rc-input-field-errors-clickable': inputFieldErrors.clickable }\"\n    ng-messages=\"inputFieldErrors.ngModelController.$error\"\n    ng-if=\"inputFieldErrors.showErrors\"\n    ng-click=\"inputFieldErrors.onClick()\">\n\n    <div ng-repeat=\"error in ::inputFieldErrors.errorMessages\" class=\"rc-error-message-{{::error.label}}\">\n        <div ng-message-exp=\"error.label\" class=\"rc-error-message\">\n            <li>\n                <rc-translatable-expression\n                    field-label=\"{{inputFieldErrors.fieldLabel}}\"\n                    i18n-templates=\"error.messageTranslations\">\n                </rc-translatable-expression>\n            </li>\n        </div>\n    </div>\n</ul>\n";

/***/ }),
/* 134 */
/***/ (function(module, exports) {

module.exports = "<a class=\"circ7\">\n    <div class=\"row\">\n        <div class=\"small-4 columns\">\n            <span class=\"circ7-code\" rc-bind-html-unsafe=\"match.model.circ7 | highlight:query:false: ' '\"></span>\n        </div>\n        <div class=\"small-6 columns\">\n            <span rc-bind-html-unsafe=\"match.model.city | highlight:query\"></span>\n        </div>\n        <div class=\"small-2 columns\">\n            <span rc-bind-html-unsafe=\"match.model.stateAbbreviation | highlight:query\"></span>\n        </div>\n    </div>\n</a>\n";

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports = "<a class=\"cityState\">\n    <div class=\"row\">\n        <div class=\"small-9 columns\">\n            <span rc-bind-html-unsafe=\"match.model.name | highlight:query:false: ' '\"></span>,\n        </div>\n        <div class=\"small-3 columns\">\n            <span rc-bind-html-unsafe=\"match.model.state.abbreviation | highlight:query\"></span>\n        </div>\n    </div>\n</a>\n";

/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports = "<a class=\"customer\">\n    <div class=\"row\">\n        <div class=\"small-10 columns\">\n            <span rc-bind-html-unsafe=\"match.model.fullName | highlight:query:false:' '\"></span>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"small-8 columns\">\n            <span rc-bind-html-unsafe=\"match.model.city | highlight:query\"></span>,\n        </div>\n        <div class=\"small-2 offset-2 columns\">\n            <span rc-bind-html-unsafe=\"match.model.state | highlight:query\"></span>\n        </div>\n    </div>\n</a>\n";

/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports = "<a class=\"person\">\n    <div class=\"row\">\n        <div class=\"small-6 columns\">\n            <span rc-bind-html-unsafe=\"match.model.fullName | highlight:query:false:' '\"></span>\n        </div>\n        <div class=\"small-3 columns\">\n            <span rc-bind-html-unsafe=\"match.model.employeeId | highlight:query\"></span>\n        </div>\n        <div class=\"small-3 columns\">\n            <span rc-bind-html-unsafe=\"match.model.userId | highlight:query\"></span>\n        </div>\n    </div>\n</a>\n";

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports = "<a class=\"splc\">\n    <div class=\"row\">\n        <div class=\"small-9 columns\">\n            <span rc-bind-html-unsafe=\"match.model.name | highlight:query:false: ' '\"></span>,\n        </div>\n        <div class=\"small-3 columns\">\n            <span rc-bind-html-unsafe=\"match.model.state.abbreviation | highlight:query\"></span>\n        </div>\n    </div>\n</a>\n";

/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports = "<a class=\"stcc\">\n    <div class=\"row\">\n        <div class=\"small-3 columns\">\n            <div rc-bind-html-unsafe=\"match.model.stcc | highlight:query:false: ' '\"></div>\n        </div>\n        <div class=\"small-9 columns\">\n            <span rc-bind-html-unsafe=\"match.model.description | capitalize | highlight:query\"></span>\n        </div>\n    </div>\n</a>\n";

/***/ }),
/* 140 */
/***/ (function(module, exports) {

module.exports = "<rc-autocomplete-multiple ng-if=\"::rcAcCtrl.multiple\"></rc-autocomplete-multiple>\n";

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports = "<div class=\"rc-autocomplete-multiple\" ng-show=\"rcAcMultiCtrl.items.length > 0\">\n    <div class=\"rc-autocomplete-multiple-item\" ng-repeat=\"item in rcAcMultiCtrl.items\" tabindex=\"0\" ng-keydown=\"rcAcMultiCtrl.keyPressed($event, $index)\">\n        <div class=\"rc-autocomplete-multiple-remove\" ng-click=\"rcAcMultiCtrl.removeItem($index)\" >\n            <span class=\"icon close inverted\" ></span>\n        </div>\n        <div class=\"rc-autocomplete-multiple-item-label\" >{{ rcAcMultiCtrl.formatForDisplay(item) }}</div>\n    </div>\n</div>\n\n";

/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports = "<ul class=\"f-dropdown rc-autocomplete-dropdown\"\n    rc-scroller\n    ng-style=\"{ display: rcAcDropCtrl.showMatches() && 'block' || 'none', top: rcAcDropCtrl.position.top+'px', left: rcAcDropCtrl.position.left+'px' }\">\n    <li ng-repeat=\"match in rcAcDropCtrl.matches\"\n        ng-class=\"{active: rcAcDropCtrl.isActive($index)}\"\n        ng-mouseenter=\"rcAcDropCtrl.selectActive($index)\"\n        ng-mousedown=\"rcAcDropCtrl.selectMatch($index)\"\n        rc-scroll-if=\"rcAcDropCtrl.isActive($index)\">\n        <rc-autocomplete-match index=\"$index\"\n            match=\"match\"\n            query=\"rcAcDropCtrl.query\"\n            template-url=\"rcAcDropCtrl.templateUrl\"></rc-autocomplete-match>\n    </li>\n</ul>\n";

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports = "<a tabindex=\"-1\" rc-bind-html-unsafe=\"$ctrl.match.label | highlight: $ctrl.query\"></a>\n";

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports = "<div class=\"rc-calendar-date-number\" ng-bind=\"::rcCalDayCtrl.number()\"></div>\n<div class=\"rc-calendar-indicator\"></div>\n";

/***/ }),
/* 145 */
/***/ (function(module, exports) {

module.exports = "<div class=\"rc-calendar-month-heading\" ng-bind=\"::rcCalMCtrl.heading\"></div>\n<rc-calendar-week-headers></rc-calendar-week-headers>\n<rc-calendar-week ng-repeat=\"week in ::rcCalMCtrl.weeks track by $index\" item=\"week\"></rc-calendar-week>";

/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports = "<div class=\"rc-calendar-control\" ng-transclude=\"controls\" >\n    <a class=\"rc-calendar-today-button button\"\n        ng-if=\"::rcCalPopCtrl.todayButton()\"\n        ng-click=\"rcCalPopCtrl.focusToday()\"\n        href>\n        <rc-translatable-expression i18n-templates=\"rcCalPopCtrl.todayTranslation\"></rc-translatable-expression>\n    </a>\n    <a class=\"rc-calendar-ok-button button\"\n        ng-if=\"rcCalPopCtrl.showOkButton()\"\n        ng-click=\"rcCalPopCtrl.complete()\"\n        href>\n        <rc-translatable-expression i18n-templates=\"rcCalPopCtrl.okTranslation\"></rc-translatable-expression>\n    </a>\n    <a class=\"rc-calendar-close button icon close\"\n        ng-click=\"rcCalPopCtrl.cancel()\"\n        href\n    ></a>\n</div>\n<div class=\"rc-calendar-content\" ng-transclude=\"content\" >\n    <rc-calendar-scroll-content></rc-calendar-scroll-content>\n</div>\n";

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports = "<div class=\"rc-calendar-scroll-y\" rc-isolate-scroll=\"rcCalScrlCtrl.onBoundary($boundary, $event)\">\n    <div class=\"rc-calendar-scroll-month\" ng-repeat=\"month in rcCalScrlCtrl.months\">\n        <rc-calendar-month item=\"month\">\n    </div> \n</div>\n";

/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports = "<rc-calendar-day \n    ng-repeat=\"day in ::rcCalWeekCtrl.week track by $index\" \n    item=\"day\"></rc-calendar-day>\n";

/***/ }),
/* 149 */
/***/ (function(module, exports) {

module.exports = "<div class=\"rc-calendar-week-heading\"\n    ng-repeat=\"day in ::rcCalWHCtrl.days\">{{::day | firstLetter}}</div>";

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports = "<div class=\"button-addon\">\n    <span class=\"buttonfix\"><button\n        type=\"button\"\n        class=\"icon calendar\"\n        ng-click=\"rcCalCtrl.togglePopup()\"\n        ng-keydown=\"rcCalCtrl.buttonKeydown($event)\"\n        rc-focus=\"rcCalCtrl.focusCalendarButton\"\n    ></button></span>\n</div>\n\n";

/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports = "<div class=\"rc-box\"></div>\n<div class=\"rc-mark\"></div>\n<label ng-transclude></label>\n";

/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports = "<div class=\"rc-loading-backdrop\" ></div>\n";

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports = "<div class=\"rc-loading-content\">\n    <div class=\"rc-loading-animation\"></div>\n    <div class=\"rc-loading-title\" ng-switch=\"useTooltip\">\n        <span ng-if=\"message\" rc-tooltip=\"{{message}}\">\n            <rc-translatable-expression i18n-templates=\"loadingTranslation\"></rc-translatable-expression>\n        </span>\n        <span ng-if=\"!message\">\n            <rc-translatable-expression i18n-templates=\"loadingTranslation\"></rc-translatable-expression>\n        </span>\n    </div>\n    <div class=\"rc-loading-message\">{{message}}</div>\n</div>\n";

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports = "<overlay-target ng-click=\"$ctrl.open()\" ng-class=\"$ctrl.targetStyles\">\n    <span ng-transclude=\"overlayTarget\"></span>\n</overlay-target>\n\n<overlay-content>\n    <div class=\"rc-overlay-popup-content\"\n        ng-transclude=\"overlayContent\"\n        ng-if=\"$ctrl.visible\"\n        ng-style=\"$ctrl.overlayPosition\">\n    </div>\n</overlay-content>\n\n";

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports = "<modal-container tab-isolation>\n    <modal-wrapper class=\"{{windowClass}}\">\n        <modal-header>\n            <modal-title>{{title}}</modal-title>\n            <modal-cancel ng-if=\"includeCancel\" ng-click=\"cancelModal()\">\n                <a href class=\"icon close inverted\"></a>\n            </modal-cancel>\n        </modal-header>\n        <modal-content ng-transclude></modal-content>\n    </modal-wrapper>\n</modal-container>";

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"$ctrl.toggle\">\n    <modal-overlay></modal-overlay>\n    <modal-container tab-isolation>\n        <modal-wrapper ng-class=\"$ctrl.userClasses\">\n            <modal-header>\n                <modal-title ng-transclude=\"header\">{{::$ctrl.heading}}</modal-title>\n                <modal-cancel ng-if=\"$ctrl.showCancel\" ng-click=\"$ctrl.close()\">\n                    <a href class=\"icon close inverted\"></a>\n                </modal-cancel>\n            </modal-header>\n            <modal-content>\n                <ng-transclude></ng-transclude>\n                <div class=\"shadow-hide-slat\"></div>\n            </modal-content>\n            <modal-footer ng-transclude=\"footer\" ng-if=\"$ctrl.hasFooter\"></modal-footer>\n        </modal-wrapper>\n    </modal-container>\n</div>";

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports = "<span class=\"rc-smart-menu\"\n    tabindex=\"0\"\n    ng-click=\"$ctrl.toggleSmartMenu($event)\"\n    ng-keyup=\"$ctrl.toggleSmartMenu($event)\">\n    <span class=\"rc-smart-menu-label\">\n        <span ng-transclude></span><span class=\"rc-smart-menu-chevron\"></span>\n    </span>\n</span>\n";

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports = "<section class=\"additional-content\"\n    ng-if=\"smartMenuPopup.hasSummaryContent()\"\n    alternate-summary=\"smartMenuPopup.altSummary\">\n    <table>\n        <tbody>\n            <tr ng-repeat=\"data in smartMenuPopup.summaryContent\" ng-show=\"data.value\">\n                <td class=\"key\">{{ ::data.label }}</td>\n                <td class=\"value\">{{ ::data.value }}</td>\n            </tr>\n        </tbody>\n    </table>\n</section>\n<ul class=\"rc-smart-menu-items\">\n    <li ng-repeat=\"item in smartMenuPopup.menuItems\"\n        ng-class=\"{\n            'error': item.error,\n            'default': smartMenuPopup.menuAdditions.length && $index > smartMenuPopup.menuAdditions.length-1\n            }\"\n        ng-switch=\"item.url && item.url.length > 0\">\n        <a class=\"rc-smart-menu-item\"\n            ng-switch-when=\"true\"\n            ng-click=\"smartMenuPopup.publishClick($event, item)\"\n            ng-href=\"{{ ::item.url }}\"\n            ng-attr-target=\"{{::item.target || '_blank'}}\">{{ ::item.label }}</a>\n        <span class=\"rc-smart-menu-item\"\n            ng-switch-default\n            ng-click=\"smartMenuPopup.handleCallback($event, item)\"\n            ng-keyup=\"smartMenuPopup.handleCallback($event, item)\"\n            tabindex=\"0\">{{ ::item.label }}</span>\n    </li>\n</ul>\n";

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports = "<table-control ng-hide=\"rcTblCtrl.hideControls()\">\n    <table-group-toggle>\n        <a ng-show=\"rcTblCtrl.hasGroups()\"\n            ng-click=\"rcTblCtrl.toggleGroups()\"\n            href>\n            <span class=\"rc-table-link-text\" ng-bind=\"rcTblCtrl.expandCollapseText\"></span>\n        </a>\n    </table-group-toggle>\n    <table-custom-control ng-transclude=\"control\"></table-custom-control>\n    <table-column-toggle>\n        <rc-table-column-toggle\n            ng-if=\"rcTblCtrl.showColumnToggle\"\n            columns=\"rcTblCtrl.columns\"\n            on-column-toggle=\"rcTblCtrl.onColumnToggle($event)\"></rc-table-column-toggle>\n    </table-column-toggle>\n</table-control>\n<table-content ng-transclude=\"content\"\n        rc-scroll-isolate=\"rcTblCtrl.onIsolateScroll($event)\"></table-content>\n\n";

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports = "<thead>\n    <tr>\n        <th ng-repeat=\"column in $rcTblAgent.getColumns()\"\n            ng-class=\"{\n                'sortable': $rcTblAgent.isSortable(column),\n                'sort-asc': $rcTblAgent.isAscendingSort(column),\n                'sort-desc': $rcTblAgent.isDescendingSort(column)\n            }\"\n            ng-click=\"$rcTblAgent.sortBy(column, $event)\"\n            ng-keyup=\"$rcTblAgent.sortBy(column, $event)\"\n            tabindex=\"{{ ::column.tabindex }}\"\n            ng-show=\"column.show()\"\n            ng-init=\"template = column.header()\"\n            class=\"{{ ::column.sortIndex() }}\">\n            <div ng-if=\"!template\" ng-bind=\"::column.title()\"></div>\n            <div ng-if=\"template\">\n                <div ng-include=\"template\"></div>\n            </div>\n        </th>\n    </tr>\n</thead>\n";

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports = "<rc-overlay>\n    <rc-overlay-target>\n        <a href>\n            <rc-translatable-expression class=\"rc-table-link-text\"\n                i18n-templates=\"toggleCtrl.toggleLabel\"></rc-translatable-expression>\n        </a>\n    </rc-overlay-target>\n    <rc-overlay-content class=\"rc-column-list\">\n        <ul>\n            <li ng-repeat=\"state in toggleCtrl.states track by $index\"\n                ng-click=\"toggleCtrl.toggleColumn($index, $event)\"\n                ng-if=\"toggleCtrl.isTogglable($index)\">\n                <label class=\"rc-table-column-toggle-label\">\n                    <rc-checkbox>\n                        <input type=\"checkbox\" ng-model=\"state.visible\">\n                    </rc-checkbox>\n                    {{ ::state.title }}\n                </label>\n            </li>\n        </ul>\n    </rc-overlay-content>\n</rc-overlay>";

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }

    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;

        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;

                return true;
            }

            return false;
        });

        return result;
    }

    return (function () {
        function anonymous() {
            this.__entries__ = [];
        }

        var prototypeAccessors = { size: { configurable: true } };

        /**
         * @returns {boolean}
         */
        prototypeAccessors.size.get = function () {
            return this.__entries__.length;
        };

        /**
         * @param {*} key
         * @returns {*}
         */
        anonymous.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];

            return entry && entry[1];
        };

        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        anonymous.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);

            if (~index) {
                this.__entries__[index][1] = value;
            } else {
                this.__entries__.push([key, value]);
            }
        };

        /**
         * @param {*} key
         * @returns {void}
         */
        anonymous.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);

            if (~index) {
                entries.splice(index, 1);
            }
        };

        /**
         * @param {*} key
         * @returns {void}
         */
        anonymous.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };

        /**
         * @returns {void}
         */
        anonymous.prototype.clear = function () {
            this.__entries__.splice(0);
        };

        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        anonymous.prototype.forEach = function (callback, ctx) {
            var this$1 = this;
            if ( ctx === void 0 ) ctx = null;

            for (var i = 0, list = this$1.__entries__; i < list.length; i += 1) {
                var entry = list[i];

                callback.call(ctx, entry[1], entry[0]);
            }
        };

        Object.defineProperties( anonymous.prototype, prototypeAccessors );

        return anonymous;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }

    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }

    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }

    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }

    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;

/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
var throttle = function (callback, delay) {
    var leadingCall = false,
        trailingCall = false,
        lastCallTime = 0;

    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;

            callback();
        }

        if (trailingCall) {
            proxy();
        }
    }

    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }

    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();

        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }

            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;

            setTimeout(timeoutCallback, delay);
        }

        lastCallTime = timeStamp;
    }

    return proxy;
};

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;

// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];

// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';

/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = function() {
    this.connected_ = false;
    this.mutationEventsAdded_ = false;
    this.mutationsObserver_ = null;
    this.observers_ = [];

    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
};

/**
 * Adds observer to observers list.
 *
 * @param {ResizeObserverSPI} observer - Observer to be added.
 * @returns {void}
 */


/**
 * Holds reference to the controller's instance.
 *
 * @private {ResizeObserverController}
 */


/**
 * Keeps reference to the instance of MutationObserver.
 *
 * @private {MutationObserver}
 */

/**
 * Indicates whether DOM listeners have been added.
 *
 * @private {boolean}
 */
ResizeObserverController.prototype.addObserver = function (observer) {
    if (!~this.observers_.indexOf(observer)) {
        this.observers_.push(observer);
    }

    // Add listeners if they haven't been added yet.
    if (!this.connected_) {
        this.connect_();
    }
};

/**
 * Removes observer from observers list.
 *
 * @param {ResizeObserverSPI} observer - Observer to be removed.
 * @returns {void}
 */
ResizeObserverController.prototype.removeObserver = function (observer) {
    var observers = this.observers_;
    var index = observers.indexOf(observer);

    // Remove observer if it's present in registry.
    if (~index) {
        observers.splice(index, 1);
    }

    // Remove listeners if controller has no connected observers.
    if (!observers.length && this.connected_) {
        this.disconnect_();
    }
};

/**
 * Invokes the update of observers. It will continue running updates insofar
 * it detects changes.
 *
 * @returns {void}
 */
ResizeObserverController.prototype.refresh = function () {
    var changesDetected = this.updateObservers_();

    // Continue running updates if changes have been detected as there might
    // be future ones caused by CSS transitions.
    if (changesDetected) {
        this.refresh();
    }
};

/**
 * Updates every observer from observers list and notifies them of queued
 * entries.
 *
 * @private
 * @returns {boolean} Returns "true" if any observer has detected changes in
 *  dimensions of it's elements.
 */
ResizeObserverController.prototype.updateObservers_ = function () {
    // Collect observers that have active observations.
    var activeObservers = this.observers_.filter(function (observer) {
        return observer.gatherActive(), observer.hasActive();
    });

    // Deliver notifications in a separate cycle in order to avoid any
    // collisions between observers, e.g. when multiple instances of
    // ResizeObserver are tracking the same element and the callback of one
    // of them changes content dimensions of the observed target. Sometimes
    // this may result in notifications being blocked for the rest of observers.
    activeObservers.forEach(function (observer) { return observer.broadcastActive(); });

    return activeObservers.length > 0;
};

/**
 * Initializes DOM listeners.
 *
 * @private
 * @returns {void}
 */
ResizeObserverController.prototype.connect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already added.
    if (!isBrowser || this.connected_) {
        return;
    }

    // Subscription to the "Transitionend" event is used as a workaround for
    // delayed transitions. This way it's possible to capture at least the
    // final state of an element.
    document.addEventListener('transitionend', this.onTransitionEnd_);

    window.addEventListener('resize', this.refresh);

    if (mutationObserverSupported) {
        this.mutationsObserver_ = new MutationObserver(this.refresh);

        this.mutationsObserver_.observe(document, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
        });
    } else {
        document.addEventListener('DOMSubtreeModified', this.refresh);

        this.mutationEventsAdded_ = true;
    }

    this.connected_ = true;
};

/**
 * Removes DOM listeners.
 *
 * @private
 * @returns {void}
 */
ResizeObserverController.prototype.disconnect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already removed.
    if (!isBrowser || !this.connected_) {
        return;
    }

    document.removeEventListener('transitionend', this.onTransitionEnd_);
    window.removeEventListener('resize', this.refresh);

    if (this.mutationsObserver_) {
        this.mutationsObserver_.disconnect();
    }

    if (this.mutationEventsAdded_) {
        document.removeEventListener('DOMSubtreeModified', this.refresh);
    }

    this.mutationsObserver_ = null;
    this.mutationEventsAdded_ = false;
    this.connected_ = false;
};

/**
 * "Transitionend" event handler.
 *
 * @private
 * @param {TransitionEvent} event
 * @returns {void}
 */
ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
        var propertyName = ref.propertyName; if ( propertyName === void 0 ) propertyName = '';

    // Detect whether transition may affect dimensions of an element.
    var isReflowProperty = transitionKeys.some(function (key) {
        return !!~propertyName.indexOf(key);
    });

    if (isReflowProperty) {
        this.refresh();
    }
};

/**
 * Returns instance of the ResizeObserverController.
 *
 * @returns {ResizeObserverController}
 */
ResizeObserverController.getInstance = function () {
    if (!this.instance_) {
        this.instance_ = new ResizeObserverController();
    }

    return this.instance_;
};

ResizeObserverController.instance_ = null;

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
        var key = list[i];

        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }

    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;

    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);

/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}

/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [], len = arguments.length - 1;
    while ( len-- > 0 ) positions[ len ] = arguments[ len + 1 ];

    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];

        return size + toFloat(value);
    }, 0);
}

/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};

    for (var i = 0, list = positions; i < list.length; i += 1) {
        var position = list[i];

        var value = styles['padding-' + position];

        paddings[position] = toFloat(value);
    }

    return paddings;
}

/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();

    return createRectInit(0, 0, bbox.width, bbox.height);
}

/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth;
    var clientHeight = target.clientHeight;

    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }

    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;

    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width),
        height = toFloat(styles.height);

    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }

        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }

    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;

        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }

        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }

    return createRectInit(paddings.left, paddings.top, width, height);
}

/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }

    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function'; };
})();

/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}

/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }

    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }

    return getHTMLElementContentRect(target);
}

/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(ref) {
    var x = ref.x;
    var y = ref.y;
    var width = ref.width;
    var height = ref.height;

    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);

    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });

    return rect;
}

/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = function(target) {
    this.broadcastWidth = 0;
    this.broadcastHeight = 0;
    this.contentRect_ = createRectInit(0, 0, 0, 0);

    this.target = target;
};

/**
 * Updates content rectangle and tells whether it's width or height properties
 * have changed since the last broadcast.
 *
 * @returns {boolean}
 */


/**
 * Reference to the last observed content rectangle.
 *
 * @private {DOMRectInit}
 */


/**
 * Broadcasted width of content rectangle.
 *
 * @type {number}
 */
ResizeObservation.prototype.isActive = function () {
    var rect = getContentRect(this.target);

    this.contentRect_ = rect;

    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
};

/**
 * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
 * from the corresponding properties of the last observed content rectangle.
 *
 * @returns {DOMRectInit} Last observed content rectangle.
 */
ResizeObservation.prototype.broadcastRect = function () {
    var rect = this.contentRect_;

    this.broadcastWidth = rect.width;
    this.broadcastHeight = rect.height;

    return rect;
};

var ResizeObserverEntry = function(target, rectInit) {
    var contentRect = createReadOnlyRect(rectInit);

    // According to the specification following properties are not writable
    // and are also not enumerable in the native implementation.
    //
    // Property accessors are not being used as they'd require to define a
    // private WeakMap storage which may cause memory leaks in browsers that
    // don't support this type of collections.
    defineConfigurable(this, { target: target, contentRect: contentRect });
};

var ResizeObserverSPI = function(callback, controller, callbackCtx) {
    this.activeObservations_ = [];
    this.observations_ = new MapShim();

    if (typeof callback !== 'function') {
        throw new TypeError('The callback provided as parameter 1 is not a function.');
    }

    this.callback_ = callback;
    this.controller_ = controller;
    this.callbackCtx_ = callbackCtx;
};

/**
 * Starts observing provided element.
 *
 * @param {Element} target - Element to be observed.
 * @returns {void}
 */


/**
 * Registry of the ResizeObservation instances.
 *
 * @private {Map<Element, ResizeObservation>}
 */


/**
 * Public ResizeObserver instance which will be passed to the callback
 * function and used as a value of it's "this" binding.
 *
 * @private {ResizeObserver}
 */

/**
 * Collection of resize observations that have detected changes in dimensions
 * of elements.
 *
 * @private {Array<ResizeObservation>}
 */
ResizeObserverSPI.prototype.observe = function (target) {
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
    }

    if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_;

    // Do nothing if element is already being observed.
    if (observations.has(target)) {
        return;
    }

    observations.set(target, new ResizeObservation(target));

    this.controller_.addObserver(this);

    // Force the update of observations.
    this.controller_.refresh();
};

/**
 * Stops observing provided element.
 *
 * @param {Element} target - Element to stop observing.
 * @returns {void}
 */
ResizeObserverSPI.prototype.unobserve = function (target) {
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
    }

    if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_;

    // Do nothing if element is not being observed.
    if (!observations.has(target)) {
        return;
    }

    observations.delete(target);

    if (!observations.size) {
        this.controller_.removeObserver(this);
    }
};

/**
 * Stops observing all elements.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.disconnect = function () {
    this.clearActive();
    this.observations_.clear();
    this.controller_.removeObserver(this);
};

/**
 * Collects observation instances the associated element of which has changed
 * it's content rectangle.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.gatherActive = function () {
        var this$1 = this;

    this.clearActive();

    this.observations_.forEach(function (observation) {
        if (observation.isActive()) {
            this$1.activeObservations_.push(observation);
        }
    });
};

/**
 * Invokes initial callback function with a list of ResizeObserverEntry
 * instances collected from active resize observations.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.broadcastActive = function () {
    // Do nothing if observer doesn't have active observations.
    if (!this.hasActive()) {
        return;
    }

    var ctx = this.callbackCtx_;

    // Create ResizeObserverEntry instance for every active observation.
    var entries = this.activeObservations_.map(function (observation) {
        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
    });

    this.callback_.call(ctx, entries, ctx);
    this.clearActive();
};

/**
 * Clears the collection of active observations.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.clearActive = function () {
    this.activeObservations_.splice(0);
};

/**
 * Tells whether observer has active observations.
 *
 * @returns {boolean}
 */
ResizeObserverSPI.prototype.hasActive = function () {
    return this.activeObservations_.length > 0;
};

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();

/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = function(callback) {
    if (!(this instanceof ResizeObserver)) {
        throw new TypeError('Cannot call a class as a function.');
    }
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    var controller = ResizeObserverController.getInstance();
    var observer = new ResizeObserverSPI(callback, controller, this);

    observers.set(this, observer);
};

// Expose public methods of ResizeObserver.
['observe', 'unobserve', 'disconnect'].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        return (ref = observers.get(this))[method].apply(ref, arguments);
        var ref;
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }

    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["a"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(163)))

/***/ }),
/* 163 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports = "<ng-transclude class=\"rc-tab-content\" ng-class=\"{ 'active': rcTabCtrl.active }\"></ng-transclude>\n";

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports = "<rc-tabset-header class=\"noselect\" tabs=\"rcTabsetCtrl.tabs\"></rc-tabset-header>\n<ng-transclude class=\"rc-tabset-content rc-container\"></ng-transclude>\n";

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports = "<a href class=\"rc-tabset-scroll-left noselect\"></a>\n<div class=\"rc-tab-heading\"\n    ng-repeat=\"tab in rcTsHdrCtrl.tabs()\"\n    ng-class=\"{ 'active': tab.active, 'disabled': tab.disabled }\">\n    <a ng-if=\"tab.heading\" ng-click=\"rcTsHdrCtrl.select(tab)\">{{::tab.heading}}</a>\n    <a ng-if=\"tab.headerTranscludeFn\" ng-click=\"rcTsHdrCtrl.select(tab)\" rc-transclude-header-for=\"tab.headerTranscludeFn\"></a>\n</div>\n<a href class=\"rc-tabset-scroll-right noselect\"></a>\n";

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports = "<span class=\"tooltip tip-{{::placement}}\"\n  ng-class=\"{ in: isOpen(), fade: animation() }\">\n  <span ng-bind=\"content\"></span>\n  <span class=\"nub\"></span>\n</span>\n";

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports = "<span class=\"tooltip tip-{{placement}}\"\n  ng-class=\"{ in: isOpen(), fade: animation() }\">\n  <span rc-bind-html-unsafe=\"content\"></span>\n  <span class=\"nub\"></span>\n</span>\n";

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports = "<div class=\"wcPosition \" ng-class=\"{'watcherWarning' : wcCtrl.getWatchers() >= 2000}\" ng-style=\"{'bottom': wcCtrl.bottom, 'top':wcCtrl.top, 'left': wcCtrl.left, 'right':wcCtrl.right}\">\n    <p>Watch count: {{wcCtrl.getWatchers()}}</p>\n</div>\n\n<style>\n    .wcPosition {\n        position: fixed;\n        border: 2px solid;\n        border-radius: 5px;\n        z-index: 1;\n        background-color: rgba(255, 255, 255, .8) ;\n    }\n    \n    .watcherWarning {\n        color: red;\n    }\n</style>";

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports = "<div class=\"rc-wizard-steps\">\n    <a class=\"header button fit-text\" ng-repeat=\"step in rcWzCtrl.enabledSteps\" ng-click=\"rcWzCtrl.setActive($index);\" ng-class=\"{ 'active': $index === rcWzCtrl.currentStep,\n            'not-completed': $index > rcWzCtrl.currentStep,\n            'completed': $index < rcWzCtrl.currentStep,\n            'is-disabled': !rcWzCtrl.validUpTo($index) }\">\n            <span class=\"stepNumber\" ng-bind=\"($index+1)\"></span> <span ng-bind=\"step.heading\"></span>\n    </a>\n</div>\n<div class=\"rc-wizard-step-content rc-container\">\n    <div ng-transclude></div>\n</div>\n<rc-wizard-prev-next></rc-wizard-prev-next>\n";

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row prev-next\">\n    <div class=\"small-4 medium-3 columns\">\n        <button type=\"button\" ng-click=\"$ctrl.rcWizard.previousStep();\" ng-if=\"$ctrl.rcWizard.currentStep > 0\">\n            <rc-translatable-expression i18n-templates=\"$ctrl.back\"></rc-translatable-expression>\n        </button>\n        <span ng-if=\"$ctrl.rcWizard.currentStep === 0\">&nbsp;</span>\n    </div>\n    <div class=\"small-4 medium-6 columns indicators\">\n        <span ng-repeat=\"step in $ctrl.rcWizard.enabledSteps\" class=\"indicator\" ng-class=\"{ 'active': step.isActive() }\"></span>\n    </div>\n    <div class=\"text-right small-4 medium-3 columns\">\n        <button ng-if=\"$ctrl.isLastStep()\" class=\"primary\" ng-click=\"$ctrl.rcWizard.finish();\">\n            <rc-translatable-expression i18n-templates=\"$ctrl.submit\"></rc-translatable-expression>\n        </button>\n        <button ng-if=\"!$ctrl.isLastStep()\" type=\"button\" class=\"primary\" ng-click=\"$ctrl.rcWizard.nextStep();\">\n            <rc-translatable-expression i18n-templates=\"$ctrl.next\"></rc-translatable-expression>\n        </button>\n    </div>\n</div>\n";

/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports = "<section class=\"rc-wizard-step\" ng-class=\"{ 'active': isActive() }\" ng-transclude></section>\n";

/***/ })
/******/ ]);
});
//# sourceMappingURL=ricola.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ricola3/ricola.js
// module id = 7
// module chunks = 0